var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key2 of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key2) && key2 !== except)
        __defProp(to, key2, { get: () => from[key2], enumerable: !(desc = __getOwnPropDesc(from, key2)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  API_NOT_ALLOWED: () => API_NOT_ALLOWED,
  ActionValue: () => ActionValue,
  BASKET_LIST_DEFAULT_SIZE: () => BASKET_LIST_DEFAULT_SIZE,
  BasketSortDirection: () => BasketSortDirection,
  BasketUserType: () => BasketUserType,
  BasketsSort: () => BasketsSort,
  Browsers: () => Browsers,
  BusinessFilterNature: () => BusinessFilterNature,
  CONNECTION_HIT_SESSION_STORAGE_ITEM_NAME: () => CONNECTION_HIT_SESSION_STORAGE_ITEM_NAME,
  ComponentAugmentKey: () => ComponentAugmentKey,
  ComponentOverrideKey: () => ComponentOverrideKey,
  DATAVIEW_BASKET_DEFAULT_SIZE: () => DATAVIEW_BASKET_DEFAULT_SIZE,
  DATAVIEW_DEFAULT_PAGE: () => DATAVIEW_DEFAULT_PAGE,
  DATAVIEW_DEFAULT_SCROLL: () => DATAVIEW_DEFAULT_SCROLL,
  DATAVIEW_DEFAULT_SIZE: () => DATAVIEW_DEFAULT_SIZE,
  DATAVIEW_DEFAULT_SORT: () => DATAVIEW_DEFAULT_SORT,
  DATAVIEW_DEFAULT_TOTAL_COUNT: () => DATAVIEW_DEFAULT_TOTAL_COUNT,
  DOWNLOAD_MANAGER_FORMAT_BY: () => DOWNLOAD_MANAGER_FORMAT_BY,
  DataViewElementsAuthorizedIcon: () => DataViewElementsAuthorizedIcon,
  DataViewElementsThumbnailSize: () => DataViewElementsThumbnailSize,
  DataViewKey: () => DataViewKey,
  DataviewDisplayModes: () => DataviewDisplayModes,
  Direction: () => Direction,
  DownloadManagerOpenStatus: () => DownloadManagerOpenStatus,
  ELEMENT_SUMMARY_ID_PREFIX: () => ELEMENT_SUMMARY_ID_PREFIX,
  ERROR_CODE_QUERY_PARAM: () => ERROR_CODE_QUERY_PARAM,
  EmbeddedMediaField: () => EmbeddedMediaField,
  ExecuteError: () => ExecuteError,
  ExecutionState: () => ExecutionState,
  FIRST_LOGIN_TYPE: () => FIRST_LOGIN_TYPE,
  FIRST_LOGIN_TYPE_QUERY_PARAM: () => FIRST_LOGIN_TYPE_QUERY_PARAM,
  FOLDERS_FACET_NAME_BEGIN: () => FOLDERS_FACET_NAME_BEGIN,
  FOLDER_FACET_ID: () => FOLDER_FACET_ID,
  FQ_PARAMETER: () => FQ_PARAMETER,
  FetcherMode: () => FetcherMode,
  FieldType: () => FieldType,
  FilterType: () => FilterType,
  FqType: () => FqType,
  FunctionOverrideKey: () => FunctionOverrideKey,
  ID_TOKEN_EXPIRED_MSG: () => ID_TOKEN_EXPIRED_MSG,
  ID_TOKEN_INVALID_MSG: () => ID_TOKEN_INVALID_MSG,
  ImportStatus: () => ImportStatus,
  IsJsonString: () => IsJsonString,
  JWT_TOKEN_IS_EMPTY_MSG: () => JWT_TOKEN_IS_EMPTY_MSG,
  KCConsumerStatus: () => KCConsumerStatus,
  KeycloakInstanceType: () => KeycloakInstanceType,
  KpkAttachmentMetaDateType: () => KpkAttachmentMetaDateType,
  KpkAttachmentMetaType: () => KpkAttachmentMetaType,
  KpkAutoCompleteType: () => KpkAutoCompleteType,
  KpkFilterModifierType: () => KpkFilterModifierType,
  KpkFilterType: () => KpkFilterType,
  KpkMetaFieldType: () => KpkMetaFieldType,
  LS_KC_SESSION_ID: () => LS_KC_SESSION_ID,
  LS_KC_TOKEN_EXP: () => LS_KC_TOKEN_EXP,
  Language: () => Language,
  LayoutOverrideKey: () => LayoutOverrideKey,
  ListViewSize: () => ListViewSize,
  LiveMesure: () => LiveMesure,
  LockState: () => LockState,
  MANDATORY_FIELDS: () => MANDATORY_FIELDS,
  MEDIA_TYPE_RICH_ELEMENT: () => MEDIA_TYPE_RICH_ELEMENT,
  MINUTES_UNIT: () => MINUTES_UNIT,
  MandatoryProviderException: () => MandatoryProviderException,
  MasonryViewSize: () => MasonryViewSize,
  MediaField: () => MediaField,
  MediaFieldCompatibleAdvancedSearch: () => MediaFieldCompatibleAdvancedSearch,
  MediaFieldCompatibleFacet: () => MediaFieldCompatibleFacet,
  MediaFieldCompatibleFacetMulti: () => MediaFieldCompatibleFacetMulti,
  MediaLinksField: () => MediaLinksField,
  MediaType: () => MediaType,
  MetaField: () => MetaField,
  MetamodelTypeEnum: () => MetamodelTypeEnum,
  Modifier: () => Modifier,
  NO_FACETS_COUNT: () => NO_FACETS_COUNT,
  OrderTypeFacetValues: () => OrderTypeFacetValues,
  PageOverrideKey: () => PageOverrideKey,
  PageSecurisation: () => PageSecurisation,
  PanelListFilterType: () => PanelListFilterType,
  PermanentFilterType: () => PermanentFilterType,
  Position: () => Position,
  QueryParamElement: () => QueryParamElement,
  REFERRER_SESSION_STORAGE_ITEM_NAME: () => REFERRER_SESSION_STORAGE_ITEM_NAME,
  REGISTRATION_FORM_URL: () => REGISTRATION_FORM_URL,
  RICH_TYPE_META_MODEL_ID: () => RICH_TYPE_META_MODEL_ID,
  SHOULD_FLUSH_LS_KEY: () => SHOULD_FLUSH_LS_KEY,
  SORT_LIST_DEFAULT_FIELDS: () => SORT_LIST_DEFAULT_FIELDS,
  ScrollTriggerDirection: () => ScrollTriggerDirection,
  SelectAllStatus: () => SelectAllStatus,
  SentryBreadcrumbCategory: () => SentryBreadcrumbCategory,
  ShareEntryPointInputId: () => ShareEntryPointInputId,
  ShareManagerSelectionType: () => ShareManagerSelectionType,
  ShareSizingType: () => ShareSizingType,
  SpecificDataviewType: () => SpecificDataviewType,
  TECH_PRO_NAME: () => TECH_PRO_NAME,
  ThumbnailGenerationSourceMediaFormatEnum: () => ThumbnailGenerationSourceMediaFormatEnum,
  ThumbnailGenerationSourceMediaModeEnum: () => ThumbnailGenerationSourceMediaModeEnum,
  ThumbnailType: () => ThumbnailType,
  UserRight: () => UserRight,
  VisualAlertDateTargetMode: () => VisualAlertDateTargetMode,
  VisualAlertDateTargetUnit: () => VisualAlertDateTargetUnit,
  VisualAlertFieldType: () => VisualAlertFieldType,
  VisualAlertPosition: () => VisualAlertPosition,
  WrapperOverrideKey: () => WrapperOverrideKey,
  activeBusinessFiltersState: () => activeBusinessFiltersState,
  activeFilterIsOnlyBasket: () => activeFilterIsOnlyBasket,
  activeFilterValuesSelector: () => activeFilterValuesSelector,
  addMandatoryFields: () => addMandatoryFields,
  addMediaToBasket: () => addMediaToBasket,
  addMediasToBasket: () => addMediasToBasket,
  addToBasketModalState: () => addToBasketModalState,
  addToBasketSelection: () => addToBasketSelection,
  advancedSearchCriteriasFetcherSelector: () => advancedSearchCriteriasFetcherSelector,
  advancedSearchCriteriasSelector: () => advancedSearchCriteriasSelector,
  advancedSearchIsExpired: () => advancedSearchIsExpired,
  anticipatedNeedRefreshState: () => anticipatedNeedRefreshState,
  anticipatedRefreshState: () => anticipatedRefreshState,
  apiConfigSelector: () => apiConfigSelector,
  authConfigurationSelector: () => authConfigurationSelector,
  authLoadingSelector: () => authLoadingSelector,
  authTokensAtom: () => authTokensAtom,
  availableLocaleListSelector: () => availableLocaleListSelector,
  basketActiveAtom: () => basketActiveAtom,
  basketCountState: () => basketCountState,
  basketDownloadLevelSelector: () => basketDownloadLevelSelector,
  basketElementsSelector: () => basketElementsSelector,
  basketElementsState: () => basketElementsState,
  basketInternalMode: () => basketInternalMode,
  basketInternalModePerUserTypeConfiguration: () => basketInternalModePerUserTypeConfiguration,
  basketItemSelector: () => basketItemSelector,
  basketListCallIdState: () => basketListCallIdState,
  basketListCallIdsSelector: () => basketListCallIdsSelector,
  basketListQuery: () => basketListQuery,
  basketListRawSelector: () => basketListRawSelector,
  basketListSelector: () => basketListSelector,
  basketListState: () => basketListState,
  basketPublicShareQuery: () => basketPublicShareQuery,
  basketSelector: () => basketSelector,
  basketTitle: () => basketTitle,
  basketTotalCountSelector: () => basketTotalCountSelector,
  basketTotalCountWithInternalModeSelector: () => basketTotalCountWithInternalModeSelector,
  buildAdvancedFilterList: () => buildAdvancedFilterList,
  buildOptimizedLightDataviewElementsSelector: () => buildOptimizedLightDataviewElementsSelector,
  buildParamsForShare: () => buildParamsForShare,
  businessFilterGroupIsExpandedState: () => businessFilterGroupIsExpandedState,
  businessFilterIsExpandedState: () => businessFilterIsExpandedState,
  businessFilterPanelIsOpenState: () => businessFilterPanelIsOpenState,
  businessFilterPanelIsOpenStateConfiguration: () => businessFilterPanelIsOpenStateConfiguration,
  businessFiltersConfiguration: () => businessFiltersConfiguration,
  checkBusinessFilterFiltersAgainstFacets: () => checkBusinessFilterFiltersAgainstFacets,
  checkPanelListFilterAgasintFacets: () => checkPanelListFilterAgasintFacets,
  checkUserIsTech: () => checkUserIsTech,
  contactSheetsSelector: () => contactSheetsSelector,
  convertBusinessFilterFilterToBusinessFilterFacet: () => convertBusinessFilterFilterToBusinessFilterFacet,
  convertBusinessFilterToKpkFilter: () => convertBusinessFilterToKpkFilter,
  convertIsPassedGetDamTypeToFirstLoginType: () => convertIsPassedGetDamTypeToFirstLoginType,
  convertKpkApiAdvancedSearchCriteriaTypeToKpkFilterType: () => convertKpkApiAdvancedSearchCriteriaTypeToKpkFilterType,
  convertKpkApiFacetToBusinessFilter: () => convertKpkApiFacetToBusinessFilter,
  convertKpkFilterToBusinessFilter: () => convertKpkFilterToBusinessFilter,
  convertKpkMetaFieldTypeToKpkApiFacetType: () => convertKpkMetaFieldTypeToKpkApiFacetType,
  convertToKpkMedia: () => convertToKpkMedia,
  convertToKpkMetaFieldType: () => convertToKpkMetaFieldType,
  convertToRightType: () => convertToRightType,
  createAdvancedBusinessFilter: () => createAdvancedBusinessFilter,
  createAdvancedThesaurusBusinessFilter: () => createAdvancedThesaurusBusinessFilter,
  createAssociationsBusinessFilter: () => createAssociationsBusinessFilter,
  createBasketBusinessFilter: () => createBasketBusinessFilter,
  createBasketInputId: () => createBasketInputId,
  createBasketModalState: () => createBasketModalState,
  createBasketTitleState: () => createBasketTitleState,
  createFacetForBounceSearch: () => createFacetForBounceSearch,
  createFolderBusinessFilter: () => createFolderBusinessFilter,
  createFullTextBusinessFilter: () => createFullTextBusinessFilter,
  currentBrowser: () => currentBrowser,
  currentDataLocaleSelector: () => currentDataLocaleSelector,
  currentFolderRootBreadcrumbContext: () => currentFolderRootBreadcrumbContext,
  currentLocaleAtom: () => currentLocaleAtom,
  currentUiQuery: () => currentUiQuery,
  currentUserAssignedGroupsQuery: () => currentUserAssignedGroupsQuery,
  currentUserQuery: () => currentUserQuery,
  customSelectorInOut: () => customSelectorInOut,
  customerCommonOverrideAtom: () => customerCommonOverrideAtom,
  dataViewAdvancedSearchFilterSelector: () => dataViewAdvancedSearchFilterSelector,
  dataViewAdvancedSearchId: () => dataViewAdvancedSearchId,
  dataViewAdvancedSearchIdQuery: () => dataViewAdvancedSearchIdQuery,
  dataViewAdvancedSearchPermanentFiltersConfiguration: () => dataViewAdvancedSearchPermanentFiltersConfiguration,
  dataViewDisplayMode: () => dataViewDisplayMode,
  dataViewElement: () => dataViewElement,
  dataViewElementFieldsToDisplaySelector: () => dataViewElementFieldsToDisplaySelector,
  dataViewElementsAuthorizedIconsConfiguration: () => dataViewElementsAuthorizedIconsConfiguration,
  dataViewElementsButtonsConfiguration: () => dataViewElementsButtonsConfiguration,
  dataViewElementsElementIdDisplayRuleConfiguration: () => dataViewElementsElementIdDisplayRuleConfiguration,
  dataViewElementsLinksConfiguration: () => dataViewElementsLinksConfiguration,
  dataViewElementsSelector: () => dataViewElementsSelector,
  dataViewElementsThumbnailSizeConfiguration: () => dataViewElementsThumbnailSizeConfiguration,
  dataViewElementsTotalCountSelector: () => dataViewElementsTotalCountSelector,
  dataViewElementsVisualAlertConfiguration: () => dataViewElementsVisualAlertConfiguration,
  dataViewFacetsSelector: () => dataViewFacetsSelector,
  dataViewFieldConstructorSelector: () => dataViewFieldConstructorSelector,
  dataViewFieldsConfiguration: () => dataViewFieldsConfiguration,
  dataViewListSize: () => dataViewListSize,
  dataViewMasonryDisplaySize: () => dataViewMasonryDisplaySize,
  dataViewPage: () => dataViewPage,
  dataViewReferencesSelectors: () => dataViewReferencesSelectors,
  dataViewScroll: () => dataViewScroll,
  dataViewSelector: () => dataViewSelector,
  dataViewSize: () => dataViewSize,
  dataViewSort: () => dataViewSort,
  dataViewSortSelector: () => dataViewSortSelector,
  dataViewSortsConfiguration: () => dataViewSortsConfiguration,
  dataviewElementFetcherSelector: () => dataviewElementFetcherSelector,
  dayjs: () => import_dayjs.default,
  directExportNumberLimitSelector: () => directExportNumberLimitSelector,
  downloadBasketAskedAtom: () => downloadBasketAskedAtom,
  downloadManagerDataviewKey: () => downloadManagerDataviewKey,
  downloadManagerOpenState: () => downloadManagerOpenState,
  downloadManagerOpenStatusState: () => downloadManagerOpenStatusState,
  downloadManagerPreferenceFormatByState: () => downloadManagerPreferenceFormatByState,
  downloadManagerPreferenceFormatFavoritesState: () => downloadManagerPreferenceFormatFavoritesState,
  downloadManagerPreferenceLastUsedFormatsState: () => downloadManagerPreferenceLastUsedFormatsState,
  downloadManagerSelectedElementsState: () => downloadManagerSelectedElementsState,
  downloadManagerSelectionSelector: () => downloadManagerSelectionSelector,
  elementFetcherSelector: () => elementFetcherSelector,
  elementIsSelected: () => elementIsSelected,
  elementPermalinkQuerySelector: () => elementPermalinkQuerySelector,
  elementQuerySelector: () => elementQuerySelector,
  elementsSelectionIdState: () => elementsSelectionIdState,
  enablePublicDownloadRequestSelector: () => enablePublicDownloadRequestSelector,
  enableRequestDownloadOnReadOnlySelector: () => enableRequestDownloadOnReadOnlySelector,
  execute: () => execute,
  extractAdvancedFilters: () => extractAdvancedFilters,
  extractFacetFilters: () => extractFacetFilters,
  extractInternalNameFromLink: () => extractInternalNameFromLink,
  extractQueryFilters: () => extractQueryFilters,
  extractQueryFiltersForFieldParameter: () => extractQueryFiltersForFieldParameter,
  fetcherModeAtom: () => fetcherModeAtom,
  fetcherTokenIdAtom: () => fetcherTokenIdAtom,
  fixedFacetsState: () => fixedFacetsState,
  folderHierarchySelector: () => folderHierarchySelector,
  folderHierarchyState: () => folderHierarchyState,
  folderSearchState: () => folderSearchState,
  folderTreeAtom: () => folderTreeAtom,
  folderTreeChildrenList: () => folderTreeChildrenList,
  folderTreeCountMedias: () => folderTreeCountMedias,
  folderTreeSelector: () => folderTreeSelector,
  folderTreesSelector: () => folderTreesSelector,
  forceIsAuthenticated: () => forceIsAuthenticated,
  formAtom: () => formAtom,
  formFetcherSelector: () => formFetcherSelector,
  formQuerySelector: () => formQuerySelector,
  formatFieldsForKpkApi: () => formatFieldsForKpkApi,
  formatSortValueForKpkApi: () => formatSortValueForKpkApi,
  formsQuerySelector: () => formsQuerySelector,
  genericTechProSelector: () => genericTechProSelector,
  getActiveFiltersExceptFolder: () => getActiveFiltersExceptFolder,
  getActiveValues: () => getActiveValues,
  getAdvancedSearchQuery: () => getAdvancedSearchQuery,
  getAllAdvancedSearchCriterias: () => getAllAdvancedSearchCriterias,
  getAxiosInstanceAtom: () => getAxiosInstanceAtom,
  getBasketMediaList: () => getBasketMediaList,
  getBasketSelector: () => getBasketSelector,
  getBusinessFilterFirstValue: () => getBusinessFilterFirstValue,
  getBusinessFilterFullTextValue: () => getBusinessFilterFullTextValue,
  getBusinessFiltersForCurrentLocale: () => getBusinessFiltersForCurrentLocale,
  getChangesToExecute: () => getChangesToExecute,
  getCustomerOverrideComponent: () => getCustomerOverrideComponent,
  getCustomerOverrideFunction: () => getCustomerOverrideFunction,
  getDataViewContentQuery: () => getDataViewContentQuery,
  getDimensionObject: () => getDimensionObject,
  getExtension: () => getExtension,
  getFieldsForApi: () => getFieldsForApi,
  getFieldsToDisplay: () => getFieldsToDisplay,
  getFiltersForCurrentLocale: () => getFiltersForCurrentLocale,
  getFolderSelector: () => getFolderSelector,
  getInternalNameWithoutLocale: () => getInternalNameWithoutLocale,
  getKaliteeChecks: () => getKaliteeChecks,
  getKaliteeGs1: () => getKaliteeGs1,
  getKeycloakConfigurationFromUrl: () => getKeycloakConfigurationFromUrl,
  getKpkFilter: () => getKpkFilter,
  getKpkMetaFieldLabelByFieldName: () => getKpkMetaFieldLabelByFieldName,
  getLastThesaurusTerm: () => getLastThesaurusTerm,
  getLoggerAtom: () => getLoggerAtom,
  getMetamodelType: () => getMetamodelType,
  getParameterByName: () => getParameterByName,
  getSignaturesSelector: () => getSignaturesSelector,
  getTranslatedAndSortedMediaFields: () => getTranslatedAndSortedMediaFields,
  getUserRight: () => getUserRight,
  getUserThumbnailTemplatesSelector: () => getUserThumbnailTemplatesSelector,
  hasActiveValues: () => hasActiveValues,
  hasValidGroupById: () => hasValidGroupById,
  idTokenAtom: () => idTokenAtom,
  idTokenParsedAtom: () => idTokenParsedAtom,
  insertElement: () => insertElement,
  isAdministrator: () => isAdministrator,
  isAuthenticatedLoadingAtom: () => isAuthenticatedLoadingAtom,
  isAuthenticatedQuery: () => isAuthenticatedQuery,
  isAuthenticatedSelector: () => isAuthenticatedSelector,
  isAxiosError: () => isAxiosError,
  isClientSide: () => isClientSide,
  isEmbeddedField: () => isEmbeddedField,
  isKeycloakInitializedAtom: () => isKeycloakInitializedAtom,
  isLogoutInProgressAtom: () => isLogoutInProgressAtom,
  isMaxReachedAnonymous: () => isMaxReachedAnonymous,
  isMediaField: () => isMediaField,
  isMediaLinksField: () => isMediaLinksField,
  isPassedGetDamState: () => isPassedGetDamState,
  isPublicVisitor: () => isPublicVisitor,
  isPublicVisitorState: () => isPublicVisitorState,
  isRightAllowed: () => isRightAllowed,
  isServerSide: () => isServerSide,
  isTechAdministrator: () => isTechAdministrator,
  isVisitor: () => isVisitor,
  isVisitorState: () => isVisitorState,
  keycloak: () => keycloak,
  keycloakInstanceAtom: () => keycloakInstanceAtom,
  keycloakIsAuthenticated: () => keycloakIsAuthenticated,
  keycloakMinValidity: () => keycloakMinValidity,
  localStorageEffect: () => localStorageEffect,
  lookupSelector: () => lookupSelector,
  mapPanelListFilterFromBusinessFilterFilterRecursivly: () => mapPanelListFilterFromBusinessFilterFilterRecursivly,
  massBasketDeleteModalState: () => massBasketDeleteModalState,
  maxElementsByContactSheetSelector: () => maxElementsByContactSheetSelector,
  maxElementsByDownloadSelector: () => maxElementsByDownloadSelector,
  mediaApiPublicShareSelector: () => mediaApiPublicShareSelector,
  mergePermanentFilters: () => mergePermanentFilters,
  mockAxiosGetDam: () => mockAxiosGetDam,
  mockAxiosGetMedia: () => mockAxiosGetMedia,
  mockAxiosGetMediaLabels: () => mockAxiosGetMediaLabels,
  mockAxiosGetMediaPermalinks: () => mockAxiosGetMediaPermalinks,
  mockAxiosGetMediasAdvancedSearch: () => mockAxiosGetMediasAdvancedSearch,
  mockAxiosGetMediasForms: () => mockAxiosGetMediasForms,
  mockAxiosGetSheetFileds: () => mockAxiosGetSheetFileds,
  mockAxiosGetUser: () => mockAxiosGetUser,
  mockAxiosGetUserAssignedGroups: () => mockAxiosGetUserAssignedGroups,
  mockAxiosGetUserThumbnailTemplates: () => mockAxiosGetUserThumbnailTemplates,
  onActiveBusinessFiltersChangeState: () => onActiveBusinessFiltersChangeState,
  openMessagePopup: () => openMessagePopup,
  openPopup: () => openPopup,
  pageMaxSizeSelector: () => pageMaxSizeSelector,
  panelListFiltersSelector: () => panelListFiltersSelector,
  parseNumericParameter: () => parseNumericParameter,
  parseStringParameter: () => parseStringParameter,
  registrationFormUrlPathState: () => registrationFormUrlPathState,
  removeHash: () => removeHash,
  removeLastOccurence: () => removeLastOccurence,
  removeMediaFromBasket: () => removeMediaFromBasket,
  removeQueryStringAndHash: () => removeQueryStringAndHash,
  removeStatsSessionStorageItems: () => removeStatsSessionStorageItems,
  removeUndefinedDeep: () => removeUndefinedDeep,
  searchFoldersApiSelector: () => searchFoldersApiSelector,
  searchFoldersSelector: () => searchFoldersSelector,
  selectAllCurrentSearchSelector: () => selectAllCurrentSearchSelector,
  selectAllCurrentSearchStatusSelector: () => selectAllCurrentSearchStatusSelector,
  selectBasketIdForFetch: () => selectBasketIdForFetch,
  selectedAccessCodeForPublicSharingState: () => selectedAccessCodeForPublicSharingState,
  selectedAttachmentsVisibleForPublicSharingState: () => selectedAttachmentsVisibleForPublicSharingState,
  selectedDeactivationDateForPublicSharingState: () => selectedDeactivationDateForPublicSharingState,
  selectedElements: () => selectedElements,
  selectedElementsFromKeysSelector: () => selectedElementsFromKeysSelector,
  selectedExportDefinitionForPublicSharingState: () => selectedExportDefinitionForPublicSharingState,
  selectedStatusForPublicSharingState: () => selectedStatusForPublicSharingState,
  selectedUnitaryPublicShareExportDefinitionState: () => selectedUnitaryPublicShareExportDefinitionState,
  serializeComplexeParamsForRecoil: () => serializeComplexeParamsForRecoil,
  sessionStorageEffect: () => sessionStorageEffect,
  shareAccessCodeModalState: () => shareAccessCodeModalState,
  shareAccessCodeState: () => shareAccessCodeState,
  shareBasketModalState: () => shareBasketModalState,
  shareBasketsSelector: () => shareBasketsSelector,
  shareManagerConfiguration: () => shareManagerConfiguration,
  shareManagerIsOpenState: () => shareManagerIsOpenState,
  shareManagerSelectionIdQuery: () => shareManagerSelectionIdQuery,
  shareManagerSelectionsIdsSelector: () => shareManagerSelectionsIdsSelector,
  shareManagerSelectionsSelector: () => shareManagerSelectionsSelector,
  shareManagerSelectionsState: () => shareManagerSelectionsState,
  shareTokenAxiosHeadersSelector: () => shareTokenAxiosHeadersSelector,
  shareTokenQuerySelector: () => shareTokenQuerySelector,
  shareUnitaryPublicShareDeactivationDateState: () => shareUnitaryPublicShareDeactivationDateState,
  shareUnitaryPublicShareDownloadLevelState: () => shareUnitaryPublicShareDownloadLevelState,
  shareUnitaryPublicShareEmbedSelector: () => shareUnitaryPublicShareEmbedSelector,
  shareUnitaryPublicShareSelector: () => shareUnitaryPublicShareSelector,
  shareUnitaryPublicShareSizeHeightState: () => shareUnitaryPublicShareSizeHeightState,
  shareUnitaryPublicShareSizeState: () => shareUnitaryPublicShareSizeState,
  shareUnitaryPublicShareSizeWidthState: () => shareUnitaryPublicShareSizeWidthState,
  shareUnitaryPublicSharesSelector: () => shareUnitaryPublicSharesSelector,
  sharedBasketQuerySelector: () => sharedBasketQuerySelector,
  sheetFieldsAtom: () => sheetFieldsAtom,
  sheetFieldsFetcherSelector: () => sheetFieldsFetcherSelector,
  sheetFieldsSelector: () => sheetFieldsSelector,
  shouldClearSelectedElementsByKeysAtom: () => shouldClearSelectedElementsByKeysAtom,
  shouldNotCreateAdvancedId: () => shouldNotCreateAdvancedId,
  shouldRefreshGetAdvancedSearchQuery: () => shouldRefreshGetAdvancedSearchQuery,
  shouldSelectAllInCurrentSearch: () => shouldSelectAllInCurrentSearch,
  shouldUpdateAdvancedSearchId: () => shouldUpdateAdvancedSearchId,
  signaturesFetcherSelector: () => signaturesFetcherSelector,
  statsFolderIdForFolderHit: () => statsFolderIdForFolderHit,
  statsSearchValueForTextAtom: () => statsSearchValueForTextAtom,
  tabLoadingAtom: () => tabLoadingAtom,
  tagsConfigurationAtom: () => tagsConfigurationAtom,
  tagsQuerySelector: () => tagsQuerySelector,
  techProDefaultValue: () => techProDefaultValue,
  techProFetcherSelector: () => techProFetcherSelector,
  thesaurusIdToLoadForBusinessFilterSelector: () => thesaurusIdToLoadForBusinessFilterSelector,
  thumbnailGenerationServiceConfigurationSelector: () => thumbnailGenerationServiceConfigurationSelector,
  toUserRight: () => toUserRight,
  updateIcons: () => updateIcons,
  updateLabels: () => updateLabels,
  updatePublicSharedState: () => updatePublicSharedState,
  updateUnitaryPublicSharedState: () => updateUnitaryPublicSharedState,
  useApiConfig: () => useApiConfig,
  useAuth: () => useAuth,
  useAuthInit: () => useAuthInit,
  useAuthLogin: () => useAuthLogin,
  useAuthLogout: () => useAuthLogout,
  useAuthRefresh: () => useAuthRefresh,
  useBasketAddTo: () => useBasketAddTo,
  useBasketCreate: () => useBasketCreate,
  useBasketDelete: () => useBasketDelete,
  useBasketDownload: () => useBasketDownload,
  useBasketEdit: () => useBasketEdit,
  useBasketInternalAddTo: () => useBasketInternalAddTo,
  useBasketInternalMode: () => useBasketInternalMode,
  useBasketList: () => useBasketList,
  useBasketListPaginated: () => useBasketListPaginated,
  useBasketPageCount: () => useBasketPageCount,
  useBasketRemove: () => useBasketRemove,
  useBasketShare: () => useBasketShare,
  useBasketSynchronization: () => useBasketSynchronization,
  useBasketsDelete: () => useBasketsDelete,
  useBasketsReload: () => useBasketsReload,
  useBounceSearch: () => useBounceSearch,
  useClearSelectionRules: () => useClearSelectionRules,
  useCurrentUi: () => useCurrentUi,
  useCurrentUser: () => useCurrentUser,
  useDataView: () => useDataView,
  useDataViewElement: () => useDataViewElement,
  useDataViewElementButtons: () => useDataViewElementButtons,
  useDataViewElementLinks: () => useDataViewElementLinks,
  useDimensions: () => useDimensions,
  useFilterAdd: () => useFilterAdd,
  useFilterDelete: () => useFilterDelete,
  useFilterReset: () => useFilterReset,
  useFilterUpdate: () => useFilterUpdate,
  useFirstLoginType: () => useFirstLoginType,
  useFolderHierarchy: () => useFolderHierarchy,
  useFolderSearch: () => useFolderSearch,
  useFolderTree: () => useFolderTree,
  useGetTags: () => useGetTags,
  useI18NSorts: () => useI18NSorts,
  useIsAuthenticated: () => useIsAuthenticated,
  useIsVisitor: () => useIsVisitor,
  useKeyboardSelection: () => useKeyboardSelection,
  useLoadableErrorLogger: () => useLoadableErrorLogger,
  useLookup: () => useLookup,
  useOpenCreateBasket: () => useOpenCreateBasket,
  useReference: () => useReference,
  useReset: () => useReset,
  useScrollRestoration: () => useScrollRestoration,
  useSelectAllInAdvancedSearch: () => useSelectAllInAdvancedSearch,
  useShare: () => useShare,
  useShareManager: () => useShareManager,
  useShareManagerActivation: () => useShareManagerActivation,
  useShareManagerExportDefinition: () => useShareManagerExportDefinition,
  useShareManagerOpen: () => useShareManagerOpen,
  useShareManagerSelections: () => useShareManagerSelections,
  useShareToken: () => useShareToken,
  useSheetFields: () => useSheetFields,
  useStats: () => useStats,
  useStatsConnectionHit: () => useStatsConnectionHit,
  useStatsDownloadHit: () => useStatsDownloadHit,
  useStatsQueueListener: () => useStatsQueueListener,
  useStatsQueueSender: () => useStatsQueueSender,
  useStatsSearchHit: () => useStatsSearchHit,
  useStatsViewHit: () => useStatsViewHit,
  useThumbnailGeneratorAllowed: () => useThumbnailGeneratorAllowed,
  useTotalCount: () => useTotalCount,
  useUiByClientId: () => useUiByClientId,
  userHasAttachmentsRights: () => userHasAttachmentsRights,
  userHasDynameekWriteAuthorization: () => userHasDynameekWriteAuthorization,
  userHasImportRights: () => userHasImportRights,
  userHasPublicShare: () => userHasPublicShare,
  userThumbnailTemplatesFetcherSelector: () => userThumbnailTemplatesFetcherSelector,
  validateJSONSchema: () => validateJSONSchema
});
module.exports = __toCommonJS(src_exports);

// src/utils/ssr.ts
function isClientSide() {
  return typeof window !== "undefined";
}
function isServerSide() {
  return !isClientSide();
}

// src/utils/query.ts
function parseNumericParameter(queryParameter) {
  const regexp = /[^0-9]*/g;
  let num;
  if (typeof queryParameter === "string") {
    num = queryParameter;
  } else if (Array.isArray(queryParameter)) {
    num = queryParameter[0];
  }
  if (num == null || !num.match(regexp)) {
    return;
  }
  return parseInt(num);
}
function parseStringParameter(queryParameter) {
  let stringParameter;
  if (typeof queryParameter === "string") {
    stringParameter = queryParameter;
  } else if (Array.isArray(queryParameter)) {
    stringParameter = queryParameter[0];
  }
  return stringParameter;
}
function removeHash(path) {
  const hash = "#";
  if (path.indexOf(hash) > 0) {
    return path.split(hash)[0];
  }
  return path;
}
function removeQueryStringAndHash(path) {
  const queryString = "?";
  if (path.indexOf(queryString) > 0) {
    return removeHash(path.split(queryString)[0]);
  }
  return removeHash(path);
}

// src/utils/json.ts
function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

// src/utils/overrides/getCustomerOverrideFunction.ts
function getCustomerOverrideFunction(overrideFunctionKey, params, customerCommonOverrides) {
  try {
    if (customerCommonOverrides && customerCommonOverrides.function && customerCommonOverrides.function[overrideFunctionKey]) {
      return customerCommonOverrides.function[overrideFunctionKey](params);
    }
  } catch (e) {
    console.info("can't load customer override", e);
  }
  return void 0;
}

// src/utils/overrides/customSelectorInOut.ts
function customSelectorInOut(overrideFunctionKey, params, customerCommonOverrides) {
  const ret = getCustomerOverrideFunction(overrideFunctionKey, params, customerCommonOverrides);
  if (ret !== void 0) {
    return ret;
  } else {
    return params;
  }
}

// src/models/exceptions/mandatory-provider-exception.ts
var MandatoryProviderException = class extends Error {
  constructor(message) {
    super(message);
    this.name = "MandatoryProviderException";
  }
};

// src/models/auth/index.ts
var KCConsumerStatus = /* @__PURE__ */ ((KCConsumerStatus2) => {
  KCConsumerStatus2["Authorized"] = "AUTHORIZED";
  KCConsumerStatus2["Loading"] = "LOADING";
  KCConsumerStatus2["Unauthorized"] = "UNAUTHORIZED";
  return KCConsumerStatus2;
})(KCConsumerStatus || {});
var PageSecurisation = /* @__PURE__ */ ((PageSecurisation2) => {
  PageSecurisation2["None"] = "NONE";
  PageSecurisation2["Full"] = "FULL";
  PageSecurisation2["Hybrid"] = "HYBRID";
  PageSecurisation2["Disable"] = "DISABLE";
  return PageSecurisation2;
})(PageSecurisation || {});
var ID_TOKEN_INVALID_MSG = "Token is invalid";
var ID_TOKEN_EXPIRED_MSG = "Token is expired";
var JWT_TOKEN_IS_EMPTY_MSG = "JWT Token is empty";
var API_NOT_ALLOWED = "API_NOT_ALLOWED";
var ERROR_CODE_QUERY_PARAM = "error_code";

// src/models/overrides/functions/keys.ts
var FunctionOverrideKey = /* @__PURE__ */ ((FunctionOverrideKey2) => {
  FunctionOverrideKey2["OverrideJsonConfig"] = "OverrideJsonConfig";
  FunctionOverrideKey2["ConvertToKpkApiAdvancedSearchFilter"] = "ConvertToKpkApiAdvancedSearchFilter";
  FunctionOverrideKey2["DownloadManagerFormatsQueryIn"] = "DownloadManagerFormatsQueryIn";
  FunctionOverrideKey2["DownloadManagerFormatsQueryOut"] = "DownloadManagerFormatsQueryOut";
  FunctionOverrideKey2["DownloadManagerFormatsOut"] = "DownloadManagerFormatsOut";
  FunctionOverrideKey2["UserAssignedGroupsQueryOut"] = "UserAssignedGroupsQueryOut";
  FunctionOverrideKey2["DataViewElementsIn"] = "DataViewElementsIn";
  FunctionOverrideKey2["DataViewElementsOut"] = "DataViewElementsOut";
  FunctionOverrideKey2["ElementSelectorIn"] = "ElementSelectorIn";
  FunctionOverrideKey2["ElementActions"] = "ElementActions";
  FunctionOverrideKey2["FunctionalFieldsToDisplayQueryOut"] = "FunctionalFieldsToDisplayQueryOut";
  FunctionOverrideKey2["AttachmentsSelectorOut"] = "AttachmentsSelectorOut";
  FunctionOverrideKey2["CustomDomainsToAllow"] = "CustomDomainsToAllow";
  FunctionOverrideKey2["OverrideClassificationStep"] = "OverrideClassificationStep";
  FunctionOverrideKey2["ComponentThesaurusOptionsOut"] = "ComponentThesaurusOptionsOut";
  FunctionOverrideKey2["NeedDidomi"] = "NeedDidomi";
  return FunctionOverrideKey2;
})(FunctionOverrideKey || {});

// src/models/overrides/components/keys.ts
var ComponentAugmentKey = /* @__PURE__ */ ((ComponentAugmentKey2) => {
  ComponentAugmentKey2["ActionsBarLayout"] = "ActionsBarLayout";
  ComponentAugmentKey2["Paginate"] = "Paginate";
  ComponentAugmentKey2["BasketActions"] = "BasketActions";
  ComponentAugmentKey2["FirstLoginOverridable"] = "FirstLoginOverridable";
  ComponentAugmentKey2["MediaDetailHeaderActions"] = "MediaDetailHeaderActions";
  return ComponentAugmentKey2;
})(ComponentAugmentKey || {});
var ComponentOverrideKey = /* @__PURE__ */ ((ComponentOverrideKey2) => {
  ComponentOverrideKey2["ActiveFilters"] = "ActiveFilters";
  ComponentOverrideKey2["ElementCount"] = "ElementCount";
  ComponentOverrideKey2["ElementSummary"] = "ElementSummary";
  ComponentOverrideKey2["KGrid"] = "KGrid";
  ComponentOverrideKey2["Dataview"] = "Dataview";
  ComponentOverrideKey2["MediaDetail"] = "MediaDetail";
  ComponentOverrideKey2["Custom"] = "Custom";
  ComponentOverrideKey2["FilterCheckbox"] = "FilterCheckbox";
  ComponentOverrideKey2["FilterRadio"] = "FilterRadio";
  ComponentOverrideKey2["FilterDate"] = "FilterDate";
  ComponentOverrideKey2["FilterText"] = "FilterText";
  ComponentOverrideKey2["FilterDuration"] = "FilterDuration";
  ComponentOverrideKey2["KTemplates"] = "KTemplates";
  ComponentOverrideKey2["KHead"] = "KHead";
  ComponentOverrideKey2["KScripts"] = "KScripts";
  ComponentOverrideKey2["DetailDownloadButton"] = "DetailDownloadButton";
  return ComponentOverrideKey2;
})(ComponentOverrideKey || {});
var WrapperOverrideKey = /* @__PURE__ */ ((WrapperOverrideKey3) => {
})(WrapperOverrideKey || {});
var PageOverrideKey = /* @__PURE__ */ ((PageOverrideKey2) => {
  PageOverrideKey2["Home"] = "Home";
  PageOverrideKey2["Search"] = "Search";
  PageOverrideKey2["Element"] = "Element";
  PageOverrideKey2["Login"] = "Login";
  PageOverrideKey2["Share"] = "Share";
  PageOverrideKey2["ShareElement"] = "ShareElement";
  PageOverrideKey2["Custom404"] = "Custom404";
  PageOverrideKey2["Baskets"] = "Baskets";
  PageOverrideKey2["BasketElement"] = "BasketElement";
  return PageOverrideKey2;
})(PageOverrideKey || {});
var LayoutOverrideKey = /* @__PURE__ */ ((LayoutOverrideKey2) => {
  LayoutOverrideKey2["LandingPageLayout"] = "LandingPageLayout";
  LayoutOverrideKey2["DefaultLayout"] = "DefaultLayout";
  LayoutOverrideKey2["ShareLayout"] = "ShareLayout";
  return LayoutOverrideKey2;
})(LayoutOverrideKey || {});

// src/models/generics/kpk-attachment.ts
var KpkAttachmentMetaType = /* @__PURE__ */ ((KpkAttachmentMetaType2) => {
  KpkAttachmentMetaType2["Size"] = "SIZE";
  KpkAttachmentMetaType2["Date"] = "DATE";
  return KpkAttachmentMetaType2;
})(KpkAttachmentMetaType || {});
var KpkAttachmentMetaDateType = /* @__PURE__ */ ((KpkAttachmentMetaDateType2) => {
  KpkAttachmentMetaDateType2["Created"] = "CREATED";
  KpkAttachmentMetaDateType2["Updated"] = "UPDATED";
  return KpkAttachmentMetaDateType2;
})(KpkAttachmentMetaDateType || {});

// src/models/generics/kpk-auto-complete.ts
var KpkAutoCompleteType = /* @__PURE__ */ ((KpkAutoCompleteType2) => {
  KpkAutoCompleteType2["Folder"] = "FOLDER";
  KpkAutoCompleteType2["Text"] = "TEXT";
  KpkAutoCompleteType2["Thesaurus"] = "THESAURUS";
  return KpkAutoCompleteType2;
})(KpkAutoCompleteType || {});

// src/models/generics/kpk-filter.ts
var KpkFilterType = /* @__PURE__ */ ((KpkFilterType2) => {
  KpkFilterType2["Date"] = "DATE";
  KpkFilterType2["Text"] = "TEXT";
  KpkFilterType2["Checkbox"] = "CHECKBOX";
  KpkFilterType2["Radio"] = "RADIO";
  KpkFilterType2["RadioFacet"] = "RADIO_FACET";
  KpkFilterType2["Folder"] = "FOLDER";
  KpkFilterType2["Basket"] = "BASKET";
  KpkFilterType2["Duration"] = "DURATION";
  KpkFilterType2["Thesaurus"] = "THESAURUS";
  KpkFilterType2["Associations"] = "ASSOCIATIONS";
  KpkFilterType2["Tags"] = "TAGS";
  return KpkFilterType2;
})(KpkFilterType || {});
var KpkFilterModifierType = /* @__PURE__ */ ((KpkFilterModifierType2) => {
  KpkFilterModifierType2["BeginsWith"] = "BEGINS_WITH";
  KpkFilterModifierType2["ContainsAll"] = "CONTAINS_ALL";
  KpkFilterModifierType2["ContainsNone"] = "CONTAINS_NONE";
  KpkFilterModifierType2["ContainsOne"] = "CONTAINS_ONE";
  KpkFilterModifierType2["DateCurrentMonth"] = "DATE_CURRENT_MONTH";
  KpkFilterModifierType2["DateLast30Days"] = "DATE_LAST_30_DAYS";
  KpkFilterModifierType2["DateLast7Days"] = "DATE_LAST_7_DAYS";
  KpkFilterModifierType2["DateLastMonth"] = "DATE_LAST_MONTH";
  KpkFilterModifierType2["DateToday"] = "DATE_TODAY";
  KpkFilterModifierType2["DateYesterday"] = "DATE_YESTERDAY";
  KpkFilterModifierType2["Empty"] = "EMPTY";
  KpkFilterModifierType2["EndsWith"] = "ENDS_WITH";
  KpkFilterModifierType2["Equals"] = "EQUALS";
  KpkFilterModifierType2["EqualsNoValues"] = "EQUALS_NO_VALUES";
  KpkFilterModifierType2["EqualsOne"] = "EQUALS_ONE";
  KpkFilterModifierType2["FromTo"] = "FROM_TO";
  KpkFilterModifierType2["GroupContainsNone"] = "GROUP_CONTAINS_NONE";
  KpkFilterModifierType2["GroupContainsOne"] = "GROUP_CONTAINS_ONE";
  KpkFilterModifierType2["NotEmpty"] = "NOT_EMPTY";
  return KpkFilterModifierType2;
})(KpkFilterModifierType || {});

// src/models/generics/kpk-media.ts
var MediaType = /* @__PURE__ */ ((MediaType2) => {
  MediaType2[MediaType2["PICTURE"] = 0] = "PICTURE";
  MediaType2[MediaType2["VIDEO"] = 1] = "VIDEO";
  MediaType2[MediaType2["AUDIO"] = 2] = "AUDIO";
  MediaType2[MediaType2["DOCUMENT"] = 3] = "DOCUMENT";
  MediaType2[MediaType2["OTHER"] = 4] = "OTHER";
  MediaType2[MediaType2["RICH_MEDIA"] = 5] = "RICH_MEDIA";
  return MediaType2;
})(MediaType || {});
var KpkMetaFieldType = /* @__PURE__ */ ((KpkMetaFieldType2) => {
  KpkMetaFieldType2["CheckBox"] = "CHECK_BOX";
  KpkMetaFieldType2["Date"] = "DATE";
  KpkMetaFieldType2["Datetime"] = "DATETIME";
  KpkMetaFieldType2["Email"] = "EMAIL";
  KpkMetaFieldType2["FieldSet"] = "FIELD_SET";
  KpkMetaFieldType2["Geo"] = "GEO";
  KpkMetaFieldType2["HTML"] = "HTML";
  KpkMetaFieldType2["MultipleList"] = "MULTIPLE_LIST";
  KpkMetaFieldType2["Number"] = "NUMBER";
  KpkMetaFieldType2["PersonList"] = "PERSON_LIST";
  KpkMetaFieldType2["SimpleList"] = "SIMPLE_LIST";
  KpkMetaFieldType2["Text"] = "TEXT";
  KpkMetaFieldType2["TextArea"] = "TEXT_AREA";
  KpkMetaFieldType2["Thesaurus"] = "THESAURUS";
  KpkMetaFieldType2["URL"] = "URL";
  KpkMetaFieldType2["Folder"] = "FOLDER";
  return KpkMetaFieldType2;
})(KpkMetaFieldType || {});

// src/models/search/dataView.ts
var DataViewKey = /* @__PURE__ */ ((DataViewKey8) => {
  DataViewKey8["SEARCH"] = "search";
  DataViewKey8["BASKET"] = "basket";
  DataViewKey8["BASKET_DETAIL"] = "basket-detail";
  DataViewKey8["ASSOCIATION"] = "association";
  DataViewKey8["REPORT"] = "report";
  return DataViewKey8;
})(DataViewKey || {});

// src/models/search/filters.ts
var BusinessFilterNature = /* @__PURE__ */ ((BusinessFilterNature2) => {
  BusinessFilterNature2["FULL_TEXT"] = "FULL_TEXT";
  BusinessFilterNature2["ADVANCED"] = "ADVANCED";
  BusinessFilterNature2["FACET"] = "FACET";
  BusinessFilterNature2["FACET_MULTI"] = "FACET_MULTI";
  BusinessFilterNature2["BASKET"] = "BASKET";
  BusinessFilterNature2["ASSOCIATIONS"] = "ASSOCIATIONS";
  return BusinessFilterNature2;
})(BusinessFilterNature || {});

// src/models/user/index.ts
var UserRight = /* @__PURE__ */ ((UserRight2) => {
  UserRight2[UserRight2["VISITOR"] = 0] = "VISITOR";
  UserRight2[UserRight2["PUBLIC_VISITOR"] = 1] = "PUBLIC_VISITOR";
  UserRight2[UserRight2["ADMINISTRATOR"] = 2] = "ADMINISTRATOR";
  UserRight2[UserRight2["TECH_ADMINISTRATOR"] = 3] = "TECH_ADMINISTRATOR";
  return UserRight2;
})(UserRight || {});

// src/models/import/index.ts
var ImportStatus = /* @__PURE__ */ ((ImportStatus2) => {
  ImportStatus2["ADDED"] = "Added";
  ImportStatus2["UPLOADING"] = "Uploading";
  ImportStatus2["CANCELED"] = "Canceled";
  ImportStatus2["ERROR"] = "Error";
  ImportStatus2["SUCCESS"] = "Success";
  return ImportStatus2;
})(ImportStatus || {});

// src/models/firstLogin/index.ts
var FIRST_LOGIN_TYPE = /* @__PURE__ */ ((FIRST_LOGIN_TYPE2) => {
  FIRST_LOGIN_TYPE2["NONE"] = "NONE";
  FIRST_LOGIN_TYPE2["PASS"] = "PASS";
  FIRST_LOGIN_TYPE2["PENDING"] = "PENDING";
  FIRST_LOGIN_TYPE2["NOT_AUTHORIZED_WITH_FORM"] = "NOT_AUTHORIZED_WITH_FORM";
  FIRST_LOGIN_TYPE2["NOT_AUTHORIZED_WITHOUT_FORM"] = "NOT_AUTHORIZED_WITHOUT_FORM";
  FIRST_LOGIN_TYPE2["ERROR"] = "ERROR";
  FIRST_LOGIN_TYPE2["GDPR_VALIDATION"] = "GDPR_VALIDATION";
  FIRST_LOGIN_TYPE2["CUSTOM"] = "CUSTOM";
  return FIRST_LOGIN_TYPE2;
})(FIRST_LOGIN_TYPE || {});
var FIRST_LOGIN_TYPE_QUERY_PARAM = "first_login_type";
var REGISTRATION_FORM_URL = /* @__PURE__ */ ((REGISTRATION_FORM_URL3) => {
  REGISTRATION_FORM_URL3["DEV"] = "https://registration.ci.keepeek-dev.com/";
  REGISTRATION_FORM_URL3["PROD"] = "https://registration.keepeek.com/";
  REGISTRATION_FORM_URL3["PROD_OFFLINE"] = "https://offline-registration.keepeek.com/";
  return REGISTRATION_FORM_URL3;
})(REGISTRATION_FORM_URL || {});

// src/models/techPro/thumbnail-generation-service-configuration.ts
var ThumbnailGenerationSourceMediaModeEnum = /* @__PURE__ */ ((ThumbnailGenerationSourceMediaModeEnum2) => {
  ThumbnailGenerationSourceMediaModeEnum2["DIRECT"] = "direct";
  ThumbnailGenerationSourceMediaModeEnum2["PERMALINK"] = "permalink";
  return ThumbnailGenerationSourceMediaModeEnum2;
})(ThumbnailGenerationSourceMediaModeEnum || {});
var ThumbnailGenerationSourceMediaFormatEnum = /* @__PURE__ */ ((ThumbnailGenerationSourceMediaFormatEnum2) => {
  ThumbnailGenerationSourceMediaFormatEnum2["UHD"] = "uhd";
  ThumbnailGenerationSourceMediaFormatEnum2["WHR"] = "whr";
  return ThumbnailGenerationSourceMediaFormatEnum2;
})(ThumbnailGenerationSourceMediaFormatEnum || {});

// src/models/dataView/index.ts
var ActionValue = /* @__PURE__ */ ((ActionValue2) => {
  ActionValue2["DOWNLOAD"] = "download";
  ActionValue2["DOWNLOAD_CONTACT_SHEET"] = "downloadContactSheet";
  ActionValue2["CONTACT_SHEETS"] = "contactSheets";
  ActionValue2["ADD_TO_BASKET"] = "addSelectionToBasket";
  ActionValue2["OPEN_ELEMENT"] = "openElement";
  ActionValue2["DELETE_BASKET"] = "deleteBasket";
  ActionValue2["EDIT_BASKET"] = "editBasket";
  ActionValue2["REMOVE_FROM_BASKET"] = "removeFromBasket";
  ActionValue2["CLEAR_BASKET"] = "clearBasket";
  ActionValue2["SELECT_ALL"] = "selectAll";
  ActionValue2["UNSELECT_ALL"] = "unselectAll";
  ActionValue2["SHARE"] = "share";
  ActionValue2["SHOW_ATTACHMENT"] = "showAttachment";
  ActionValue2["INSERT"] = "insert";
  ActionValue2["SHOW_THUMBNAIL_GENERATOR"] = "showThumbnailGenerator";
  return ActionValue2;
})(ActionValue || {});
var DataViewElementsAuthorizedIcon = /* @__PURE__ */ ((DataViewElementsAuthorizedIcon3) => {
  DataViewElementsAuthorizedIcon3["VIDEO"] = "video";
  DataViewElementsAuthorizedIcon3["IMAGE"] = "image";
  DataViewElementsAuthorizedIcon3["PDF"] = "pdf";
  DataViewElementsAuthorizedIcon3["AUDIO"] = "audio";
  return DataViewElementsAuthorizedIcon3;
})(DataViewElementsAuthorizedIcon || {});
var DataViewElementsThumbnailSize = /* @__PURE__ */ ((DataViewElementsThumbnailSize3) => {
  DataViewElementsThumbnailSize3["CONTAIN"] = "contain";
  DataViewElementsThumbnailSize3["COVER"] = "cover";
  return DataViewElementsThumbnailSize3;
})(DataViewElementsThumbnailSize || {});

// src/models/downloadManager/index.ts
var DOWNLOAD_MANAGER_FORMAT_BY = /* @__PURE__ */ ((DOWNLOAD_MANAGER_FORMAT_BY2) => {
  DOWNLOAD_MANAGER_FORMAT_BY2[DOWNLOAD_MANAGER_FORMAT_BY2["TYPE"] = 0] = "TYPE";
  DOWNLOAD_MANAGER_FORMAT_BY2[DOWNLOAD_MANAGER_FORMAT_BY2["ELEMENT"] = 1] = "ELEMENT";
  DOWNLOAD_MANAGER_FORMAT_BY2[DOWNLOAD_MANAGER_FORMAT_BY2["OTHER"] = 2] = "OTHER";
  return DOWNLOAD_MANAGER_FORMAT_BY2;
})(DOWNLOAD_MANAGER_FORMAT_BY || {});

// src/models/shareManager/index.ts
var ShareManagerSelectionType = /* @__PURE__ */ ((ShareManagerSelectionType2) => {
  ShareManagerSelectionType2["UNITARY_PUBLIC_SHARE"] = "UNITARY_PUBLIC_SHARE";
  ShareManagerSelectionType2["BASKET"] = "BASKET";
  return ShareManagerSelectionType2;
})(ShareManagerSelectionType || {});

// src/models/visualAlert/index.ts
var VisualAlertDateTargetMode = /* @__PURE__ */ ((VisualAlertDateTargetMode2) => {
  VisualAlertDateTargetMode2["ExpireWithin"] = "EXPIRE_WITHIN";
  VisualAlertDateTargetMode2["ExpiredSince"] = "EXPIRED_SINCE";
  VisualAlertDateTargetMode2["ExpiredSinceLessThan"] = "EXPIRED_SINCE_LESS_THAN";
  return VisualAlertDateTargetMode2;
})(VisualAlertDateTargetMode || {});
var VisualAlertDateTargetUnit = /* @__PURE__ */ ((VisualAlertDateTargetUnit2) => {
  VisualAlertDateTargetUnit2["Days"] = "DAYS";
  VisualAlertDateTargetUnit2["Months"] = "MONTHS";
  VisualAlertDateTargetUnit2["Years"] = "YEARS";
  return VisualAlertDateTargetUnit2;
})(VisualAlertDateTargetUnit || {});
var VisualAlertPosition = /* @__PURE__ */ ((VisualAlertPosition2) => {
  VisualAlertPosition2["BottomLeft"] = "BOTTOM_LEFT";
  VisualAlertPosition2["BottomRight"] = "BOTTOM_RIGHT";
  VisualAlertPosition2["TopLeft"] = "TOP_LEFT";
  VisualAlertPosition2["TopRight"] = "TOP_RIGHT";
  return VisualAlertPosition2;
})(VisualAlertPosition || {});
var VisualAlertFieldType = /* @__PURE__ */ ((VisualAlertFieldType2) => {
  VisualAlertFieldType2["Date"] = "DATE";
  VisualAlertFieldType2["SubStatus"] = "SUB_STATUS";
  return VisualAlertFieldType2;
})(VisualAlertFieldType || {});

// src/models/configuration/index.ts
var DataviewDisplayModes = /* @__PURE__ */ ((DataviewDisplayModes2) => {
  DataviewDisplayModes2["List"] = "list";
  DataviewDisplayModes2["Masonry"] = "masonry";
  DataviewDisplayModes2["Mosaic"] = "mosaic";
  return DataviewDisplayModes2;
})(DataviewDisplayModes || {});
var MetamodelTypeEnum = /* @__PURE__ */ ((MetamodelTypeEnum2) => {
  MetamodelTypeEnum2["Document"] = "DOCUMENT";
  MetamodelTypeEnum2["Other"] = "OTHER";
  MetamodelTypeEnum2["Picture"] = "PICTURE";
  MetamodelTypeEnum2["Sound"] = "SOUND";
  MetamodelTypeEnum2["Video"] = "VIDEO";
  return MetamodelTypeEnum2;
})(MetamodelTypeEnum || {});
var Direction = /* @__PURE__ */ ((Direction2) => {
  Direction2["Asc"] = "ASC";
  Direction2["Desc"] = "DESC";
  return Direction2;
})(Direction || {});
var OrderTypeFacetValues = /* @__PURE__ */ ((OrderTypeFacetValues2) => {
  OrderTypeFacetValues2["Alphabetic"] = "alphabetic";
  OrderTypeFacetValues2["Occurrences"] = "occurrences";
  return OrderTypeFacetValues2;
})(OrderTypeFacetValues || {});
var FilterType = /* @__PURE__ */ ((FilterType2) => {
  FilterType2["Advanced"] = "advanced";
  FilterType2["Facet"] = "facet";
  FilterType2["FacetMulti"] = "facet-multi";
  return FilterType2;
})(FilterType || {});
var Language = /* @__PURE__ */ ((Language2) => {
  Language2["De"] = "de";
  Language2["En"] = "en";
  Language2["Es"] = "es";
  Language2["Fr"] = "fr";
  Language2["Hu"] = "hu";
  Language2["It"] = "it";
  Language2["Nl"] = "nl";
  Language2["Pl"] = "pl";
  Language2["Pt"] = "pt";
  Language2["Ro"] = "ro";
  return Language2;
})(Language || {});
var FieldType = /* @__PURE__ */ ((FieldType2) => {
  FieldType2["Mediafield"] = "MEDIAFIELD";
  FieldType2["Metafield"] = "METAFIELD";
  return FieldType2;
})(FieldType || {});
var Modifier = /* @__PURE__ */ ((Modifier2) => {
  Modifier2["BeginsWith"] = "BEGINS_WITH";
  Modifier2["ContainsAll"] = "CONTAINS_ALL";
  Modifier2["ContainsNone"] = "CONTAINS_NONE";
  Modifier2["ContainsOne"] = "CONTAINS_ONE";
  Modifier2["DateCurrentMonth"] = "DATE_CURRENT_MONTH";
  Modifier2["DateFromToUpcomingDays"] = "DATE_FROM_TO_UPCOMING_DAYS";
  Modifier2["DateFromToUpcomingDaysOrEmpty"] = "DATE_FROM_TO_UPCOMING_DAYS_OR_EMPTY";
  Modifier2["DateLast30_Days"] = "DATE_LAST_30_DAYS";
  Modifier2["DateLast7_Days"] = "DATE_LAST_7_DAYS";
  Modifier2["DateLastMonth"] = "DATE_LAST_MONTH";
  Modifier2["DateToday"] = "DATE_TODAY";
  Modifier2["DateYesterday"] = "DATE_YESTERDAY";
  Modifier2["Empty"] = "EMPTY";
  Modifier2["EndsWith"] = "ENDS_WITH";
  Modifier2["Equals"] = "EQUALS";
  Modifier2["EqualsNoValues"] = "EQUALS_NO_VALUES";
  Modifier2["EqualsOne"] = "EQUALS_ONE";
  Modifier2["FromTo"] = "FROM_TO";
  Modifier2["GroupContainsNone"] = "GROUP_CONTAINS_NONE";
  Modifier2["GroupContainsOne"] = "GROUP_CONTAINS_ONE";
  Modifier2["NotEmpty"] = "NOT_EMPTY";
  return Modifier2;
})(Modifier || {});
var PermanentFilterType = /* @__PURE__ */ ((PermanentFilterType2) => {
  PermanentFilterType2["Associationsfield"] = "ASSOCIATIONSFIELD";
  PermanentFilterType2["Checkboxfield"] = "CHECKBOXFIELD";
  PermanentFilterType2["Datefield"] = "DATEFIELD";
  PermanentFilterType2["Datetimefield"] = "DATETIMEFIELD";
  PermanentFilterType2["Emailfield"] = "EMAILFIELD";
  PermanentFilterType2["Extensionfield"] = "EXTENSIONFIELD";
  PermanentFilterType2["Filesizefield"] = "FILESIZEFIELD";
  PermanentFilterType2["Folderfield"] = "FOLDERFIELD";
  PermanentFilterType2["Geofield"] = "GEOFIELD";
  PermanentFilterType2["Htmlfield"] = "HTMLFIELD";
  PermanentFilterType2["Listfield"] = "LISTFIELD";
  PermanentFilterType2["Metamodelfield"] = "METAMODELFIELD";
  PermanentFilterType2["Metamodeltypefield"] = "METAMODELTYPEFIELD";
  PermanentFilterType2["Multiplelistfield"] = "MULTIPLELISTFIELD";
  PermanentFilterType2["Numberfield"] = "NUMBERFIELD";
  PermanentFilterType2["Personsfield"] = "PERSONSFIELD";
  PermanentFilterType2["Socialnetworksfield"] = "SOCIALNETWORKSFIELD";
  PermanentFilterType2["Statusfield"] = "STATUSFIELD";
  PermanentFilterType2["Tagsfield"] = "TAGSFIELD";
  PermanentFilterType2["Textarea"] = "TEXTAREA";
  PermanentFilterType2["Textfield"] = "TEXTFIELD";
  PermanentFilterType2["Thesaurusfield"] = "THESAURUSFIELD";
  PermanentFilterType2["Unknonwfield"] = "UNKNONWFIELD";
  PermanentFilterType2["Urlfield"] = "URLFIELD";
  PermanentFilterType2["Usersfield"] = "USERSFIELD";
  return PermanentFilterType2;
})(PermanentFilterType || {});
var Position = /* @__PURE__ */ ((Position2) => {
  Position2["BottomLeft"] = "BOTTOM_LEFT";
  Position2["BottomRight"] = "BOTTOM_RIGHT";
  Position2["TopLeft"] = "TOP_LEFT";
  Position2["TopRight"] = "TOP_RIGHT";
  return Position2;
})(Position || {});

// src/models/basket/index.ts
var BasketUserType = /* @__PURE__ */ ((BasketUserType2) => {
  BasketUserType2["Administrator"] = "ADMINISTRATOR";
  BasketUserType2["All"] = "ALL";
  BasketUserType2["Manager"] = "MANAGER";
  BasketUserType2["PublicVisitor"] = "PUBLIC_VISITOR";
  BasketUserType2["Visitor"] = "VISITOR";
  BasketUserType2["Writer"] = "WRITER";
  return BasketUserType2;
})(BasketUserType || {});
var BasketSortDirection = /* @__PURE__ */ ((BasketSortDirection2) => {
  BasketSortDirection2["ASC"] = "asc";
  BasketSortDirection2["DSC"] = "desc";
  return BasketSortDirection2;
})(BasketSortDirection || {});
var BasketsSort = /* @__PURE__ */ ((BasketsSort2) => {
  BasketsSort2["Title"] = "title";
  BasketsSort2["CreationDate"] = "creationDate";
  BasketsSort2["UpdateDate"] = "updateDate";
  return BasketsSort2;
})(BasketsSort || {});

// src/utils/overrides/getCustomerOverrideComponent.ts
var Noop = function() {
  return null;
};
var getCustomerOverrideComponent = function(overrideKey, defaultComponent = Noop, customerCommonOverrides) {
  let overrideComponent;
  try {
    if (!customerCommonOverrides) {
      return defaultComponent;
    }
    if (isPageOverrideKey(overrideKey) && customerCommonOverrides.page && customerCommonOverrides.page[overrideKey]) {
      overrideComponent = customerCommonOverrides.page[overrideKey];
    } else if (isLayoutOverrideKey(overrideKey) && customerCommonOverrides.layout && customerCommonOverrides.layout[overrideKey]) {
      overrideComponent = customerCommonOverrides.layout[overrideKey];
    } else if (isComponentOverrideKey(overrideKey) && customerCommonOverrides.component && customerCommonOverrides.component[overrideKey]) {
      overrideComponent = customerCommonOverrides.component[overrideKey];
      overrideComponent = customerCommonOverrides.component[overrideKey];
    }
  } catch (e) {
    console.info("can't load customer override", e);
  }
  return overrideComponent || defaultComponent;
};
var isPageOverrideKey = function(overrideKey) {
  return Object.values(PageOverrideKey).includes(overrideKey);
};
var isLayoutOverrideKey = function(overrideKey) {
  return Object.values(LayoutOverrideKey).includes(overrideKey);
};
var isComponentOverrideKey = function(overrideKey) {
  return Object.values(ComponentOverrideKey).includes(overrideKey);
};

// src/utils/arrays.ts
function removeUndefinedDeep(obj) {
  if (Array.isArray(obj)) {
    return obj.map((item) => removeUndefinedDeep(item)).filter((item) => item !== void 0);
  } else if (typeof obj === "object" && obj !== null) {
    return Object.keys(obj).reduce((acc, key2) => {
      const value = removeUndefinedDeep(obj[key2]);
      if (value !== void 0) {
        acc[key2] = value;
      }
      return acc;
    }, {});
  } else {
    return obj;
  }
}

// src/utils/field.ts
var import_api_client = require("@keepeek/api-client");
var import_compact = __toESM(require("lodash/compact"));
var import_react_i18next = require("react-i18next");
var MediaField = /* @__PURE__ */ ((MediaField2) => {
  MediaField2["ID"] = "id";
  MediaField2["STATUS"] = "status";
  MediaField2["PERMISSION"] = "permission";
  MediaField2["ANNOTATION"] = "annotation";
  MediaField2["WIDTH"] = "width";
  MediaField2["HEIGHT"] = "height";
  MediaField2["RESOLUTION"] = "resolution";
  MediaField2["MEDIA_TYPE"] = "mediaType";
  MediaField2["FILE_SIZE"] = "fileSize";
  MediaField2["FILE_SIZE_STRING"] = "fileSizeString";
  MediaField2["ORIGINAL_FILE_NAME"] = "originalFileName";
  MediaField2["CREATION_DATE"] = "creationDate";
  MediaField2["UPDATE_DATE"] = "updateDate";
  MediaField2["IMPORT_DATE"] = "importDate";
  MediaField2["TRASH_DATE"] = "trashDate";
  MediaField2["DURATION"] = "duration";
  MediaField2["DURATION_IN_SECONDS"] = "durationInSeconds";
  MediaField2["PAGE_COUNT"] = "pageCount";
  MediaField2["COLORSPACE"] = "colorSpace";
  MediaField2["LATITUDE"] = "latitude";
  MediaField2["LONGITUDE"] = "longitude";
  MediaField2["ADDRESS"] = "address";
  MediaField2["DUPLICATION_STATUS"] = "duplicationStatus";
  MediaField2["THUMBNAIL_GENERATION_STATUS"] = "thumbnailGenerationStatus";
  MediaField2["XMP_SPHERICAL"] = "xmpSpherical";
  MediaField2["XMP_SPHERICAL_STEREO_MODE"] = "xmpSphericalStereoMode";
  MediaField2["XMP_SPHERICAL_PROJECTION_TYPE"] = "xmpSphericalProjectionType";
  MediaField2["CHECKSUMS"] = "checkSums";
  MediaField2["FOLDER_ID"] = "folderId";
  MediaField2["EXTENSION"] = "extension";
  MediaField2["META_MODEL_TYPE"] = "metaModelType";
  MediaField2["META_MODEL_ID"] = "metamodelId";
  MediaField2["PROVIDER_NAME"] = "richMediaInformation.providerName";
  MediaField2["ORIENTATION"] = "orientation";
  MediaField2["SUB_STATUS_ID"] = "subStatusId";
  MediaField2["ATTACHMENT_COUNTS"] = "attachmentCounts";
  MediaField2["MEDIA_LINK_COUNT"] = "mediaLinkCount";
  MediaField2["DOWNLOAD_LEVEL"] = "downloadLevel";
  MediaField2["STATUS_UPDATE_DATE"] = "statusUpdateDate";
  MediaField2["TAGS_IN_MEDIA"] = "tagsInMedia";
  return MediaField2;
})(MediaField || {});
var MediaFieldCompatibleFacet = [
  "status" /* STATUS */,
  "folderId" /* FOLDER_ID */,
  "extension" /* EXTENSION */,
  "metaModelType" /* META_MODEL_TYPE */,
  "metamodelId" /* META_MODEL_ID */,
  "orientation" /* ORIENTATION */,
  "subStatusId" /* SUB_STATUS_ID */
];
var MediaFieldCompatibleFacetMulti = ["extension" /* EXTENSION */];
var MediaFieldCompatibleAdvancedSearch = [
  "originalFileName" /* ORIGINAL_FILE_NAME */,
  "creationDate" /* CREATION_DATE */,
  "updateDate" /* UPDATE_DATE */,
  "importDate" /* IMPORT_DATE */,
  "statusUpdateDate" /* STATUS_UPDATE_DATE */,
  "duration" /* DURATION */,
  "extension" /* EXTENSION */,
  "tagsInMedia" /* TAGS_IN_MEDIA */
];
var convertToKpkMetaFieldType = (kpkApiSheetFieldType) => {
  switch (kpkApiSheetFieldType) {
    case import_api_client.KpkApiSheetFieldType.Date:
      return "DATE" /* Date */;
    case import_api_client.KpkApiSheetFieldType.Datetime:
      return "DATETIME" /* Datetime */;
    case import_api_client.KpkApiSheetFieldType.Thesaurus:
      return "THESAURUS" /* Thesaurus */;
    case import_api_client.KpkApiSheetFieldType.CheckBox:
      return "CHECK_BOX" /* CheckBox */;
    case import_api_client.KpkApiSheetFieldType.Email:
      return "EMAIL" /* Email */;
    case import_api_client.KpkApiSheetFieldType.Geo:
      return "GEO" /* Geo */;
    case import_api_client.KpkApiSheetFieldType.HTML:
      return "HTML" /* HTML */;
    case import_api_client.KpkApiSheetFieldType.MultipleList:
      return "MULTIPLE_LIST" /* MultipleList */;
    case import_api_client.KpkApiSheetFieldType.Number:
      return "NUMBER" /* Number */;
    case import_api_client.KpkApiSheetFieldType.PersonList:
      return "PERSON_LIST" /* PersonList */;
    case import_api_client.KpkApiSheetFieldType.SimpleList:
      return "SIMPLE_LIST" /* SimpleList */;
    case import_api_client.KpkApiSheetFieldType.Text:
      return "TEXT" /* Text */;
    case import_api_client.KpkApiSheetFieldType.TextArea:
      return "TEXT_AREA" /* TextArea */;
    case import_api_client.KpkApiSheetFieldType.URL:
      return "URL" /* URL */;
    default:
      return "TEXT" /* Text */;
  }
};
var convertToKpkMedia = (forms, kpkApiMedia, kpkApiSheetFields, permalinks, thumbnail = ThumbnailType.XLARGE, allTags) => {
  if (kpkApiMedia.id !== void 0 && kpkApiMedia._links !== void 0) {
    let previewThumbnail = kpkApiMedia._links[`kpk:${thumbnail}`];
    if (!previewThumbnail) {
      previewThumbnail = kpkApiMedia._links[MediaLinksField.XLARGE];
    }
    const previewPdfUrl = getPreviewPdfUrl(kpkApiMedia, forms);
    const kpkMedia = {
      id: kpkApiMedia.id,
      title: convertToKpkMetaField(kpkApiMedia, kpkApiSheetFields, MetaField.TITLE),
      originalFileName: kpkApiMedia?.originalFileName ?? "",
      previewUrl: previewThumbnail?.href ?? "",
      fields: convertToKpkMetaFields(kpkApiMedia, kpkApiSheetFields),
      formId: convertMediaLinkForm(kpkApiMedia),
      subStatusId: convertMediaLinkSubStatus(kpkApiMedia),
      folders: convertMediaFolders(kpkApiMedia),
      mediaType: kpkApiMedia.mediaType || "",
      formType: convertToMediaType(kpkApiMedia, forms, previewPdfUrl),
      downloadLevel: kpkApiMedia.downloadLevel,
      hiresUrl: kpkApiMedia._links[`kpk:hires`]?.href || null,
      pointOfInterest: kpkApiMedia.pointOfInterest
    };
    if (previewPdfUrl) {
      kpkMedia.previewPdfUrl = previewPdfUrl;
    }
    const previewAudioUrl = getPreviewAudioUrl(kpkApiMedia, forms);
    if (previewAudioUrl) {
      kpkMedia.previewAudioUrl = previewAudioUrl;
    }
    kpkMedia.attachmentCounts = kpkApiMedia.attachmentCounts;
    kpkMedia.mediaLinkCount = kpkApiMedia.mediaLinkCount;
    kpkMedia.permalinks = permalinks && permalinks.length > 0 ? permalinks.map((permalink) => {
      return {
        id: permalink.id,
        title: permalink.title,
        description: permalink.description,
        url: permalink && permalink._links ? permalink._links["latest-version"].href : null
      };
    }) : void 0;
    kpkMedia.labels = kpkApiMedia._embedded?.label && kpkApiMedia._embedded?.label.length > 0 ? (0, import_compact.default)(
      kpkApiMedia._embedded?.label.map((label) => {
        const foundedTag = allTags?.find((l) => Number(l.id) === Number(label.id));
        if (!foundedTag) {
          return;
        }
        return {
          id: foundedTag.id,
          name: foundedTag.name,
          backgroundColor: foundedTag.backgroundColor,
          textColor: foundedTag.textColor
        };
      })
    ) : void 0;
    return kpkMedia;
  } else {
    console.error(`kpkApiMedia do not contains mandatory field`);
    throw new Error(`kpkApiMedia do not contains mandatory field`);
  }
};
var ThumbnailType = /* @__PURE__ */ ((ThumbnailType2) => {
  ThumbnailType2["XLARGE"] = "xlarge";
  ThumbnailType2["WHR"] = "whr";
  return ThumbnailType2;
})(ThumbnailType || {});
var MediaLinksField = /* @__PURE__ */ ((MediaLinksField2) => {
  MediaLinksField2["FORM"] = "kpk:form";
  MediaLinksField2["SUB_STATUS"] = "kpk:custom-status";
  MediaLinksField2["PREVIEW"] = "preview";
  MediaLinksField2["WHR"] = "kpk:whr";
  MediaLinksField2["SMALL"] = "kpk:small";
  MediaLinksField2["MEDIUM"] = "kpk:medium";
  MediaLinksField2["LARGE"] = "kpk:large";
  MediaLinksField2["XLARGE"] = "kpk:xlarge";
  MediaLinksField2["IMAGES_KPK"] = "kpk:images-service-url";
  MediaLinksField2["IMAGES_KPKP"] = "kpk:images-service-permalink";
  return MediaLinksField2;
})(MediaLinksField || {});
var EmbeddedMediaField = /* @__PURE__ */ ((EmbeddedMediaField2) => {
  EmbeddedMediaField2["ATTACHMENT"] = "attachments";
  EmbeddedMediaField2["FOLDERS"] = "folders";
  EmbeddedMediaField2["LABEL"] = "label";
  return EmbeddedMediaField2;
})(EmbeddedMediaField || {});
var mediaFieldSet = new Set(Object.values(MediaField));
function isMediaField(fieldName) {
  return mediaFieldSet.has(fieldName);
}
function isMediaLinksField(fieldName) {
  return Object.values(MediaLinksField).includes(fieldName);
}
function isEmbeddedField(fieldName) {
  return Object.values(EmbeddedMediaField).includes(fieldName);
}
var convertToKpkMetaFields = (kpkApiMedia, kpkApiSheetFields) => {
  const ret = [];
  Object.values(MediaField).forEach((field) => {
    switch (field) {
      case "folderId" /* FOLDER_ID */:
        break;
      case "checkSums" /* CHECKSUMS */:
        const checkSumsValue = kpkApiMedia["checkSums" /* CHECKSUMS */]?.md5;
        if (checkSumsValue) {
          ret.push({
            id: "checkSums" /* CHECKSUMS */,
            type: "TEXT" /* Text */,
            name: "checkSums" /* CHECKSUMS */,
            value: checkSumsValue
          });
        }
        break;
      case "extension" /* EXTENSION */:
        const extensionValue = kpkApiMedia.originalFileName?.split(".");
        const extension = extensionValue?.[extensionValue?.length - 1] ?? "";
        ret.push({
          id: "extension" /* EXTENSION */,
          type: "TEXT" /* Text */,
          name: "extension" /* EXTENSION */,
          value: extension
        });
        break;
      case "attachmentCounts" /* ATTACHMENT_COUNTS */:
        const attachmentCounts = kpkApiMedia.attachmentCounts?.online || 0;
        ret.push({
          id: "attachmentCounts" /* ATTACHMENT_COUNTS */,
          type: "NUMBER" /* Number */,
          name: (0, import_react_i18next.getI18n)().t(`mediafield_attachmentCounts`, {
            ns: "refront-components"
          }),
          value: attachmentCounts.toString()
        });
        break;
      case "orientation" /* ORIENTATION */:
        const orientation = kpkApiMedia.orientation || "";
        ret.push({
          id: "orientation" /* ORIENTATION */,
          type: "TEXT" /* Text */,
          name: (0, import_react_i18next.getI18n)().t(`mediafield_orientation`, {
            ns: "refront-components"
          }),
          value: (0, import_react_i18next.getI18n)().t(`components.orientation.${orientation.toLowerCase()}`, {
            ns: "refront-components"
          })
        });
        break;
      default:
        ret.push(convertToKpkMetaField(kpkApiMedia, kpkApiSheetFields, field));
        break;
    }
  });
  kpkApiMedia._embedded?.metadata?.forEach((metadata) => {
    if (metadata.id) {
      ret.push(convertToKpkMetaField(kpkApiMedia, kpkApiSheetFields, metadata.id));
    }
  });
  return ret;
};
var convertToKpkMetaField = (kpkApiMedia, kpkApiSheetFields, fieldName) => {
  if (isMediaField(fieldName)) {
    const cast = fieldName;
    return {
      id: cast,
      type: getKpkMetaFieldTypeByFieldName(kpkApiSheetFields, cast),
      name: (0, import_react_i18next.getI18n)().t(`mediafield_${cast}`, {
        ns: "refront-components"
      }),
      value: kpkApiMedia?.[cast]?.toString() ?? ""
    };
  } else {
    const metadata = getMetadataValueById(
      fieldName,
      kpkApiMedia._embedded?.metadata || []
    );
    const type = getKpkMetaFieldTypeByFieldName(kpkApiSheetFields, fieldName);
    let value;
    const descriptionByValue = {};
    let valueMapping;
    if (type === "THESAURUS" /* Thesaurus */) {
      value = metadata?._embedded?.value?.map((thesaurus) => thesaurus.title || "") || [];
      valueMapping = metadata?._embedded?.value?.map((v) => {
        return { title: v.title || "", id: v.id || -1 };
      });
      metadata?._embedded?.value?.forEach((thesaurus) => {
        if (thesaurus.title && thesaurus.description) {
          descriptionByValue[thesaurus.title] = thesaurus.description;
        }
      });
    } else if (type === "MULTIPLE_LIST" /* MultipleList */) {
      value = metadata?.value?.split(/,|;/).filter((v) => v !== "") || [];
    } else {
      value = metadata?.value || "";
    }
    return {
      id: fieldName,
      type,
      name: metadata?.name || fieldName,
      value,
      valueMapping,
      descriptionByValue
    };
  }
};
function getKpkMetaFieldLabelByFieldName(kpkApiSheetFields, fieldName) {
  const fieldWithoutLocale = getInternalNameWithoutLocale(fieldName);
  if (isMediaField(fieldName)) {
    return (0, import_react_i18next.getI18n)().t(`mediafield_${fieldWithoutLocale}`, {
      ns: "refront-components"
    });
  } else {
    const sheetField = kpkApiSheetFields && kpkApiSheetFields.find((apiSheetField) => apiSheetField.id === fieldWithoutLocale);
    if (sheetField && sheetField.title) {
      return sheetField.title;
    }
    return "";
  }
}
function getInternalNameWithoutLocale(internalName) {
  if (internalName.indexOf(".") > 0) {
    return internalName.split(".")[0];
  }
  return internalName;
}
var getMetadataValueById = (metadataId, metadatas) => {
  return metadatas.find((m) => m.id === metadataId);
};
var convertToMediaType = (kpkApiMedia, forms, previewPdfUrl) => {
  let kpkApiFormType = kpkApiMedia.formType;
  if (!kpkApiFormType) {
    const formId = convertMediaLinkForm(kpkApiMedia);
    kpkApiFormType = forms?.find((f) => f.id === formId)?.type;
  }
  if (!kpkApiFormType) {
    return 4 /* OTHER */;
  }
  switch (kpkApiFormType) {
    case import_api_client.KpkApiFormType.Picture:
      return 0 /* PICTURE */;
    case import_api_client.KpkApiFormType.Video:
      return 1 /* VIDEO */;
    case import_api_client.KpkApiFormType.Sound:
      return 2 /* AUDIO */;
    case import_api_client.KpkApiFormType.RICH_MEDIA:
      return 5 /* RICH_MEDIA */;
    case import_api_client.KpkApiFormType.Document:
      if (previewPdfUrl) {
        return 3 /* DOCUMENT */;
      }
      return 4 /* OTHER */;
    default:
      return 4 /* OTHER */;
  }
};
function getPreviewPdfUrl(kpkApiMedia, forms) {
  let isPdfMediaType = false;
  forms?.map((form) => {
    if (form.type === import_api_client.KpkApiFormType.Document && form.id !== void 0 && kpkApiMedia && kpkApiMedia?._links) {
      const formIdInLink = import_api_client.KpkApiResponseUtils.extractEntityIdFromHref(
        kpkApiMedia?._links?.["kpk:form"]?.href
      );
      if (formIdInLink === form.id.toString()) {
        isPdfMediaType = true;
      }
    }
  });
  const isPdfPreviewExtension = kpkApiMedia && kpkApiMedia._links && kpkApiMedia._links.preview && kpkApiMedia._links.preview.href && kpkApiMedia._links.preview.href.length > 0 && kpkApiMedia._links.preview.href.endsWith(".pdf");
  if (isPdfMediaType || isPdfPreviewExtension) {
    return kpkApiMedia?._links?.preview?.href;
  } else {
    return;
  }
}
function getPreviewAudioUrl(kpkApiMedia, forms) {
  let isAudioMediaType = false;
  forms?.map((form) => {
    if (form.type === import_api_client.KpkApiFormType.Sound && form.id !== void 0 && kpkApiMedia && kpkApiMedia?._links) {
      const formIdInLink = import_api_client.KpkApiResponseUtils.extractEntityIdFromHref(
        kpkApiMedia?._links["kpk:form"]?.href
      );
      if (formIdInLink === form.id.toString()) {
        isAudioMediaType = true;
      }
    }
  });
  if (isAudioMediaType) {
    return kpkApiMedia?._links?.preview.href;
  } else {
    return;
  }
}
var convertMediaLinkForm = (kpkApiMedia) => {
  const formLink = kpkApiMedia?._links?.["kpk:form" /* FORM */]?.href;
  if (formLink) {
    const formId = Number(formLink.split("forms/")?.[1] ?? -1);
    return formId;
  }
  return -1;
};
var convertMediaLinkSubStatus = (kpkApiMedia) => {
  const subStatusLink = kpkApiMedia?._links?.["kpk:custom-status" /* SUB_STATUS */]?.href;
  if (subStatusLink) {
    const subStatusId = Number(subStatusLink.split("custom-statuses/")?.[1] ?? -1);
    return subStatusId;
  }
  return -1;
};
var convertMediaFolders = (kpkApiMedia) => {
  const folders = [];
  if (kpkApiMedia._embedded?.folders) {
    kpkApiMedia._embedded?.folders.forEach((f) => {
      if (f.id) {
        folders.push({ id: f.id, title: f.title, path: f.path });
      }
    });
  }
  return folders;
};
function getKpkMetaFieldTypeByFieldName(kpkApiSheetFields, fieldName) {
  if (isMediaField(fieldName)) {
    if (fieldName === "creationDate" /* CREATION_DATE */ || fieldName === "importDate" /* IMPORT_DATE */ || fieldName === "trashDate" /* TRASH_DATE */ || fieldName === "updateDate" /* UPDATE_DATE */) {
      return "DATE" /* Date */;
    } else {
      return "TEXT" /* Text */;
    }
  } else {
    const index = kpkApiSheetFields?.findIndex((apiSheetField) => apiSheetField.id === fieldName) ?? -1;
    if (index >= 0 && kpkApiSheetFields?.[index]) {
      return convertToKpkMetaFieldType(kpkApiSheetFields[index].type);
    }
    return "TEXT" /* Text */;
  }
}
var MetaField = /* @__PURE__ */ ((MetaField2) => {
  MetaField2["TITLE"] = "title";
  return MetaField2;
})(MetaField || {});

// src/utils/recoil-utils.ts
function serializeComplexeParamsForRecoil(params) {
  return {
    ...params,
    toJSON: () => {
      return JSON.stringify(params);
    }
  };
}

// src/utils/mocks/axios/dam.ts
var mockAxiosGetDam = ({
  axiosMock,
  currentUi = 0,
  currentUserId = 21
}) => axiosMock.onGet(`/api/dam`).reply(200, {
  title: "qualification",
  _links: {
    self: {
      href: "https://qualification.ci.keepeek-dev.com/api/dam"
    },
    curies: [
      {
        name: "kpk",
        href: "https://qualification.ci.keepeek-dev.com/api/doc/rels/{rel}",
        templated: true
      }
    ],
    "kpk:folders": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/folders"
    },
    "kpk:folder-tree": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/folder-tree"
    },
    "kpk:medias": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/medias"
    },
    search: {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/search"
    },
    "kpk:baskets": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/baskets"
    },
    "kpk:forms": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/forms"
    },
    "kpk:current-user": {
      href: `https://qualification.ci.keepeek-dev.com/api/dam/users/${currentUserId}`
    },
    "kpk:current-ui": {
      href: `https://qualification.ci.keepeek-dev.com/api/dam/user-interfaces/${currentUi}`
    },
    "kpk:files": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/files"
    },
    "kpk:thesauruses": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/thesauruses"
    },
    "kpk:thesaurus-tree": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/thesaurus-tree"
    },
    "kpk:user-interfaces": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/user-interfaces"
    },
    "kpk:properties": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/properties"
    },
    "kpk:faces": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/faces"
    },
    "kpk:individuals": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/individuals"
    },
    "kpk:sheet-fields": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/sheet-fields"
    },
    "kpk:users": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/users"
    },
    "kpk:groups": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/groups"
    },
    "kpk:boards": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/boards"
    },
    "kpk:wikis": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/wikis"
    },
    "kpk:workflows": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/workflows"
    },
    "kpk:share": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/share"
    },
    "kpk:download-validation-requests": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/download-validation-requests"
    },
    "kpk:classification-validation-requests": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/classification-validation-requests"
    },
    "kpk:file-resources": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/file-resources"
    },
    "kpk:contact-sheets": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/contact-sheets"
    },
    "kpk:services": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/services"
    }
  }
});

// src/utils/mocks/axios/user.ts
var mockAxiosGetUser = ({ axiosMock, userId = 21 }) => axiosMock.onGet(`/api/dam/users/${userId}`).reply(200, {
  id: userId,
  login: "rd-techadmin",
  lastName: "TechAdmin",
  firstName: "RD",
  email: "noreply@noreply.com",
  status: 1,
  acronym: "RTE",
  externalAuthentication: false,
  permission: "WRITE",
  interfaceLocale: "FR",
  dataLocale: "FR",
  gdprValidationDate: "2023-11-03T09:20:57.000Z",
  _links: {
    self: {
      href: `https://qualification.ci.keepeek-dev.com/api/dam/users/${userId}`
    },
    curies: [
      {
        name: "kpk",
        href: "https://qualification.ci.keepeek-dev.com/api/doc/rels/{rel}",
        templated: true
      }
    ],
    "kpk:exports": {
      href: `https://qualification.ci.keepeek-dev.com/api/dam/users/${userId}/exports`
    },
    "kpk:selections": {
      href: `https://qualification.ci.keepeek-dev.com/api/dam/users/${userId}/selections`
    },
    "kpk:assigned-groups": {
      href: `https://qualification.ci.keepeek-dev.com/api/dam/users/${userId}/assigned-groups`
    },
    "kpk:authorized-user-interfaces": {
      href: `https://qualification.ci.keepeek-dev.com/api/dam/users/${userId}/authorized-user-interfaces`
    },
    "kpk:available-groups": {
      href: `https://qualification.ci.keepeek-dev.com/api/dam/users/${userId}/available-groups`
    },
    "kpk:user-thumbnail-templates": {
      href: `https://qualification.ci.keepeek-dev.com/api/dam/users/${userId}/thumbnail-templates`
    }
  },
  _embedded: {
    profile: {
      authorizations: ["TECH_ADMINISTRATOR", "IMPORT", "PUBLIC_SHARE"]
    }
  }
});
var mockAxiosGetUserAssignedGroups = ({
  axiosMock,
  userId = 21
}) => axiosMock.onGet(`/api/dam/users/${userId}/assigned-groups`).reply(200, {
  _links: {
    self: {
      href: `https://qualification.ci.keepeek-dev.com/api/dam/users/${userId}/assigned-groups?page=1&size=20`
    },
    curies: [
      {
        name: "kpk",
        href: "https://qualification.ci.keepeek-dev.com/api/doc/rels/{rel}",
        templated: true
      }
    ]
  },
  _embedded: {
    assignedGroup: [
      {
        status: "VALID",
        _links: {
          group: {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/groups/1"
          },
          self: {
            href: `https://qualification.ci.keepeek-dev.com/api/dam/users/${userId}/assigned-groups/1`
          }
        },
        id: 1,
        name: "Administrateur",
        type: "ADMINISTRATOR",
        enabled: true
      }
    ]
  },
  totalCount: 1
});
var mockAxiosGetUserThumbnailTemplates = ({
  axiosMock,
  userId = 21
}) => axiosMock.onGet(`/api/dam/users/${userId}/thumbnail-templates`).reply(200, {
  _links: {
    self: {
      href: `https://qualification.ci.keepeek-dev.com/api/dam/users/${userId}/thumbnail-templates?page=1&size=20`
    },
    curies: [
      {
        name: "kpk",
        href: "https://qualification.ci.keepeek-dev.com/api/doc/rels/{rel}",
        templated: true
      }
    ]
  },
  _embedded: {
    "thumbnail-template": [
      {
        id: 9,
        label: "thumb cms",
        width: 800,
        height: 800,
        format: "jpeg",
        shared: false,
        _links: {
          self: {
            href: `https://qualification.ci.keepeek-dev.com/api/dam/users/${userId}/thumbnail-templates/9`
          }
        }
      },
      {
        id: 12,
        label: "thumb facebook",
        width: 800,
        height: 800,
        format: "png",
        shared: false,
        _links: {
          self: {
            href: `https://qualification.ci.keepeek-dev.com/api/dam/users/${userId}/thumbnail-templates/12`
          }
        }
      },
      {
        id: 15,
        label: "thumb insta",
        width: 800,
        height: 800,
        format: "webp",
        shared: false,
        _links: {
          self: {
            href: `https://qualification.ci.keepeek-dev.com/api/dam/users/${userId}/thumbnail-templates/15`
          }
        }
      }
    ]
  },
  totalCount: 3
});

// src/utils/mocks/axios/media.ts
var mockAxiosGetMedia = ({ axiosMock, mediaId = 75 }) => axiosMock.onGet(`api/dam/medias/${mediaId}`).reply(200, {
  id: mediaId,
  title: "Fum\xE9es \xE9paisses ",
  status: "PUBLISHED",
  permission: "ADMIN",
  downloadLevel: "HD",
  annotation: "NONE",
  width: 1024,
  height: 680,
  resolution: 72,
  mediaType: "image/jpeg",
  fileSize: 251859,
  totalSize: 421602,
  fileSizeString: "251,9 Ko",
  totalSizeString: "421,6 Ko",
  originalFileName: "\xA9USDA Forest Service Coconino National Park Forest - 6 mai 2010.jpg",
  creationDate: "2012-08-27T22:00:00.000Z",
  updateDate: "2013-03-04T23:00:00.000Z",
  importDate: "2012-08-27T22:00:00.000Z",
  durationInSeconds: 0,
  latitude: 34.0489281,
  longitude: -111.0937311,
  address: "Arizona Etats-Unis",
  duplicationStatus: "NO_DUPLICATES",
  thumbnailGenerationStatus: "GENERATED",
  checkSums: {
    md5: "9059aff6fc74786c4ffb532f86088b0"
  },
  attachmentCounts: {
    online: 0,
    offline: 0,
    pendingToOnline: 0
  },
  mediaLinkCount: 0,
  formType: "PICTURE",
  _links: {
    self: {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75"
    },
    curies: [
      {
        name: "kpk",
        href: "https://qualification.ci.keepeek-dev.com/api/doc/rels/{rel}",
        templated: true
      }
    ],
    "kpk:500x500_extended": {
      href: "https://assets.ci.keepeek-dev.com/medias/domain1/media0/75-m9wsqmxgxs-500x500_extended.png"
    },
    "kpk:large": {
      href: "https://assets.ci.keepeek-dev.com/medias/domain1/media0/75-m9wsqmxgxs-large.jpg"
    },
    "kpk:medium": {
      href: "https://assets.ci.keepeek-dev.com/medias/domain1/media0/75-m9wsqmxgxs-medium.jpg"
    },
    preview: {
      href: "https://assets.ci.keepeek-dev.com/medias/domain1/media0/75-m9wsqmxgxs-preview.jpg"
    },
    "kpk:small": {
      href: "https://assets.ci.keepeek-dev.com/medias/domain1/media0/75-m9wsqmxgxs-small.jpg"
    },
    "kpk:whr": {
      href: "https://assets.ci.keepeek-dev.com/medias/domain1/media0/75-m9wsqmxgxs-whr.jpg"
    },
    "kpk:xlarge": {
      href: "https://assets.ci.keepeek-dev.com/medias/domain1/media0/75-m9wsqmxgxs-xlarge.jpg"
    },
    "kpk:hires": {
      href: "https://assets.ci.keepeek-dev.com/medias/domain1/media0/75-pok5g4x0v6.jpg"
    },
    "kpk:form": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/forms/1"
    },
    "kpk:images-service-url": {
      href: "kpk://tst/1/0/75-m9wsqmxgxs.jpg"
    },
    "kpk:images-service-permalink": {
      href: "kpkp://tst/1/0/75-078e6e4e7e.jpg"
    },
    "kpk:terms-of-use": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/terms-of-use"
    },
    "kpk:metadatas": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/metadatas"
    },
    "kpk:folders": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/folders"
    },
    "kpk:custom-status": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/custom-statuses/2"
    },
    "kpk:permalinks": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/permalinks"
    },
    "kpk:file-versions": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/file-versions"
    },
    "kpk:labels": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/labels"
    },
    "kpk:media-links": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/media-links"
    },
    "kpk:cover": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/cover"
    },
    "kpk:attachment": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/attachments"
    },
    "kpk:share": {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/share"
    },
    current: {
      href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/file-versions/current"
    }
  },
  _embedded: {
    metadata: [
      {
        id: "title",
        name: "Titre",
        value: "Fum\xE9es \xE9paisses ",
        _links: {
          self: {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/metadatas/title"
          },
          "kpk:field": {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/forms/1/fields/2"
          }
        }
      },
      {
        id: "shot_date",
        name: "Date de prise de vue",
        value: "2010-05-05T22:00:00.000Z",
        _links: {
          self: {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/metadatas/shot_date"
          },
          "kpk:field": {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/forms/1/fields/5"
          }
        }
      },
      {
        id: "legend",
        name: "L\xE9gende",
        value: "Automobiliste circulant sur une route d\xE9serte avec au loin d'\xE9paisses fum\xE9es dues \xE0 un incendie de for\xEAt. \n",
        _links: {
          self: {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/metadatas/legend"
          },
          "kpk:field": {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/forms/1/fields/147"
          }
        }
      },
      {
        id: "location",
        name: "Localisation",
        value: "Arizona Etats-Unis",
        _links: {
          self: {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/metadatas/location"
          },
          "kpk:field": {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/forms/1/fields/149"
          }
        }
      },
      {
        id: "keywords",
        name: "Mots-clefs libres",
        value: "route, ciel, opaque, opacit\xE9, chauss\xE9e, paysage, route,perspective, jour, fum\xE9e, gris, d\xE9sert\xE9,",
        _links: {
          self: {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/metadatas/keywords"
          },
          "kpk:field": {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/forms/1/fields/152"
          }
        }
      },
      {
        id: "author",
        name: "Auteur",
        value: "USDA USDA Forest Service, Coconino National Forest",
        _links: {
          self: {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/metadatas/author"
          },
          "kpk:field": {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/forms/1/fields/158"
          }
        }
      },
      {
        id: "start_date",
        name: "Date de d\xE9but des droits",
        value: "2010-05-05T22:00:00.000Z",
        _links: {
          self: {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/metadatas/start_date"
          },
          "kpk:field": {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/forms/1/fields/160"
          }
        }
      },
      {
        id: "use_conditions",
        name: "Conditions d'utilisation",
        value: "CC - BY - SA : Paternit\xE9 - Partage des conditions initiales \xE0 l'identique\nNom officiel : Share Alike / SA\nSelon le crit\xE8re de la licence retenue par l\u2019auteur, le nom de l'auteur doit \xEAtre obligatoirement cit\xE9. La reprise de l'\u0153uvre ne peut s'effectuer que dans des conditions identiques \xE0 la cession initiale. Le lien correspondant \xE0 la licence CC-BY-SA en r\xE9f\xE9rence doit \xEAtre mentionn\xE9: http://creativecommons.org/licenses/by-sa/2.0/deed.fr\n",
        _links: {
          self: {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/medias/75/metadatas/use_conditions"
          },
          "kpk:field": {
            href: "https://qualification.ci.keepeek-dev.com/api/dam/forms/1/fields/162"
          }
        }
      }
    ],
    importUser: {
      id: 1,
      lastName: "Anonyme",
      firstName: "Anonyme",
      email: "deleted-1",
      status: 1
    },
    updateUser: {
      id: 1,
      lastName: "Anonyme",
      firstName: "Anonyme",
      email: "deleted-1",
      status: 1
    }
  }
});
var mockAxiosGetMediaPermalinks = ({
  axiosMock,
  mediaId = 75
}) => axiosMock.onGet(`api/dam/medias/${mediaId}/permalinks/`).reply(200, {
  _links: {
    self: {
      href: `https://qualification.ci.keepeek-dev.com/api/dam/medias/${mediaId}/permalinks?page=1&size=20`
    },
    curies: [
      {
        name: "kpk",
        href: "https://qualification.ci.keepeek-dev.com/api/doc/rels/{rel}",
        templated: true
      }
    ]
  },
  _embedded: {
    permalink: [
      {
        title: "500x500_extended",
        description: "500x500_extended <br/> (png 500 x 281 px)",
        _links: {
          self: {
            href: `https://qualification.ci.keepeek-dev.com/api/dam/medias/${mediaId}/permalinks/500x500_extended`
          },
          "latest-version": {
            href: `https://assets.ci.keepeek-dev.com/pm_1_6_${mediaId}-mb27vnm93m-500x500_extended.png`
          }
        }
      },
      {
        title: "large",
        description: "Grande r\xE9solution <br/> (jpg 224 x 126 px)",
        _links: {
          self: {
            href: `https://qualification.ci.keepeek-dev.com/api/dam/medias/${mediaId}/permalinks/large`
          },
          "latest-version": {
            href: `https://assets.ci.keepeek-dev.com/pm_1_6_${mediaId}-mb27vnm93m-large.jpg`
          }
        }
      },
      {
        title: "medium",
        description: "Moyenne r\xE9solution <br/> (jpg 112 x 63 px)",
        _links: {
          self: {
            href: `https://qualification.ci.keepeek-dev.com/api/dam/medias/${mediaId}/permalinks/medium`
          },
          "latest-version": {
            href: `https://assets.ci.keepeek-dev.com/pm_1_6_${mediaId}-mb27vnm93m-medium.jpg`
          }
        }
      },
      {
        title: "preview",
        description: "Pr\xE9visualisation <br/> (jpg 607 x 341 px)",
        _links: {
          self: {
            href: `https://qualification.ci.keepeek-dev.com/api/dam/medias/${mediaId}/permalinks/preview`
          },
          "latest-version": {
            href: `https://assets.ci.keepeek-dev.com/pm_1_6_${mediaId}-mb27vnm93m-preview.jpg`
          }
        }
      },
      {
        title: "small",
        description: "Petite r\xE9solution <br/> (jpg 56 x 32 px)",
        _links: {
          self: {
            href: `https://qualification.ci.keepeek-dev.com/api/dam/medias/${mediaId}/permalinks/small`
          },
          "latest-version": {
            href: `https://assets.ci.keepeek-dev.com/pm_1_6_${mediaId}-mb27vnm93m-small.jpg`
          }
        }
      },
      {
        title: "whr",
        description: "Web Haute r\xE9solution <br/> (jpg 1200 x 675 px)",
        _links: {
          self: {
            href: `https://qualification.ci.keepeek-dev.com/api/dam/medias/${mediaId}/permalinks/whr`
          },
          "latest-version": {
            href: `https://assets.ci.keepeek-dev.com/pm_1_6_${mediaId}-mb27vnm93m-whr.jpg`
          }
        }
      },
      {
        title: "xlarge",
        description: "Tr\xE8s Grande r\xE9solution <br/> (jpg 448 x 252 px)",
        _links: {
          self: {
            href: `https://qualification.ci.keepeek-dev.com/api/dam/medias/${mediaId}/permalinks/xlarge`
          },
          "latest-version": {
            href: `https://assets.ci.keepeek-dev.com/pm_1_6_${mediaId}-mb27vnm93m-xlarge.jpg`
          }
        }
      },
      {
        title: "original",
        description: "Fichier original <br/> (jpg 3840 x 2160 px)",
        _links: {
          self: {
            href: `https://qualification.ci.keepeek-dev.com/api/dam/medias/${mediaId}/permalinks/original`
          },
          "latest-version": {
            href: `https://assets.ci.keepeek-dev.com/pm_1_6_${mediaId}-l83593dpjy.jpg`
          }
        }
      }
    ]
  },
  totalCount: 8
});

// src/utils/mocks/axios/search.ts
var import_api_client2 = require("@keepeek/api-client");
var mockAxiosGetMediasAdvancedSearch = ({
  axiosMock,
  elements,
  mediasCount = 20,
  advancedSearchId = "temp-advanced-search",
  facets = [],
  criterias = []
}) => axiosMock.onPost(`api/dam/search/advanced`).reply(201, {
  id: advancedSearchId,
  type: import_api_client2.KpkApiAdvancedSearchType.Temporary
}).onGet(`api/dam/search/advanced/criterias`).reply(200, {
  totalCount: 100,
  _embedded: {
    criteria: criterias
  }
}).onGet(`api/dam/search/advanced/${advancedSearchId}/media`).reply(200, {
  totalCount: mediasCount,
  _embedded: {
    media: elements ?? createMediasList(mediasCount),
    facet: facets
  }
});
function createMediasList(mediaCount) {
  return Array.from({ length: mediaCount }, (_, index) => ({
    id: index,
    title: `media ${index}`,
    _links: { self: { href: `http://localhost:8080/api/dam/medias/${index}` } }
  }));
}

// src/utils/mocks/axios/labels.ts
var mockAxiosGetMediaLabels = ({
  axiosMock,
  labels = []
}) => axiosMock.onGet(`api/dam/medias/labels`).reply(200, {
  _embedded: {
    label: labels
  }
});

// src/utils/mocks/axios/forms.ts
var mockAxiosGetMediasForms = ({
  axiosMock,
  forms = []
}) => axiosMock.onGet(`api/dam/forms`).reply(200, {
  _embedded: {
    form: forms
  }
});

// src/utils/mocks/axios/sheetFields.ts
var mockAxiosGetSheetFileds = ({
  axiosMock,
  sheetFields = []
}) => axiosMock.onGet(`api/dam/sheet-fields`).reply(200, {
  totalCount: 200,
  _embedded: {
    "sheet-field": sheetFields
  }
});

// src/utils/file.ts
var getExtension = (fileName) => fileName?.substring(fileName?.lastIndexOf(".") + 1)?.toLowerCase();

// src/utils/popup.ts
var openPopup = (url, popupWidth, popupHeight) => {
  const y = window.outerHeight / 2 + window.screenY - popupHeight / 2;
  const x = window.outerWidth / 2 + window.screenX - popupWidth / 2;
  return window.open(
    url,
    "_blank",
    `scrollbars=yes,width=${popupWidth},height=${popupHeight},top=${y},left=${x}`
  );
};
var openMessagePopup = async ({
  onMessage,
  onBadOrigin,
  onPopupClosed,
  logger,
  url,
  allowedOrigins,
  expectedType,
  customPopupBuilder
}) => {
  const messageListener = (event) => {
    if (!event || !event.data || !event.data.type || event.data.type !== expectedType) {
      return;
    }
    logger && logger().debug("received message from popup");
    window.removeEventListener("message", messageListener);
    clearInterval(timer);
    popupRef?.close();
    if (isOriginValid({ allowedOrigins, logger, event })) {
      onMessage(event);
    } else {
      onBadOrigin();
    }
  };
  window.addEventListener("message", messageListener);
  logger && logger().debug("opening popup", url);
  let popupRef = null;
  if (customPopupBuilder) {
    popupRef = await customPopupBuilder(url);
  } else {
    popupRef = openPopup(url, 500, 500);
  }
  const timer = setInterval(() => {
    if (popupRef?.closed) {
      logger && logger().debug("popup closed by user");
      window.removeEventListener("message", messageListener);
      clearInterval(timer);
      onPopupClosed();
    }
  }, 500);
};
function isOriginValid({
  allowedOrigins,
  logger,
  event
}) {
  if (!allowedOrigins.includes(event.origin)) {
    logger && logger().debug("invalid origin", event);
    return false;
  }
  return true;
}

// src/lib/field-utils.ts
var import_uniq = __toESM(require("lodash/uniq"));
var import_react_i18next2 = require("react-i18next");
var MANDATORY_FIELDS = [
  "id" /* ID */,
  "height" /* HEIGHT */,
  "width" /* WIDTH */,
  "originalFileName" /* ORIGINAL_FILE_NAME */,
  "durationInSeconds" /* DURATION_IN_SECONDS */,
  "mediaType" /* MEDIA_TYPE */,
  "downloadLevel" /* DOWNLOAD_LEVEL */,
  "title" /* TITLE */,
  "kpk:form" /* FORM */,
  "preview" /* PREVIEW */,
  "kpk:whr" /* WHR */,
  "kpk:xlarge" /* XLARGE */,
  "label" /* LABEL */
];
function getFieldsToDisplay(fieldsConfiguration, media, forms) {
  if (!fieldsConfiguration || !media) {
    return [];
  }
  if (fieldsConfiguration.metamodel) {
    const metamodelConfiguration = fieldsConfiguration.metamodel.find(
      (metamodel) => metamodel.metamodelId.includes(media.formId)
    );
    if (metamodelConfiguration) {
      return (0, import_uniq.default)(metamodelConfiguration.fields);
    }
  }
  if (fieldsConfiguration.metamodelType) {
    const metamodelType = getMetamodelType(media, forms);
    if (metamodelType) {
      const conf = fieldsConfiguration.metamodelType.find(
        (conf2) => conf2.metamodelType.includes(metamodelType)
      );
      if (conf) {
        return (0, import_uniq.default)(conf.fields);
      }
    }
  }
  return (0, import_uniq.default)(fieldsConfiguration.default);
}
function getMetamodelType(media, forms) {
  if (!media || !forms || forms.length === 0) {
    return null;
  }
  const form = forms.find((f) => f.id === media.formId);
  if (!form) {
    return null;
  }
  return form.type;
}
var getTranslatedAndSortedMediaFields = () => {
  const res = [];
  Object.values(MediaField).forEach((field) => {
    res.push({
      id: field,
      name: (0, import_react_i18next2.getI18n)().t(`mediafield_${field}`, {
        ns: "refront-components"
      })
    });
  });
  return res.sort((a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
  });
};

// src/lib/api/kpk-api-utils.ts
function formatSortValueForKpkApi(sort) {
  const fieldName = sort.toString().split("-")[0];
  const order = sort.toString().split("-")[1];
  return `${fieldName} ${order.toLowerCase()}`;
}
function formatFieldsForKpkApi(fields) {
  const mediaFields = [];
  const metaFields = [];
  const mediaLinks = [];
  const embeddedFields = [];
  const fieldsUniq = [...new Set(fields)];
  fieldsUniq.forEach((field) => {
    if (isMediaField(field)) {
      mediaFields.push(field);
    } else if (isMediaLinksField(field)) {
      mediaLinks.push(field);
    } else if (isEmbeddedField(field)) {
      embeddedFields.push(field);
    } else {
      metaFields.push(field);
    }
  });
  const params = [];
  params.push(...mediaFields);
  if (metaFields.length > 0) {
    params.push(`_embedded{metadata.byId(${metaFields.join(",")})}`);
  }
  if (mediaLinks.length > 0) {
    params.push(`_links{${mediaLinks.join(",")}}`);
  }
  if (embeddedFields.length > 0) {
    params.push(`_embedded{${embeddedFields.join(",")}}`);
  }
  return params.join(",");
}
function addMandatoryFields(fields) {
  const ret = [...fields];
  [...MANDATORY_FIELDS].forEach((f) => {
    if (!ret.includes(f)) {
      ret.push(f);
    }
  });
  return ret;
}
function getFieldsForApi(fieldsConfiguration, basket) {
  if (!fieldsConfiguration) {
    return [];
  }
  let fieldsForApi = [];
  if (fieldsConfiguration.metamodel) {
    fieldsConfiguration.metamodel.forEach((fields) => {
      fields.fields.forEach((fieldName) => {
        if (fieldName !== "folderId" /* FOLDER_ID */ || !basket) {
          if (fieldName === "folderId" /* FOLDER_ID */) {
            fieldsForApi = fieldsForApi.concat("folders" /* FOLDERS */);
          } else {
            fieldsForApi = fieldsForApi.concat(fieldName);
          }
        }
      });
    });
  }
  if (fieldsConfiguration.metamodelType) {
    fieldsConfiguration.metamodelType?.forEach((fields) => {
      fields.fields.forEach((f) => {
        if (f !== "folderId" /* FOLDER_ID */ || !basket) {
          if (f === "folderId" /* FOLDER_ID */) {
            fieldsForApi = fieldsForApi.concat("folders" /* FOLDERS */);
          } else {
            fieldsForApi = fieldsForApi.concat(f);
          }
        }
      });
    });
  }
  if (fieldsConfiguration.default) {
    fieldsConfiguration.default.forEach((f) => {
      if (f !== "folderId" /* FOLDER_ID */ || !basket) {
        if (f === "folderId" /* FOLDER_ID */) {
          fieldsForApi = fieldsForApi.concat("folders" /* FOLDERS */);
        } else {
          fieldsForApi = fieldsForApi.concat(f);
        }
      }
    });
  }
  return fieldsForApi;
}
var MEDIA_TYPE_RICH_ELEMENT = "application/vnd.keepeek.rich";
var RICH_TYPE_META_MODEL_ID = "RICH";

// src/lib/dayjs/index.ts
var import_dayjs = __toESM(require("dayjs"));
var import_duration = __toESM(require("dayjs/plugin/duration"));
var import_localizedFormat = __toESM(require("dayjs/plugin/localizedFormat"));
var import_relativeTime = __toESM(require("dayjs/plugin/relativeTime"));
var import_utc = __toESM(require("dayjs/plugin/utc"));
import_dayjs.default.extend(import_localizedFormat.default);
import_dayjs.default.extend(import_utc.default);
import_dayjs.default.extend(import_duration.default);
import_dayjs.default.extend(import_relativeTime.default);

// src/lib/recoil/recoil-persist.ts
var import_recoil = require("recoil");
var localStorageEffect = (key2) => ({ setSelf, onSet }) => {
  if (isClientSide()) {
    const savedValue = localStorage.getItem(key2);
    if (savedValue !== null && IsJsonString(savedValue)) {
      setSelf(JSON.parse(savedValue));
    }
    onSet((newValue, _, isReset) => {
      if (newValue instanceof import_recoil.DefaultValue || isReset) {
        localStorage.removeItem(key2);
      } else {
        localStorage.setItem(key2, JSON.stringify(newValue));
      }
    });
  }
};
var sessionStorageEffect = (key2) => ({ setSelf, onSet }) => {
  if (isClientSide()) {
    const savedValue = sessionStorage.getItem(key2);
    if (savedValue !== null && IsJsonString(savedValue)) {
      setSelf(JSON.parse(savedValue));
    }
    onSet((newValue, _, isReset) => {
      if (newValue instanceof import_recoil.DefaultValue || isReset) {
        sessionStorage.removeItem(key2);
      } else {
        sessionStorage.setItem(key2, JSON.stringify(newValue));
      }
    });
  }
};

// src/lib/search/advanced-search-utils.ts
var import_api_client3 = require("@keepeek/api-client");
var sizeToFetch = 500;
async function getAllAdvancedSearchCriterias(axiosInstance) {
  let page = 1;
  const data = await fetchData(axiosInstance, page);
  let ret = data._embedded?.criteria || [];
  const totalCount = data.totalCount || 0;
  if (totalCount > 0) {
    while (ret.length < totalCount) {
      page++;
      const tmp = await fetchData(axiosInstance, page);
      if (!tmp._embedded || !tmp._embedded.criteria || tmp._embedded.criteria.length === 0) {
        break;
      }
      ret = [...ret, ...tmp._embedded?.criteria || []];
    }
  }
  return ret;
}
async function fetchData(axiosInstance, page) {
  const result = await (0, import_api_client3.getAdvancedSearchCriterias)(axiosInstance, { size: sizeToFetch, page });
  return result.data;
}

// src/lib/search/search-media.ts
var import_api_client4 = require("@keepeek/api-client");
var FqType = /* @__PURE__ */ ((FqType2) => {
  FqType2["Facet"] = "facet:";
  FqType2["Basket"] = "basketId:";
  FqType2["Associations"] = "associations:";
  return FqType2;
})(FqType || {});
var FOLDER_FACET_ID = "folderName";
var MINUTES_UNIT = "m";
function extractQueryFiltersForFieldParameter(filters) {
  if (!filters || filters.length === 0) {
    return [];
  }
  return filters.reduce((acc, f) => {
    switch (f.nature) {
      case "ADVANCED" /* ADVANCED */: {
        if (f.filter && f.filter.values && f.filter.type === "TEXT" /* Text */) {
          f.filter.values.forEach((v) => {
            acc.push(`${f.filter.id}:${v.label}`);
          });
        }
        break;
      }
      default:
        break;
    }
    return acc;
  }, []);
}
function extractFacetFilters(filters) {
  if (!filters || filters.length === 0) {
    return [];
  }
  return filters.reduce((acc, f) => {
    if (f.filters && (f.filters?.length ?? 0) > 0) {
      for (const filter of f.filters) {
        switch (filter.type) {
          case "facet-multi" /* FacetMulti */:
          case "facet" /* Facet */: {
            if (filter.name) {
              if (filter.name === "folderId" /* FOLDER_ID */) {
                acc.push(FOLDER_FACET_ID);
              } else {
                acc.push(filter.name);
              }
            }
            break;
          }
          default:
            break;
        }
      }
    } else {
      switch (f.type) {
        case "facet-multi" /* FacetMulti */:
        case "facet" /* Facet */: {
          if (f.name) {
            if (f.name === "folderId" /* FOLDER_ID */) {
              acc.push(FOLDER_FACET_ID);
            } else {
              acc.push(f.name);
            }
          }
          break;
        }
        default:
          break;
      }
    }
    return acc;
  }, []);
}
function extractQueryFilters(filters) {
  if (!filters || filters.length === 0) {
    return [];
  }
  return filters.reduce((acc, f) => {
    switch (f.nature) {
      case "FACET" /* FACET */: {
        const facetId = f.filter.id;
        f.filter.values.filter((f2) => f2.selected).forEach((v) => {
          const facetValue = v.id;
          acc.push(
            `${"facet:" /* Facet */}${f.filter.internalName ? f.filter.internalName : facetId}:${facetValue}`
          );
        });
        break;
      }
      case "BASKET" /* BASKET */: {
        const basketId = f.filter.values[0].id;
        acc.push(`${"basketId:" /* Basket */}${basketId}`);
        break;
      }
      case "ASSOCIATIONS" /* ASSOCIATIONS */: {
        const mediaIds = f.filter.values.filter((value) => value.label === "mediaId").map((value) => value.id).join(" ");
        const typeIds = f.filter.values.filter((value) => value.label === "typeId").map((value) => value.id).join(" ");
        acc.push(`${"associations:" /* Associations */}(${mediaIds})${typeIds ? ` types:(${typeIds})` : ``}`);
        break;
      }
      default:
        break;
    }
    return acc;
  }, []);
}
function extractAdvancedFilters(filters, criterias, customerCommonOverrides) {
  const ret = [];
  if (filters.length === 0) {
    return ret;
  }
  filters.forEach((filter) => {
    if (filter.nature === "ADVANCED" /* ADVANCED */ || filter.nature === "FACET_MULTI" /* FACET_MULTI */) {
      const kpkApiAdvancedFilter = convertToKpkApiAdvancedSearchFilter(
        filter.filter,
        filter.nature,
        criterias,
        customerCommonOverrides
      );
      if (kpkApiAdvancedFilter) {
        ret.push(kpkApiAdvancedFilter);
      }
    }
  });
  return ret;
}
var convertToKpkApiAdvancedSearchFilter = (filter, nature, criterias, customerCommonOverrides) => {
  const customFunction = getCustomerOverrideFunction(
    "ConvertToKpkApiAdvancedSearchFilter" /* ConvertToKpkApiAdvancedSearchFilter */,
    { filter },
    customerCommonOverrides
  );
  if (customFunction) {
    return customFunction;
  }
  const criteria = criterias.find(
    (c) => c.internalFieldName === filter.id || c.internalFieldName?.startsWith(`${filter.id}.`)
  );
  if (!criteria || !criteria.fieldType || !criteria.type) {
    console.debug(
      `No data from API for advanced filter ${filter.id} - ${criteria}`,
      filter,
      criteria
    );
    return null;
  }
  if (!filter.modifiers) {
    console.warn(`Advanced filter modifiers is empty ${filter.id}`, filter);
    return null;
  }
  const modifier = filter.modifiers.find((m) => m.selected);
  if (!modifier) {
    console.warn(`Advanced filter have no selected modifier ${filter.id}`, filter);
    return null;
  }
  let convertedModifier = modifier.type;
  if (!convertedModifier) {
    console.warn(
      `Advanced filter modifier can't be converted to API modifier ${filter.id}`,
      filter
    );
    return null;
  }
  let values;
  let type = criteria.type;
  if (filter.type === "RADIO" /* Radio */) {
    values = filter.values.filter((v) => v.selected).map((v) => v.id);
  } else if (filter.type === "DURATION" /* Duration */) {
    values = filter.values.map((v) => adaptDuration(v.id, v.label));
    if (nature === "ADVANCED" /* ADVANCED */ && (filter.internalName === "duration" /* DURATION */ || filter.id === "duration" /* DURATION */)) {
      type = import_api_client4.KpkApiAdvancedSearchCriteriaType.Durationfield;
    }
  } else if (filter.type === "CHECKBOX" /* Checkbox */ && filter.modifiers.find((v) => v.type === "NOT_EMPTY" /* NotEmpty */)) {
    type = import_api_client4.KpkApiAdvancedSearchCriteriaType.Thesaurusfield;
    convertedModifier = import_api_client4.KpkApiAdvancedSearchFilterModifier.NotEmpty;
  } else {
    values = filter.values.map((v) => v.id);
  }
  return {
    internalFieldName: filter.internalName ?? filter.id,
    fieldType: criteria.fieldType,
    showSub: filter.type === "FOLDER" /* Folder */,
    values,
    modifier: convertedModifier,
    type
  };
};
var adaptDuration = (id, label) => {
  let newId = id;
  if (label.includes(MINUTES_UNIT)) {
    newId = id * 60;
  }
  return newId;
};

// src/lib/sentry/breadcrumbs.ts
var SentryBreadcrumbCategory = /* @__PURE__ */ ((SentryBreadcrumbCategory2) => {
  SentryBreadcrumbCategory2["USER_INTERACTION"] = "USER_INTERACTION";
  SentryBreadcrumbCategory2["VISUAL_FEEDBACK"] = "VISUAL_FEEDBACK";
  SentryBreadcrumbCategory2["WINDOW"] = "WINDOW";
  return SentryBreadcrumbCategory2;
})(SentryBreadcrumbCategory || {});

// src/lib/basket/basket-medias.ts
var import_api_client5 = require("@keepeek/api-client");
async function getBasketMediaList(axios, params, logger) {
  logger && logger().debug(`getBasketMediaList ${params.page}`);
  try {
    const resultBasketMedias = await (0, import_api_client5.getBasketMedias)(axios, {
      basketId: params.basketId,
      page: params.page,
      size: params.size,
      fields: formatFieldsForKpkApi(["id", "title"])
    });
    if (resultBasketMedias?.data && params.sheetFields) {
      const result = [];
      resultBasketMedias?.data._embedded?.media.forEach((kpkApiMedia) => {
        result.push(
          convertToKpkMedia(
            params.forms,
            kpkApiMedia,
            params.sheetFields || [],
            [],
            "xlarge" /* XLARGE */
          )
        );
      });
      return { medias: result, totalCount: resultBasketMedias?.data.totalCount || result.length };
    }
  } catch (error) {
    logger && logger().error(`error getting basket media list`);
  }
  return null;
}
async function addMediaToBasket(axiosInstance, params, logger) {
  logger && logger().debug(`addMediaToBasket`);
  try {
    const result = await (0, import_api_client5.addMediaToBasket)(axiosInstance, {
      basketId: params.basketId,
      media: {
        id: params.mediaId
      }
    });
    return result?.data;
  } catch (error) {
    logger && logger().error(`error adding media to basket`);
  }
  return null;
}
async function addMediasToBasket(axiosInstance, params, logger) {
  logger && logger().debug(`addMediasToBasket`);
  try {
    const result = await (0, import_api_client5.addMediasToBasket)(axiosInstance, {
      basketId: params.basketId,
      ids: params.mediaIds
    });
    return result?.data;
  } catch (error) {
    logger && logger().error(`error adding medias to basket`);
  }
  return null;
}
async function removeMediaFromBasket(axiosInstance, params, logger) {
  logger && logger().debug(`removeMediaFromBasket`);
  try {
    const result = await (0, import_api_client5.removeMediaFromBasket)(axiosInstance, {
      basketId: params.basketId,
      mediaId: params.mediaId
    });
    return result?.data;
  } catch (error) {
    logger && logger().error(`error removing media from basket`);
  }
  return null;
}

// src/lib/updater/schema/validate.ts
var import_ajv = __toESM(require("ajv"));
function validateJSONSchema(schema, body, keywordsToAdd, formatsToAdd, ajvOptions) {
  const ajv = new import_ajv.default({ schemaId: "$id", ...ajvOptions && { ...ajvOptions } });
  if (keywordsToAdd) {
    for (const keyword of keywordsToAdd) {
      ajv.addKeyword(keyword);
    }
  }
  if (formatsToAdd) {
    for (const formatToAdd of formatsToAdd) {
      ajv.addFormat(formatToAdd.name, formatToAdd.format);
    }
  }
  const validate = ajv.compile(schema);
  const valid = validate(body);
  if (!valid && validate.errors) {
    return validate.errors;
  }
  return null;
}

// src/lib/updater/types.ts
var LockState = /* @__PURE__ */ ((LockState2) => {
  LockState2["Locked"] = "LOCKED";
  LockState2["Unlocked"] = "UNLOCKED";
  return LockState2;
})(LockState || {});
var ExecutionState = /* @__PURE__ */ ((ExecutionState2) => {
  ExecutionState2["Success"] = "SUCCESS";
  ExecutionState2["Fail"] = "FAIL";
  return ExecutionState2;
})(ExecutionState || {});
var ExecuteError = /* @__PURE__ */ ((ExecuteError2) => {
  ExecuteError2["Locked"] = "LOCKED";
  ExecuteError2["ValidateSchema"] = "VALIDATE-SCHEMA";
  return ExecuteError2;
})(ExecuteError || {});

// src/lib/updater/execute.ts
async function execute({
  setLockState,
  loadConfiguration,
  saveConfiguration,
  filesToExecute,
  schemaForValidation,
  logger
}) {
  if (!filesToExecute || filesToExecute.length === 0) {
    logger && logger().info("[updater] No file to execute");
    return Promise.resolve({ state: "SUCCESS" /* Success */, updateFilesStatus: [] });
  }
  logger && logger().info("[updater] Lock database");
  try {
    await setLockState("LOCKED" /* Locked */);
  } catch (e) {
    return Promise.reject(new Error("LOCKED" /* Locked */));
  }
  try {
    logger && logger().info("[updater] Load configuration");
    let conf = await loadConfiguration();
    const fileResults = [];
    const executedFiles = [];
    let failed = false;
    for (const fileToExecute of filesToExecute) {
      const fileResult = {
        ...fileToExecute,
        executionDate: new Date()
      };
      try {
        logger && logger().info("[updater] Executing {}", fileToExecute.id);
        conf = await fileToExecute.upgrade(conf);
        executedFiles.push(fileToExecute);
        fileResults.push({
          ...fileResult,
          executionState: "SUCCESS" /* Success */
        });
      } catch (e) {
        failed = true;
        fileResults.push({
          ...fileResult,
          executionState: "FAIL" /* Fail */,
          error: e
        });
        break;
      }
    }
    if (!failed) {
      logger && logger().info("[updater] Validating schema");
      const validateError = validateJSONSchema(
        schemaForValidation.schema,
        conf,
        schemaForValidation.keywordsToAdd,
        schemaForValidation.formatsToAdd,
        schemaForValidation.ajvOptions
      );
      if (validateError) {
        logger && logger().info("[updater] Validation error, releasing lock", validateError);
        await setLockState("UNLOCKED" /* Unlocked */);
        return Promise.reject(new Error("VALIDATE-SCHEMA" /* ValidateSchema */));
      }
      logger && logger().info("[updater] Saving configuration");
      await saveConfiguration(conf, executedFiles);
    }
    logger && logger().info("[updater] Releasing lock");
    await setLockState("UNLOCKED" /* Unlocked */);
    return Promise.resolve({
      state: failed ? "FAIL" /* Fail */ : "SUCCESS" /* Success */,
      updateFilesStatus: fileResults
    });
  } catch (e) {
    logger && logger().info("[updater] Releasing lock, because there has been an error");
    await setLockState("UNLOCKED" /* Unlocked */);
    throw e;
  }
}

// src/lib/updater/changes.ts
var import_orderBy = __toESM(require("lodash/orderBy"));
function getChangesToExecute({
  executedUpdateFiles,
  allUpdateFiles
}) {
  return Promise.resolve(
    (0, import_orderBy.default)(
      allUpdateFiles.filter(
        (allFile) => !executedUpdateFiles.some((executedFile) => executedFile.id === allFile.id)
      ),
      [(file) => file.id],
      ["asc"]
    )
  );
}

// src/lib/updater/transformer/update-labels.ts
function updateLabels(data, transformers) {
  const labelsJsonData = data.find((section) => section.configSection === "labels")?.jsonData;
  if (labelsJsonData) {
    labelsJsonData.forEach((translation) => {
      const label = transformers.find((label2) => label2.oldKey === translation.key);
      if (label) {
        translation.key = label.newKey;
        translation.namespace = label.newNamespace;
      }
    });
  }
}

// src/lib/updater/transformer/update-icons.ts
function updateIcons(data, transformers) {
  const iconsJsonData = data.find((section) => section.configSection === "icons")?.jsonData;
  if (iconsJsonData) {
    iconsJsonData.icons?.forEach((iconOverride) => {
      const icon = transformers?.find((icon2) => icon2.oldIconKey === iconOverride.key);
      if (icon) {
        iconOverride.key = icon.newIconKey;
      }
    });
  }
}

// src/hooks/useDimensions.ts
var import_react = require("react");
var import_throttle = __toESM(require("lodash/throttle"));
var ScrollTriggerDirection = /* @__PURE__ */ ((ScrollTriggerDirection2) => {
  ScrollTriggerDirection2["Up"] = "up";
  ScrollTriggerDirection2["Down"] = "down";
  return ScrollTriggerDirection2;
})(ScrollTriggerDirection || {});
var LiveMesure = /* @__PURE__ */ ((LiveMesure2) => {
  LiveMesure2["None"] = "none";
  LiveMesure2["Resize"] = "resize";
  LiveMesure2["Scroll"] = "scroll";
  LiveMesure2["AnimationEnd"] = "animationend";
  LiveMesure2["All"] = "all";
  return LiveMesure2;
})(LiveMesure || {});
var undefinedDimensionObject = {
  width: void 0,
  height: void 0,
  top: void 0,
  left: void 0,
  x: void 0,
  y: void 0,
  right: void 0,
  bottom: void 0,
  scrollLeft: void 0,
  scrollTop: void 0,
  scrollWidth: void 0
};
function getDimensionObject(node) {
  const rect = node?.getBoundingClientRect();
  if (rect) {
    return {
      width: rect?.width,
      height: rect?.height,
      top: rect?.top,
      left: rect?.left,
      x: rect?.x,
      y: rect?.y,
      right: rect?.right,
      bottom: rect?.bottom,
      scrollLeft: node?.scrollLeft,
      scrollTop: node?.scrollTop,
      scrollWidth: node?.scrollWidth
    };
  }
  return undefinedDimensionObject;
}
var useIsomorphicLayoutEffect = isClientSide() ? import_react.useLayoutEffect : import_react.useEffect;
var useDimensions = ({
  liveMeasure = "all" /* All */,
  throttleTime = 100,
  ownContext = false
} = {}) => {
  const [dimensions, setDimensions] = (0, import_react.useState)(undefinedDimensionObject);
  const [node, setNode] = (0, import_react.useState)(null);
  const [scrollDirectionIsUp, setScrollDirectionIsUp] = (0, import_react.useState)(false);
  const scrollDirection = scrollDirectionIsUp ? "up" /* Up */ : "down" /* Down */;
  const ref = (0, import_react.useCallback)((node2) => {
    setNode(node2);
  }, []);
  useIsomorphicLayoutEffect(() => {
    if (node && typeof window !== void 0) {
      const measure = () => window.requestAnimationFrame(() => setDimensions(getDimensionObject(node)));
      measure();
      const checkScrollDirectionIsUp = (e) => {
        setScrollDirectionIsUp(e.deltaY < 0);
      };
      if (liveMeasure === "all" /* All */ || liveMeasure === "resize" /* Resize */) {
        (ownContext ? node : window).addEventListener("resize", (0, import_throttle.default)(measure, throttleTime));
      }
      if (liveMeasure === "all" /* All */ || liveMeasure === "scroll" /* Scroll */) {
        (ownContext ? node : window).addEventListener("scroll", (0, import_throttle.default)(measure, throttleTime));
        (ownContext ? node : window).addEventListener(
          "wheel",
          (0, import_throttle.default)(checkScrollDirectionIsUp, throttleTime)
        );
      }
      if (liveMeasure === "all" /* All */ || liveMeasure === "animationend" /* AnimationEnd */) {
        (ownContext ? node : window).addEventListener(
          "animationend",
          (0, import_throttle.default)(measure, throttleTime)
        );
      }
      return () => {
        if (liveMeasure === "all" /* All */ || liveMeasure === "resize" /* Resize */) {
          (ownContext ? node : window).removeEventListener(
            "resize",
            (0, import_throttle.default)(measure, throttleTime)
          );
        }
        if (liveMeasure === "all" /* All */ || liveMeasure === "scroll" /* Scroll */) {
          (ownContext ? node : window).removeEventListener(
            "scroll",
            (0, import_throttle.default)(measure, throttleTime)
          );
          (ownContext ? node : window).removeEventListener(
            "wheel",
            (0, import_throttle.default)(checkScrollDirectionIsUp, throttleTime)
          );
        }
        if (liveMeasure === "all" /* All */ || liveMeasure === "animationend" /* AnimationEnd */) {
          (ownContext ? node : window).removeEventListener(
            "animationend",
            (0, import_throttle.default)(measure, throttleTime)
          );
        }
      };
    } else {
      return () => {
      };
    }
  }, [liveMeasure, node, throttleTime]);
  return { ref, dimensions, node, scrollDirection };
};

// src/providers/advancedSearch/selectors.ts
var import_recoil50 = require("recoil");

// src/providers/fetcher/atoms/mode.ts
var import_recoil2 = require("recoil");
var FetcherMode = /* @__PURE__ */ ((FetcherMode2) => {
  FetcherMode2[FetcherMode2["SHARE"] = 0] = "SHARE";
  FetcherMode2[FetcherMode2["LOGGED"] = 1] = "LOGGED";
  return FetcherMode2;
})(FetcherMode || {});
var fetcherModeAtom = (0, import_recoil2.atom)({
  key: "FetcherModeAtom",
  default: 1 /* LOGGED */
});
var fetcherTokenIdAtom = (0, import_recoil2.atom)({
  key: "FetcherTokenIdAtom",
  default: ""
});

// src/providers/fetcher/atoms/user.ts
var import_recoil3 = require("recoil");
var isVisitorState = (0, import_recoil3.atom)({
  key: "IsVisitorState",
  default: false
});
var isPublicVisitorState = (0, import_recoil3.atom)({
  key: "IsPublicVisitorState",
  default: false
});

// src/providers/fetcher/utils.ts
function buildParamsForShare(params, headers, tokenId) {
  let axiosRequestConfig = {};
  if (params && params.axiosRequestConfig) {
    axiosRequestConfig = params.axiosRequestConfig;
  }
  return {
    ...params,
    axiosRequestConfig: {
      ...axiosRequestConfig,
      headers
    },
    tokenId
  };
}

// src/providers/fetcher/selectors/form.ts
var import_recoil25 = require("recoil");

// src/providers/share/selectors.ts
var import_api_client6 = require("@keepeek/api-client");
var import_recoil6 = require("recoil");

// src/providers/share/atoms/shareAccessCode.ts
var import_recoil4 = require("recoil");
var shareAccessCodeModalState = (0, import_recoil4.atomFamily)({
  key: "CreateBasketModalState",
  default: false
});
var shareAccessCodeState = (0, import_recoil4.atomFamily)({
  key: "ShareAccessCodeState",
  default: null
});

// src/providers/axios/atoms.ts
var import_recoil5 = require("recoil");
var getAxiosInstanceAtom = (0, import_recoil5.atom)({
  key: "GetAxiosInstanceAtom",
  default: void 0
});

// src/providers/share/selectors.ts
var shareTokenQuerySelector = (0, import_recoil6.selectorFamily)({
  key: "ShareTokenQuerySelector",
  get: (tokenId) => async ({ get }) => {
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    if (tokenId) {
      const headers = get(shareTokenAxiosHeadersSelector);
      return (await (0, import_api_client6.getPublicShare)(getAxiosInstance(), {
        tokenId,
        axiosRequestConfig: {
          handleErrorLocally: true,
          headers
        }
      })).data;
    }
    return void 0;
  }
});
var sharedBasketQuerySelector = (0, import_recoil6.selectorFamily)({
  key: "SharedBasketQuerySelector",
  get: (tokenId) => async ({ get }) => {
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    if (tokenId) {
      const headers = get(shareTokenAxiosHeadersSelector);
      return (await (0, import_api_client6.getPublicSharedBasket)(getAxiosInstance(), {
        tokenId,
        axiosRequestConfig: {
          handleErrorLocally: true,
          headers
        }
      })).data;
    }
    return void 0;
  }
});
var shareTokenAxiosHeadersSelector = (0, import_recoil6.selector)({
  key: "ShareTokenAxiosHeadersSelector",
  get: ({ get }) => {
    const tokenId = get(fetcherTokenIdAtom);
    const accessCode = get(shareAccessCodeState(tokenId));
    if (accessCode !== null) {
      const accessCodeBase64 = btoa(`:${accessCode}`);
      return {
        Authorization: `Basic ${accessCodeBase64}`
      };
    } else {
      return {};
    }
  }
});

// src/providers/form/utils.ts
var import_api_client7 = require("@keepeek/api-client");
var formsSizeToFetch = 500;
async function getLoggedForm(axiosInstance, id) {
  return (await (0, import_api_client7.getForm)(axiosInstance, { formId: id })).data;
}
async function getPublicShareForm(axiosInstance, params, id) {
  return (await (0, import_api_client7.getPublicShareForm)(axiosInstance, { formId: id, ...params })).data;
}
async function getLoggedForms(axiosInstance) {
  return getForms((params) => (0, import_api_client7.getForms)(axiosInstance, params));
}
async function getPublicShareForms(axiosInstance, params) {
  return getForms(
    (p) => (0, import_api_client7.getPublicShareForms)(axiosInstance, { ...p, ...params })
  );
}
async function getForms(getFormsApi2) {
  let page = 1;
  const data = await fetchFormsData(getFormsApi2, page);
  let ret = data._embedded?.form || [];
  const totalCount = data.totalCount || 0;
  if (totalCount > 0) {
    while (ret.length < totalCount) {
      page++;
      const tmp = await fetchFormsData(getFormsApi2, page);
      if (!tmp._embedded || !tmp._embedded.form || tmp._embedded.form.length === 0) {
        break;
      }
      ret = [...ret, ...tmp._embedded?.form || []];
    }
  }
  return ret;
}
async function fetchFormsData(getFormsApi2, page) {
  const result = await getFormsApi2({
    size: formsSizeToFetch,
    page
  });
  return result.data;
}

// src/providers/auth/atoms/secrets.ts
var import_recoil7 = require("recoil");
var authTokensAtom = (0, import_recoil7.atom)({
  key: "AuthTokensAtom",
  default: void 0
});
var idTokenAtom = (0, import_recoil7.atom)({
  key: "IdTokenAtom",
  default: void 0
});
var idTokenParsedAtom = (0, import_recoil7.atom)({
  key: "IdTokenParsedAtom",
  default: void 0
});
var forceIsAuthenticated = (0, import_recoil7.atom)({
  key: "ForceIsAuthenticatedAtom",
  default: false
});

// src/providers/auth/atoms/loading.ts
var import_recoil8 = require("recoil");
var isKeycloakInitializedAtom = (0, import_recoil8.atom)({
  key: "IsKeycloakInitializedAtom",
  default: false
});
var isAuthenticatedLoadingAtom = (0, import_recoil8.atom)({
  key: "IsAuthenticatedLoadingAtom",
  default: false
});
var isPassedGetDamState = (0, import_recoil8.atom)({
  key: "IsPassedGetDamState",
  default: "NONE" /* NONE */
});
var registrationFormUrlPathState = (0, import_recoil8.atom)({
  key: "RegistrationFormUrlPathState",
  default: void 0
});

// src/providers/auth/atoms/keycloak.ts
var import_recoil9 = require("recoil");
var keycloakInstanceAtom = (0, import_recoil9.atom)({
  key: "keycloakInstanceAtom",
  default: void 0,
  dangerouslyAllowMutability: true
});
var keycloakIsAuthenticated = (0, import_recoil9.atom)({
  key: "KeycloakIsAuthenticated",
  default: void 0
});

// src/providers/auth/atoms/refresh.ts
var import_recoil10 = require("recoil");
var anticipatedRefreshState = (0, import_recoil10.atom)({ key: "AnticipatedRefreshState", default: false });
var anticipatedNeedRefreshState = (0, import_recoil10.atom)({
  key: "AnticipatedNeedRefreshState",
  default: false
});

// src/providers/auth/atoms/logout.ts
var import_recoil11 = require("recoil");
var isLogoutInProgressAtom = (0, import_recoil11.atom)({
  key: "IsLogoutInProgressAtom",
  default: false
});

// src/providers/auth/selectors/isAuthenticated.ts
var import_api_client8 = require("@keepeek/api-client");
var import_recoil12 = require("recoil");

// src/providers/auth/utils.ts
var import_keycloak_js = __toESM(require("keycloak-js"));
var keycloak = (keycloackConfig) => {
  if (keycloackConfig && isClientSide()) {
    const { clientId, realm, url } = keycloackConfig;
    return new import_keycloak_js.default({
      clientId,
      realm,
      url
    });
  }
  return void 0;
};
var Browsers = /* @__PURE__ */ ((Browsers2) => {
  Browsers2["MozillaFirefox"] = "Mozilla Firefox";
  Browsers2["SamsungBrowser"] = "Samsung Internet";
  Browsers2["Opera"] = "Opera";
  Browsers2["Trident"] = "Microsoft Internet Explorer";
  Browsers2["Edge"] = "Microsoft Edge";
  Browsers2["Chrome"] = "Google Chrome or Chromium";
  Browsers2["Safari"] = "Apple Safari";
  Browsers2["Unknow"] = "unknow";
  return Browsers2;
})(Browsers || {});
var currentBrowser = () => {
  try {
    let sBrowser = "unknow" /* Unknow */;
    const sUsrAg = navigator.userAgent;
    if (sUsrAg.indexOf("Firefox") > -1) {
      sBrowser = "Mozilla Firefox" /* MozillaFirefox */;
    } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
      sBrowser = "Samsung Internet" /* SamsungBrowser */;
    } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
      sBrowser = "Opera" /* Opera */;
    } else if (sUsrAg.indexOf("Trident") > -1) {
      sBrowser = "Microsoft Internet Explorer" /* Trident */;
    } else if (sUsrAg.indexOf("Edge") > -1) {
      sBrowser = "Microsoft Edge" /* Edge */;
    } else if (sUsrAg.indexOf("Chrome") > -1) {
      sBrowser = "Google Chrome or Chromium" /* Chrome */;
    } else if (sUsrAg.indexOf("Safari") > -1) {
      sBrowser = "Apple Safari" /* Safari */;
    }
    return sBrowser;
  } catch (error) {
    return "unknow" /* Unknow */;
  }
};
var LS_KC_TOKEN_EXP = "KC_TOKEN_EXP";
var keycloakMinValidity = 10;
var OPEN_ID_REALM_URL_FRAGMENT = "/auth/realms/";
function getKeycloakConfigurationFromUrl(openIdUrl) {
  if (!openIdUrl) {
    throw new Error("empty-open-id-url");
  }
  const url = openIdUrl.substring(0, openIdUrl.indexOf(OPEN_ID_REALM_URL_FRAGMENT));
  if (!url) {
    throw new Error("cannot-extract-configuration-from-open-id-url");
  } else {
    const realm = openIdUrl.substring(url.length + OPEN_ID_REALM_URL_FRAGMENT.length).split("/")[0];
    return {
      url: `${url}/auth/`,
      realm
    };
  }
}

// src/providers/auth/selectors/isAuthenticated.ts
function isAxiosError(error) {
  return error.response !== void 0;
}
var isAuthenticatedQuery = (0, import_recoil12.selectorFamily)({
  key: "IsAuthenticatedQuery",
  get: (token) => async ({ get }) => {
    if (isClientSide() && !!token) {
      const forceIsAuth = get(forceIsAuthenticated);
      if (forceIsAuth) {
        return true;
      }
      const axiosInstance = get(getAxiosInstanceAtom);
      if (axiosInstance && token !== "" && token !== void 0) {
        axiosInstance().defaults.headers.common["Authorization"] = `Bearer ${token}`;
        let isAuthenticated = false;
        try {
          const { status } = await (0, import_api_client8.getDam)(axiosInstance(), {
            axiosRequestConfig: {
              data: null,
              headers: {
                "Content-Type": "*/*",
                Accept: "*/*",
                "Access-Control-Allow-Origin": "*",
                Authorization: `Bearer ${token}`
              }
            }
          });
          isAuthenticated = status === 200;
        } catch (error) {
          if (isAxiosError(error)) {
            const axiosError = error;
            if (axiosError.response?.status === 401) {
              return axiosError.response?.data.code || axiosError.response?.data.message || axiosError.code || axiosError.message;
            }
          }
        }
        if (!isAuthenticated) {
          delete axiosInstance().defaults.headers.common["Authorization"];
        }
        return isAuthenticated;
      }
    }
    return false;
  }
});
var isAuthenticatedSelector = (0, import_recoil12.selector)({
  key: "IsAuthenticatedSelector",
  get: ({ get }) => {
    const forceIsAuth = get(forceIsAuthenticated);
    const token = get(authTokensAtom);
    const keycloakInstance = get(keycloakInstanceAtom);
    const passedGetDam = get(isPassedGetDamState);
    if (token && passedGetDam === "ERROR" /* ERROR */ && !!keycloakInstance && !forceIsAuth) {
      localStorage.removeItem(LS_KC_TOKEN_EXP);
      if (!keycloakInstance.isTokenExpired(0)) {
        keycloakInstance.logout({
          redirectUri: `${location.origin}/?${FIRST_LOGIN_TYPE_QUERY_PARAM}=${passedGetDam}`
        });
      }
    }
    if (forceIsAuth) {
      return true;
    }
    return passedGetDam === "PASS" /* PASS */ && token !== void 0;
  }
});

// src/providers/auth/selectors/loading.ts
var import_recoil13 = require("recoil");
var authLoadingSelector = (0, import_recoil13.selector)({
  key: "AuthLoadingSelector",
  get: ({ get }) => get(isKeycloakInitializedAtom) ? get(isAuthenticatedLoadingAtom) : true
});

// src/providers/auth/selectors/configuration.ts
var import_recoil15 = require("recoil");
var import_api_client9 = require("@keepeek/api-client");

// src/providers/logger/atoms.ts
var import_recoil14 = require("recoil");
var getLoggerAtom = (0, import_recoil14.atom)({
  key: "GetLoggerAtom",
  default: void 0
});

// src/providers/auth/selectors/configuration.ts
var authConfigurationSelector = (0, import_recoil15.selector)({
  key: "AuthConfigurationSelector",
  get: async ({ get }) => {
    const logger = get(getLoggerAtom);
    if (!logger) {
      throw new MandatoryProviderException("logger");
    }
    const axiosInstance = get(getAxiosInstanceAtom);
    if (!axiosInstance) {
      throw new MandatoryProviderException("axiosInstance");
    }
    const iamConfiguration = await (0, import_api_client9.getPublicIamConfiguration)(axiosInstance());
    logger().info(`OpenID configuration end point is ${iamConfiguration.data.openIdConfiguration}`);
    if (!iamConfiguration.data.openIdConfiguration) {
      throw new Error("Keycloak is not configured on instance");
    }
    return getKeycloakConfigurationFromUrl(iamConfiguration.data.openIdConfiguration);
  }
});

// src/providers/auth/hooks/useAuth.ts
var import_recoil21 = require("recoil");

// src/providers/auth/hooks/useAuthLogin.ts
var import_react2 = require("react");
var import_recoil17 = require("recoil");

// src/providers/i18n/atoms.ts
var import_recoil16 = require("recoil");
var currentLocaleAtom = (0, import_recoil16.atom)({
  key: "currentLocaleAtom",
  default: void 0
});

// src/providers/auth/hooks/useAuthLogin.ts
var useAuthLogin = ({ guest, redirectUri }) => {
  const locale = (0, import_recoil17.useRecoilValue)(currentLocaleAtom);
  const keyloakInstance = (0, import_recoil17.useRecoilValue)(keycloakInstanceAtom);
  const logger = (0, import_recoil17.useRecoilValue)(getLoggerAtom);
  const login = (0, import_react2.useCallback)(
    (idpHint) => {
      logger && logger().debug("useAuthLogin - login");
      if (keyloakInstance) {
        return keyloakInstance.login({ locale, idpHint, redirectUri });
      }
      return Promise.resolve();
    },
    [keyloakInstance, locale, logger, redirectUri]
  );
  const loginUrl = (0, import_react2.useCallback)(
    (idpHint) => {
      logger && logger().debug("useAuthLogin - loginUrl");
      return keyloakInstance?.createLoginUrl({
        locale,
        idpHint,
        redirectUri
      });
    },
    [keyloakInstance, locale, logger, redirectUri]
  );
  const guestLoginUrl = (0, import_react2.useMemo)(() => {
    if (guest && keyloakInstance) {
      const { hash, expirationDate } = guest;
      const url = new URL(keyloakInstance.createLoginUrl({ locale, redirectUri }));
      url.searchParams.set("kpk_auth_action", "GUEST_ACCESS");
      url.searchParams.set("kpk_hash", hash);
      url.searchParams.set("exp_date", `${expirationDate}`);
      return url.href;
    }
    return "";
  }, [guest, keyloakInstance, locale, redirectUri]);
  const guestLogin = (0, import_react2.useCallback)(() => {
    logger && logger().debug("useAuthLogin - guestLogin");
    window.location.href = guestLoginUrl;
  }, [guestLoginUrl, logger]);
  return {
    login,
    loginUrl,
    guestLogin,
    guestLoginUrl
  };
};

// src/providers/auth/hooks/useAuthLogout.ts
var import_recoil18 = require("recoil");
var import_react3 = require("react");
var useAuthLogout = () => {
  const keycloakInstance = (0, import_recoil18.useRecoilValue)(keycloakInstanceAtom);
  const setTokens = (0, import_recoil18.useSetRecoilState)(authTokensAtom);
  const setIdToken = (0, import_recoil18.useSetRecoilState)(idTokenAtom);
  const setIdTokenParsed = (0, import_recoil18.useSetRecoilState)(idTokenParsedAtom);
  const setKeycloakIsAuthenticated = (0, import_recoil18.useSetRecoilState)(keycloakIsAuthenticated);
  const setIsPassedGetDamState = (0, import_recoil18.useSetRecoilState)(isPassedGetDamState);
  const setIsLogoutInProgressState = (0, import_recoil18.useSetRecoilState)(isLogoutInProgressAtom);
  const logger = (0, import_recoil18.useRecoilValue)(getLoggerAtom);
  const logout = (0, import_react3.useCallback)(
    (redirectUriReceived, specificKeycloakInstance, adaptorLogout) => {
      logger?.().debug("useAuthLogout - logout");
      localStorage.clear();
      sessionStorage.clear();
      indexedDB.deleteDatabase("localforage");
      setIsLogoutInProgressState(true);
      setTokens(void 0);
      setIdToken(void 0);
      setIdTokenParsed(void 0);
      setKeycloakIsAuthenticated(false);
      setIsPassedGetDamState("NONE" /* NONE */);
      const redirectUri = redirectUriReceived || `${location.origin}/`;
      const kcLogoutUrl = (specificKeycloakInstance?.createLogoutUrl({ redirectUri }) || keycloakInstance?.createLogoutUrl({ redirectUri }))?.replace("&id_token_hint=undefined", "");
      if (!kcLogoutUrl) {
        logger?.().info("can't keycloak logout : no logout url, using redirect url", redirectUri);
        location.href = redirectUri;
        return Promise.resolve();
      }
      logger?.().info("logout using keycloak URL", kcLogoutUrl);
      if (specificKeycloakInstance && adaptorLogout) {
        return specificKeycloakInstance.logout({ redirectUri });
      } else if (keycloakInstance && adaptorLogout) {
        return keycloakInstance.logout({ redirectUri });
      } else {
        location.href = kcLogoutUrl;
        return Promise.resolve();
      }
    },
    [
      keycloakInstance,
      logger,
      setIdToken,
      setIdTokenParsed,
      setIsLogoutInProgressState,
      setIsPassedGetDamState,
      setKeycloakIsAuthenticated,
      setTokens
    ]
  );
  return { logout };
};

// src/providers/auth/hooks/useIsAuthenticated.ts
var import_react5 = require("react");
var import_recoil20 = require("recoil");

// src/providers/auth/hooks/useAuthRefresh.ts
var import_react4 = require("react");
var import_recoil19 = require("recoil");
var useAuthRefresh = () => {
  const { logout } = useAuthLogout();
  const keycloakInstance = (0, import_recoil19.useRecoilValue)(keycloakInstanceAtom);
  const logger = (0, import_recoil19.useRecoilValue)(getLoggerAtom);
  const anticipatedRefresh = (0, import_recoil19.useRecoilValue)(anticipatedRefreshState);
  const [anticipatedNeedRefresh, setAnticipatedNeedRefresh] = (0, import_recoil19.useRecoilState)(
    anticipatedNeedRefreshState
  );
  const refresh = (0, import_react4.useCallback)(
    async (forceRefresh = false) => {
      const validityCheckTime = forceRefresh ? keycloakMinValidity : 10 * 60;
      try {
        const refreshed = await keycloakInstance?.updateToken(validityCheckTime);
        if (refreshed) {
          logger && logger().debug("useAuthRefresh - Token was successfully refreshed");
        } else {
          logger && logger().debug("useAuthRefresh - Token is still valid");
        }
      } catch (error) {
        logger && logger().debug("useAuthRefresh - cannot refresh -> logout", error);
        logout();
      }
    },
    [keycloakInstance, logger, logout]
  );
  (0, import_react4.useEffect)(() => {
    if (anticipatedNeedRefresh) {
      setAnticipatedNeedRefresh(false);
      if (anticipatedRefresh) {
        refresh();
      }
    }
  }, [anticipatedNeedRefresh, anticipatedRefresh, refresh, setAnticipatedNeedRefresh]);
  return {
    refresh
  };
};

// src/providers/auth/hooks/useIsAuthenticated.ts
var userNeedRegistration = "user-need-registration";
var useIsAuthenticated = () => {
  const keycloakInstance = (0, import_recoil20.useRecoilValue)(keycloakInstanceAtom);
  const [loading, setLoading] = (0, import_recoil20.useRecoilState)(isAuthenticatedLoadingAtom);
  const isAuthenticated = (0, import_recoil20.useRecoilValue)(isAuthenticatedSelector);
  const { refresh } = useAuthRefresh();
  const getAxiosInstance = (0, import_recoil20.useRecoilValue)(getAxiosInstanceAtom);
  const logger = (0, import_recoil20.useRecoilValue)(getLoggerAtom);
  const token = (0, import_recoil20.useRecoilValue)(authTokensAtom);
  const isKeycloakAuthenticated = (0, import_recoil20.useRecoilValue)(keycloakIsAuthenticated);
  const passedGetDamQuery = (0, import_recoil20.useRecoilValueLoadable)(isAuthenticatedQuery(token));
  const [passedGetDam, setPassedGetDam] = (0, import_recoil20.useRecoilState)(isPassedGetDamState);
  const handlePassedGetDamQuery = (0, import_react5.useCallback)(
    (passedGetDamQueryContent) => {
      if (passedGetDamQueryContent === true) {
        setPassedGetDam("PASS" /* PASS */);
      } else if (passedGetDamQueryContent === "error.account.to_be_validated") {
        setPassedGetDam("PENDING" /* PENDING */);
      } else if (typeof passedGetDamQueryContent === "string" && passedGetDamQueryContent.includes(userNeedRegistration)) {
        const hash = passedGetDamQueryContent.slice(userNeedRegistration.length + 1);
        setPassedGetDam(`${"NOT_AUTHORIZED_WITH_FORM" /* NOT_AUTHORIZED_WITH_FORM */}${hash}`);
      } else if (passedGetDamQueryContent === "user-access-forbidden-for-ui") {
        setPassedGetDam("NOT_AUTHORIZED_WITHOUT_FORM" /* NOT_AUTHORIZED_WITHOUT_FORM */);
      } else if (passedGetDamQueryContent === "error.gdpr.to_be_validated") {
        setPassedGetDam("GDPR_VALIDATION" /* GDPR_VALIDATION */);
      } else {
        setPassedGetDam("ERROR" /* ERROR */);
      }
    },
    [setPassedGetDam]
  );
  (0, import_react5.useEffect)(() => {
    if (!!token && passedGetDamQuery.state === "hasValue") {
      handlePassedGetDamQuery(passedGetDamQuery.contents);
    }
    if ((passedGetDamQuery.state === "loading" || !!token) && !isAuthenticated) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [
    handlePassedGetDamQuery,
    passedGetDamQuery.contents,
    passedGetDamQuery.state,
    token,
    isAuthenticated,
    setLoading
  ]);
  (0, import_react5.useEffect)(() => {
    const axiosInstance = getAxiosInstance && getAxiosInstance();
    const interceptor = axiosInstance?.interceptors.request.use(async (req) => {
      try {
        if (isAuthenticated && keycloakInstance) {
          if (keycloakInstance.isTokenExpired(keycloakMinValidity) && req.headers?.common["Authorization"]) {
            await refresh();
            req.headers.common["Authorization"] = `Bearer ${keycloakInstance.token}`;
          }
        }
      } catch (error) {
        logger && logger().debug(`${error} ("Should be considered as a normal error in FF...")`);
      }
      return req;
    });
    return () => {
      if (interceptor) {
        axiosInstance?.interceptors.request.eject(interceptor);
      }
    };
  }, [getAxiosInstance, isAuthenticated, keycloakInstance, logger, refresh]);
  return {
    passedGetDam,
    isAuthenticated,
    isKeycloakAuthenticated,
    loading
  };
};

// src/providers/auth/hooks/useAuth.ts
var useAuth = ({ guest, redirectUri }) => {
  const isAuthenticated = useIsAuthenticated();
  const authLogin = useAuthLogin({ guest, redirectUri });
  const authLogout = useAuthLogout();
  const loading = (0, import_recoil21.useRecoilValue)(authLoadingSelector);
  return {
    isAuthenticated,
    authLogin,
    authLogout,
    loading
  };
};

// src/providers/auth/hooks/useAuthInit.ts
var import_react7 = require("react");
var import_recoil24 = require("recoil");

// src/providers/auth/adapter/popup/hooks/usePopupAdapter.ts
var import_react6 = require("react");
var import_recoil23 = require("recoil");

// src/providers/auth/adapter/keycloakInternals.ts
function parseCallback(event) {
  const oauth = {
    code: event.data.code,
    state: event.data.state,
    session_state: event.data.session_state,
    kc_action_status: event.data.kc_action_status,
    error: event.data.error,
    error_description: event.data.error_description,
    error_uri: event.data.error_uri
  };
  const key2 = `kc-callback-${oauth.state}`;
  const value = localStorage.getItem(key2);
  if (value) {
    localStorage.removeItem(key2);
    const oauthState = JSON.parse(value);
    if (oauthState) {
      oauth.valid = true;
      oauth.redirectUri = oauthState.redirectUri;
      oauth.storedNonce = oauthState.nonce;
      oauth.prompt = oauthState.prompt;
      oauth.pkceCodeVerifier = oauthState.pkceCodeVerifier;
      return oauth;
    }
  }
  return;
}
function createPromise() {
  const p = {
    setSuccess: function(result) {
      p && p.resolve && p.resolve(result);
    },
    setError: function(result) {
      p && p.reject && p.reject(result);
    },
    promise: Promise.resolve(void 0),
    resolve: () => {
    },
    reject: () => {
    }
  };
  p.promise = new Promise(function(resolve, reject) {
    p.resolve = resolve;
    p.reject = reject;
  });
  return p;
}
function setKeycloakError({
  keycloakInstance,
  promise,
  error,
  description
}) {
  const err = {
    error,
    error_description: description
  };
  keycloakInstance && keycloakInstance.onAuthError && keycloakInstance.onAuthError(err);
  promise.setError(err);
}
function processCallback(kc, oauth, promise) {
  const code = oauth.code;
  const error = oauth.error;
  const prompt = oauth.prompt;
  let timeLocal = new Date().getTime();
  if (oauth["kc_action_status"]) {
    kc.onActionUpdate && kc.onActionUpdate(oauth["kc_action_status"]);
  }
  if (error) {
    if (prompt != "none") {
      const errorData = { error, error_description: oauth.error_description };
      kc.onAuthError && kc.onAuthError(errorData);
      promise.setError(errorData);
    } else {
      promise.setSuccess(void 0);
    }
    return;
  }
  if (kc.flow != "implicit" && code) {
    let params = `code=${code}&grant_type=authorization_code`;
    const url = kc.endpoints.token();
    const req = new XMLHttpRequest();
    req.open("POST", url, true);
    req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    params += `&client_id=${encodeURIComponent(kc.clientId || "")}`;
    params += `&redirect_uri=${oauth.redirectUri}`;
    if (oauth.pkceCodeVerifier) {
      params += `&code_verifier=${oauth.pkceCodeVerifier}`;
    }
    req.withCredentials = true;
    req.onreadystatechange = function() {
      if (req.readyState == 4) {
        if (req.status == 200) {
          const tokenResponse = JSON.parse(req.responseText);
          authSuccess(
            tokenResponse["access_token"],
            tokenResponse["refresh_token"],
            tokenResponse["id_token"],
            kc.flow === "standard"
          );
        } else {
          const error2 = { error: "cannot-get-token", error_description: "Cannot get token" };
          kc.onAuthError && kc.onAuthError(error2);
          promise.setError(error2);
        }
      }
    };
    req.send(params);
  }
  function authSuccess(accessToken, refreshToken, idToken, fulfillPromise) {
    timeLocal = (timeLocal + new Date().getTime()) / 2;
    if (kc.tokenParsed && kc.tokenParsed.nonce != oauth.storedNonce || kc.refreshTokenParsed && kc.refreshTokenParsed.nonce != oauth.storedNonce || kc.idTokenParsed && kc.idTokenParsed.nonce != oauth.storedNonce) {
      promise.setError({
        error: "nonce-does-not-match",
        error_description: "Nonce does not match"
      });
    } else {
      if (fulfillPromise) {
        kc.onAuthSuccess && kc.onAuthSuccess();
        promise.setSuccess({ accessToken, refreshToken, idToken });
      }
    }
  }
}
function getRealmUrl(kc) {
  if (typeof kc.authServerUrl !== "undefined") {
    if (kc.authServerUrl.charAt(kc.authServerUrl.length - 1) == "/") {
      return `${kc.authServerUrl}realms/${encodeURIComponent(kc.realm || "")}`;
    } else {
      return `${kc.authServerUrl}/realms/${encodeURIComponent(kc.realm || "")}`;
    }
  } else {
    return void 0;
  }
}

// src/providers/auth/adapter/popup/adapter.ts
var ALLOWED_ORIGINS = [
  "https://auth.keepeek.com",
  "https://auth2.keepeek.com",
  "https://keycloak.ci.keepeek-dev.com",
  "https://keepeek-keycloak.keepeek-dev.com",
  "https://keycloak1.keepeek.com"
];
var buildPopupAdapter = ({
  keycloakInstance,
  keycloakEventListener,
  setKeycloakInstance,
  keycloackConfig,
  setPopupAdapterTokens,
  setKeycloakIsAuthenticated,
  setIsLogoutInProgressState,
  logger,
  getCurrentUiLocaleForPopup,
  customPopupBuilder
}) => {
  return {
    async login(options) {
      logger && logger().debug("useAuthInit - popup adapter - login");
      setKeycloakIsAuthenticated(void 0);
      const promise = createPromise();
      await openMessagePopup({
        onMessage: (event) => {
          const oauth = parseCallback(event);
          if (oauth) {
            processCallback(keycloakInstance, oauth, promise);
            promise.promise.then(async (result) => {
              logger && logger().debug("useAuthInit - popup adapter - code processed");
              if (result) {
                await initializeKeycloak({
                  keycloakEventListener,
                  setKeycloakInstance,
                  keycloackConfig,
                  token: result.accessToken,
                  refreshToken: result.refreshToken,
                  idToken: result.idToken,
                  setPopupAdapterTokens,
                  setKeycloakIsAuthenticated,
                  setIsLogoutInProgressState,
                  logger,
                  getCurrentUiLocaleForPopup,
                  customPopupBuilder
                });
              }
            }).catch((e) => {
              logger && logger().debug("useAuthInit - popup adapter - error getting tokens", e);
              setKeycloakError({
                keycloakInstance,
                promise,
                error: "error-getting-tokens",
                description: "Error while getting tokens"
              });
            });
          }
        },
        onBadOrigin: () => {
          setKeycloakError({
            keycloakInstance,
            promise,
            error: "invalid-origin",
            description: "Invalid origin, please contact your administrator"
          });
        },
        onPopupClosed: () => {
          setKeycloakError({
            keycloakInstance,
            promise,
            error: "closed-popup",
            description: "Popup have been closed"
          });
        },
        url: keycloakInstance.createLoginUrl({
          locale: getCurrentUiLocaleForPopup && getCurrentUiLocaleForPopup(),
          idpHint: options?.idpHint
        }),
        allowedOrigins: ALLOWED_ORIGINS,
        expectedType: "keepeek-redirect",
        logger,
        customPopupBuilder
      });
      return promise.promise.then(() => {
      });
    },
    async logout(_options) {
      logger && logger().debug("useAuthInit - popup adapter - logout");
      const promise = createPromise();
      if (!keycloakInstance || !keycloakInstance.authenticated) {
        return promise.setSuccess(void 0);
      } else {
        await openMessagePopup({
          onMessage: () => {
            setIsLogoutInProgressState(false);
            setPopupAdapterTokens(void 0);
            setKeycloakInstance(void 0);
            promise.setSuccess(void 0);
          },
          onPopupClosed: () => {
            setIsLogoutInProgressState(false);
            setKeycloakError({
              keycloakInstance,
              promise,
              error: "closed-popup",
              description: "Popup have been closed"
            });
          },
          onBadOrigin: () => {
            setIsLogoutInProgressState(false);
            setKeycloakError({
              keycloakInstance,
              promise,
              error: "invalid-origin",
              description: "Invalid origin, please contact your administrator"
            });
          },
          url: keycloakInstance.createLogoutUrl({
            redirectUri: getRedirectUri(keycloakInstance, "logout")
          }),
          allowedOrigins: ALLOWED_ORIGINS,
          expectedType: "keepeek-logout",
          logger
        });
      }
      return promise.promise.then(() => {
      });
    },
    register(_options) {
      throw "Registration not supported";
    },
    accountManagement() {
      throw "Account management not supported";
    },
    redirectUri(options, _encodeHash) {
      if (options.redirectUri) {
        return options.redirectUri;
      }
      return getRedirectUri(keycloakInstance, "login");
    }
  };
};
function getRedirectUri(keycloakInstance, type) {
  return `${getRealmUrl(keycloakInstance)}/keepicker/${type}?clientId=${encodeURIComponent(
    keycloakInstance.clientId || ""
  )}&redirectUri=${encodeURIComponent(window.location.toString())}`;
}
async function initializeKeycloak({
  keycloakEventListener,
  setKeycloakInstance,
  keycloackConfig,
  setPopupAdapterTokens,
  setKeycloakIsAuthenticated,
  setIsLogoutInProgressState,
  logger,
  token,
  refreshToken,
  idToken,
  getCurrentUiLocaleForPopup,
  customPopupBuilder
}) {
  const newKeycloakInstance = keycloak(keycloackConfig);
  if (!newKeycloakInstance) {
    throw new Error();
  }
  setPopupAdapterTokens({
    token,
    refreshToken,
    idToken
  });
  keycloakEventListener(newKeycloakInstance, "popup" /* POPUP */);
  try {
    await newKeycloakInstance.init({
      useNonce: true,
      pkceMethod: "S256",
      onLoad: void 0,
      silentCheckSsoRedirectUri: void 0,
      checkLoginIframe: false,
      token,
      refreshToken,
      idToken,
      adapter: buildPopupAdapter({
        keycloakInstance: newKeycloakInstance,
        keycloakEventListener,
        setKeycloakInstance,
        keycloackConfig,
        setPopupAdapterTokens,
        setKeycloakIsAuthenticated,
        setIsLogoutInProgressState,
        logger,
        getCurrentUiLocaleForPopup,
        customPopupBuilder
      })
    });
    setKeycloakInstance(newKeycloakInstance);
  } catch (error) {
    logger && logger().debug("useAuthInit - Tokens are not valid");
    setPopupAdapterTokens(void 0);
    setKeycloakInstance(void 0);
  }
  return newKeycloakInstance;
}

// src/providers/auth/adapter/popup/atoms/secrets.ts
var import_recoil22 = require("recoil");
var popupAdapterTokens = (0, import_recoil22.atomFamily)({
  key: "PopupAdapterTokens",
  default: void 0,
  effects: (key2) => [sessionStorageEffect(`PopupAdapterTokens-${key2}`)]
});

// src/providers/auth/adapter/popup/hooks/usePopupAdapter.ts
var usePopupAdapter = ({
  realm,
  getCurrentUiLocaleForPopup,
  customPopupBuilder
}) => {
  const [getPopupAdapterTokens, setPopupAdapterTokens] = (0, import_recoil23.useRecoilState)(popupAdapterTokens(realm));
  const logger = (0, import_recoil23.useRecoilValue)(getLoggerAtom);
  const setKeycloakInstance = (0, import_recoil23.useSetRecoilState)(keycloakInstanceAtom);
  const setKeycloakIsAuthenticated = (0, import_recoil23.useSetRecoilState)(keycloakIsAuthenticated);
  const setIsLogoutInProgressState = (0, import_recoil23.useSetRecoilState)(isLogoutInProgressAtom);
  const buildPopupAdapter2 = (0, import_react6.useCallback)(
    ({ keycloakInstance, keycloackConfig, keycloakEventListener }) => {
      if (!keycloakInstance) {
        return void 0;
      }
      return buildPopupAdapter({
        keycloakInstance,
        keycloakEventListener,
        setKeycloakInstance,
        keycloackConfig,
        setPopupAdapterTokens,
        setKeycloakIsAuthenticated,
        setIsLogoutInProgressState,
        logger,
        getCurrentUiLocaleForPopup,
        customPopupBuilder
      });
    },
    [
      customPopupBuilder,
      getCurrentUiLocaleForPopup,
      logger,
      setIsLogoutInProgressState,
      setKeycloakInstance,
      setKeycloakIsAuthenticated,
      setPopupAdapterTokens
    ]
  );
  return {
    buildPopupAdapter: buildPopupAdapter2,
    popupAdapterTokens: getPopupAdapterTokens
  };
};

// src/providers/auth/hooks/useAuthInit.ts
var KeycloakInstanceType = /* @__PURE__ */ ((KeycloakInstanceType2) => {
  KeycloakInstanceType2["DEFAULT"] = "default";
  KeycloakInstanceType2["POPUP"] = "popup";
  return KeycloakInstanceType2;
})(KeycloakInstanceType || {});
var useAuthInit = (config, options) => {
  const { logout } = useAuthLogout();
  const [settedKeycloakInstance, setKeycloakInstance] = (0, import_recoil24.useRecoilState)(keycloakInstanceAtom);
  const setKeycloakIsAuthenticated = (0, import_recoil24.useSetRecoilState)(keycloakIsAuthenticated);
  const setAuthTokens = (0, import_recoil24.useSetRecoilState)(authTokensAtom);
  const setIdToken = (0, import_recoil24.useSetRecoilState)(idTokenAtom);
  const setIdTokenParsed = (0, import_recoil24.useSetRecoilState)(idTokenParsedAtom);
  const setIsKeycloakInitializedAtom = (0, import_recoil24.useSetRecoilState)(isKeycloakInitializedAtom);
  const setAnticipatedNeedRefresh = (0, import_recoil24.useSetRecoilState)(anticipatedNeedRefreshState);
  const logger = (0, import_recoil24.useRecoilValue)(getLoggerAtom);
  const initRef = (0, import_react7.useRef)(false);
  const popupMode = options && options.popupMode ? options.popupMode : false;
  const keycloakEventListener = (0, import_react7.useCallback)(
    (keycloakInstance, keycloakInstanceType) => {
      keycloakInstance.onReady = (authenticated) => {
        setIsKeycloakInitializedAtom(true);
        setKeycloakIsAuthenticated(authenticated);
        logger && logger().debug(
          `useAuthInit - ${keycloakInstanceType}\xA0- onReady authenticated:`,
          authenticated
        );
      };
      keycloakInstance.onAuthError = (errorData) => {
        logger && logger().error(`useAuthInit - ${keycloakInstanceType}- onAuthError`, { errorData });
        setKeycloakIsAuthenticated(false);
        if (!popupMode) {
          logout(void 0, keycloakInstance);
        }
      };
      keycloakInstance.onAuthSuccess = () => {
        setAuthTokens(keycloakInstance.token);
        setIdToken(keycloakInstance.idToken);
        setIdTokenParsed(keycloakInstance.idTokenParsed);
        localStorage.setItem(LS_KC_TOKEN_EXP, `${keycloakInstance?.tokenParsed?.exp}`);
        logger && logger().debug(
          `useAuthInit - ${keycloakInstanceType} - onAuthSuccess token exp:`,
          keycloakInstance?.tokenParsed?.exp
        );
      };
      keycloakInstance.onAuthRefreshSuccess = () => {
        setAuthTokens(keycloakInstance.token);
        setIdToken(keycloakInstance.idToken);
        setIdTokenParsed(keycloakInstance.idTokenParsed);
        localStorage.setItem(LS_KC_TOKEN_EXP, `${keycloakInstance?.tokenParsed?.exp}`);
        logger && logger().debug(
          `useAuthInit - ${keycloakInstanceType} - onAuthRefreshSuccess token exp:`,
          keycloakInstance?.tokenParsed?.exp
        );
      };
      keycloakInstance.onTokenExpired = () => {
        logger && logger().debug(`useAuthInit - ${keycloakInstanceType} - onTokenExpired`);
        setAnticipatedNeedRefresh(true);
      };
    },
    [
      setIsKeycloakInitializedAtom,
      setKeycloakIsAuthenticated,
      logger,
      logout,
      setAuthTokens,
      setIdToken,
      setIdTokenParsed,
      setAnticipatedNeedRefresh,
      popupMode
    ]
  );
  const { buildPopupAdapter: buildPopupAdapter2, popupAdapterTokens: popupAdapterTokens2 } = usePopupAdapter({
    realm: config?.realm || "",
    getCurrentUiLocaleForPopup: options?.getCurrentUiLocaleForPopup,
    customPopupBuilder: options?.customPopupBuilder
  });
  const init = (0, import_react7.useCallback)(
    async (keycloakInstance) => {
      logger && logger().debug("useAuthInit - init started with", config, options);
      let silentCheckSsoRedirectUri = options?.silentCheckSsoRedirectUri ?? `${window.location.origin}/auth/silent-check-sso`;
      silentCheckSsoRedirectUri = options?.disableSilentCheckSso ? void 0 : silentCheckSsoRedirectUri;
      try {
        await keycloakInstance.init({
          useNonce: true,
          pkceMethod: "S256",
          onLoad: popupMode ? void 0 : "check-sso",
          silentCheckSsoRedirectUri,
          checkLoginIframe: false,
          token: popupAdapterTokens2?.token,
          refreshToken: popupAdapterTokens2?.refreshToken,
          idToken: popupAdapterTokens2?.idToken,
          adapter: popupMode ? buildPopupAdapter2({
            keycloakInstance,
            keycloackConfig: config,
            keycloakEventListener
          }) : "default"
        });
      } catch (error) {
        logger && logger().debug("useAuthInit - init in error");
        logger && logger().error(error);
        await logout();
      }
      logger && logger().debug("useAuthInit - init done");
    },
    [
      buildPopupAdapter2,
      config,
      keycloakEventListener,
      logger,
      logout,
      options,
      popupAdapterTokens2?.idToken,
      popupAdapterTokens2?.refreshToken,
      popupAdapterTokens2?.token,
      popupMode
    ]
  );
  (0, import_react7.useEffect)(() => {
    const needInit = !initRef.current && !settedKeycloakInstance || popupMode && !settedKeycloakInstance;
    logger && logger().debug(`useAuthInit - init effect - need initialization: ${needInit ? "yes" : "no"}`);
    if (needInit) {
      logger && logger().debug("useAuthInit - init");
      const keycloakInstance = keycloak(config);
      logger && logger().debug("useAuthInit - trying to set instance with config", config);
      setKeycloakInstance(keycloakInstance);
      if (keycloakInstance) {
        initRef.current = true;
        keycloakEventListener(keycloakInstance, "default" /* DEFAULT */);
        init(keycloakInstance);
      }
    }
  }, [
    config,
    init,
    keycloakEventListener,
    logger,
    popupMode,
    setKeycloakInstance,
    settedKeycloakInstance
  ]);
};

// src/providers/fetcher/selectors/form.ts
var formFetcherSelector = (0, import_recoil25.selectorFamily)({
  key: "FormFetcherSelector",
  get: (mode) => ({ get }) => {
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    switch (mode) {
      case 0 /* SHARE */:
        const tokenId = get(fetcherTokenIdAtom);
        const headers = get(shareTokenAxiosHeadersSelector);
        return {
          getForm: (id) => {
            return getPublicShareForm(
              getAxiosInstance(),
              buildParamsForShare(null, headers, tokenId),
              id
            );
          },
          getForms: () => {
            return getPublicShareForms(
              getAxiosInstance(),
              buildParamsForShare(null, headers, tokenId)
            );
          }
        };
      default:
        const isAuthenticated = get(isAuthenticatedSelector);
        return {
          getForm: (id) => {
            if (!isAuthenticated) {
              getLogger().debug("FormFetcherSelector Cannot fetch without auth");
              return Promise.resolve(void 0);
            }
            return getLoggedForm(getAxiosInstance(), id);
          },
          getForms: () => {
            if (!isAuthenticated) {
              getLogger().debug("FormFetcherSelector Cannot fetch without auth");
              return new Promise((resolve) => resolve(void 0));
            }
            return getLoggedForms(getAxiosInstance());
          }
        };
    }
  }
});

// src/providers/fetcher/selectors/sheetField.ts
var import_recoil43 = require("recoil");

// src/providers/share/hooks/useShare.ts
var useShare = (pathname, tokenIdParam) => {
  const isShare = pathname.startsWith("/share");
  const tokenId = parseStringParameter(tokenIdParam) || "";
  const isUnitaryShareElement = isShare && tokenId.startsWith("m");
  return {
    isShare,
    tokenId,
    isUnitaryShareElement
  };
};

// src/providers/share/hooks/useShareToken.ts
var import_react9 = require("react");
var import_api_client17 = require("@keepeek/api-client");
var import_recoil42 = require("recoil");

// src/providers/shareManager/atoms/configuration.ts
var import_recoil26 = require("recoil");
var shareManagerConfiguration = (0, import_recoil26.atom)({
  key: "ShareManagerConfiguration",
  default: void 0
});

// src/providers/shareManager/atoms/open.ts
var import_recoil27 = require("recoil");
var shareManagerIsOpenState = (0, import_recoil27.atom)({
  key: "ShareManagerIsOpenState",
  default: false
});

// src/providers/shareManager/atoms/selection.ts
var import_recoil28 = require("recoil");
var shareManagerSelectionsState = (0, import_recoil28.atom)({
  key: "shareManagerSelectionsState",
  default: []
});

// src/providers/shareManager/atoms/unitaryPublicShare.ts
var import_api_client10 = require("@keepeek/api-client");
var import_recoil29 = require("recoil");
var ShareSizingType = /* @__PURE__ */ ((ShareSizingType2) => {
  ShareSizingType2["AUTO"] = "AUTO";
  ShareSizingType2["MANUAL"] = "MANUAL";
  return ShareSizingType2;
})(ShareSizingType || {});
var shareUnitaryPublicShareSizeState = (0, import_recoil29.atom)({
  key: "ShareUnitaryPublicShareSizeState",
  default: "AUTO" /* AUTO */
});
var shareUnitaryPublicShareSizeHeightState = (0, import_recoil29.atom)({
  key: "ShareUnitaryPublicShareSizeHeightState",
  default: 600
});
var shareUnitaryPublicShareSizeWidthState = (0, import_recoil29.atom)({
  key: "ShareUnitaryPublicShareSizeWidthState",
  default: 800
});
var shareUnitaryPublicShareDeactivationDateState = (0, import_recoil29.atom)({
  key: "ShareUnitaryPublicShareDeactivationDateState",
  default: void 0
});
var shareUnitaryPublicShareDownloadLevelState = (0, import_recoil29.atom)({
  key: "ShareUnitaryPublicShareDeactivationDateActiveState",
  default: import_api_client10.KpkApiMediaDownloadLevel.None
});
var selectedUnitaryPublicShareExportDefinitionState = (0, import_recoil29.atom)({
  key: "SelectedUnitaryPublicShareExportDefinitionState",
  default: import_api_client10.KpkApiPublicShareExportDefinition.HD
});
var updateUnitaryPublicSharedState = (0, import_recoil29.atom)({
  key: "UpdateUnitaryPublicSharedState",
  default: 0
});

// src/providers/shareManager/hooks/useShareExportDefinition.ts
var import_api_client11 = require("@keepeek/api-client");
var import_react_i18next3 = require("react-i18next");
var import_recoil30 = require("recoil");
var useShareManagerExportDefinition = () => {
  const { t } = (0, import_react_i18next3.useTranslation)();
  const [selectedExportDefinition, setSelectedExportDefinition] = (0, import_recoil30.useRecoilState)(
    selectedUnitaryPublicShareExportDefinitionState
  );
  const exportDefinitions = Object.values(import_api_client11.KpkApiPublicShareExportDefinition).map(
    (definition) => ({
      title: t(`basket.share.content.export-definition.${definition}.title`),
      description: t(`basket.share.content.export-definition.${definition}.description`),
      id: definition,
      metas: [],
      href: "",
      active: definition === selectedExportDefinition
    })
  );
  return {
    exportDefinitions,
    selectedExportDefinition,
    setSelectedExportDefinition
  };
};

// src/providers/shareManager/hooks/useShareManagerActivation.ts
var import_api_client12 = require("@keepeek/api-client");
var import_axios3 = __toESM(require("axios"));
var useShareManagerActivation = (onUpdateShareManagerError) => {
  async function handleUpdateSharePublic(mediaId, status, exportDefinition, date, attachmentsVisible) {
    if (mediaId) {
      try {
        await (0, import_api_client12.updateMediaSharePublic)(import_axios3.default, {
          mediaId,
          sharePublic: {
            status,
            exportDefinition,
            deactivationDate: date,
            attachmentsVisible
          }
        });
      } catch (error) {
        onUpdateShareManagerError(error);
      }
    }
  }
  return {
    handleUpdateSharePublic
  };
};

// src/providers/shareManager/hooks/useShareManagerOpen.ts
var import_recoil31 = require("recoil");
var useShareManagerOpen = () => {
  const [isOpen, setIsOpen] = (0, import_recoil31.useRecoilState)(shareManagerIsOpenState);
  const setUpdateUnitaryPublicShared = (0, import_recoil31.useSetRecoilState)(updateUnitaryPublicSharedState);
  const open = () => {
    setIsOpen(true);
  };
  const close = () => {
    setIsOpen(false);
    setUpdateUnitaryPublicShared((prev) => prev + 1);
  };
  return {
    isOpen,
    open,
    close
  };
};

// src/providers/shareManager/hooks/useShareManagerSelections.ts
var import_recoil40 = require("recoil");

// src/providers/shareManager/selectors/shareManagerSelectionsSelector.ts
var import_recoil39 = require("recoil");

// src/providers/shareManager/selectors/shareManagerBasketSelectors.ts
var import_recoil32 = require("recoil");
var shareBasketsSelector = (0, import_recoil32.selectorFamily)({
  key: "ShareBasketsSelector",
  get: (basketIds) => () => {
    const logger = (0, import_recoil32.useRecoilValue)(getLoggerAtom);
    if (!logger) {
      throw new MandatoryProviderException("logger");
    }
    logger().debug(
      "shareBasketsSelector - currently not supported, we should move shareBasket here",
      basketIds
    );
    return [];
  }
});

// src/providers/shareManager/selectors/shareManagerUnitaryPublicShareSelectors.ts
var import_api_client16 = require("@keepeek/api-client");
var import_recoil38 = require("recoil");

// src/providers/user/hooks/useCurrentUser.ts
var import_recoil37 = require("recoil");

// src/providers/user/selectors/currentUser.ts
var import_api_client14 = require("@keepeek/api-client");
var import_recoil34 = require("recoil");

// src/providers/overrides/atoms.ts
var import_recoil33 = require("recoil");
var customerCommonOverrideAtom = (0, import_recoil33.atom)({
  key: "CustomerCommonOverrideAtom",
  default: {}
});

// src/providers/user/utils.ts
var import_api_client13 = require("@keepeek/api-client");
var SHOULD_FLUSH_LS_KEY = "SHOULD_FLUSH_LS_KEY";
var API_TECH_ADMINISTRATOR_GROUP_ID = 2;
var hasValidGroupById = (assignedGroups, groupId) => assignedGroups.some(
  (ag) => ag.id === groupId && ag.status === import_api_client13.KpkApiAssignedGroupStatus.Valid && ag.enabled
);
var hasValidGroupByType = (assignedGroups, groupType) => assignedGroups.some(
  (ag) => ag.type === groupType && ag.status === import_api_client13.KpkApiAssignedGroupStatus.Valid && ag.enabled
);
var isAdministrator = (assignedGroups) => hasValidGroupByType(assignedGroups, import_api_client13.Type.Administrator);
var isTechAdministrator = (assignedGroups) => hasValidGroupById(assignedGroups, API_TECH_ADMINISTRATOR_GROUP_ID);
var isVisitor = (assignedGroups) => hasValidGroupByType(assignedGroups, import_api_client13.Type.Visitor);
var getUserRight = (assignedGroups, jwtTokenDecoded) => {
  if (assignedGroups === void 0) {
    return void 0;
  }
  if (isTechAdministrator(assignedGroups)) {
    return 3 /* TECH_ADMINISTRATOR */;
  } else if (isAdministrator(assignedGroups)) {
    return 2 /* ADMINISTRATOR */;
  } else if (isPublicVisitor(jwtTokenDecoded)) {
    return 1 /* PUBLIC_VISITOR */;
  } else if (isVisitor(assignedGroups)) {
    return 0 /* VISITOR */;
  }
  return void 0;
};
var isRightAllowed = (userRight, rightToCheck) => {
  if (userRight === void 0 || rightToCheck === void 0) {
    return false;
  }
  return userRight >= rightToCheck;
};
var toUserRight = (userRightKey) => {
  if (!userRightKey) {
    return void 0;
  }
  const foundedKey = Object.keys(UserRight).filter((key2) => Number.isNaN(Number(key2))).find((key2) => key2.toLowerCase() === userRightKey.toLowerCase());
  if (foundedKey) {
    return UserRight[foundedKey];
  }
  return void 0;
};
var checkUserIsTech = async (axiosInstance) => {
  const user = await (0, import_api_client13.getCurrentUser)(axiosInstance);
  const assignedGroupsResult = await (0, import_api_client13.getUserAssignedGroups)(axiosInstance, { userId: user.data.id });
  const assignedGroups = assignedGroupsResult.data._embedded?.assignedGroup ?? [];
  if (!isTechAdministrator(assignedGroups)) {
    throw new Error("User is not a tech");
  }
  return user.data;
};
var isPublicVisitor = (jwtTokenDecoded) => {
  if (!jwtTokenDecoded) {
    return false;
  }
  try {
    const decodedToken = jwtTokenDecoded;
    const result = Boolean(decodedToken.app_access_rights.is_guest);
    return result;
  } catch (err) {
    console.debug("[isVisitor] can't extract information from token", err);
    return false;
  }
};
var userHasImportRights = (authorizations) => {
  if (authorizations) {
    return authorizations.filter((authorization) => authorization === import_api_client13.KpkApiProfileAuthorization.Import).length > 0;
  }
  return false;
};
var userHasPublicShare = (authorizations) => {
  if (authorizations) {
    return authorizations.filter(
      (authorization) => authorization === import_api_client13.KpkApiProfileAuthorization.PublicShare
    ).length > 0;
  }
  return false;
};
var userHasAttachmentsRights = (authorizations) => {
  if (authorizations) {
    return authorizations.some(
      (authorization) => authorization === import_api_client13.KpkApiProfileAuthorization.Attachments
    );
  }
  return false;
};
var userHasDynameekWriteAuthorization = (authorizations) => {
  if (authorizations) {
    return authorizations.some(
      (authorization) => authorization === import_api_client13.KpkApiProfileAuthorization.DynameekWrite
    );
  }
  return false;
};

// src/providers/user/selectors/currentUser.ts
var currentUserQuery = (0, import_recoil34.selector)({
  key: "CurentUserQuery",
  get: async ({ get }) => {
    const keycloakInstance = get(keycloakInstanceAtom);
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    const forceIsAuth = get(forceIsAuthenticated);
    const token = get(authTokensAtom);
    const passedGetDam = get(isPassedGetDamState);
    const logger = get(getLoggerAtom);
    if (!forceIsAuth && (!token || token && passedGetDam !== "PASS" /* PASS */)) {
      logger && logger().debug("currentUserQuery can't fetch without authentication");
      return {};
    }
    if (!forceIsAuth && token && keycloakInstance && keycloakInstance.isTokenExpired(keycloakMinValidity)) {
      logger && logger().debug("currentUserQuery token is expired");
      return {};
    }
    if (!forceIsAuth) {
      getAxiosInstance().defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    const { data } = await (0, import_api_client14.getCurrentUser)(getAxiosInstance());
    const shouldFlushLSKey = localStorage.getItem(SHOULD_FLUSH_LS_KEY);
    if (shouldFlushLSKey !== null && shouldFlushLSKey !== void 0 && shouldFlushLSKey !== `${data.id}`) {
      localStorage.clear();
    }
    localStorage.setItem(SHOULD_FLUSH_LS_KEY, `${data.id}`);
    return data;
  }
});
var currentUserAssignedGroupsQuery = (0, import_recoil34.selector)({
  key: "CurrentUserGroups",
  get: async ({ get }) => {
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    const isAuthenticated = get(isAuthenticatedSelector);
    const logger = get(getLoggerAtom);
    if (!isAuthenticated) {
      logger && logger().debug("CurrentUserGroups can't fetch without authentication");
      return [];
    }
    const user = get(currentUserQuery);
    if (user.id) {
      const { data } = await (0, import_api_client14.getUserAssignedGroups)(getAxiosInstance(), { userId: user.id });
      const groups = data._embedded?.assignedGroup ?? [];
      const { groups: outGroups } = customSelectorInOut(
        "UserAssignedGroupsQueryOut" /* UserAssignedGroupsQueryOut */,
        {
          user,
          groups,
          get
        },
        get(customerCommonOverrideAtom)
      );
      return outGroups;
    }
    return [];
  }
});

// src/providers/contactSheets/selectors/index.ts
var import_api_client15 = require("@keepeek/api-client");
var import_recoil35 = require("recoil");
var contactSheetsSelector = (0, import_recoil35.selector)({
  key: "ContactSheetsSelector",
  get: async ({ get }) => {
    const logger = get(getLoggerAtom);
    if (!logger) {
      throw new MandatoryProviderException("logger");
    }
    const axiosInstance = get(getAxiosInstanceAtom);
    if (!axiosInstance) {
      throw new MandatoryProviderException("axiosInstance");
    }
    const isAuthenticated = get(isAuthenticatedSelector);
    if (!isAuthenticated) {
      logger().debug("ContactSheetsSelector can't fetch without authentication");
      return void 0;
    }
    const contactSheets = await (0, import_api_client15.getContactSheets)(axiosInstance());
    return contactSheets.data._embedded?.contactSheet;
  }
});

// src/providers/user/hooks/useIsVisitor.ts
var import_react8 = require("react");
var import_recoil36 = require("recoil");
var useIsVisitor = () => {
  const [visitorValue, setIsVisitorValue] = (0, import_recoil36.useRecoilState)(isVisitorState);
  const [publicVisitorValue, setPublicVisitorValue] = (0, import_recoil36.useRecoilState)(isPublicVisitorState);
  const assignedGroupsQuery = (0, import_recoil36.useRecoilValueLoadable)(currentUserAssignedGroupsQuery);
  const assignedGroups = (0, import_react8.useMemo)(
    () => assignedGroupsQuery.state === "hasValue" ? assignedGroupsQuery.contents : [],
    [assignedGroupsQuery.contents, assignedGroupsQuery.state]
  );
  const keycloakInstance = (0, import_recoil36.useRecoilValue)(keycloakInstanceAtom);
  const token = (0, import_recoil36.useRecoilValue)(authTokensAtom);
  const tokenParsed = (0, import_react8.useMemo)(() => {
    return keycloakInstance?.tokenParsed;
  }, [keycloakInstance?.tokenParsed, token]);
  (0, import_react8.useEffect)(() => {
    setIsVisitorValue(isVisitor(assignedGroups));
  }, [assignedGroups, setIsVisitorValue]);
  (0, import_react8.useEffect)(() => {
    setPublicVisitorValue(isPublicVisitor(tokenParsed));
  }, [setPublicVisitorValue, tokenParsed]);
  return {
    visitor: visitorValue || publicVisitorValue,
    publicVisitor: publicVisitorValue,
    tokenParsed
  };
};

// src/providers/user/hooks/useCurrentUser.ts
var useCurrentUser = () => {
  const queryCurrentUser = (0, import_recoil37.useRecoilValueLoadable)(currentUserQuery);
  const currentUser = queryCurrentUser.state === "hasValue" ? queryCurrentUser.contents : {};
  const loadingUser = queryCurrentUser.state === "loading";
  const hasImportRights = userHasImportRights(currentUser?._embedded?.profile?.authorizations);
  const hasPublicShare = userHasPublicShare(currentUser?._embedded?.profile?.authorizations);
  const hasAttachmentsRights = userHasAttachmentsRights(
    currentUser?._embedded?.profile?.authorizations
  );
  const hasDynameekWriteAuthorization = userHasDynameekWriteAuthorization(
    currentUser?._embedded?.profile?.authorizations
  );
  const queryCurrentUserAssignedGroups = (0, import_recoil37.useRecoilValueLoadable)(currentUserAssignedGroupsQuery);
  const assignedGroup = queryCurrentUserAssignedGroups.state === "hasValue" ? queryCurrentUserAssignedGroups.contents : [];
  const loadingAssignedGroups = queryCurrentUserAssignedGroups.state === "loading" || assignedGroup.length === 0;
  const hasContactSheetsQuery = (0, import_recoil37.useRecoilValueLoadable)(contactSheetsSelector);
  const hasContactSheets = hasContactSheetsQuery.state === "hasValue" && hasContactSheetsQuery.contents && hasContactSheetsQuery.contents.length !== 0;
  const { visitor: isVisitor2, publicVisitor, tokenParsed } = useIsVisitor();
  return {
    currentUser,
    loadingUser,
    assignedGroup,
    loadingAssignedGroups,
    isVisitor: isVisitor2,
    isPublicVisitor: publicVisitor,
    isTech: isTechAdministrator(assignedGroup),
    isAdministrator: isAdministrator(assignedGroup),
    hasContactSheets,
    hasImportRights,
    hasPublicShare,
    hasAttachmentsRights,
    right: getUserRight(assignedGroup, tokenParsed),
    hasDynameekWriteAuthorization
  };
};

// src/providers/shareManager/selectors/shareManagerUnitaryPublicShareSelectors.ts
var mediaApiPublicShareSelector = (0, import_recoil38.selectorFamily)({
  key: "MediaApiPublicShareSelector",
  get: (element) => async ({ get }) => {
    const axiosInstance = get(getAxiosInstanceAtom);
    if (!axiosInstance) {
      return {
        link: void 0,
        status: import_api_client16.KpkApiPublicShareStatus.Deactivated,
        exportDefinition: import_api_client16.KpkApiPublicShareExportDefinition.None,
        downloadLevel: import_api_client16.KpkApiMediaDownloadLevel.None
      };
    }
    get(updateUnitaryPublicSharedState);
    const mediaSharePublic = await (0, import_api_client16.getMediaSharePublic)(axiosInstance(), { mediaId: element.id });
    const media = await (0, import_api_client16.getMedia)(axiosInstance(), { mediaId: element.id });
    const downloadLevel = media.data.downloadLevel;
    const status = mediaSharePublic.data.status || import_api_client16.KpkApiPublicShareStatus.Deactivated;
    const link = mediaSharePublic?.data?._links && status === import_api_client16.KpkApiPublicShareStatus.Activated ? mediaSharePublic?.data?._links["kpk:link"].href : void 0;
    let detailLink;
    if (mediaSharePublic?.data?._links && status === import_api_client16.KpkApiPublicShareStatus.Activated) {
      const detailHref = mediaSharePublic?.data?._links["kpk:detail"]?.href;
      detailLink = `${window.location.origin}/share/${detailHref.substring(
        detailHref.lastIndexOf("/") + 1
      )}/element/${element.id}`;
    }
    const deactivationDate = mediaSharePublic?.data?._links && status === import_api_client16.KpkApiPublicShareStatus.Activated ? mediaSharePublic?.data?.deactivationDate : void 0;
    const exportDefinition = mediaSharePublic?.data?.exportDefinition || import_api_client16.KpkApiPublicShareExportDefinition.HD;
    const attachmentVisible = mediaSharePublic?.data.attachmentsVisible;
    return {
      detailLink,
      link,
      status,
      deactivationDate,
      exportDefinition,
      downloadLevel,
      attachmentVisible
    };
  }
});
var shareUnitaryPublicShareEmbedSelector = (0, import_recoil38.selectorFamily)({
  key: "ShareUnitaryPublicShareEmbedSelector",
  get: (element) => ({ get }) => {
    const sizeType = get(shareUnitaryPublicShareSizeState);
    const sizeHeight = get(shareUnitaryPublicShareSizeHeightState);
    const sizeWidth = get(shareUnitaryPublicShareSizeWidthState);
    const mediaPublicShare = get(mediaApiPublicShareSelector(element));
    if (mediaPublicShare) {
      if (sizeType === "AUTO" /* AUTO */) {
        return `<object data="${mediaPublicShare.link ?? ""}" type="${element.mediaType}" />`;
      }
      return `<object data="${mediaPublicShare.link ?? ""}" width="${sizeWidth}" height="${sizeHeight}" type="${element.mediaType}"/>`;
    }
    return void 0;
  }
});
var shareUnitaryPublicShareSelector = (0, import_recoil38.selectorFamily)({
  key: "ShareUnitaryPublicShareSelector",
  get: (element) => ({ get }) => {
    const {
      detailLink,
      link,
      status,
      deactivationDate,
      exportDefinition,
      downloadLevel,
      attachmentVisible
    } = get(mediaApiPublicShareSelector(element));
    const embed = get(shareUnitaryPublicShareEmbedSelector(element));
    return {
      elementId: element.id,
      detailLink,
      link,
      status,
      embed,
      mediaType: element.mediaType,
      deactivationDate,
      title: element.title,
      exportDefinition,
      downloadLevel,
      attachmentVisible
    };
  }
});
var shareUnitaryPublicSharesSelector = (0, import_recoil38.selectorFamily)({
  key: "ShareElementsSelector",
  get: (elements) => ({ get }) => elements.map((element) => get(shareUnitaryPublicShareSelector(element)))
});
var shareManagerSelectionIdQuery = (0, import_recoil38.selector)({
  key: "shareManagerSelectionIdQuery",
  get: async ({ get }) => {
    const logger = get(getLoggerAtom);
    if (!logger) {
      throw new MandatoryProviderException("logger");
    }
    const axiosInstance = get(getAxiosInstanceAtom);
    if (!axiosInstance) {
      throw new MandatoryProviderException("axiosInstance");
    }
    const elementIds = get(shareManagerSelectionsIdsSelector);
    const userId = get(currentUserQuery).id;
    const tokenId = get(fetcherTokenIdAtom);
    const headers = get(shareTokenAxiosHeadersSelector);
    if (elementIds.length > 0 && tokenId && headers) {
      try {
        const postSelectionQuery = await (0, import_api_client16.postPublicShareSelection)(
          axiosInstance(),
          buildParamsForShare({ userId }, headers, tokenId)
        );
        if (!postSelectionQuery) {
          throw new Error("cannot post selection without authenticated user");
        }
        const {
          data: { id: selectionId }
        } = postSelectionQuery;
        await (0, import_api_client16.postPublicShareSelectionMediasCollection)(
          axiosInstance(),
          buildParamsForShare(
            {
              userId,
              selectionId,
              mediaIds: elementIds
            },
            headers,
            tokenId
          )
        );
        return { selectionId };
      } catch (error) {
        logger().error(`shareManagerSelectionIdQuery: ${error}`);
      }
    }
    return {
      selectionId: null
    };
  }
});

// src/providers/shareManager/selectors/shareManagerSelectionsSelector.ts
var shareManagerSelectionsSelector = (0, import_recoil39.selectorFamily)({
  key: "ShareManagerSelectionsSelector",
  get: (selections) => ({ get }) => {
    const getShareManagerConfiguration = get(shareManagerConfiguration);
    const basketTypeElements = selections.filter((s) => s.type === "BASKET" /* BASKET */).flatMap((s) => s.elements.map((e) => e.id));
    const elementTypeElements = selections.filter((s) => s.type === "UNITARY_PUBLIC_SHARE" /* UNITARY_PUBLIC_SHARE */).flatMap((s) => s.elements);
    const selectionsResolved = [];
    let basketsSelection;
    if (basketTypeElements.length > 0) {
      basketsSelection = {
        type: "BASKET" /* BASKET */,
        resolved: get(shareBasketsSelector(basketTypeElements))
      };
      selectionsResolved.push(basketsSelection);
    }
    let elementsSelection;
    const unitaryPublicShareActive = getShareManagerConfiguration?.unitaryPublicShare?.active ?? false;
    if (elementTypeElements.length > 0 && unitaryPublicShareActive) {
      elementsSelection = {
        type: "UNITARY_PUBLIC_SHARE" /* UNITARY_PUBLIC_SHARE */,
        resolved: get(shareUnitaryPublicSharesSelector(elementTypeElements))
      };
      selectionsResolved.push(elementsSelection);
    }
    return selectionsResolved;
  }
});
var shareManagerSelectionsIdsSelector = (0, import_recoil39.selector)({
  key: "ShareManagerSelectionsIdsSelector",
  get: ({ get }) => {
    const selections = get(shareManagerSelectionsState);
    return selections.map((s) => s.elements.map((e) => e.id)).flat();
  }
});

// src/providers/shareManager/hooks/useShareManagerSelections.ts
var useShareManagerSelections = () => {
  const { open, close } = useShareManagerOpen();
  const [selections, setSelections] = (0, import_recoil40.useRecoilState)(shareManagerSelectionsState);
  const selectionsResolvedQuery = (0, import_recoil40.useRecoilValueLoadable)(
    shareManagerSelectionsSelector(selections)
  );
  const loading = selectionsResolvedQuery.state === "loading";
  const selectionsResolved = selectionsResolvedQuery.state === "hasValue" ? selectionsResolvedQuery.contents : [];
  const selectionIdQuery = (0, import_recoil40.useRecoilValueLoadable)(shareManagerSelectionIdQuery);
  const loadingSelectionId = selectionIdQuery.state === "loading";
  const selectionId = selectionIdQuery.state === "hasValue" ? selectionIdQuery.contents.selectionId : null;
  const handleSelections = (selections2) => {
    setSelections(selections2);
    if (selections2.length > 0) {
      open();
    } else {
      close();
    }
  };
  const addToSelections = (selection) => {
    setSelections((prev) => {
      const computed = [...prev, selection];
      if (computed.length > 0) {
        open();
      } else {
        close();
      }
      return computed;
    });
  };
  const emptySelections = () => {
    setSelections([]);
    close();
  };
  return {
    handleSelections,
    addToSelections,
    emptySelections,
    loading,
    selectionsResolved,
    selectionId,
    loadingSelectionId
  };
};

// src/providers/shareManager/hooks/useShareManager.ts
var useShareManager = ({
  onUpdateShareManagerError
}) => {
  const managerOpen = useShareManagerOpen();
  const managerSelection = useShareManagerSelections();
  const managerActivation = useShareManagerActivation(onUpdateShareManagerError);
  const managerExportDefinition = useShareManagerExportDefinition();
  return {
    managerOpen,
    managerSelection,
    managerActivation,
    managerExportDefinition
  };
};

// src/providers/techPro/selectors.ts
var import_recoil41 = require("recoil");

// src/providers/techPro/utils.ts
var TECH_PRO_NAME = /* @__PURE__ */ ((TECH_PRO_NAME2) => {
  TECH_PRO_NAME2["EXPORT_NUMBER_LIMIT"] = "EXPORT_NUMBER_LIMIT";
  TECH_PRO_NAME2["API_PAGE_MAX_SIZE"] = "API_PAGE_MAX_SIZE";
  TECH_PRO_NAME2["ENABLE_REQUEST_DOWNLOAD_ON_READ_ONLY"] = "ENABLE_REQUEST_DOWNLOAD_ON_READ_ONLY";
  TECH_PRO_NAME2["MAX_MEDIAS_FOR_PDF_EXPORT"] = "MAX_MEDIAS_FOR_PDF_EXPORT";
  TECH_PRO_NAME2["AVAILABLE_LOCALE_LIST"] = "AVAILABLE_LOCALE_LIST";
  TECH_PRO_NAME2["DIRECT_EXPORT_NUMBER_LIMIT"] = "DIRECT_EXPORT_NUMBER_LIMIT";
  TECH_PRO_NAME2["THUMBNAIL_GENERATION_SERVICE_CONFIGURATION"] = "THUMBNAIL_GENERATION_SERVICE_CONFIGURATION";
  TECH_PRO_NAME2["ENABLE_PUBLIC_DOWNLOAD_REQUEST"] = "ENABLE_PUBLIC_DOWNLOAD_REQUEST";
  return TECH_PRO_NAME2;
})(TECH_PRO_NAME || {});
var techProDefaultValue = {
  ["EXPORT_NUMBER_LIMIT" /* EXPORT_NUMBER_LIMIT */]: 200,
  ["API_PAGE_MAX_SIZE" /* API_PAGE_MAX_SIZE */]: 1e3,
  ["ENABLE_REQUEST_DOWNLOAD_ON_READ_ONLY" /* ENABLE_REQUEST_DOWNLOAD_ON_READ_ONLY */]: true,
  ["MAX_MEDIAS_FOR_PDF_EXPORT" /* MAX_MEDIAS_FOR_PDF_EXPORT */]: 200,
  ["AVAILABLE_LOCALE_LIST" /* AVAILABLE_LOCALE_LIST */]: "EN",
  ["DIRECT_EXPORT_NUMBER_LIMIT" /* DIRECT_EXPORT_NUMBER_LIMIT */]: 50,
  ["THUMBNAIL_GENERATION_SERVICE_CONFIGURATION" /* THUMBNAIL_GENERATION_SERVICE_CONFIGURATION */]: {},
  ["ENABLE_PUBLIC_DOWNLOAD_REQUEST" /* ENABLE_PUBLIC_DOWNLOAD_REQUEST */]: false
};

// src/providers/techPro/selectors.ts
var pageMaxSizeSelector = (0, import_recoil41.selector)({
  key: "PageMaxSizeSelector",
  get: () => techProDefaultValue["API_PAGE_MAX_SIZE" /* API_PAGE_MAX_SIZE */]
});
var maxElementsByDownloadSelector = (0, import_recoil41.selector)({
  key: "MaxElementsByDownloadSelector",
  get: async ({ get }) => {
    const { getProperty: getProperty2 } = get(techProFetcherSelector(get(fetcherModeAtom)));
    const getPropertyQuery = await getProperty2({
      propertyId: "EXPORT_NUMBER_LIMIT" /* EXPORT_NUMBER_LIMIT */
    });
    if (!getPropertyQuery) {
      return techProDefaultValue["EXPORT_NUMBER_LIMIT" /* EXPORT_NUMBER_LIMIT */];
    }
    const {
      data: { value }
    } = getPropertyQuery;
    return value ? Number(value) : techProDefaultValue["EXPORT_NUMBER_LIMIT" /* EXPORT_NUMBER_LIMIT */];
  }
});
var maxElementsByContactSheetSelector = (0, import_recoil41.selector)({
  key: "MaxElementsByContactSheetSelector",
  get: async ({ get }) => {
    const { getProperty: getProperty2 } = get(techProFetcherSelector(get(fetcherModeAtom)));
    const getPropertyQuery = await getProperty2({
      propertyId: "MAX_MEDIAS_FOR_PDF_EXPORT" /* MAX_MEDIAS_FOR_PDF_EXPORT */
    });
    if (!getPropertyQuery) {
      return techProDefaultValue["MAX_MEDIAS_FOR_PDF_EXPORT" /* MAX_MEDIAS_FOR_PDF_EXPORT */];
    }
    const {
      data: { value }
    } = getPropertyQuery;
    return value ? Number(value) : techProDefaultValue["MAX_MEDIAS_FOR_PDF_EXPORT" /* MAX_MEDIAS_FOR_PDF_EXPORT */];
  }
});
var enableRequestDownloadOnReadOnlySelector = (0, import_recoil41.selector)({
  key: "EnableRequestDownloadOnReadOnlySelector",
  get: async ({ get }) => {
    try {
      const { getProperty: getProperty2 } = get(techProFetcherSelector(get(fetcherModeAtom)));
      const getPropertyQuery = await getProperty2({
        propertyId: "ENABLE_REQUEST_DOWNLOAD_ON_READ_ONLY" /* ENABLE_REQUEST_DOWNLOAD_ON_READ_ONLY */
      });
      if (!getPropertyQuery) {
        return techProDefaultValue["ENABLE_REQUEST_DOWNLOAD_ON_READ_ONLY" /* ENABLE_REQUEST_DOWNLOAD_ON_READ_ONLY */];
      }
      const {
        data: { value }
      } = getPropertyQuery;
      return value ? value.toLowerCase() === "true" : techProDefaultValue["ENABLE_REQUEST_DOWNLOAD_ON_READ_ONLY" /* ENABLE_REQUEST_DOWNLOAD_ON_READ_ONLY */];
    } catch (error) {
      return techProDefaultValue["ENABLE_REQUEST_DOWNLOAD_ON_READ_ONLY" /* ENABLE_REQUEST_DOWNLOAD_ON_READ_ONLY */];
    }
  }
});
var availableLocaleListSelector = (0, import_recoil41.selector)({
  key: "AvailableLocaleListSelector",
  get: async ({ get }) => {
    try {
      const { getProperty: getProperty2 } = get(techProFetcherSelector(get(fetcherModeAtom)));
      const getPropertyQuery = await getProperty2({
        propertyId: "AVAILABLE_LOCALE_LIST" /* AVAILABLE_LOCALE_LIST */
      });
      if (!getPropertyQuery) {
        return techProDefaultValue["AVAILABLE_LOCALE_LIST" /* AVAILABLE_LOCALE_LIST */];
      }
      const {
        data: { value }
      } = getPropertyQuery;
      if (value && value.includes("#")) {
        return value.split("#").map((v) => v.trim().toLowerCase());
      }
      return techProDefaultValue["AVAILABLE_LOCALE_LIST" /* AVAILABLE_LOCALE_LIST */];
    } catch (error) {
      return techProDefaultValue["AVAILABLE_LOCALE_LIST" /* AVAILABLE_LOCALE_LIST */];
    }
  }
});
var directExportNumberLimitSelector = (0, import_recoil41.selector)({
  key: "DirectExportNumberLimitSelector",
  get: async ({ get }) => {
    try {
      const { getProperty: getProperty2 } = get(techProFetcherSelector(get(fetcherModeAtom)));
      const getPropertyQuery = await getProperty2({
        propertyId: "DIRECT_EXPORT_NUMBER_LIMIT" /* DIRECT_EXPORT_NUMBER_LIMIT */,
        axiosRequestConfig: {
          handleErrorLocally: true
        }
      });
      if (!getPropertyQuery) {
        return techProDefaultValue["DIRECT_EXPORT_NUMBER_LIMIT" /* DIRECT_EXPORT_NUMBER_LIMIT */];
      }
      const {
        data: { value }
      } = getPropertyQuery;
      return value ? Number(value) : techProDefaultValue["DIRECT_EXPORT_NUMBER_LIMIT" /* DIRECT_EXPORT_NUMBER_LIMIT */];
    } catch (error) {
      return techProDefaultValue["DIRECT_EXPORT_NUMBER_LIMIT" /* DIRECT_EXPORT_NUMBER_LIMIT */];
    }
  }
});
var thumbnailGenerationServiceConfigurationSelector = (0, import_recoil41.selector)({
  key: "ThumbnailGenerationServiceConfigurationSelector",
  get: async ({ get }) => {
    try {
      const { getProperty: getProperty2 } = get(techProFetcherSelector(get(fetcherModeAtom)));
      const getPropertyQuery = await getProperty2({
        propertyId: "THUMBNAIL_GENERATION_SERVICE_CONFIGURATION" /* THUMBNAIL_GENERATION_SERVICE_CONFIGURATION */,
        axiosRequestConfig: {
          disableNotificationErrorCodes: [404]
        }
      });
      if (!getPropertyQuery) {
        return techProDefaultValue["THUMBNAIL_GENERATION_SERVICE_CONFIGURATION" /* THUMBNAIL_GENERATION_SERVICE_CONFIGURATION */];
      }
      const {
        data: { value }
      } = getPropertyQuery;
      return value ? JSON.parse(value) : techProDefaultValue["THUMBNAIL_GENERATION_SERVICE_CONFIGURATION" /* THUMBNAIL_GENERATION_SERVICE_CONFIGURATION */];
    } catch (error) {
      return techProDefaultValue["THUMBNAIL_GENERATION_SERVICE_CONFIGURATION" /* THUMBNAIL_GENERATION_SERVICE_CONFIGURATION */];
    }
  }
});
var enablePublicDownloadRequestSelector = (0, import_recoil41.selector)({
  key: "EnablePublicDownloadRequestSelector",
  get: async ({ get }) => {
    try {
      const { getProperty: getProperty2 } = get(techProFetcherSelector(get(fetcherModeAtom)));
      const getPropertyQuery = await getProperty2({
        propertyId: "ENABLE_PUBLIC_DOWNLOAD_REQUEST" /* ENABLE_PUBLIC_DOWNLOAD_REQUEST */
      });
      if (!getPropertyQuery) {
        return techProDefaultValue["ENABLE_PUBLIC_DOWNLOAD_REQUEST" /* ENABLE_PUBLIC_DOWNLOAD_REQUEST */];
      }
      const {
        data: { value }
      } = getPropertyQuery;
      return value ? value.toLowerCase() === "true" : techProDefaultValue["ENABLE_PUBLIC_DOWNLOAD_REQUEST" /* ENABLE_PUBLIC_DOWNLOAD_REQUEST */];
    } catch (error) {
      return techProDefaultValue["ENABLE_PUBLIC_DOWNLOAD_REQUEST" /* ENABLE_PUBLIC_DOWNLOAD_REQUEST */];
    }
  }
});
var genericTechProSelector = (0, import_recoil41.selectorFamily)({
  key: "genericTechProSelector",
  get: (techProName) => async ({ get }) => {
    const { getProperty: getProperty2 } = get(techProFetcherSelector(get(fetcherModeAtom)));
    const getPropertyQuery = await getProperty2({
      propertyId: techProName,
      axiosRequestConfig: {
        disableNotificationErrorCodes: [404]
      }
    });
    return getPropertyQuery?.data.value;
  }
});

// src/providers/share/hooks/useShareToken.ts
var useShareToken = (pathname, tokenIdParam) => {
  const share = useShare(pathname, tokenIdParam);
  const tokenId = (0, import_recoil42.useRecoilValue)(fetcherTokenIdAtom);
  const shareTokenQuery = (0, import_recoil42.useRecoilValueLoadable)(shareTokenQuerySelector(tokenId));
  const [shareAccessCode, setShareAccessCode] = (0, import_recoil42.useRecoilState)(shareAccessCodeState(tokenId));
  const [shareAccessCodeModal, setShareAccessCodeModal] = (0, import_recoil42.useRecoilState)(
    shareAccessCodeModalState(tokenId)
  );
  const getShareManagerConfiguration = (0, import_recoil42.useRecoilValue)(shareManagerConfiguration);
  const loading = shareTokenQuery.state === "loading";
  const shareToken = shareTokenQuery.state === "hasValue" ? shareTokenQuery.contents : void 0;
  const status = shareTokenQuery.state === "hasError" ? shareTokenQuery.contents.response?.status : void 0;
  const message = shareTokenQuery.state === "hasError" ? shareTokenQuery.contents.response?.data?.message : void 0;
  const shareTokenUnauthorized = status === 401 && message === "share-token-unauthorized";
  const shareTokenNotFound = status === 404 && message === "share-token-not-found";
  const enablePublicDownloadRequest = (0, import_recoil42.useRecoilValue)(enablePublicDownloadRequestSelector);
  const shareTokenDownloadAuthorized = !!(shareToken && (shareToken.exportDefinition !== import_api_client17.KpkApiPublicShareTokenExportDefinition.None || getShareManagerConfiguration?.enableAskDownload && enablePublicDownloadRequest));
  const shareTokenAttachementAuthorized = shareToken && shareToken.exportDefinition === import_api_client17.KpkApiPublicShareTokenExportDefinition.HD && shareToken.attachmentsVisible ? true : false;
  (0, import_react9.useEffect)(() => {
    if (!loading) {
      setShareAccessCodeModal(shareTokenUnauthorized);
    }
  }, [loading, setShareAccessCodeModal, shareTokenUnauthorized]);
  const accessCodeError = shareAccessCode && shareAccessCode.length > 0 && shareTokenUnauthorized ? true : false;
  return {
    ...share,
    loading,
    shareToken,
    shareTokenUnauthorized,
    shareTokenNotFound,
    shareTokenDownloadAuthorized,
    shareTokenAttachementAuthorized,
    shareAccessCodeModal,
    accessCodeError,
    shareAccessCode,
    setShareAccessCode
  };
};

// src/providers/sheetField/utils.ts
var import_api_client18 = require("@keepeek/api-client");
var sheetFieldsSizeToFetch = 500;
async function getAllLoggedSheetFields(axiosInstance) {
  return getAllSheetFields((params) => (0, import_api_client18.getSheetFields)(axiosInstance, params));
}
async function getAllPublicShareSheetFields(axiosInstance, params) {
  return getAllSheetFields((p) => (0, import_api_client18.getPublicShareSheetFields)(axiosInstance, { ...p, ...params }));
}
async function getAllSheetFields(getSheetFieldsApi2) {
  let page = 1;
  const data = await fetchSheetFieldsData(getSheetFieldsApi2, page);
  let ret = data._embedded?.["sheet-field"] || [];
  const totalCount = data.totalCount || 0;
  if (totalCount > 0) {
    while (ret.length < totalCount) {
      page++;
      const tmp = await fetchSheetFieldsData(getSheetFieldsApi2, page);
      if (!tmp._embedded || !tmp._embedded["sheet-field"] || tmp._embedded["sheet-field"].length === 0) {
        break;
      }
      ret = [...ret, ...tmp._embedded?.["sheet-field"] || []];
    }
  }
  return ret;
}
async function fetchSheetFieldsData(getSheetFieldsApi2, page) {
  const result = await getSheetFieldsApi2({
    size: sheetFieldsSizeToFetch,
    page
  });
  return result.data;
}

// src/providers/fetcher/selectors/sheetField.ts
var sheetFieldsFetcherSelector = (0, import_recoil43.selectorFamily)({
  key: "SheetFieldsFetcherSelector",
  get: (mode) => ({ get }) => {
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    switch (mode) {
      case 0 /* SHARE */:
        const tokenId = get(fetcherTokenIdAtom);
        const headers = get(shareTokenAxiosHeadersSelector);
        return {
          getSheetFields: () => {
            return getAllPublicShareSheetFields(
              getAxiosInstance(),
              buildParamsForShare(null, headers, tokenId)
            );
          }
        };
      default:
        const isAuthenticated = get(isAuthenticatedSelector);
        return {
          getSheetFields: () => {
            if (!isAuthenticated) {
              getLogger().debug("SheetFieldsFetcherSelector Cannot fetch without auth");
              return new Promise((resolve) => resolve(void 0));
            }
            return getAllLoggedSheetFields(getAxiosInstance());
          }
        };
    }
  }
});

// src/providers/fetcher/selectors/techPro.ts
var import_api_client19 = require("@keepeek/api-client");
var import_recoil44 = require("recoil");
var techProFetcherSelector = (0, import_recoil44.selectorFamily)({
  key: "TechProFetcherSelector",
  get: (mode) => ({ get }) => {
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    switch (mode) {
      case 0 /* SHARE */:
        return {
          getProperty: (params) => {
            return (0, import_api_client19.getPublicProperty)(getAxiosInstance(), params);
          }
        };
      default:
        const isAuthenticated = get(isAuthenticatedSelector);
        return {
          getProperty: (params) => {
            if (!isAuthenticated) {
              getLogger().debug("TechProFetcherSelector Cannot fetch without auth");
              return new Promise((resolve) => resolve(void 0));
            }
            return (0, import_api_client19.getProperty)(getAxiosInstance(), params);
          }
        };
    }
  }
});

// src/providers/fetcher/selectors/element.ts
var import_api_client20 = require("@keepeek/api-client");
var import_recoil45 = require("recoil");
var elementFetcherSelector = (0, import_recoil45.selectorFamily)({
  key: "ElementFetcherSelector",
  get: ({ fetcherMode, embeddedFolders }) => ({ get }) => {
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    switch (fetcherMode) {
      case 0 /* SHARE */:
        const tokenId = get(fetcherTokenIdAtom);
        const headers = get(shareTokenAxiosHeadersSelector);
        return {
          getElement: (elementId) => {
            return (0, import_api_client20.getPublicSharedMedia)(
              getAxiosInstance(),
              buildParamsForShare(
                {
                  sharedMediaId: elementId
                },
                headers,
                tokenId
              )
            );
          },
          getElementPath: (elementId) => `/share/${tokenId}/element/${elementId}`,
          getElementPermalinks: () => {
            getLogger().debug(
              "ElementFetcherSelector - getElementPermalinks - Cannot fetch without auth"
            );
            return Promise.resolve(void 0);
          },
          updateElement: () => {
            getLogger().debug(
              "ElementFetcherSelector - updateElement - Cannot fetch without auth"
            );
            return Promise.resolve(void 0);
          }
        };
      default:
        const isAuthenticated = get(isAuthenticatedSelector);
        return {
          getElement: (elementId) => {
            if (!isAuthenticated) {
              return Promise.resolve(void 0);
            }
            return (0, import_api_client20.getMedia)(getAxiosInstance(), {
              mediaId: elementId,
              embeddedFolders
            });
          },
          getElementPath: (elementId) => `element/?id=${elementId}`,
          getElementPermalinks: (elementId) => {
            if (!isAuthenticated) {
              return Promise.resolve(void 0);
            }
            return (0, import_api_client20.getMediaPermalinks)(getAxiosInstance(), {
              mediaId: elementId
            });
          },
          updateElement: (params) => {
            if (!isAuthenticated) {
              return Promise.resolve(void 0);
            }
            return (0, import_api_client20.updateMedia)(getAxiosInstance(), params);
          }
        };
    }
  }
});

// src/providers/fetcher/selectors/signatures.ts
var import_api_client21 = require("@keepeek/api-client");
var import_recoil46 = require("recoil");
var signaturesFetcherSelector = (0, import_recoil46.selectorFamily)({
  key: "SignaturesFetcherSelector",
  get: (mode) => ({ get }) => {
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    switch (mode) {
      case 0 /* SHARE */:
        return {
          getSignedLinks: () => {
            getLogger().debug("SignaturesFetcherSelector Cannot fetch without auth");
            return new Promise((resolve) => resolve(void 0));
          }
        };
      default:
        const isAuthenticated = get(isAuthenticatedSelector);
        return {
          getSignedLinks: (params) => {
            if (!isAuthenticated) {
              getLogger().debug("SignaturesFetcherSelector Cannot fetch without auth");
              return new Promise((resolve) => resolve(void 0));
            }
            return (0, import_api_client21.getSignedLinks)(getAxiosInstance(), params);
          }
        };
    }
  }
});

// src/providers/fetcher/selectors/advancedSearch.ts
var import_recoil47 = require("recoil");
var advancedSearchCriteriasFetcherSelector = (0, import_recoil47.selectorFamily)({
  key: "AdvancedSearchCriteriasFetcherSelector",
  get: (mode) => ({ get }) => {
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    switch (mode) {
      case 0 /* SHARE */:
        return {
          getAdvancedSearchCriterias: () => {
            return new Promise((resolve) => {
              resolve([]);
            });
          }
        };
      default:
        const isAuthenticated = get(isAuthenticatedSelector);
        return {
          getAdvancedSearchCriterias: () => {
            if (!isAuthenticated) {
              return Promise.resolve(void 0);
            }
            return getAllAdvancedSearchCriterias(getAxiosInstance());
          }
        };
    }
  }
});

// src/providers/fetcher/selectors/dataviewElement.ts
var import_recoil48 = require("recoil");
var ELEMENT_SUMMARY_ID_PREFIX = "elementSummary-";
var dataviewElementFetcherSelector = (0, import_recoil48.selectorFamily)({
  key: "DataviewElementFetcherSelector",
  get: (mode) => ({ get }) => {
    const tokenId = get(fetcherTokenIdAtom);
    switch (mode) {
      case 0 /* SHARE */:
        return {
          getElementBackContext: (elementId, query) => {
            return {
              sourcePage: {
                pathname: `/share/${tokenId}`,
                query,
                hash: `${ELEMENT_SUMMARY_ID_PREFIX}${elementId}`
              },
              targetPage: { pathname: `/share/${tokenId}/element/${elementId}` }
            };
          }
        };
      default:
        return {
          getElementBackContext: (elementId, query) => {
            return {
              sourcePage: {
                pathname: `/search`,
                query,
                hash: `${ELEMENT_SUMMARY_ID_PREFIX}${elementId}`
              },
              targetPage: { pathname: `/element`, query: { id: elementId } }
            };
          }
        };
    }
  }
});

// src/providers/fetcher/selectors/userThumbnailTemplates.ts
var import_api_client22 = require("@keepeek/api-client");
var import_recoil49 = require("recoil");
var userThumbnailTemplatesFetcherSelector = (0, import_recoil49.selectorFamily)({
  key: "UserThumbnailTemplatesFetcherSelector",
  get: (mode) => ({ get }) => {
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    switch (mode) {
      case 0 /* SHARE */:
        return {
          getUserThumbnailTemplates: () => {
            getLogger().debug("UserThumbnailTemplatesFetcherSelector Cannot fetch without auth");
            return new Promise((resolve) => resolve(void 0));
          },
          createUserThumbnailTemplate: () => {
            getLogger().debug("UserThumbnailTemplatesFetcherSelector Cannot fetch without auth");
            return new Promise((resolve) => resolve(void 0));
          },
          updateUserThumbnailTemplate: () => {
            getLogger().debug("UserThumbnailTemplatesFetcherSelector Cannot fetch without auth");
            return new Promise((resolve) => resolve(void 0));
          },
          deleteUserThumbnailTemplate: () => {
            getLogger().debug("UserThumbnailTemplatesFetcherSelector Cannot fetch without auth");
            return new Promise((resolve) => resolve(void 0));
          }
        };
      default:
        const isAuthenticated = get(isAuthenticatedSelector);
        return {
          getUserThumbnailTemplates: (params) => {
            if (!isAuthenticated) {
              getLogger().debug(
                "UserThumbnailTemplatesFetcherSelector Cannot fetch without auth"
              );
              return new Promise((resolve) => resolve(void 0));
            }
            return (0, import_api_client22.getUserThumbnailTemplates)(getAxiosInstance(), params);
          },
          createUserThumbnailTemplate: (params) => {
            if (!isAuthenticated) {
              getLogger().debug(
                "UserThumbnailTemplatesFetcherSelector Cannot fetch without auth"
              );
              return new Promise((resolve) => resolve(void 0));
            }
            return (0, import_api_client22.createUserThumbnailTemplate)(getAxiosInstance(), params);
          },
          updateUserThumbnailTemplate: (params) => {
            if (!isAuthenticated) {
              getLogger().debug(
                "UserThumbnailTemplatesFetcherSelector Cannot fetch without auth"
              );
              return new Promise((resolve) => resolve(void 0));
            }
            return (0, import_api_client22.updateUserThumbnailTemplate)(getAxiosInstance(), params);
          },
          deleteUserThumbnailTemplate: (params) => {
            if (!isAuthenticated) {
              getLogger().debug(
                "UserThumbnailTemplatesFetcherSelector Cannot fetch without auth"
              );
              return new Promise((resolve) => resolve(void 0));
            }
            return (0, import_api_client22.deleteUserThumbnailTemplate)(getAxiosInstance(), params);
          }
        };
    }
  }
});

// src/providers/advancedSearch/selectors.ts
var advancedSearchCriteriasSelector = (0, import_recoil50.selector)(
  {
    key: "AdvancedSearchCriteriasSelector",
    get: async ({ get }) => {
      const { getAdvancedSearchCriterias: getAdvancedSearchCriterias2 } = get(
        advancedSearchCriteriasFetcherSelector(get(fetcherModeAtom))
      );
      return await getAdvancedSearchCriterias2();
    }
  }
);

// src/providers/form/atoms.ts
var import_recoil51 = require("recoil");
var formAtom = (0, import_recoil51.atom)({ key: "FormAtom", default: void 0 });

// src/providers/form/selector/formsQuerySelector.ts
var import_recoil52 = require("recoil");
var formsQuerySelector = (0, import_recoil52.selector)({
  key: "FormQuerySelector",
  get: async ({ get }) => {
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    const forms = get(formAtom);
    if (forms) {
      return forms;
    }
    try {
      const { getForms: getForms2 } = get(formFetcherSelector(get(fetcherModeAtom)));
      return await getForms2() || null;
    } catch (error) {
      getLogger().info("formQuerySelector", error);
    }
    return null;
  },
  set: ({ set }, newValue) => set(formAtom, newValue)
});

// src/providers/form/selector/formQuerySelector.ts
var import_recoil53 = require("recoil");
var formQuerySelector = (0, import_recoil53.selectorFamily)({
  key: "FormQuerySelector",
  get: ({ id }) => async ({ get }) => {
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    try {
      const { getForm } = get(formFetcherSelector(get(fetcherModeAtom)));
      return await getForm(id) || null;
    } catch (error) {
      getLogger().info("formQuerySelector", error);
    }
    return null;
  }
});

// src/providers/sheetField/atoms.ts
var import_recoil54 = require("recoil");
var sheetFieldsAtom = (0, import_recoil54.atomFamily)({
  key: "SheetFieldsAtom",
  default: void 0
});

// src/providers/sheetField/hooks.ts
var import_recoil56 = require("recoil");

// src/providers/sheetField/selectors.ts
var import_recoil55 = require("recoil");
var sheetFieldsSelector = (0, import_recoil55.selector)({
  key: "SheetFieldsSelector",
  get: async ({ get }) => {
    const currentLocale = get(currentLocaleAtom);
    if (!currentLocale) {
      console.debug("sheetFieldsSelector current locale atom is not valued");
      return;
    }
    return get(getSheetFieldsSelector(currentLocale));
  }
});
var getSheetFieldsSelector = (0, import_recoil55.selectorFamily)({
  key: "GetSheetFieldsSelector",
  get: () => async ({ get }) => {
    const { getSheetFields } = get(sheetFieldsFetcherSelector(get(fetcherModeAtom)));
    return getSheetFields();
  }
});

// src/providers/sheetField/hooks.ts
var useSheetFields = () => {
  const sheetFieldsQuery = (0, import_recoil56.useRecoilValueLoadable)(sheetFieldsSelector);
  const loading = sheetFieldsQuery.state === "loading";
  const sheetFields = sheetFieldsQuery.state === "hasValue" ? sheetFieldsQuery.contents : void 0;
  return { loading, sheetFields };
};

// src/providers/lookups/hooks.ts
var import_recoil58 = require("recoil");

// src/providers/lookups/selectors.ts
var import_api_client23 = require("@keepeek/api-client");
var import_recoil57 = require("recoil");
var lookupSelector = (0, import_recoil57.selectorFamily)({
  key: "LookupSelector",
  get: (lookupId) => async ({ get }) => {
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    if (!lookupId) {
      return void 0;
    }
    const lookup = await (0, import_api_client23.getLookup)(getAxiosInstance(), {
      lookupId
    });
    return lookup.data;
  }
});

// src/providers/lookups/hooks.ts
var useLookup = ({
  lookupId
}) => {
  const loadable = (0, import_recoil58.useRecoilValueLoadable)(lookupSelector(lookupId));
  const loading = loadable.state === "loading";
  const lookup = loadable.state === "hasValue" ? loadable.contents : void 0;
  return { loading, lookup };
};

// src/providers/stats/hooks/useStats.ts
var import_api_client24 = require("@keepeek/api-client");
var import_react10 = require("react");
var import_recoil59 = require("recoil");

// src/providers/stats/utils/index.ts
var CONNECTION_HIT_SESSION_STORAGE_ITEM_NAME = "CONNECTION_HIT";
var REFERRER_SESSION_STORAGE_ITEM_NAME = "REFERRER";
var LS_KC_SESSION_ID = "LS_KC_SESSION_ID";
function removeStatsSessionStorageItems() {
  sessionStorage.removeItem(REFERRER_SESSION_STORAGE_ITEM_NAME);
}

// src/providers/stats/hooks/useStats.ts
var useStats = ({
  ip,
  isPublicShare = false
}) => {
  const logger = (0, import_recoil59.useRecoilValue)(getLoggerAtom);
  const axiosInstance = (0, import_recoil59.useRecoilValue)(getAxiosInstanceAtom);
  const keycloakInstance = (0, import_recoil59.useRecoilValue)(keycloakInstanceAtom);
  const { currentUser } = useCurrentUser();
  const publicVisitorValue = (0, import_recoil59.useRecoilValue)(isPublicVisitorState);
  const sendHit = (0, import_react10.useCallback)(
    async (params) => {
      if (!ip) {
        console.debug("useStats - sendHit: cannot send the stat hit because of missing ip");
        return Promise.resolve(false);
      }
      if (!axiosInstance) {
        console.debug("useStats - sendHit: Instance axios not inited");
        return Promise.resolve(false);
      }
      if (!keycloakInstance || !keycloakInstance.clientId) {
        console.debug("Instance keycloak not initialized");
        return Promise.resolve(false);
      }
      if ((!currentUser || !currentUser.id) && !publicVisitorValue && !isPublicShare) {
        console.debug("Current user not initialized");
        return Promise.resolve(false);
      }
      const referrer = sessionStorage.getItem(REFERRER_SESSION_STORAGE_ITEM_NAME) || void 0;
      const date = new Date();
      const sessionId = keycloakInstance.sessionId;
      const hitParams = {
        axiosRequestConfig: {
          handleErrorLocally: true
        },
        users: [
          !publicVisitorValue && !isPublicShare ? {
            userId: currentUser.id
          } : {}
        ],
        referrer,
        date,
        ip,
        sessionId,
        ...params
      };
      try {
        const response = await (0, import_api_client24.createHit)(axiosInstance(), { ...hitParams });
        return Promise.resolve(response.status === 200);
      } catch (error) {
        logger && logger().error(`useStats - sendHit: can't send hit with`, hitParams, error);
        return Promise.resolve(false);
      }
    },
    [axiosInstance, currentUser, ip, isPublicShare, keycloakInstance, logger, publicVisitorValue]
  );
  return {
    sendHit
  };
};

// src/providers/stats/hooks/useStatsConnectionHit.ts
var import_api_client25 = require("@keepeek/api-client");
var import_react11 = require("react");
var import_recoil60 = require("recoil");
var useStatsConnectionHit = ({
  ip
}) => {
  const { sendHit } = useStats({ ip });
  const logger = (0, import_recoil60.useRecoilValue)(getLoggerAtom);
  const keycloakInstance = (0, import_recoil60.useRecoilValue)(keycloakInstanceAtom);
  const sendingRef = (0, import_react11.useRef)(false);
  const sentRef = (0, import_react11.useRef)(false);
  const { currentUser } = useCurrentUser();
  const publicVisitorValue = (0, import_recoil60.useRecoilValue)(isPublicVisitorState);
  (0, import_react11.useEffect)(() => {
    if (!logger) {
      return;
    }
    if ((!currentUser || !currentUser.id) && !publicVisitorValue) {
      logger().debug("[sendConnectionHit] currentUser not defined");
      return;
    }
    if (!ip) {
      logger().debug("[sendConnectionHit] won't send without IP");
      return;
    }
    if (isServerSide()) {
      logger().debug(`[sendConnectionHit] do not send stat server side`);
      return;
    }
    logger().debug(`[sendConnectionHit] start the sequence`);
    const sessionId = keycloakInstance?.sessionId;
    const lsSessionId = localStorage.getItem(LS_KC_SESSION_ID);
    if (!sessionId) {
      logger().debug("[sendConnectionHit] won't send without sessionId");
      return;
    }
    if (sessionId === lsSessionId) {
      logger().debug("[sendConnectionHit] won't send because this sessionId has already hit");
      sentRef.current = true;
      return;
    }
    if (sendingRef.current) {
      return;
    }
    sendingRef.current = true;
    const sendStat = async () => {
      let result = false;
      try {
        result = await sendHit({
          connection: {
            mode: import_api_client25.KpkApiHitConnectionMode.Sso,
            success: keycloakInstance?.authenticated
          },
          type: import_api_client25.KpkApiHitHitType.Connection
        });
        logger().debug(`[sendConnectionHit] ${result ? "success" : "failed"}`);
      } catch (err) {
        logger && logger().error(`[sendConnectionHit] error`, err);
      } finally {
        sendingRef.current = false;
        sentRef.current = result;
        if (result) {
          localStorage.setItem(LS_KC_SESSION_ID, sessionId);
        }
      }
    };
    sendStat();
  }, [
    ip,
    keycloakInstance?.sessionId,
    logger,
    currentUser,
    keycloakInstance?.authenticated,
    sendHit,
    publicVisitorValue
  ]);
  return {
    sending: sendingRef.current,
    sent: sentRef.current
  };
};

// src/providers/stats/hooks/useStatsViewHit.ts
var import_api_client26 = require("@keepeek/api-client");
var import_react12 = require("react");
var import_recoil61 = require("recoil");
var useStatsViewHit = ({
  element,
  queryId,
  userId,
  needPlayer,
  ip,
  isPublicShare
}) => {
  const logger = (0, import_recoil61.useRecoilValue)(getLoggerAtom);
  const { sendHit } = useStats({ ip, isPublicShare });
  const sendViewHit = (0, import_react12.useCallback)(
    async ({ elementId }) => {
      if (!logger) {
        return false;
      }
      if (!elementId) {
        logger().debug(`[sendViewHit] cannot send hit because no mediaId was given`);
        return false;
      }
      logger().debug(`[sendViewHit] for mediaId=${elementId}`);
      if (isServerSide()) {
        logger().debug(`[sendViewHit] do not send stat server side`);
        return false;
      }
      return await sendHit({ type: import_api_client26.KpkApiHitHitType.View, medias: [{ mediaId: elementId }] });
    },
    [logger, sendHit]
  );
  (0, import_react12.useEffect)(() => {
    const elementId = element?.id || null;
    const mediaType = element?.mediaType || null;
    const playerUsed = mediaType && needPlayer;
    if (!playerUsed && (userId || isPublicShare) && elementId && queryId && elementId === queryId) {
      sendViewHit({ elementId });
    }
  }, [
    element?.formType,
    element?.id,
    element?.mediaType,
    isPublicShare,
    needPlayer,
    queryId,
    sendViewHit,
    userId
  ]);
};

// src/providers/stats/hooks/useStatsSearchHit.ts
var import_api_client27 = require("@keepeek/api-client");
var import_recoil62 = require("recoil");
var useStatsSearchHit = ({ ip }) => {
  const { sendHit } = useStats({ ip });
  const logger = (0, import_recoil62.useRecoilValue)(getLoggerAtom);
  const sendSearchHit = async (params) => {
    if (!logger) {
      return false;
    }
    return await sendHit({
      type: import_api_client27.KpkApiHitHitType.Search,
      search: params
    });
  };
  const sendTextSearchHit = async ({
    searchValue,
    resultCount
  }) => {
    if (!logger) {
      return false;
    }
    return await sendHit({
      type: import_api_client27.KpkApiHitHitType.Search,
      search: {
        searchType: import_api_client27.KpkApiHitSearchType.Text,
        searchValue,
        resultCount
      }
    });
  };
  const sendFolderSearchHit = async ({
    folderId,
    resultCount
  }) => {
    if (!logger) {
      return false;
    }
    return await sendHit({
      type: import_api_client27.KpkApiHitHitType.Search,
      folders: [{ folderId }],
      search: {
        searchType: import_api_client27.KpkApiHitSearchType.Folder,
        searchValue: "",
        resultCount
      }
    });
  };
  return { sendSearchHit, sendTextSearchHit, sendFolderSearchHit };
};

// src/providers/stats/hooks/useStatsDownloadHit.ts
var import_api_client28 = require("@keepeek/api-client");
var import_react13 = require("react");
var import_recoil63 = require("recoil");
var useStatsDownloadHit = ({
  ip
}) => {
  const { sendHit } = useStats({ ip });
  const logger = (0, import_recoil63.useRecoilValue)(getLoggerAtom);
  return (0, import_react13.useCallback)(
    async ({ elementId, usage }) => {
      console.log("sendDownloadHit");
      if (!logger) {
        return false;
      }
      if (!elementId) {
        logger().debug(`[sendDownloadHit] cannot send hit because no mediaId was given`);
        return false;
      }
      logger().debug(`[sendDownloadHit] for mediaId=${elementId}`);
      if (isServerSide()) {
        logger().debug(`[sendDownloadHit] do not send stat server side`);
        return false;
      }
      return sendHit({
        type: import_api_client28.KpkApiHitHitType.Download,
        medias: [{ mediaId: elementId }],
        ...usage && { download: { usage } }
      });
    },
    [logger, sendHit]
  );
};

// src/providers/stats/hooks/useStatsQueueListener.ts
var import_react21 = require("react");
var import_recoil101 = require("recoil");

// src/providers/stats/atoms.ts
var import_recoil64 = require("recoil");
var statsSearchValueForTextAtom = (0, import_recoil64.atom)({
  key: "StatsSearchValueForTextAtom",
  default: void 0
});
var statsFolderIdForFolderHit = (0, import_recoil64.atom)({
  key: "statsFolderIdForFolderHit",
  default: void 0
});

// src/providers/dataView/hooks/useClearSelectionRules.ts
var import_react14 = require("react");
var import_recoil92 = require("recoil");

// src/providers/dataView/atoms.ts
var import_recoil65 = require("recoil");

// src/providers/dataView/constants.ts
var DATAVIEW_DEFAULT_SIZE = 40;
var DATAVIEW_BASKET_DEFAULT_SIZE = 20;
var DATAVIEW_DEFAULT_PAGE = 1;
var DATAVIEW_DEFAULT_SORT = "";
var DATAVIEW_DEFAULT_TOTAL_COUNT = -1;
var DATAVIEW_DEFAULT_SCROLL = {
  x: 0,
  y: 0
};
var SORT_LIST_DEFAULT_FIELDS = [
  {
    field: "importDate" /* IMPORT_DATE */,
    direction: "DESC" /* Desc */,
    default: true
  },
  {
    field: "title",
    direction: "ASC" /* Asc */
  },
  {
    field: "title",
    direction: "DESC" /* Desc */
  }
];

// src/providers/dataView/types.ts
var SpecificDataviewType = /* @__PURE__ */ ((SpecificDataviewType3) => {
  SpecificDataviewType3["MOSAIC"] = "mosaic";
  SpecificDataviewType3["LIST"] = "list";
  SpecificDataviewType3["MASONRY"] = "masonry";
  return SpecificDataviewType3;
})(SpecificDataviewType || {});
var SelectAllStatus = /* @__PURE__ */ ((SelectAllStatus2) => {
  SelectAllStatus2["ALL"] = "all";
  SelectAllStatus2["PARTIAL"] = "partial";
  SelectAllStatus2["NONE"] = "none";
  return SelectAllStatus2;
})(SelectAllStatus || {});
var MasonryViewSize = /* @__PURE__ */ ((MasonryViewSize2) => {
  MasonryViewSize2[MasonryViewSize2["Small"] = 240] = "Small";
  MasonryViewSize2[MasonryViewSize2["Medium"] = 320] = "Medium";
  MasonryViewSize2[MasonryViewSize2["Large"] = 400] = "Large";
  return MasonryViewSize2;
})(MasonryViewSize || {});
var ListViewSize = /* @__PURE__ */ ((ListViewSize2) => {
  ListViewSize2["L"] = "L";
  ListViewSize2["XL"] = "XL";
  return ListViewSize2;
})(ListViewSize || {});

// src/providers/dataView/atoms.ts
var dataViewPage = (0, import_recoil65.atomFamily)({
  key: "DataViewPage",
  default: DATAVIEW_DEFAULT_PAGE,
  effects: (key2) => [localStorageEffect(`DataViewPage-${key2}`)]
});
var dataViewSize = (0, import_recoil65.atomFamily)({
  key: "DataViewSize",
  default: (key2) => {
    if (key2 === "basket" /* BASKET */) {
      return DATAVIEW_BASKET_DEFAULT_SIZE;
    } else if (key2 === "association" /* ASSOCIATION */) {
      return 1e3;
    }
    return DATAVIEW_DEFAULT_SIZE;
  },
  effects: (key2) => [localStorageEffect(`DataViewSizeAtom-${key2}`)]
});
var dataViewListSize = (0, import_recoil65.atom)({
  key: "DataViewListSize",
  default: "L" /* L */,
  effects: [localStorageEffect(`DataViewListSize`)]
});
var dataViewSort = (0, import_recoil65.atomFamily)({
  key: "DataViewSort",
  default: void 0,
  effects: (key2) => [localStorageEffect(`DataViewSort-${key2}`)]
});
var dataViewSortsConfiguration = (0, import_recoil65.atom)({
  key: "DataViewSortsConfiguration",
  default: void 0
});
var dataViewAdvancedSearchPermanentFiltersConfiguration = (0, import_recoil65.atom)({
  key: "DataViewAdvancedSearchPermanentFiltersConfiguration",
  default: void 0
});
var dataViewFieldsConfiguration = (0, import_recoil65.atom)({
  key: "DataViewFieldsConfiguration",
  default: void 0
});
var dataViewElementsButtonsConfiguration = (0, import_recoil65.atom)({
  key: "DataViewElementsButtonsConfiguration",
  default: void 0
});
var dataViewElementsAuthorizedIconsConfiguration = (0, import_recoil65.atom)({
  key: "DataViewElementsAuthorizedIconsConfiguration",
  default: void 0
});
var dataViewElementsThumbnailSizeConfiguration = (0, import_recoil65.atom)({
  key: "DataViewElementsThumbnailSizeConfiguration",
  default: void 0
});
var dataViewElementsElementIdDisplayRuleConfiguration = (0, import_recoil65.atom)({
  key: "DataViewElementsElementIdDisplayRuleConfiguration",
  default: void 0
});
var dataViewElementsVisualAlertConfiguration = (0, import_recoil65.atom)({
  key: "dataViewElementsVisualAlertConfiguration",
  default: void 0
});
var dataViewElementsLinksConfiguration = (0, import_recoil65.atom)({
  key: "DataViewElementsLinksConfiguration",
  default: void 0
});
var dataViewDisplayMode = (0, import_recoil65.atomFamily)({
  key: "DataViewDisplayMode",
  default: void 0,
  effects: (key2) => [localStorageEffect(`DataViewDisplayMode-${key2}`)]
});
var dataViewMasonryDisplaySize = (0, import_recoil65.atomFamily)({
  key: "DataViewMasonryDisplaySize",
  default: 240 /* Small */,
  effects: (key2) => [localStorageEffect(`DataViewMasonryDisplaySize-${key2}`)]
});
var dataViewScroll = (0, import_recoil65.atomFamily)({
  key: "DataViewScroll",
  default: DATAVIEW_DEFAULT_SCROLL,
  effects: (key2) => [sessionStorageEffect(`DataViewScroll-${key2}`)]
});
var selectedElements = (0, import_recoil65.atomFamily)({
  key: "SelectedElements",
  default: [],
  effects: (key2) => [localStorageEffect(`SelectedElements-${key2}`)]
});
var shouldSelectAllInCurrentSearch = (0, import_recoil65.atomFamily)({
  key: "ShouldSelectAllAtom",
  default: false
});
var selectBasketIdForFetch = (0, import_recoil65.atom)({
  key: "SelectBasketIdForFetch",
  default: -1
});
var shouldUpdateAdvancedSearchId = (0, import_recoil65.atomFamily)({
  key: "ShouldUpdateAdvancedSearchId",
  default: 0
});
var shouldRefreshGetAdvancedSearchQuery = (0, import_recoil65.atomFamily)({
  key: "ShouldRefreshGetAdvancedSearchQuery",
  default: 0
});
var shouldNotCreateAdvancedId = (0, import_recoil65.atomFamily)({
  key: "ShouldNotCreateAdvancedId",
  default: false
});
var shouldClearSelectedElementsByKeysAtom = (0, import_recoil65.atom)({
  key: "ShouldClearSelectedElementsByKeys",
  default: []
});

// src/providers/dataView/selectors/create.ts
var import_recoil68 = require("recoil");
var import_uuid = require("uuid");

// src/providers/fetcher/dataview.ts
var import_api_client30 = require("@keepeek/api-client");
var import_recoil67 = require("recoil");

// src/providers/dataLocale/selectors.ts
var import_recoil66 = require("recoil");
var import_api_client29 = require("@keepeek/api-client");
var currentDataLocaleSelector = (0, import_recoil66.selector)({
  key: "CurrentDataLocaleSelector",
  get: async ({ get }) => {
    const currentLocale = get(currentLocaleAtom);
    const interfaceLanguage = currentLocale || "";
    const availableLocaleList = get(availableLocaleListSelector);
    if (availableLocaleList.includes(interfaceLanguage)) {
      return interfaceLanguage;
    } else {
      const axiosInstance = get(getAxiosInstanceAtom);
      if (!axiosInstance) {
        throw new MandatoryProviderException("axiosInstance");
      }
      const logger = get(getLoggerAtom);
      if (!logger) {
        throw new MandatoryProviderException("logger");
      }
      const isAuthenticated = get(isAuthenticatedSelector);
      if (!isAuthenticated) {
        const fallbackLocale = availableLocaleList.length > 0 ? availableLocaleList[0] : interfaceLanguage;
        logger().debug(
          `currentDataLocaleSelector not authenticated : get first available locale ${fallbackLocale}`
        );
        return fallbackLocale;
      }
      const res = await (0, import_api_client29.getDam)(axiosInstance());
      return res.headers["content-language"];
    }
  }
});

// src/providers/fetcher/dataview.ts
var dataViewFetcherSelector = (0, import_recoil67.selectorFamily)({
  key: "DataViewFetcherSelector",
  get: (mode) => ({ get }) => {
    const isAuthenticated = get(isAuthenticatedSelector);
    const currentDataLocale = get(currentDataLocaleSelector);
    const tokenId = get(fetcherTokenIdAtom);
    const headers = get(shareTokenAxiosHeadersSelector);
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    switch (mode) {
      case 0 /* SHARE */:
        return {
          createAdvancedSearch: (filter) => {
            return (0, import_api_client30.createPublicShareAdvancedSearch)(
              getAxiosInstance(),
              buildParamsForShare(
                {
                  filter
                },
                headers,
                tokenId
              )
            );
          },
          getAdvancedSearch: (params) => {
            return (0, import_api_client30.getPublicShareAdvancedSearch)(
              getAxiosInstance(),
              buildParamsForShare(params, headers, tokenId)
            );
          }
        };
      default:
        if (!isAuthenticated || !currentDataLocale) {
          console.debug(
            "dataViewFetcherSelector current locale atom is not valued or isAuthenticated is false",
            {
              isAuthenticated,
              currentDataLocale
            }
          );
          return {
            createAdvancedSearch: () => Promise.resolve(void 0),
            getAdvancedSearch: () => Promise.resolve(void 0)
          };
        }
        return {
          createAdvancedSearch: (filter) => {
            const acc = filter.reduce(
              (acc2, f) => {
                if (f.type === import_api_client30.KpkApiAdvancedSearchFilterType.Thesaurusfield) {
                  const internalFieldNameWithLocale = f.internalFieldName?.split(".");
                  acc2.push({
                    ...f,
                    type: import_api_client30.KpkApiAdvancedSearchFilterType.Textfield,
                    internalFieldName: internalFieldNameWithLocale?.length === 1 ? `${f.internalFieldName}.${currentDataLocale.toUpperCase()}` : f.internalFieldName
                  });
                } else {
                  acc2.push(f);
                }
                return acc2;
              },
              []
            );
            return (0, import_api_client30.createAdvancedSearch)(getAxiosInstance(), {
              filter: acc,
              notFoundReference: true
            });
          },
          getAdvancedSearch: (searchParams) => {
            return (0, import_api_client30.getAdvancedSearch)(getAxiosInstance(), searchParams);
          }
        };
    }
  }
});

// src/providers/dataView/utils.ts
var import_sanitize_url = require("@braintree/sanitize-url");
var import_api_client31 = require("@keepeek/api-client");
function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[[\]]/g, "\\$&");
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec((0, import_sanitize_url.sanitizeUrl)(url));
  if (!results)
    return null;
  if (!results[2])
    return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
var advancedSearchIsExpired = (expirationDate) => {
  return (0, import_dayjs.default)().isSame((0, import_dayjs.default)(expirationDate)) || (0, import_dayjs.default)().isAfter((0, import_dayjs.default)(expirationDate));
};
var mergePermanentFilters = (filters, permanentFilters) => {
  if (filters.length === 0 && permanentFilters.length === 0) {
    return [];
  } else if (filters.length === 0) {
    return permanentFilters;
  } else if (permanentFilters.length === 0) {
    return filters;
  }
  let mergedFilters = [];
  let tempPermaFilters = [...permanentFilters];
  const evaluation = (pf, f) => (pf && pf.internalFieldName) === (f && f.internalFieldName);
  filters.forEach((filter) => {
    const matchIndex = tempPermaFilters.findIndex((pf) => evaluation(pf, filter));
    if (matchIndex === -1) {
      mergedFilters.push(filter);
    } else if (matchIndex !== -1) {
      switch (filter.type) {
        case import_api_client31.KpkApiAdvancedSearchFilterType.Folderfield:
          mergedFilters.push(filter);
          break;
        default: {
          if (filter.modifier === tempPermaFilters[matchIndex].modifier) {
            const mergedFilter = {
              ...filter,
              values: [...filter?.values ?? [], ...tempPermaFilters[matchIndex]?.values ?? []]
            };
            mergedFilters.push(mergedFilter);
          } else {
            mergedFilters.push(filter);
            mergedFilters.push(tempPermaFilters[matchIndex]);
          }
          break;
        }
      }
      delete tempPermaFilters[matchIndex];
    }
  });
  tempPermaFilters = tempPermaFilters.filter((pf) => pf);
  mergedFilters = [...mergedFilters, ...tempPermaFilters];
  return mergedFilters;
};
var convertToRightType = (value) => {
  try {
    return JSON.parse(value.toLowerCase());
  } catch (e) {
    if (Number.isInteger(value)) {
      return Number.parseInt(value);
    }
    return value;
  }
};
function getBusinessFilterFirstValue(businessFilters, nature, filterId) {
  const filter = businessFilters?.find(
    (f) => f.nature === nature && f.filter.id === filterId
  )?.filter;
  if (filter && filter.values && filter.values.length > 0) {
    return filter.values[0];
  }
  return;
}
function getBusinessFilterFullTextValue(businessFilters) {
  const fullTextFilterValue = getBusinessFilterFirstValue(
    businessFilters,
    "FULL_TEXT" /* FULL_TEXT */,
    "FULL_TEXT" /* FULL_TEXT */
  );
  if (fullTextFilterValue) {
    return fullTextFilterValue.id;
  }
  return "";
}
function buildOptimizedLightDataviewElementsSelector({
  key: key2,
  filtersConfiguration,
  filters,
  size = 1,
  enableFacets = true
}) {
  return serializeComplexeParamsForRecoil({
    key: key2,
    sort: "id-desc",
    size,
    page: 1,
    filtersConfiguration,
    filters,
    overrideFields: ["id"],
    enableFacets
  });
}

// src/utils/permanent-filters-utils.ts
function convertPermanentFiltersToKpkApiAdvancedSearchFilter(permanentFilters) {
  if (!permanentFilters) {
    return [];
  }
  return permanentFilters.map((f) => {
    return {
      internalFieldName: f.internalFieldName,
      fieldType: f.fieldType,
      modifier: f.modifier,
      showSub: f.showSub,
      type: f.type,
      values: f.values
    };
  });
}

// src/providers/dataView/selectors/create.ts
var dataViewAdvancedSearchFilterSelector = (0, import_recoil68.selectorFamily)({
  key: "DataViewAdvancedSearchFilterSelector",
  get: (filters) => function({ get }) {
    const logger = get(getLoggerAtom);
    if (!logger) {
      throw new MandatoryProviderException("logger");
    }
    const permanentFilters = get(dataViewAdvancedSearchPermanentFiltersConfiguration);
    if (permanentFilters === void 0) {
      logger().debug(
        "dataViewAdvancedSearchFilterSelector permanentFilters is mandatory cancel call => we are in loading state ?"
      );
      return null;
    }
    const criterias = get(advancedSearchCriteriasSelector) || [];
    const convertedFilters = extractAdvancedFilters(
      filters,
      criterias,
      get(customerCommonOverrideAtom)
    );
    const assignedGroups = get(currentUserAssignedGroupsQuery);
    const filteredPermanentFilters = permanentFilters.filter(
      (pf) => !Array.isArray(pf.profileIds) || !pf.profileIds.length || pf.profileIds.some((f) => hasValidGroupById(assignedGroups, f))
    );
    const convertedPermanentFilters = convertPermanentFiltersToKpkApiAdvancedSearchFilter(filteredPermanentFilters);
    const parametersFiltersTyped = convertedPermanentFilters.map((pf) => ({
      ...pf,
      values: pf.values?.map((v) => convertToRightType(v))
    }));
    return mergePermanentFilters(convertedFilters, parametersFiltersTyped);
  }
});
var dataViewAdvancedSearchIdQuery = (0, import_recoil68.selectorFamily)({
  key: "DataViewAdvancedSearchIdQuery",
  get: ({ filters }) => async ({ get }) => {
    const { createAdvancedSearch: createAdvancedSearch2 } = get(dataViewFetcherSelector(get(fetcherModeAtom)));
    const createdAdvancedSearch = await createAdvancedSearch2(filters);
    if (!createdAdvancedSearch) {
      return null;
    }
    return {
      advancedSearchId: createdAdvancedSearch.data.id || "",
      expirationDate: createdAdvancedSearch.data.expirationDate || ""
    };
  }
});
var dataViewAdvancedSearchId = (0, import_recoil68.selectorFamily)({
  key: "DataViewAdvancedSearchId",
  get: ({ key: key2, filters }) => function({ get }) {
    const logger = get(getLoggerAtom);
    if (!logger) {
      throw new MandatoryProviderException("logger");
    }
    const shouldNot = get(shouldNotCreateAdvancedId(key2));
    if (shouldNot) {
      logger().debug("dataViewAdvancedSearchId shouldNot");
      return null;
    }
    const isAuthenticated = get(isAuthenticatedSelector);
    const update = get(shouldUpdateAdvancedSearchId(key2));
    let advancedSearchFilters = null;
    if (filters) {
      advancedSearchFilters = get(
        dataViewAdvancedSearchFilterSelector(
          filters.map((f) => serializeComplexeParamsForRecoil(f))
        )
      );
    }
    if (advancedSearchFilters === null) {
      logger().debug(
        "dataViewAdvancedSearchId advancedSearchFilters is mandatory cancel call => we are in loading state ?"
      );
      return null;
    }
    const keycloakInstance = get(keycloakInstanceAtom);
    const uuidData = JSON.stringify({
      key: key2,
      update,
      isAuthenticated,
      filters: advancedSearchFilters,
      sessionId: keycloakInstance?.sessionId
    });
    const cacheKey = `DataViewAdvancedSearchId-${(0, import_uuid.v5)(uuidData, import_uuid.v5.URL)}`;
    const advancedSearchFromCache = sessionStorage.getItem(cacheKey);
    if (advancedSearchFromCache) {
      logger().debug(`dataViewAdvancedSearchId from cache ${cacheKey}`, advancedSearchFromCache);
      return JSON.parse(advancedSearchFromCache);
    }
    const advancedSearch = get(
      dataViewAdvancedSearchIdQuery(
        serializeComplexeParamsForRecoil({
          update,
          isAuthenticated,
          filters: advancedSearchFilters
        })
      )
    );
    if (advancedSearch) {
      sessionStorage.setItem(cacheKey, JSON.stringify(advancedSearch));
      logger().debug(`Set dataViewAdvancedSearchId in cache ${cacheKey}`, advancedSearch);
    }
    return advancedSearch;
  }
});

// src/providers/dataView/selectors/element.ts
var import_uniq2 = __toESM(require("lodash/uniq"));
var import_recoil89 = require("recoil");

// src/providers/dataView/selectors/sort.ts
var import_recoil69 = require("recoil");
var dataViewSortSelector = (0, import_recoil69.selectorFamily)({
  key: "DataViewSortSelector",
  get: (key2) => ({ get }) => {
    const sortConfig = get(dataViewDefaultSortSelector);
    const currentSort = get(dataViewSort(key2));
    const fallbackSort = SORT_LIST_DEFAULT_FIELDS.find((sort) => sort.default);
    if (currentSort) {
      return currentSort;
    } else if (sortConfig) {
      return `${sortConfig.field}-${sortConfig.direction}`;
    } else {
      return `${fallbackSort?.field}-${fallbackSort?.direction}`;
    }
  },
  set: (key2) => ({ set }, newValue) => {
    set(dataViewSort(key2), newValue);
  }
});
var dataViewDefaultSortSelector = (0, import_recoil69.selector)({
  key: "DataViewDefaultSortSelector",
  get: ({ get }) => {
    const sortsConfig = get(dataViewSortsConfiguration);
    const defaultSortConf = sortsConfig?.find((f) => f.default);
    if (defaultSortConf) {
      return {
        default: true,
        field: defaultSortConf.field,
        direction: defaultSortConf.direction
      };
    } else {
      return void 0;
    }
  }
});

// src/providers/businessFilter/atoms/activeBusinessFilters.ts
var import_recoil70 = require("recoil");
var activeBusinessFiltersState = (0, import_recoil70.atomFamily)({
  key: "ActiveBusinessFilters",
  default: void 0
});

// src/providers/businessFilter/atoms/businessFiltersConfiguration.ts
var import_recoil71 = require("recoil");
var businessFiltersConfiguration = (0, import_recoil71.atom)({
  key: "BusinessFiltersConfiguration",
  default: void 0,
  effects: [localStorageEffect(`BusinessFiltersConfiguration`)]
});

// src/providers/businessFilter/atoms/fixedFacets.ts
var import_recoil72 = require("recoil");
var fixedFacetsState = (0, import_recoil72.atomFamily)({
  key: "FixedFacetsState",
  default: []
});

// src/providers/businessFilter/atoms/state.ts
var import_recoil73 = require("recoil");
var businessFilterPanelIsOpenStateConfiguration = (0, import_recoil73.atom)({
  key: "BusinessFilterPanelIsOpenStateConfiguration",
  default: false,
  effects: [localStorageEffect(`BusinessFilterPanelIsOpenStateConfiguration`)]
});
var businessFilterPanelIsOpenState = (0, import_recoil73.atom)({
  key: "BusinessFilterPanelIsOpenState",
  default: businessFilterPanelIsOpenStateConfiguration,
  effects: [localStorageEffect("BusinessFilterPanelIsOpenState")]
});
var businessFilterIsExpandedState = (0, import_recoil73.atomFamily)({
  key: "BusinessFilterIsExpandedState",
  default: false,
  effects: ({ key: key2, id }) => [localStorageEffect(`BusinessFilterIsExpandedState-${key2}-${id}`)]
});
var businessFilterGroupIsExpandedState = (0, import_recoil73.atomFamily)({
  key: "BusinessFilterGroupIsExpandedState",
  default: false
});

// src/providers/businessFilter/atoms/onActiveBusinessFiltersChange.ts
var import_recoil74 = require("recoil");
var onActiveBusinessFiltersChangeState = (0, import_recoil74.atom)({
  key: "OnActiveBusinessFiltersChange",
  default: void 0
});

// src/providers/businessFilter/hooks/useBounceSearch.ts
var import_recoil77 = require("recoil");

// src/providers/businessFilter/utils/getters.ts
function getLastThesaurusTerm(title) {
  if (!title || title.indexOf(">") <= 0) {
    return title;
  }
  return title.substr(title.lastIndexOf(">") + 2);
}

// src/providers/businessFilter/utils/converters/convertBusinessFilterWithKpkFilter.ts
function convertBusinessFilterToKpkFilter(businessFilter) {
  return {
    ...businessFilter.filter,
    id: `${businessFilter.nature}-${businessFilter.filter.id}`
  };
}
function convertKpkFilterToBusinessFilter(kpkFilter) {
  const nature = kpkFilter.id.split("-")[0];
  return {
    nature,
    filter: {
      ...kpkFilter,
      id: kpkFilter.id.substr(nature.length + 1)
    }
  };
}

// src/providers/businessFilter/utils/converters/convertKpkApiFacetToBusinessFilter.ts
var import_api_client32 = require("@keepeek/api-client");
var import_sortBy = __toESM(require("lodash/sortBy"));

// src/providers/businessFilter/constants.ts
var FQ_PARAMETER = "fq";
var FOLDERS_FACET_NAME_BEGIN = "folders";
var NO_FACETS_COUNT = "noFacetsCount";

// src/providers/businessFilter/utils/converters/convertKpkApiFacetToBusinessFilter.ts
var convertKpkApiFacetToBusinessFilter = ({
  kpkApiFacet,
  hideFacetOccurrences,
  sortDirection,
  sortByOccurrences,
  isSelected,
  facetType,
  activeFilters
}) => {
  let entries = (0, import_sortBy.default)(kpkApiFacet._embedded?.entry, [
    function(entry) {
      let facetValue = getLastThesaurusTerm(entry.value);
      facetValue = facetValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      return sortByOccurrences ? entry.count : facetValue;
    }
  ]);
  if (sortDirection === "DESC") {
    entries = entries.reverse();
  }
  const filterId = facetType && facetType === "facet" /* Facet */ ? kpkApiFacet.id : kpkApiFacet.id?.split(".")[0];
  let internalName;
  if (import_api_client32.KpkApiFacetType.Microthesaurus === kpkApiFacet.type) {
    const url = entries[0]._links && entries[0]._links["kpk:media-search"] ? entries[0]._links["kpk:media-search"].href : "";
    internalName = extractInternalNameFromLink(url, kpkApiFacet.id) || activeFilters?.find((f) => f.filter.id === kpkApiFacet.id)?.filter.internalName;
  }
  return {
    nature: facetType && facetType === "facet" /* Facet */ ? "FACET" /* FACET */ : "FACET_MULTI" /* FACET_MULTI */,
    filter: {
      id: filterId || "",
      label: kpkApiFacet.title || "",
      type: facetType && facetType === "facet" /* Facet */ ? "RADIO_FACET" /* RadioFacet */ : "CHECKBOX" /* Checkbox */,
      modifiers: null,
      internalName,
      values: entries.map((e) => {
        let label = e.value;
        let title = e.value.replaceAll("#", "/");
        let newId = e.value;
        const selected = isSelected ? isSelected : false;
        if (kpkApiFacet.type === import_api_client32.KpkApiFacetType.Microthesaurus) {
          label = getLastThesaurusTerm(title);
          if (e.id) {
            newId = e.id;
          }
        } else if (kpkApiFacet.type === import_api_client32.KpkApiFacetType.Date) {
          const date = new Date(Date.parse(e.value));
          title = date.getFullYear();
          label = title;
          newId = date.getTime();
        } else if (kpkApiFacet.id?.startsWith(FOLDERS_FACET_NAME_BEGIN)) {
          label = e.value ? e.value.substr(e.value.lastIndexOf("#") + 1) : "";
        }
        return {
          id: newId,
          label,
          title,
          selected,
          count: !hideFacetOccurrences ? e.count : void 0,
          mediaSearchLink: e._links && e._links["kpk:media-search"] ? e._links["kpk:media-search"].href : "",
          path: e.path ? e.path : ""
        };
      }) || []
    }
  };
};
var extractInternalNameFromLink = (link, fieldId) => {
  if (!fieldId) {
    return void 0;
  }
  const parameterValueFqs = new URLSearchParams(link).getAll(FQ_PARAMETER);
  if (parameterValueFqs) {
    const fieldNameWithoutLocale = fieldId.split(".").length === 2 ? fieldId.split(".")[0] : fieldId;
    const parameterValueFq = parameterValueFqs.find((fq) => fq.includes(fieldNameWithoutLocale));
    if (parameterValueFq && parameterValueFq.includes("facet:" /* Facet */)) {
      if (!parameterValueFq.includes(fieldId)) {
        if (parameterValueFq.split(":").length === 3) {
          return parameterValueFq.split(":")[1];
        }
      }
    }
  }
  return void 0;
};

// src/providers/businessFilter/utils/converters/convertBusinessFilterFilterWithBusinessFilter.ts
var convertBusinessFilterFilterToBusinessFilterFacet = (filter, facets = [], activeFilters) => {
  const facetMatch = facets.find(
    (f) => f.id === filter.name || f.id?.startsWith(`${filter.name}.`) || filter.name === "folderId" /* FOLDER_ID */ && f.id?.startsWith(FOLDERS_FACET_NAME_BEGIN)
  );
  if (!facetMatch) {
    return void 0;
  }
  const sortDirection = filter?.orderDirectionFacetValues ?? "ASC" /* Asc */;
  const sortByOccurrences = filter?.orderTypeFacetValues === "occurrences" /* Occurrences */ || false;
  const hideFacetOccurrences = filter?.hideFacetOccurrences || false;
  return convertKpkApiFacetToBusinessFilter({
    kpkApiFacet: facetMatch,
    hideFacetOccurrences,
    sortDirection,
    sortByOccurrences,
    isSelected: void 0,
    facetType: filter?.type,
    activeFilters
  });
};

// src/providers/businessFilter/utils/create/createAdvancedBusinessFilter.ts
var import_trim = __toESM(require("lodash/trim"));
function createAdvancedBusinessFilter({
  fieldId,
  query,
  filterLabel,
  searchSeparator,
  ignoreQuerySplit,
  enableNotFoundReference
}) {
  let separator = /\s/;
  if (searchSeparator) {
    separator = new RegExp(searchSeparator);
  }
  let querySplit;
  if (ignoreQuerySplit) {
    querySplit = [query];
  } else {
    querySplit = query.split(separator).map((value) => (0, import_trim.default)(value)).filter((value) => value !== "");
  }
  const filterValues = querySplit.map((value) => ({
    id: value,
    label: value,
    selected: null
  }));
  return {
    nature: "ADVANCED" /* ADVANCED */,
    hide: true,
    filter: {
      id: fieldId,
      label: filterLabel,
      modifiers: [{ type: "EQUALS_ONE" /* EqualsOne */, selected: true }],
      type: "TEXT" /* Text */,
      values: filterValues,
      ...enableNotFoundReference && { notFoundReference: true }
    }
  };
}
function createAdvancedThesaurusBusinessFilter({
  fieldId,
  query,
  filterLabel,
  searchSeparator,
  enableNotFoundReference
}) {
  let separator = /\s/;
  if (searchSeparator) {
    separator = new RegExp(searchSeparator);
  }
  const querySplit = query.split(separator).map((value) => (0, import_trim.default)(value)).filter((value) => value !== "");
  const filterValues = querySplit.map((value) => ({
    id: value,
    label: value,
    selected: null
  }));
  return {
    nature: "ADVANCED" /* ADVANCED */,
    hide: true,
    filter: {
      id: fieldId,
      label: filterLabel,
      modifiers: [{ type: "CONTAINS_ONE" /* ContainsOne */, selected: true }],
      type: "TEXT" /* Text */,
      values: filterValues,
      ...enableNotFoundReference && { notFoundReference: true }
    }
  };
}

// src/providers/businessFilter/utils/create/createBasketBusinessFilter.ts
function createBasketBusinessFilter(basketId) {
  return {
    nature: "BASKET" /* BASKET */,
    filter: {
      id: "BASKET" /* BASKET */,
      label: "basketId",
      type: "BASKET" /* Basket */,
      modifiers: null,
      values: [
        {
          id: basketId,
          label: "basketId",
          title: "",
          selected: null
        }
      ]
    },
    hide: true
  };
}

// src/providers/businessFilter/utils/create/createFullTextBusinessFilter.ts
function createFullTextBusinessFilter(search, filterLabel) {
  return {
    nature: "FULL_TEXT" /* FULL_TEXT */,
    filter: {
      id: "FULL_TEXT" /* FULL_TEXT */,
      values: [
        {
          id: search,
          label: search,
          selected: null
        }
      ],
      type: "TEXT" /* Text */,
      label: filterLabel,
      modifiers: null
    }
  };
}

// src/providers/businessFilter/utils/create/createFacetForBounceSearch.ts
function createFacetForBounceSearch({
  facetId,
  language,
  label,
  value,
  type,
  synonym
}) {
  return {
    id: `${facetId}.${language.toUpperCase()}`,
    title: label,
    type,
    _embedded: {
      entry: [
        {
          value,
          path: synonym ? value += `###${synonym}` : ""
        }
      ]
    }
  };
}

// src/providers/businessFilter/utils/create/createFolderBusinessFilter.ts
function createFolderBusinessFilter(folderId, folderName, filterLabel, filterPath) {
  return {
    nature: "ADVANCED" /* ADVANCED */,
    filter: {
      id: "folderId" /* FOLDER_ID */,
      label: filterLabel,
      modifiers: [{ type: "EQUALS_ONE" /* EqualsOne */, selected: true }],
      type: "FOLDER" /* Folder */,
      values: [
        {
          id: folderId,
          label: folderName,
          title: filterPath ?? folderName,
          selected: null
        }
      ]
    }
  };
}

// src/providers/businessFilter/utils/create/buildAdvancedFilterList.ts
var import_api_client35 = require("@keepeek/api-client");
var import_react_i18next4 = require("react-i18next");

// src/providers/businessFilter/utils/types/convertKpkApiAdvancedSearchCriteriaTypeToKpkFilterType.ts
var import_api_client33 = require("@keepeek/api-client");
function convertKpkApiAdvancedSearchCriteriaTypeToKpkFilterType(advancedSearchType) {
  switch (advancedSearchType) {
    case import_api_client33.KpkApiAdvancedSearchCriteriaType.Textarea:
    case import_api_client33.KpkApiAdvancedSearchCriteriaType.Textfield:
    case import_api_client33.KpkApiAdvancedSearchCriteriaType.Emailfield:
    case import_api_client33.KpkApiAdvancedSearchCriteriaType.Extensionfield:
      return "TEXT" /* Text */;
    case import_api_client33.KpkApiAdvancedSearchCriteriaType.Folderfield:
      return "FOLDER" /* Folder */;
    case import_api_client33.KpkApiAdvancedSearchCriteriaType.Datefield:
    case import_api_client33.KpkApiAdvancedSearchCriteriaType.Datetimefield:
      return "DATE" /* Date */;
    case import_api_client33.KpkApiAdvancedSearchCriteriaType.Checkboxfield:
      return "RADIO" /* Radio */;
    case import_api_client33.KpkApiAdvancedSearchCriteriaType.Durationfield:
      return "DURATION" /* Duration */;
    case import_api_client33.KpkApiAdvancedSearchCriteriaType.Thesaurusfield:
      return "THESAURUS" /* Thesaurus */;
    case import_api_client33.KpkApiAdvancedSearchCriteriaType.Tagsfield:
      return "TAGS" /* Tags */;
    default:
      return null;
  }
}

// src/providers/businessFilter/utils/types/convertKpkMetaFieldTypeToKpkApiFacetType.ts
var import_api_client34 = require("@keepeek/api-client");
function convertKpkMetaFieldTypeToKpkApiFacetType(type) {
  return Object.values(import_api_client34.KpkApiFacetType).find(
    (kpkApiFacetType) => kpkApiFacetType.valueOf() === type
  );
}

// src/providers/businessFilter/utils/types/getKpkFilter.ts
function getKpkFilter({
  businessFilterToConvert,
  activeValues,
  activeFilters,
  noFacetsCount
}) {
  const kpkFilterToReturn = convertBusinessFilterToKpkFilter(businessFilterToConvert);
  let values = activeValues;
  const activeFilterModifiers = activeFilters?.find(
    (activeFilter) => activeFilter.filter.id === businessFilterToConvert.filter.id
  )?.filter.modifiers;
  if (activeFilterModifiers) {
    kpkFilterToReturn.modifiers = activeFilterModifiers;
  }
  if (businessFilterToConvert.nature === "FACET" /* FACET */ || businessFilterToConvert.nature === "FACET_MULTI" /* FACET_MULTI */) {
    values = kpkFilterToReturn.values.map((v) => {
      const value = activeValues.find((av) => av.id === v.id) || v;
      const displayCount = !noFacetsCount && value.count && (businessFilterToConvert.nature === "FACET" /* FACET */ || !activeValues || activeValues.length === 0);
      if (kpkFilterToReturn.type === "RADIO_FACET" /* RadioFacet */ || kpkFilterToReturn.type === "CHECKBOX" /* Checkbox */) {
        if (typeof value.id === "number") {
          return {
            ...value,
            label: value.label + (displayCount ? ` (${value.count})` : ""),
            title: value.title + (displayCount ? ` (${value.count})` : "")
          };
        }
        if (businessFilterToConvert.filter.id.startsWith(FOLDERS_FACET_NAME_BEGIN)) {
          return {
            ...value,
            label: value.label + (displayCount ? ` (${value.count})` : ""),
            title: value.title + (displayCount ? ` (${value.count})` : "")
          };
        }
        return {
          ...value,
          label: getLastThesaurusTerm(value.id) + (displayCount ? ` (${value.count})` : ""),
          title: value.id + (displayCount ? ` (${value.count})` : "")
        };
      }
      return {
        ...value,
        label: value.label + (displayCount ? ` (${value.count})` : ""),
        title: value.title + (displayCount ? ` (${value.count})` : "")
      };
    });
  }
  const mergedWithActiveValues = {
    ...kpkFilterToReturn,
    ...values && values.length > 0 && { values }
  };
  return mergedWithActiveValues;
}

// src/providers/businessFilter/utils/create/buildAdvancedFilterList.ts
function buildAdvancedFilterList(internalName, sheetFields, criterias) {
  const ret = [];
  if (!internalName) {
    return ret;
  }
  const filteredCriteriaList = criterias?.filter((c) => c.internalFieldName === internalName) ?? [];
  if ((!filteredCriteriaList || filteredCriteriaList.length === 0) && criterias) {
    filteredCriteriaList.push(
      ...criterias.filter((c) => c.internalFieldName?.startsWith(`${internalName}.`))
    );
  }
  if (!filteredCriteriaList || filteredCriteriaList.length === 0) {
    console.debug(`No data from API for advanced filter ${internalName}`);
    return ret;
  }
  for (const criteria of filteredCriteriaList) {
    if (!criteria.availableModifiers) {
      console.info(`No availableModifiers from API for advanced filter ${internalName}`);
      continue;
    }
    const filterType = convertKpkApiAdvancedSearchCriteriaTypeToKpkFilterType(criteria.type);
    if (!filterType) {
      console.info("this filter type is not implemented", criteria);
      continue;
    }
    let filterLabel = internalName;
    const internalFieldName = getInternalNameWithoutLocale(criteria.internalFieldName || "");
    if (!internalFieldName) {
      continue;
    }
    if (criteria.fieldType === import_api_client35.KpkApiAdvancedSearchCriteriaFieldType.Metafield) {
      const sheetField = sheetFields?.find((sf) => sf.id === internalFieldName);
      if (sheetField && sheetField.title) {
        filterLabel = sheetField.title;
      }
    } else if (criteria.fieldType === import_api_client35.KpkApiAdvancedSearchCriteriaFieldType.Mediafield) {
      filterLabel = (0, import_react_i18next4.getI18n)().t(`mediafield_${internalFieldName}`, {
        ns: "refront-components"
      });
    }
    const values = [];
    let modifiers = criteria.availableModifiers.map(
      (apiModifier) => {
        return {
          selected: null,
          type: apiModifier
        };
      }
    );
    if (filterType === "THESAURUS" /* Thesaurus */) {
      modifiers = [
        {
          type: "CONTAINS_ONE" /* ContainsOne */,
          selected: true
        }
      ];
    }
    if (filterType === "RADIO" /* Radio */) {
      values.push(
        {
          id: true,
          label: (0, import_react_i18next4.getI18n)().t("components.business-filter.advanced.radio.yes.label", {
            ns: "refront-components"
          }),
          selected: false
        },
        {
          id: false,
          label: (0, import_react_i18next4.getI18n)().t("components.business-filter.advanced.radio.no.label", {
            ns: "refront-components"
          }),
          selected: false
        }
      );
      modifiers = [
        {
          type: "CONTAINS_ONE" /* ContainsOne */,
          selected: true
        }
      ];
    }
    ret.push({
      nature: "ADVANCED" /* ADVANCED */,
      filter: {
        id: criteria.internalFieldName || "",
        label: filterLabel,
        values,
        modifiers,
        type: filterType
      }
    });
  }
  return ret;
}

// src/providers/businessFilter/utils/create/createAssociationsBusinessFilter.ts
function createAssociationsBusinessFilter(mediaIds, types) {
  const values = mediaIds.map((mediaId) => {
    return {
      id: mediaId,
      label: "mediaId",
      title: "",
      selected: null
    };
  });
  types?.map((typeId) => {
    values.push({
      id: typeId,
      label: "typeId",
      title: "",
      selected: null
    });
  });
  return {
    nature: "ASSOCIATIONS" /* ASSOCIATIONS */,
    filter: {
      id: "ASSOCIATIONS" /* ASSOCIATIONS */,
      label: "associations",
      type: "ASSOCIATIONS" /* Associations */,
      modifiers: null,
      values
    },
    hide: true
  };
}

// src/providers/businessFilter/utils/ui/checkBusinessFilterFiltersAgainstFacets.ts
var import_uniqBy = __toESM(require("lodash/uniqBy"));

// src/providers/businessFilter/types/list.ts
var PanelListFilterType = /* @__PURE__ */ ((PanelListFilterType2) => {
  PanelListFilterType2["FILTER"] = "filter";
  PanelListFilterType2["GROUP"] = "group";
  return PanelListFilterType2;
})(PanelListFilterType || {});

// src/providers/businessFilter/utils/ui/checkBusinessFilterFiltersAgainstFacets.ts
var checkBusinessFilterFiltersAgainstFacets = (filter, facets = []) => filter.type === "advanced" /* Advanced */ || facets.some(
  (f) => f.id?.split(".")[0] === filter.name || f.id?.startsWith(`${FOLDERS_FACET_NAME_BEGIN}.`) && filter.name === "folderId" /* FOLDER_ID */
);
var checkPanelListFilterAgasintFacets = (panelListFilter, facets = []) => {
  const { type, data } = panelListFilter;
  switch (type) {
    case "filter" /* FILTER */:
      return checkBusinessFilterFiltersAgainstFacets(data, facets);
    case "group" /* GROUP */:
      return data.length !== 0;
    default:
      console.debug(`panelListFiltersSelector filtering on ${type} not supported`);
      return false;
  }
};
var mapPanelListFilterFromBusinessFilterFilterRecursivly = (businessFilterFilter, i, facets = []) => {
  if ("title" in businessFilterFilter && businessFilterFilter.title) {
    return {
      type: "group" /* GROUP */,
      key: businessFilterFilter.filters?.map((f) => `${f.name}${f.type}`).join(":") ?? `${i}`,
      title: businessFilterFilter.title,
      data: (0, import_uniqBy.default)(
        businessFilterFilter?.filters?.map(
          (filterConfig, i2) => mapPanelListFilterFromBusinessFilterFilterRecursivly(filterConfig, i2, facets)
        ).filter(
          (panelListFilter) => checkPanelListFilterAgasintFacets(panelListFilter, facets)
        ) ?? [],
        "key"
      )
    };
  }
  return {
    type: "filter" /* FILTER */,
    key: `${businessFilterFilter.name}${businessFilterFilter.type}` || `${i}`,
    data: businessFilterFilter
  };
};

// src/providers/businessFilter/utils/i18n.ts
function getFiltersForCurrentLocale(panelListFilters, currentLocal) {
  const ret = [];
  const filters = panelListFilters.filter(
    (f) => f.type === "filter" /* FILTER */
  );
  const localizeFilter = (f) => {
    if (f.key.includes(".")) {
      const filterIdWithoutI18n = getInternalNameWithoutLocale(f.key);
      const currentLocalFilter = filters.find(
        (i18nFilter) => i18nFilter.key.includes(`${filterIdWithoutI18n}.${currentLocal?.toUpperCase()}`) && i18nFilter.data.type === f.data.type
      );
      if (currentLocalFilter) {
        if (!ret.includes(currentLocalFilter)) {
          return currentLocalFilter;
        }
      } else {
        const firstI18nFilter = filters.find(
          (i18nFilter) => i18nFilter.key.includes(`${filterIdWithoutI18n}.`) && i18nFilter.type === f.type
        );
        if (firstI18nFilter) {
          if (!ret.includes(firstI18nFilter)) {
            return firstI18nFilter;
          }
        } else {
          console.warn(
            `[getFiltersForCurrentLocale] can't find filter for filter id ${filterIdWithoutI18n}`
          );
        }
      }
    }
    return f;
  };
  panelListFilters.forEach((f) => {
    if (f.type === "group" /* GROUP */) {
      ret.push({
        ...f,
        data: f.data.map((innerFilter) => {
          if (innerFilter.type === "filter" /* FILTER */) {
            return localizeFilter(innerFilter);
          }
          return innerFilter;
        })
      });
    } else {
      ret.push(localizeFilter(f));
    }
  });
  return ret;
}
function getBusinessFiltersForCurrentLocale(filters, currentLocal) {
  const ret = [];
  filters.forEach((f) => {
    if (f.filter.id.includes(".")) {
      const filterIdWithoutI18n = getInternalNameWithoutLocale(f.filter.id);
      const currentLocalFilter = filters.find(
        (i18nFilter) => i18nFilter.filter.id.includes(`${filterIdWithoutI18n}.${currentLocal?.toUpperCase()}`) && i18nFilter.nature === f.nature
      );
      if (currentLocalFilter) {
        if (!ret.includes(currentLocalFilter)) {
          ret.push(currentLocalFilter);
        }
      } else {
        const firstI18nFilter = filters.find(
          (i18nFilter) => i18nFilter.filter.id.includes(`${filterIdWithoutI18n}.`) && i18nFilter.nature === f.nature
        );
        if (firstI18nFilter) {
          if (!ret.includes(firstI18nFilter)) {
            ret.push(firstI18nFilter);
          }
        } else {
          console.warn(
            `[getFiltersForCurrentLocale] can't find filter for filter id ${filterIdWithoutI18n}`
          );
        }
      }
    } else {
      ret.push(f);
    }
  });
  return ret;
}

// src/providers/businessFilter/utils/activeValues.ts
var import_isEmpty = __toESM(require("lodash/isEmpty"));
var import_isNaN = __toESM(require("lodash/isNaN"));
var import_isNumber = __toESM(require("lodash/isNumber"));
var import_isString = __toESM(require("lodash/isString"));
var import_trim2 = __toESM(require("lodash/trim"));
function hasActiveValues(kpkFilter) {
  const activeValues = getActiveValues(kpkFilter);
  if (kpkFilter.type === "DURATION" /* Duration */) {
    return !!activeValues.find((av) => av.id !== 0);
  } else if (kpkFilter.type === "DATE" /* Date */ && kpkFilter.modifiers?.some((m) => m.selected === true && m.type !== "FROM_TO" /* FromTo */)) {
    return true;
  } else if (kpkFilter.type === "TAGS" /* Tags */) {
    if (kpkFilter.modifiers?.some(
      (m) => m.selected === true && m.type === "EMPTY" /* Empty */
    )) {
      return true;
    } else {
      return activeValues.length > 0;
    }
  } else {
    return activeValues.length > 0;
  }
}
function getActiveValues(kpkFilter) {
  const filterType = kpkFilter.type;
  const filterValues = kpkFilter.values;
  const ret = [];
  for (const value of filterValues) {
    if (filterType === "RADIO" /* Radio */ || filterType === "CHECKBOX" /* Checkbox */ || filterType === "RADIO_FACET" /* RadioFacet */) {
      if (value.selected) {
        ret.push(value);
      }
    } else if ((0, import_isString.default)(value.id)) {
      if ((0, import_trim2.default)(value.id) !== "") {
        ret.push(value);
      }
    } else if ((!(0, import_isEmpty.default)(value.id) || (0, import_isNumber.default)(value.id)) && !(0, import_isNaN.default)(value.id)) {
      ret.push(value);
    }
  }
  return ret;
}

// src/providers/businessFilter/utils/activeFilters.ts
var getActiveFiltersExceptFolder = (activeFilters) => {
  if (!activeFilters) {
    return [];
  }
  return activeFilters?.filter(
    (f) => !(f.nature === "ADVANCED" /* ADVANCED */ && f.filter.id === "folderId" /* FOLDER_ID */)
  );
};
var activeFilterIsOnlyBasket = (activeFilters) => {
  const basketFilter = getBusinessFilterFirstValue(
    activeFilters,
    "BASKET" /* BASKET */,
    "BASKET" /* BASKET */
  );
  return !!(activeFilters?.length === 1 && basketFilter);
};

// src/providers/businessFilter/hooks/useBounceSearch.ts
var import_api_client37 = require("@keepeek/api-client");

// src/providers/thesaurus/selectors.ts
var import_api_client36 = require("@keepeek/api-client");
var import_recoil75 = require("recoil");
var thesaurusIdToLoadForBusinessFilterSelector = (0, import_recoil75.selectorFamily)({
  key: "ThesaurusIdToLoadForBusinessFilterSelector",
  get: (thesaurusId) => async ({ get }) => {
    const axiosInstance = get(getAxiosInstanceAtom);
    if (!axiosInstance) {
      throw new MandatoryProviderException("axiosInstance");
    }
    if (!thesaurusId) {
      return void 0;
    }
    const thesaurus = await (0, import_api_client36.getThesaurus)(axiosInstance(), {
      thesaurusId
    });
    return thesaurus.data;
  }
});

// src/providers/businessFilter/hooks/useFilterReset.ts
var import_react_i18next5 = require("react-i18next");
var import_recoil76 = require("recoil");

// src/providers/businessFilter/hooks/utils.ts
var import_isEqual = __toESM(require("lodash/isEqual"));
var addFilter = (filterToAdd, activeFilters, setFixedFacetsState, onActiveBusinessFiltersChange, sentryCallback) => {
  if (filterToAdd.nature === "FACET_MULTI" /* FACET_MULTI */) {
    setFixedFacetsState((prev) => {
      if (prev.some((f) => f.filter.id === filterToAdd.filter.id)) {
        return prev.map((f) => f.filter.id === filterToAdd.filter.id ? filterToAdd : f);
      } else {
        return [...prev, filterToAdd];
      }
    });
  }
  if (!onActiveBusinessFiltersChange) {
    return;
  }
  let updatedFilters = [];
  if (isFilterToAddAlreadyInActiveFilters(filterToAdd, activeFilters)) {
    if (isFacet(filterToAdd)) {
      if (!activeFilters?.some((af) => isFilterValuesEqual(af, filterToAdd))) {
        updatedFilters.push(...activeFilters || [], filterToAdd);
      }
    } else {
      activeFilters && updatedFilters.push(
        ...activeFilters.map((af) => af.filter.id === filterToAdd.filter.id ? filterToAdd : af)
      );
    }
  } else {
    updatedFilters.push(...activeFilters || [], filterToAdd);
  }
  updatedFilters = adaptUpdatedFiltersForFacetOrFacetMulti(updatedFilters);
  sentryCallback && sentryCallback({
    category: "USER_INTERACTION" /* USER_INTERACTION */,
    message: `[useFilter] useFilter add filter IDs: ${updatedFilters.map((f) => f.filter.id).join(" ")}`
  });
  onActiveBusinessFiltersChange(updatedFilters);
};
var isFilterValuesEqual = (facet1, facet2) => (0, import_isEqual.default)(
  facet1.filter.values.map((v) => v.id),
  facet2.filter.values.map((v) => v.id)
);
var removeFilter = (filterToRemove, activeFilters, setFixedFacetsState, onActiveBusinessFiltersChange, sentryCallback) => {
  sentryCallback && sentryCallback({
    category: "USER_INTERACTION" /* USER_INTERACTION */,
    message: `[useFilter] useFilter remove filter ID: ${filterToRemove.filter.id}`
  });
  if (filterToRemove.nature === "FACET_MULTI" /* FACET_MULTI */) {
    setFixedFacetsState((oldBf) => oldBf.filter((bf) => bf.filter.id !== filterToRemove.filter.id));
  }
  if (!onActiveBusinessFiltersChange) {
    return;
  }
  const ret = [];
  if (isFacet(filterToRemove)) {
    ret.push(...activeFilters?.filter((af) => !isFilterValuesEqual(af, filterToRemove)) || []);
  } else {
    ret.push(
      ...activeFilters?.filter(
        (af) => !(af.filter.id === filterToRemove.filter.id && af.nature === filterToRemove.nature)
      ) || []
    );
  }
  onActiveBusinessFiltersChange(ret);
};
var isFilterToAddAlreadyInActiveFilters = (filterToAdd, activeFilters) => activeFilters?.some(
  (af) => af.filter.id === filterToAdd.filter.id && af.nature === filterToAdd.nature
);
var adaptUpdatedFiltersForFacetOrFacetMulti = (businessFilters) => businessFilters.map((bf) => {
  return {
    ...bf,
    filter: {
      ...bf.filter,
      ...(bf.nature === "FACET" /* FACET */ || bf.nature === "FACET_MULTI" /* FACET_MULTI */) && {
        modifiers: bf.filter.modifiers || [
          {
            type: "CONTAINS_ONE" /* ContainsOne */,
            selected: true
          }
        ],
        values: bf.filter.values.filter((value) => value.selected === true)
      }
    }
  };
});
var isFacet = (filterToAdd) => filterToAdd.nature === "FACET" /* FACET */;

// src/providers/businessFilter/hooks/useFilterReset.ts
var useFilterReset = (dataViewKey, sentryCallback) => {
  const { t } = (0, import_react_i18next5.useTranslation)();
  const setFixedFacets = (0, import_recoil76.useSetRecoilState)(fixedFacetsState(dataViewKey));
  const onActiveBusinessFiltersChange = (0, import_recoil76.useRecoilValue)(onActiveBusinessFiltersChangeState);
  const activeFilters = (0, import_recoil76.useRecoilValue)(activeBusinessFiltersState(dataViewKey));
  return ({
    exceptFolderFilter,
    exceptBasketFilter,
    resetOnlyFolderFilter,
    filterToAddAfterReset
  }) => {
    const restoreExistingFilters = [];
    const filterFolder = getBusinessFilterFirstValue(
      activeFilters,
      "ADVANCED" /* ADVANCED */,
      "folderId" /* FOLDER_ID */
    );
    if (filterFolder && exceptFolderFilter) {
      restoreExistingFilters.push(
        createFolderBusinessFilter(
          filterFolder.id,
          filterFolder.label,
          t("business-filter.advanced.folder.label"),
          filterFolder.path
        )
      );
    } else if (filterFolder && resetOnlyFolderFilter && activeFilters) {
      restoreExistingFilters.push(
        ...activeFilters.filter((f) => f.filter.type !== "FOLDER" /* Folder */)
      );
    }
    if (exceptBasketFilter) {
      const filterBasket = getBusinessFilterFirstValue(
        activeFilters,
        "BASKET" /* BASKET */,
        "BASKET" /* BASKET */
      );
      filterBasket && restoreExistingFilters.push(createBasketBusinessFilter(filterBasket.id));
    }
    setFixedFacets([]);
    if (filterToAddAfterReset) {
      addFilter(
        filterToAddAfterReset,
        restoreExistingFilters,
        setFixedFacets,
        onActiveBusinessFiltersChange,
        sentryCallback
      );
    } else if (onActiveBusinessFiltersChange) {
      onActiveBusinessFiltersChange(restoreExistingFilters);
    }
  };
};

// src/providers/businessFilter/hooks/useBounceSearch.ts
var useBounceSearch = (dataViewKey, sentryCallback) => {
  const resetFilters = useFilterReset(dataViewKey, sentryCallback);
  const language = (0, import_recoil77.useRecoilValue)(currentDataLocaleSelector);
  function getThesaurusPath(thesaurus) {
    let thesaurusPath = "";
    const thesaurusParents = thesaurus._embedded?.parent;
    if (thesaurusParents) {
      for (let i = 1; i < thesaurusParents.length; i++) {
        thesaurusPath += `${thesaurusParents[i].title} > `;
      }
    }
    thesaurusPath += thesaurus.title;
    return thesaurusPath;
  }
  return (0, import_recoil77.useRecoilCallback)(
    ({ snapshot }) => async (metaField, value) => {
      const activeFilters = await snapshot.getPromise(activeBusinessFiltersState(dataViewKey));
      if (metaField.type === "THESAURUS" /* Thesaurus */) {
        const valueId = metaField.valueMapping?.find((v) => v.title === value)?.id;
        const thesaurusToLoadForBusinessFilter = await snapshot.getPromise(
          thesaurusIdToLoadForBusinessFilterSelector(valueId)
        );
        if (thesaurusToLoadForBusinessFilter) {
          const thesaurusPath = getThesaurusPath(thesaurusToLoadForBusinessFilter);
          const thesaurusTitle = metaField?.name || "";
          const facet = createFacetForBounceSearch({
            facetId: metaField.id,
            language,
            label: thesaurusTitle,
            value: thesaurusPath,
            type: import_api_client37.KpkApiFacetType.Microthesaurus,
            synonym: thesaurusToLoadForBusinessFilter.synonyms
          });
          const filter = convertKpkApiFacetToBusinessFilter({
            kpkApiFacet: facet,
            hideFacetOccurrences: true,
            sortDirection: void 0,
            sortByOccurrences: void 0,
            isSelected: true,
            facetType: "facet" /* Facet */,
            activeFilters
          });
          resetFilters({
            exceptFolderFilter: false,
            exceptBasketFilter: dataViewKey === "basket-detail" /* BASKET_DETAIL */,
            filterToAddAfterReset: filter
          });
        }
      } else {
        const facet = createFacetForBounceSearch({
          facetId: metaField.id,
          language,
          label: metaField.name,
          value,
          type: convertKpkMetaFieldTypeToKpkApiFacetType(metaField.type)
        });
        const filter = convertKpkApiFacetToBusinessFilter({
          kpkApiFacet: facet,
          hideFacetOccurrences: true,
          isSelected: true,
          facetType: "facet" /* Facet */,
          activeFilters
        });
        resetFilters({
          exceptFolderFilter: false,
          exceptBasketFilter: dataViewKey === "basket-detail" /* BASKET_DETAIL */,
          filterToAddAfterReset: filter
        });
      }
    },
    [dataViewKey, language, resetFilters]
  );
};

// src/providers/businessFilter/hooks/useFilterAdd.ts
var import_recoil78 = require("recoil");
var useFilterAdd = (dataViewKey, sentryCallback) => {
  const onActiveBusinessFiltersChange = (0, import_recoil78.useRecoilValue)(onActiveBusinessFiltersChangeState);
  const activeFilters = (0, import_recoil78.useRecoilValue)(activeBusinessFiltersState(dataViewKey));
  const setFixedFacetsState = (0, import_recoil78.useSetRecoilState)(fixedFacetsState(dataViewKey));
  return (filterToAdd) => {
    addFilter(
      filterToAdd,
      activeFilters,
      setFixedFacetsState,
      onActiveBusinessFiltersChange,
      sentryCallback
    );
  };
};

// src/providers/businessFilter/hooks/useFilterDelete.ts
var import_recoil79 = require("recoil");
var useFilterDelete = (dataViewKey, sentryCallback) => {
  const onActiveBusinessFiltersChange = (0, import_recoil79.useRecoilValue)(onActiveBusinessFiltersChangeState);
  const activeFilters = (0, import_recoil79.useRecoilValue)(activeBusinessFiltersState(dataViewKey));
  const setFixedFacetsState = (0, import_recoil79.useSetRecoilState)(fixedFacetsState(dataViewKey));
  return (filterToDelete) => {
    removeFilter(
      filterToDelete,
      activeFilters,
      setFixedFacetsState,
      onActiveBusinessFiltersChange,
      sentryCallback
    );
  };
};

// src/providers/businessFilter/hooks/useFilterUpdate.ts
var import_recoil80 = require("recoil");
var useFilterUpdate = (dataViewKey, sentryCallback) => {
  const onActiveBusinessFiltersChange = (0, import_recoil80.useRecoilValue)(onActiveBusinessFiltersChangeState);
  const activeFilters = (0, import_recoil80.useRecoilValue)(activeBusinessFiltersState(dataViewKey));
  const setFixedFacetsState = (0, import_recoil80.useSetRecoilState)(fixedFacetsState(dataViewKey));
  return (filterToUpdate) => {
    if (hasActiveValues(convertBusinessFilterToKpkFilter(filterToUpdate))) {
      addFilter(
        filterToUpdate,
        activeFilters,
        setFixedFacetsState,
        onActiveBusinessFiltersChange,
        sentryCallback
      );
    } else {
      removeFilter(
        filterToUpdate,
        activeFilters,
        setFixedFacetsState,
        onActiveBusinessFiltersChange,
        sentryCallback
      );
    }
  };
};

// src/providers/businessFilter/selectors/activeFilterValues.ts
var import_recoil81 = require("recoil");
var activeFilterValuesSelector = (0, import_recoil81.selectorFamily)({
  key: "ActiveFilterValuesSelector",
  get: ({ dataViewKey, filterId, nature: natureIn }) => ({ get }) => {
    const businessFilter = get(activeBusinessFiltersState(dataViewKey))?.find(
      ({ filter, nature }) => filter.id === filterId && nature === natureIn
    );
    if (!businessFilter) {
      return [];
    }
    return businessFilter.filter.values;
  }
});

// src/providers/businessFilter/selectors/panelListFilter.ts
var import_uniqBy2 = __toESM(require("lodash/uniqBy"));
var import_recoil82 = require("recoil");
var panelListFiltersSelector = (0, import_recoil82.selectorFamily)({
  key: "PanelListFiltersSelector",
  get: (facets) => ({ get }) => {
    const filters = get(businessFiltersConfiguration);
    if (!filters) {
      return [];
    }
    return (0, import_uniqBy2.default)(
      filters.map(
        (filterConfig, i) => mapPanelListFilterFromBusinessFilterFilterRecursivly(filterConfig, i, facets)
      ).filter((panelListFilter) => checkPanelListFilterAgasintFacets(panelListFilter, facets)),
      "key"
    );
  }
});

// src/providers/dataView/selectors/elements.ts
var import_recoil88 = require("recoil");

// src/providers/dataView/selectors/get.ts
var import_recoil83 = require("recoil");
var getAdvancedSearchQuery = (0, import_recoil83.selectorFamily)({
  key: "GetAdvancedSearchQuery",
  get: ({ searchParams }) => async ({ get }) => {
    get(currentLocaleAtom);
    const { getAdvancedSearch: getAdvancedSearch2 } = get(dataViewFetcherSelector(get(fetcherModeAtom)));
    if (searchParams.fq?.some((q) => q.includes("basketId:" /* Basket */))) {
      searchParams = {
        ...searchParams,
        axiosRequestConfig: { disableNotificationErrorCodes: [400] }
      };
    }
    const advancedSearch = await getAdvancedSearch2(searchParams);
    if (!advancedSearch) {
      return void 0;
    }
    const { data } = advancedSearch;
    return data;
  }
});
var getDataViewContentQuery = (0, import_recoil83.selectorFamily)({
  key: "GetDataViewContent",
  get: ({
    page: pageIn,
    size: sizeIn,
    sort: sortIn,
    filters: filtersIn,
    customFields: customFieldsIn,
    filtersConfiguration,
    key: key2,
    overrideFields,
    enableFacets
  }) => ({ get }) => {
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    if (filtersConfiguration === null || filtersIn === null) {
      getLogger().debug(
        "getDataViewContentQuery: mandatory params are undefined : do not continue",
        {
          filtersConfiguration,
          filtersIn
        }
      );
      return;
    }
    const { advancedSearch, page, size, sort, filters, customFields } = customSelectorInOut(
      "DataViewElementsIn" /* DataViewElementsIn */,
      {
        key: key2,
        advancedSearch: get(
          dataViewAdvancedSearchId(
            serializeComplexeParamsForRecoil({
              key: key2,
              filters: filtersIn
            })
          )
        ),
        page: pageIn,
        size: sizeIn,
        sort: sortIn,
        filters: filtersIn,
        customFields: customFieldsIn || []
      },
      get(customerCommonOverrideAtom)
    );
    if (!advancedSearch) {
      getLogger().debug("GetDataViewContent : no advancedSearchId to make the call");
      return;
    }
    if (key2 === "basket" /* BASKET */ && !filters.some((f) => f.filter.type === "BASKET" /* Basket */)) {
      getLogger().debug(
        "GetDataViewContent : search canceled because there is no filter on basket",
        {
          key: key2,
          filters
        }
      );
      return;
    }
    const fieldsConfiguration = get(dataViewFieldsConfiguration);
    if (fieldsConfiguration === void 0) {
      getLogger().debug(
        "dataViewElements : search canceled because configuration is not yet ready"
      );
      return;
    }
    if (advancedSearchIsExpired(advancedSearch?.expirationDate ?? "")) {
      getLogger().debug("dataViewElements : advancedSearchIsExpired");
      return;
    }
    const fields = get(dataViewFieldConstructorSelector({ key: key2, customFields }));
    const searchParams = {
      advancedSearchId: advancedSearch?.advancedSearchId ?? "",
      page,
      size,
      sort: formatSortValueForKpkApi(sort),
      fields: formatFieldsForKpkApi(size === 1 ? ["id"] : overrideFields || fields),
      q: getBusinessFilterFullTextValue(filters),
      fq: extractQueryFilters(filters),
      f: extractQueryFiltersForFieldParameter(filters),
      notFoundReference: isNotFoundReferenceRequired(filters),
      facetFields: enableFacets || size === 1 ? extractFacetFilters(filtersConfiguration) : []
    };
    const shouldRefreshId = get(shouldRefreshGetAdvancedSearchQuery(key2));
    const advancedSearchResult = get(
      getAdvancedSearchQuery(
        serializeComplexeParamsForRecoil({
          searchParams,
          shouldRefreshId
        })
      )
    );
    return advancedSearchResult;
  }
});
var dataViewFieldConstructorSelector = (0, import_recoil83.selectorFamily)({
  key: "DataViewFieldSelector",
  get: ({ key: key2, customFields = [] }) => ({ get }) => {
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    const fieldsConfiguration = get(dataViewFieldsConfiguration);
    if (fieldsConfiguration === void 0) {
      getLogger().warn(
        "dataViewFieldConstructorSelector : canceled because fieldsConfiguration is not yet valued"
      );
      return [];
    }
    let defaultTechnicalFieldsToQuery = fieldsConfiguration.technicalFields?.default ?? [];
    let defaultFunctionalFieldsToQuery = fieldsConfiguration.functionalFields?.default ?? [];
    fieldsConfiguration.listViewFields?.default?.map((fieldName) => {
      if (isMediaField(fieldName)) {
        if (!defaultTechnicalFieldsToQuery.includes(fieldName)) {
          defaultTechnicalFieldsToQuery = [...defaultTechnicalFieldsToQuery, fieldName];
        }
      } else if (!defaultFunctionalFieldsToQuery.includes(fieldName)) {
        defaultFunctionalFieldsToQuery = [...defaultFunctionalFieldsToQuery, fieldName];
      }
    });
    const fields = addMandatoryFields([
      ...getFieldsForApi(
        { ...fieldsConfiguration.technicalFields, default: defaultTechnicalFieldsToQuery },
        key2 && key2 === "basket" /* BASKET */
      ),
      ...getFieldsForApi(
        { ...fieldsConfiguration.functionalFields, default: defaultFunctionalFieldsToQuery }
      ),
      ...fieldsConfiguration.visualAlertsFields ?? [],
      ...fieldsConfiguration.needMediaLinks ? ["mediaLinkCount" /* MEDIA_LINK_COUNT */] : [],
      ...fieldsConfiguration.needAttachmentCounts ? ["attachmentCounts" /* ATTACHMENT_COUNTS */] : [],
      ...customFields
    ]);
    return fields;
  }
});
var isNotFoundReferenceRequired = (filters) => filters.some((f) => f.filter.notFoundReference);

// src/providers/tags/hooks/index.ts
var import_recoil86 = require("recoil");

// src/providers/tags/selectors/index.ts
var import_recoil85 = require("recoil");

// src/providers/fetcher/selectors/tags.ts
var import_recoil84 = require("recoil");

// src/providers/tags/utils.ts
var import_api_client38 = require("@keepeek/api-client");
var tagsSizeToFetch = 50;
async function getAllTags(axiosInstance) {
  let page = 1;
  const data = await fetchTagsData(axiosInstance, page);
  let ret = data?._embedded?.label?.map((label) => ({
    id: label.id,
    name: label.title,
    backgroundColor: label.backgroundColor,
    textColor: label.textColor
  })) || [];
  const totalCount = data.totalCount || 0;
  if (totalCount > 0) {
    while (ret.length < totalCount) {
      page++;
      const tmp = await fetchTagsData(axiosInstance, page);
      if (!tmp._embedded || !tmp._embedded.label || tmp._embedded.label.length === 0) {
        break;
      }
      ret = [
        ...ret,
        ...tmp._embedded.label.map((label) => ({
          id: label.id,
          name: label.title,
          backgroundColor: label.backgroundColor,
          textColor: label.textColor
        })) || []
      ];
    }
  }
  return ret;
}
async function fetchTagsData(axiosInstance, page) {
  const result = await (0, import_api_client38.getLabels)(axiosInstance, {
    size: tagsSizeToFetch,
    page
  });
  return result.data;
}

// src/providers/fetcher/selectors/tags.ts
var tagsFetcherSelector = (0, import_recoil84.selectorFamily)({
  key: "TagsFetcherSelector",
  get: (mode) => ({ get }) => {
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    get(currentDataLocaleSelector);
    switch (mode) {
      case 0 /* SHARE */:
        return {
          getTags: () => {
            getLogger().debug(
              "TagsFetcherSelector - getTags - share mode is not implemented yet"
            );
            return new Promise((resolve) => resolve(void 0));
          }
        };
      default:
        const isAuthenticated = get(isAuthenticatedSelector);
        return {
          getTags: () => {
            if (!isAuthenticated) {
              getLogger().debug("TagsFetcherSelector - getTags - Cannot fetch without auth");
              return new Promise((resolve) => resolve(void 0));
            }
            return getAllTags(getAxiosInstance());
          }
        };
    }
  }
});

// src/providers/tags/selectors/index.ts
var tagsQuerySelector = (0, import_recoil85.selector)({
  key: "TagsQuerySelector",
  get: async ({ get }) => {
    const { getTags } = get(tagsFetcherSelector(get(fetcherModeAtom)));
    return getTags();
  }
});

// src/providers/tags/hooks/index.ts
var useGetTags = () => {
  const queryLabels = (0, import_recoil86.useRecoilValueLoadable)(tagsQuerySelector);
  return (queryLabels.state === "hasValue" ? queryLabels.contents : []) || [];
};

// src/providers/tags/atoms/index.ts
var import_recoil87 = require("recoil");
var tagsConfigurationAtom = (0, import_recoil87.atom)({
  key: "TagsConfigurationAtom",
  default: void 0
});

// src/providers/dataView/selectors/elements.ts
var dataViewSelector = (0, import_recoil88.selectorFamily)({
  key: "DataViewSelector",
  get: (params) => ({ get }) => {
    const elementsOut = get(dataViewElementsSelector(params));
    const facetsOut = get(dataViewFacetsSelector(params));
    const totalCountOut = get(dataViewElementsTotalCountSelector(params));
    const referencesOut = get(dataViewReferencesSelectors(params));
    const { elements, facets, totalCount, references } = customSelectorInOut(
      "DataViewElementsOut" /* DataViewElementsOut */,
      {
        key: params.key,
        elements: elementsOut,
        facets: facetsOut,
        totalCount: totalCountOut,
        references: referencesOut
      },
      get(customerCommonOverrideAtom)
    );
    return {
      elements,
      facets,
      totalCount,
      references
    };
  }
});
var dataViewElementsTotalCountSelector = (0, import_recoil88.selectorFamily)({
  key: "DataViewElementsTotalCountSelector",
  get: (params) => ({ get }) => {
    const advancedSearchResult = get(getDataViewContentQuery(params));
    if (!advancedSearchResult) {
      return DATAVIEW_DEFAULT_TOTAL_COUNT;
    }
    return advancedSearchResult?.totalCount ?? 0;
  }
});
var dataViewElementsSelector = (0, import_recoil88.selectorFamily)({
  key: "DataViewElementsSelector",
  get: (params) => ({ get }) => {
    const sheetFields = get(sheetFieldsSelector) ?? [];
    const advancedSearchResult = get(getDataViewContentQuery(params));
    if (advancedSearchResult?._embedded?.media) {
      return advancedSearchResult._embedded.media.map(
        (KpkApiMedia4) => convertToKpkMedia(
          get(formsQuerySelector),
          KpkApiMedia4,
          sheetFields,
          [],
          void 0,
          get(tagsQuerySelector)
        )
      ).filter((kpkMedia) => kpkMedia !== void 0) || [];
    }
    return [];
  }
});
var dataViewFacetsSelector = (0, import_recoil88.selectorFamily)({
  key: "DataViewFacetsSelector",
  get: (params) => ({ get }) => {
    const advancedSearchResult = get(getDataViewContentQuery(params));
    return advancedSearchResult?._embedded?.facet ?? [];
  }
});
var dataViewReferencesSelectors = (0, import_recoil88.selectorFamily)({
  key: "DataViewElementsSelector",
  get: ({ key: key2, filters, page, filtersConfiguration, sort, size }) => ({ get }) => {
    const advancedSearchResult = get(
      getDataViewContentQuery(
        serializeComplexeParamsForRecoil({
          key: key2,
          filters,
          page,
          filtersConfiguration,
          sort,
          size
        })
      )
    );
    const notFoundReferences = [];
    const foundReferences = [];
    const allReferences = [];
    if (advancedSearchResult?._embedded?.["notFoundReference"] && filters) {
      let i = 0;
      filters.forEach((f) => {
        if (f.filter.type !== "FOLDER" /* Folder */) {
          const notFoundReferenceForFilter = advancedSearchResult._embedded?.["notFoundReference"]?.[i];
          if (notFoundReferenceForFilter) {
            notFoundReferenceForFilter.forEach((r) => {
              notFoundReferences.push(r);
            });
          }
          f.filter.values.forEach((v) => {
            allReferences.push(v.label);
            if (!notFoundReferences.includes(v.label)) {
              foundReferences.push(v.label);
            }
          });
        }
        i++;
      });
    }
    const referencesOut = {
      notFound: notFoundReferences,
      found: foundReferences,
      all: allReferences
    };
    return referencesOut;
  }
});

// src/providers/dataView/selectors/element.ts
var elementIsSelected = (0, import_recoil89.selectorFamily)({
  key: "ElementIsSelected",
  get: ({ key: key2, id }) => ({ get }) => get(selectedElements(key2)).includes(id),
  set: ({ key: key2, id }) => ({ set, get }, value) => {
    const currentSelecteds = get(selectedElements(key2));
    if (value) {
      set(selectedElements(key2), (0, import_uniq2.default)([...currentSelecteds, id]));
    } else {
      const newValues = currentSelecteds.filter((value2) => value2 !== id);
      set(selectedElements(key2), newValues);
    }
  }
});
var dataViewElement = (0, import_recoil89.selectorFamily)({
  key: "DataViewElement",
  get: ({ key: key2, id, filters }) => ({ get }) => {
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    const size = get(dataViewSize(key2));
    const sort = get(dataViewSortSelector(key2));
    const page = get(dataViewPage(key2));
    const filtersConfiguration = get(businessFiltersConfiguration);
    if (filtersConfiguration === void 0) {
      getLogger().warn(
        "dataViewElement : canceled because filtersConfiguration is not yet valued"
      );
      return;
    }
    const params = {
      key: key2,
      filters,
      size,
      sort,
      page,
      filtersConfiguration
    };
    return get(dataViewSelector(serializeComplexeParamsForRecoil(params))).elements.find(
      (e) => e.id === id
    );
  }
});

// src/providers/dataView/selectors/selectAll.ts
var import_uniq3 = __toESM(require("lodash/uniq"));
var import_recoil90 = require("recoil");
var selectAllCurrentSearchSelector = (0, import_recoil90.selectorFamily)({
  key: "SelectAllDataviewSelector",
  get: ({ key: key2, filters = null, page = 1, basketId }) => async ({ get }) => {
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    const size = get(pageMaxSizeSelector);
    const filtersConfiguration = get(businessFiltersConfiguration);
    if (filtersConfiguration === void 0) {
      getLogger().warn(
        "selectAllCurrentSearchSelector : canceled because filtersConfiguration is not yet valued"
      );
      return null;
    }
    const shouldFetch = get(shouldSelectAllInCurrentSearch(key2));
    const basketIdForFetch = get(selectBasketIdForFetch);
    if (!shouldFetch) {
      return null;
    }
    if (basketId) {
      if (basketIdForFetch !== basketId) {
        return null;
      }
    }
    const elements = get(
      dataViewElementsSelector(
        serializeComplexeParamsForRecoil({
          key: key2,
          size,
          page,
          sort: get(dataViewSortSelector(key2)),
          filters,
          filtersConfiguration,
          overrideFields: ["id"]
        })
      )
    );
    if (!elements || elements.length === 0) {
      return null;
    }
    return (0, import_uniq3.default)(elements.map((el) => el.id));
  }
});
var selectAllCurrentSearchStatusSelector = (0, import_recoil90.selectorFamily)({
  key: "SelectAllCurrentSearchStatusSelector",
  get: ({ key: key2, filters, page = 1 }) => ({ get }) => {
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    const filtersConfiguration = get(businessFiltersConfiguration);
    if (filtersConfiguration === void 0) {
      getLogger().warn(
        "selectAllCurrentSearchStatusSelector : canceled because filtersConfiguration is not yet valued"
      );
      return "none" /* NONE */;
    }
    const totalCount = get(
      dataViewElementsTotalCountSelector(
        serializeComplexeParamsForRecoil({
          key: key2,
          filtersConfiguration,
          page,
          sort: get(dataViewSortSelector(key2)),
          size: get(dataViewSize(key2)),
          filters
        })
      )
    );
    const selected = get(selectedElements(key2));
    if (selected.length === 0) {
      return "none" /* NONE */;
    }
    if (totalCount > selected.length) {
      return "partial" /* PARTIAL */;
    }
    return "all" /* ALL */;
  }
});

// src/providers/dataView/selectors/selected.ts
var import_recoil91 = require("recoil");
var selectedElementsFromKeysSelector = (0, import_recoil91.selectorFamily)({
  key: "SelectedElementsFromKeySelector",
  get: (keys) => ({ get }) => keys.flatMap((key2) => get(selectedElements(key2))),
  set: (keys) => ({ set }, newValue) => keys.forEach((key2) => set(selectedElements(key2), newValue))
});

// src/providers/dataView/hooks/useClearSelectionRules.ts
var useClearSelectionRules = ({
  isSearchContext
}) => {
  const [shouldClearSelectedElementsByKeys, setShouldClearSelectedElementsByKeys] = (0, import_recoil92.useRecoilState)(
    shouldClearSelectedElementsByKeysAtom
  );
  const setSelectElementsFromKeys = (0, import_recoil92.useSetRecoilState)(
    selectedElementsFromKeysSelector(shouldClearSelectedElementsByKeys)
  );
  (0, import_react14.useEffect)(() => {
    const keys = Object.values({ ...DataViewKey });
    const shouldClearKeys = removeUndefinedDeep(
      keys.map((key2) => {
        switch (key2) {
          case "search" /* SEARCH */:
            if (!isSearchContext()) {
              return key2;
            }
            return void 0;
          case "basket" /* BASKET */:
          default:
            return void 0;
        }
      })
    );
    if (shouldClearKeys.length > 0) {
      setShouldClearSelectedElementsByKeys(shouldClearKeys);
    }
  }, [isSearchContext, setShouldClearSelectedElementsByKeys]);
  (0, import_react14.useEffect)(() => {
    if (shouldClearSelectedElementsByKeys.length > 0) {
      setSelectElementsFromKeys([]);
      setShouldClearSelectedElementsByKeys([]);
    }
  }, [
    setSelectElementsFromKeys,
    setShouldClearSelectedElementsByKeys,
    shouldClearSelectedElementsByKeys.length
  ]);
};

// src/providers/dataView/hooks/useDataView.ts
var import_react15 = require("react");
var import_recoil93 = require("recoil");
var useDataView = ({
  key: key2,
  filters,
  overrideFields
}) => {
  const shouldUpdateCreateQuery = (0, import_recoil93.useSetRecoilState)(shouldUpdateAdvancedSearchId(key2));
  const size = (0, import_recoil93.useRecoilValue)(dataViewSize(key2));
  const [page, setPage] = (0, import_recoil93.useRecoilState)(dataViewPage(key2));
  const sort = (0, import_recoil93.useRecoilValue)(dataViewSortSelector(key2));
  const filtersConfig = (0, import_recoil93.useRecoilValue)(businessFiltersConfiguration) || null;
  const createQuery = (0, import_recoil93.useRecoilValue)(
    dataViewAdvancedSearchId(
      serializeComplexeParamsForRecoil({
        key: key2,
        filters
      })
    )
  );
  const elementsParams = {
    key: key2,
    size,
    page,
    sort,
    filtersConfiguration: filtersConfig,
    filters,
    overrideFields
  };
  const { elements, totalCount } = (0, import_recoil93.useRecoilValue)(
    dataViewSelector(serializeComplexeParamsForRecoil(elementsParams))
  );
  (0, import_react15.useEffect)(() => {
    if (createQuery && advancedSearchIsExpired(createQuery.expirationDate)) {
      shouldUpdateCreateQuery((currVal) => currVal += 1);
    }
  }, [createQuery, shouldUpdateCreateQuery]);
  (0, import_react15.useEffect)(() => {
    if (totalCount > 0 && elements.length === 0 && page > 1) {
      setPage(1);
    }
  }, [elements.length, page, setPage, totalCount]);
  return {
    elements
  };
};

// src/providers/dataView/hooks/useKeyboardSelection.ts
var import_react16 = require("react");
var import_recoil94 = require("recoil");
var useKeyboardSelection = (key2, elements, allowSelection = true) => {
  const setSelectedElements = (0, import_recoil94.useSetRecoilState)(selectedElements(key2));
  (0, import_react16.useEffect)(() => {
    const ctrlAHandler = (e) => {
      if (!allowSelection) {
        return;
      }
      const isControlPressed = e.ctrlKey || e.metaKey;
      const aIsPressed = e.key === "a" || e.key === "A";
      if (isControlPressed && aIsPressed && elements.length > 0) {
        e.preventDefault();
        setSelectedElements(elements.map((el) => el.id));
      }
    };
    document.body.addEventListener("keydown", ctrlAHandler);
    return () => {
      document.body.removeEventListener("keydown", ctrlAHandler);
    };
  }, [allowSelection, elements, setSelectedElements]);
};

// src/providers/dataView/hooks/useReference.ts
var import_recoil95 = require("recoil");
var useReference = ({
  key: key2,
  filters = null
}) => {
  const filtersConfiguration = (0, import_recoil95.useRecoilValue)(businessFiltersConfiguration) || null;
  return (0, import_recoil95.useRecoilValue)(
    dataViewReferencesSelectors(
      buildOptimizedLightDataviewElementsSelector({
        key: key2,
        filters,
        filtersConfiguration
      })
    )
  );
};

// src/providers/dataView/hooks/useSelectAllInAdvancedSearch.ts
var import_react17 = require("react");
var import_recoil96 = require("recoil");
var useSelectAllInAdvancedSearch = ({
  key: key2,
  filters,
  page,
  totalCount,
  basketId,
  tooManyMediaSelectedCallback,
  sentryCallback
}) => {
  const setSelectedElements = (0, import_recoil96.useSetRecoilState)(selectedElements(key2));
  const filtersConfiguration = (0, import_recoil96.useRecoilValue)(businessFiltersConfiguration);
  const maxSelectAll = (0, import_recoil96.useRecoilValue)(pageMaxSizeSelector);
  const [shouldFetch, setShouldFetch] = (0, import_recoil96.useRecoilState)(shouldSelectAllInCurrentSearch(key2));
  const [basketIdForFetch, setBasketIdForFetch] = (0, import_recoil96.useRecoilState)(selectBasketIdForFetch);
  const query = (0, import_recoil96.useRecoilValueLoadable)(
    selectAllCurrentSearchSelector(
      serializeComplexeParamsForRecoil({
        basketId,
        key: key2,
        filtersConfiguration,
        filters: shouldFetch ? filters : null,
        page
      })
    )
  );
  const status = (0, import_recoil96.useRecoilValue)(
    selectAllCurrentSearchStatusSelector(
      serializeComplexeParamsForRecoil({
        key: key2,
        filtersConfiguration,
        filters,
        page
      })
    )
  );
  const create = (0, import_recoil96.useRecoilValue)(
    dataViewAdvancedSearchId(
      serializeComplexeParamsForRecoil({
        key: key2,
        filters
      })
    )
  );
  const shouldUpdateCreateQuery = (0, import_recoil96.useSetRecoilState)(shouldUpdateAdvancedSearchId(key2));
  const selectAll = () => {
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: "dataView - selectAll"
    });
    if (totalCount > maxSelectAll) {
      tooManyMediaSelectedCallback && tooManyMediaSelectedCallback(maxSelectAll);
    } else {
      if (advancedSearchIsExpired(create?.expirationDate ?? "")) {
        shouldUpdateCreateQuery((currVal) => currVal += 1);
      }
      setShouldFetch(true);
      if (basketId) {
        setBasketIdForFetch(basketId);
      }
    }
  };
  (0, import_react17.useEffect)(() => {
    if (query.state === "hasValue" && query.contents !== null) {
      setSelectedElements(query.contents);
      setShouldFetch(false);
    }
  }, [basketId, query, setSelectedElements, setShouldFetch, basketIdForFetch]);
  const unSelectAll = (0, import_react17.useCallback)(() => {
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: "dataView - unSelectAll"
    });
    setSelectedElements([]);
    setShouldFetch(false);
  }, [sentryCallback, setSelectedElements, setShouldFetch]);
  const toggleSelectAll = () => {
    switch (status) {
      case "all" /* ALL */:
        unSelectAll();
        break;
      case "partial" /* PARTIAL */:
        unSelectAll();
        break;
      case "none" /* NONE */:
        selectAll();
        break;
      default:
        break;
    }
  };
  const [advancedSearchId, setAdvancedSearchId] = (0, import_react17.useState)(void 0);
  (0, import_react17.useEffect)(() => {
    if (advancedSearchId !== create?.advancedSearchId) {
      setAdvancedSearchId(create?.advancedSearchId);
      unSelectAll();
    }
  }, [advancedSearchId, create, unSelectAll]);
  return { toggleSelectAll, selectAll, unSelectAll, status };
};

// src/providers/dataView/hooks/useTotalCount.ts
var import_recoil97 = require("recoil");
var useTotalCount = ({
  key: key2,
  filters
}) => {
  const filtersConfiguration = (0, import_recoil97.useRecoilValue)(businessFiltersConfiguration) || null;
  return (0, import_recoil97.useRecoilValue)(
    dataViewElementsTotalCountSelector(
      buildOptimizedLightDataviewElementsSelector({
        key: key2,
        filters,
        filtersConfiguration
      })
    )
  );
};

// src/providers/dataView/hooks/useScrollRestoration.ts
var import_recoil98 = require("recoil");
var import_react18 = require("react");
var import_debounce = __toESM(require("lodash/debounce"));
var import_isNil = __toESM(require("lodash/isNil"));
var useScrollRestoration = ({
  dataviewKey,
  nodeRef,
  enabled = true
}) => {
  const scroll = (0, import_recoil98.useRecoilValue)(dataViewScroll(dataviewKey));
  const setScroll = (0, import_recoil98.useRecoilCallback)(
    ({ set }) => ({ x, y }) => set(dataViewScroll(dataviewKey), { x, y })
  );
  const handleScroll = (0, import_debounce.default)(
    (0, import_react18.useCallback)(
      (ev) => {
        const x = (0, import_isNil.default)(ev.target.scrollLeft) ? scroll.x : ev.target.scrollLeft;
        const y = (0, import_isNil.default)(ev.target.scrollTop) ? scroll.y : ev.target.scrollTop;
        setScroll({
          x,
          y
        });
      },
      [scroll.x, scroll.y, setScroll]
    ),
    500
  );
  (0, import_react18.useLayoutEffect)(() => {
    if (!enabled) {
      return;
    }
    const closetScrollParent = getScrollParent(nodeRef.current);
    if (scroll && closetScrollParent) {
      closetScrollParent.scroll && closetScrollParent.scroll({ left: scroll.x, top: scroll.y, behavior: "smooth" });
      closetScrollParent.parentElement && closetScrollParent.parentElement.scroll && closetScrollParent.parentElement.scroll({
        left: scroll.x,
        top: scroll.y,
        behavior: "smooth"
      });
    }
  }, [enabled, nodeRef]);
  (0, import_react18.useLayoutEffect)(() => {
    window.addEventListener("scroll", handleScroll, {
      capture: true
    });
    return () => {
      window.removeEventListener("scroll", handleScroll, {
        capture: true
      });
    };
  }, [nodeRef, handleScroll]);
};
var getScrollParent = (node, axis = "y") => {
  if (!(node instanceof HTMLElement || node instanceof ShadowRoot)) {
    return null;
  }
  const el = node instanceof ShadowRoot ? node.host : node;
  const style = window.getComputedStyle(el);
  const overflow = axis === "y" ? style.overflowY : style.overflowX;
  const scrollSize = axis === "y" ? el.scrollHeight : el.scrollWidth;
  const clientSize = axis === "y" ? el.clientHeight : el.clientWidth;
  const isScrolled = scrollSize > clientSize;
  if (isScrolled && !overflow.includes("visible") && !overflow.includes("hidden")) {
    return el;
  }
  return getScrollParent(el.parentNode, axis) || document.body;
};

// src/providers/dataView/hooks/useI18NSorts.ts
var import_react_i18next6 = require("react-i18next");
var import_recoil99 = require("recoil");
var import_react19 = require("react");
var SORT_LIST_I18N_KEY = "components.sort-list";
var useI18NSorts = () => {
  const { t } = (0, import_react_i18next6.useTranslation)("refront-components");
  const sorts = (0, import_recoil99.useRecoilValue)(dataViewSortsConfiguration);
  const sheetFields = (0, import_recoil99.useRecoilValueLoadable)(sheetFieldsSelector);
  return (0, import_react19.useMemo)(() => {
    if (sheetFields.state === "hasValue") {
      const newRet = [];
      const fields = (sorts && sorts.length > 0 ? sorts : SORT_LIST_DEFAULT_FIELDS) || SORT_LIST_DEFAULT_FIELDS;
      fields.forEach((f) => {
        const genericTranslation = t(`${SORT_LIST_I18N_KEY}.generic.${f.direction}`, {
          field: getKpkMetaFieldLabelByFieldName(sheetFields.contents, f.field).toLowerCase()
        });
        const translation = t(
          `${SORT_LIST_I18N_KEY}.${f.field}.${f.direction}`,
          genericTranslation
        );
        newRet.push({
          translation,
          direction: f.direction,
          directionTranslation: t(`sort.direction.${f.direction}`),
          value: `${f.field}-${f.direction}`
        });
      });
      return newRet;
    } else {
      return [];
    }
  }, [sheetFields.contents, sheetFields.state, sorts, t]);
};

// src/providers/dataView/hooks/useReset.ts
var import_react20 = require("react");
var import_recoil100 = require("recoil");
var useReset = () => {
  const setPage = (0, import_recoil100.useSetRecoilState)(dataViewPage("search" /* SEARCH */));
  const setSelectedElements = (0, import_recoil100.useSetRecoilState)(selectedElements("search" /* SEARCH */));
  return (0, import_react20.useCallback)(() => {
    setPage(1);
    setSelectedElements([]);
  }, [setPage, setSelectedElements]);
};

// src/providers/stats/hooks/useStatsQueueListener.ts
var key = "search" /* SEARCH */;
var useStatsQueueListener = (filters, filtersConfiguration, clientIp) => {
  const logger = (0, import_recoil101.useRecoilValue)(getLoggerAtom);
  const [folderIdForFolderHit, setFolderIdForFolderHit] = (0, import_recoil101.useRecoilState)(statsFolderIdForFolderHit);
  const [searchValueForText, setSearchValueForText] = (0, import_recoil101.useRecoilState)(statsSearchValueForTextAtom);
  const { sendFolderSearchHit, sendTextSearchHit } = useStatsSearchHit({
    ip: clientIp
  });
  const hasFiltersIncluded = (0, import_react21.useMemo)(
    () => filters.some(
      (f) => f.filter.id === "FULL_TEXT" /* FULL_TEXT */ && f.filter.values.some((v) => v.label === searchValueForText) || f.filter.type === "FOLDER" /* Folder */ && f.filter.values.some((v) => v.id === folderIdForFolderHit)
    ),
    [filters, searchValueForText, folderIdForFolderHit]
  );
  const totalCount = (0, import_recoil101.useRecoilValue)(
    dataViewElementsTotalCountSelector(
      buildOptimizedLightDataviewElementsSelector({
        key,
        filters: hasFiltersIncluded ? filters : null,
        filtersConfiguration
      })
    )
  );
  (0, import_react21.useEffect)(() => {
    if (folderIdForFolderHit && totalCount >= 0) {
      logger?.().debug(
        `useStatsSearchHitWithResult - sending stat for folder from queue with folderId ${folderIdForFolderHit} and total count of ${totalCount}`
      );
      sendFolderSearchHit({ folderId: folderIdForFolderHit, resultCount: totalCount });
      setFolderIdForFolderHit(void 0);
    }
  }, [folderIdForFolderHit, logger, sendFolderSearchHit, setFolderIdForFolderHit, totalCount]);
  (0, import_react21.useEffect)(() => {
    if (searchValueForText && totalCount >= 0) {
      logger?.().debug(
        `useStatsSearchHitWithResult - sending stat for text search from queue with value ${searchValueForText} and total count of ${totalCount}`
      );
      sendTextSearchHit({ searchValue: searchValueForText, resultCount: totalCount });
      setSearchValueForText(void 0);
    }
  }, [logger, searchValueForText, sendTextSearchHit, setSearchValueForText, totalCount]);
};

// src/providers/stats/hooks/useStatsQueueSender.ts
var import_recoil102 = require("recoil");
var useStatsQueueSender = (clientIp) => {
  const logger = (0, import_recoil102.useRecoilValue)(getLoggerAtom);
  const { sendFolderSearchHit, sendTextSearchHit } = useStatsSearchHit({
    ip: clientIp
  });
  const setFolderIdForFolderHit = (0, import_recoil102.useSetRecoilState)(statsFolderIdForFolderHit);
  const sendFolderSearchHitToQueue = ({
    folderId,
    resultCount
  }) => {
    if (resultCount && resultCount !== -1) {
      logger?.().debug(
        `useStatsSearchHitWithResult - sending stat for folder directly with folderId ${folderId} and total count of ${resultCount}`
      );
      sendFolderSearchHit({ folderId, resultCount });
    } else {
      logger?.().debug(
        `useStatsSearchHitWithResult - sending stat for folder to queue with folderId ${folderId}`
      );
      setFolderIdForFolderHit(folderId);
    }
  };
  const setSearchValueForText = (0, import_recoil102.useSetRecoilState)(statsSearchValueForTextAtom);
  const sendTextSearchHitToQueue = ({
    searchValue,
    resultCount
  }) => {
    if (resultCount && resultCount !== -1) {
      logger?.().debug(
        `useStatsSearchHitWithResult - sending stat for text search directly with value ${searchValue} and total count of ${resultCount}`
      );
      sendTextSearchHit({ searchValue, resultCount });
    } else {
      logger?.().debug(
        `useStatsSearchHitWithResult - sending stat for text search to queue with value ${searchValue}`
      );
      setSearchValueForText(searchValue);
    }
  };
  return {
    sendFolderSearchHitToQueue,
    sendTextSearchHitToQueue
  };
};

// src/providers/folder/atoms/folderHierarchy.ts
var import_recoil103 = require("recoil");
var folderHierarchyState = (0, import_recoil103.atomFamily)({
  key: "folderHierarchyState",
  default: void 0
});

// src/providers/folder/atoms/folderTree.ts
var import_recoil104 = require("recoil");
var folderTreeAtom = (0, import_recoil104.atomFamily)({
  key: "FolderTreeAtom",
  default: void 0
});
var folderTreeCountMedias = (0, import_recoil104.atomFamily)({
  key: "FolderTreeCountMedias",
  default: void 0
});
var folderTreeChildrenList = (0, import_recoil104.atomFamily)({
  key: "FolderTreeChildrenList",
  default: void 0
});

// src/providers/folder/atoms/folderSearch.ts
var import_recoil105 = require("recoil");
var folderSearchState = (0, import_recoil105.atomFamily)({
  key: "FolderSearchState",
  default: void 0
});

// src/providers/folder/hooks/useFolderHierarchy.ts
var import_react22 = require("react");
var import_recoil111 = require("recoil");

// src/providers/folder/selectors/folderHierarchy.ts
var import_recoil109 = require("recoil");

// src/providers/folder/selectors/folder.ts
var import_recoil108 = require("recoil");

// src/providers/folder/selectors/search.ts
var import_api_client40 = require("@keepeek/api-client");
var import_recoil107 = require("recoil");

// src/providers/folder/utils.ts
var import_api_client39 = require("@keepeek/api-client");
var convertKpkApiFolderNodeToKpkFolder = (kpkApiFolderNode) => {
  if (kpkApiFolderNode.id) {
    let folderIdsFromLink = [];
    if (kpkApiFolderNode._links && kpkApiFolderNode._links["self"]) {
      const path = kpkApiFolderNode._links["self"].href;
      const indexAPIInPath = path.indexOf("api");
      folderIdsFromLink = path.substring(indexAPIInPath).match(/(\d+)/g).map((folderIdFromLink) => parseInt(folderIdFromLink));
    }
    return {
      id: kpkApiFolderNode.id,
      title: kpkApiFolderNode.title,
      path: kpkApiFolderNode.path,
      previewUrl: kpkApiFolderNode._links?.["kpk:cover"]?.href,
      treeMediaCount: kpkApiFolderNode.treeMediaCount,
      hasChildren: kpkApiFolderNode.hasChildren,
      subFolderCount: kpkApiFolderNode.childrenCount,
      parentFolderId: folderIdsFromLink.length > 1 ? folderIdsFromLink.at(folderIdsFromLink.length - 2) : void 0
    };
  }
  return void 0;
};
var convertKpkApiFolderNodesToKpkFolderTrees = (kpkApiFolderNodes, includeNoRights) => {
  const kpkFolderTrees = [];
  kpkApiFolderNodes.forEach((kafn) => {
    const folder = convertKpkApiFolderNodeToKpkFolder(kafn);
    let children;
    if (kafn.treeMediaCount === void 0 || kafn.treeMediaCount > 0) {
      if (kafn._embedded?.child) {
        const childrenComputed = [];
        kafn._embedded.child.forEach((kafnc) => {
          if (kafnc.treeMediaCount === void 0 || kafnc.treeMediaCount > 0) {
            const child = convertKpkApiFolderNodeToKpkFolder(kafnc);
            if (child) {
              if (includeNoRights) {
                childrenComputed.push(child);
              } else if (!(kafnc.permission === import_api_client39.KpkApiFolderNodePermission.NotGranted && !child.title)) {
                childrenComputed.push(child);
              }
            }
          }
        });
        children = childrenComputed;
      }
      if (folder) {
        const kpkFolderTree = {
          folder,
          children
        };
        if (includeNoRights) {
          kpkFolderTrees.push(kpkFolderTree);
        } else if (!(kafn.permission === import_api_client39.KpkApiFolderNodePermission.NotGranted && !kafn.title)) {
          kpkFolderTrees.push(kpkFolderTree);
        }
      }
    }
  });
  return kpkFolderTrees;
};

// src/providers/folder/selectors/folderTree.ts
var import_recoil106 = require("recoil");
var folderTreeSelector = (0, import_recoil106.selectorFamily)({
  key: "FolderTreeSelector",
  get: (folderId) => ({ get }) => {
    const isAuthenticated = get(isAuthenticatedSelector);
    if (!isAuthenticated) {
      return void 0;
    }
    if (folderId === void 0) {
      return void 0;
    }
    let combinedFolderTree;
    const folderTree = get(folderTreeAtom(folderId));
    if (folderTree) {
      combinedFolderTree = {
        ...folderTree,
        folder: {
          ...folderTree.folder,
          treeMediaCount: get(folderTreeCountMedias(folderTree.folder.id))
        },
        children: get(folderTreeChildrenList(folderTree.folder.id))
      };
    }
    return combinedFolderTree;
  },
  set: () => ({ set }, newValue) => {
    if (newValue) {
      const newFolderTree = newValue;
      set(folderTreeAtom(newFolderTree.folder.id), newFolderTree);
      if (newFolderTree.children) {
        set(folderTreeChildrenList(newFolderTree.folder.id), newFolderTree.children);
      }
      if (newFolderTree.folder.treeMediaCount) {
        set(folderTreeCountMedias(newFolderTree.folder.id), newFolderTree.folder.treeMediaCount);
      }
    }
  }
});
var folderTreesSelector = (0, import_recoil106.selectorFamily)({
  key: "FolderTreesSelector",
  get: (folderIds) => ({ get }) => removeUndefinedDeep(folderIds?.map((id) => get(folderTreeSelector(id)))),
  set: () => ({ set }, newValue) => {
    if (newValue) {
      const folderTrees = newValue;
      folderTrees.forEach((ft) => set(folderTreeSelector(ft.folder.id), ft));
    }
  }
});

// src/providers/folder/selectors/search.ts
var searchFoldersApiSelector = (0, import_recoil107.selectorFamily)({
  key: "SearchFoldersApiSelector",
  get: ({ folderIds, query, withChildrenList = false, countMedias = false }) => async ({ get }) => {
    const logger = get(getLoggerAtom);
    if (!logger) {
      throw new MandatoryProviderException("logger");
    }
    const axiosInstance = get(getAxiosInstanceAtom);
    if (!axiosInstance) {
      throw new MandatoryProviderException("axiosInstance");
    }
    const isAuthenticated = get(isAuthenticatedSelector);
    if (!isAuthenticated) {
      logger().debug("SearchFoldersApiSelector can't fetch without authentication");
      return void 0;
    }
    get(currentLocaleAtom);
    if ((folderIds?.length ?? 0 > 0) || folderIds === void 0 || query) {
      const page = 1;
      const folderIdsNotEmpty = folderIds && folderIds.length > 0;
      const allFirstLevelFoldersExpected = !folderIds;
      let size;
      if (folderIdsNotEmpty) {
        size = folderIds.length;
      } else if (allFirstLevelFoldersExpected) {
        size = 500;
      }
      const { data } = await (0, import_api_client40.getSearchFolders)(axiosInstance(), {
        folderIds,
        page,
        size,
        countMedias,
        withChildrenList,
        q: query
      });
      return data._embedded?.folderTreeNode;
    }
    return void 0;
  }
});
var searchFoldersSelector = (0, import_recoil107.selectorFamily)({
  key: "SearchFoldersSelector",
  get: ({ folderIds, query, withChildrenList, countMedias, includeNoRights = false }) => ({ get }) => {
    if ((folderIds?.length ?? 0 > 0) || folderIds === void 0 || query) {
      const apiFolderNodes = get(
        searchFoldersApiSelector({ query, folderIds, withChildrenList, countMedias })
      );
      if (apiFolderNodes) {
        return convertKpkApiFolderNodesToKpkFolderTrees(apiFolderNodes, includeNoRights);
      }
    }
    return void 0;
  },
  set: () => ({ set }, newValue) => {
    if (newValue) {
      const folderTrees = newValue;
      folderTrees.forEach((ft) => {
        set(folderTreeSelector(ft.folder.id), ft);
      });
    }
  }
});

// src/providers/folder/selectors/folder.ts
var getFolderSelector = (0, import_recoil108.selectorFamily)({
  key: "GetFolderSelector",
  get: ({ folderId, withChildrenList, countMedias }) => ({ get }) => {
    const logger = get(getLoggerAtom);
    if (!logger) {
      throw new MandatoryProviderException("logger");
    }
    const axiosInstance = get(getAxiosInstanceAtom);
    if (!axiosInstance) {
      throw new MandatoryProviderException("axiosInstance");
    }
    const isAuthenticated = get(isAuthenticatedSelector);
    if (!isAuthenticated) {
      logger().debug("GetFolderSelector can't fetch without authentication");
      return void 0;
    }
    const folders = get(
      searchFoldersApiSelector({
        folderIds: folderId ? [folderId] : void 0,
        withChildrenList,
        countMedias
      })
    );
    return folders ? folders?.[0] : void 0;
  }
});

// src/providers/folder/selectors/folderHierarchy.ts
var folderHierarchySelector = (0, import_recoil109.selectorFamily)({
  key: "FolderHierarchySelector",
  get: ({ folderId, folderRootId, countMedias = false, withChildrenList = false }) => ({ get }) => {
    const logger = get(getLoggerAtom);
    if (!logger) {
      throw new MandatoryProviderException("logger");
    }
    const axiosInstance = get(getAxiosInstanceAtom);
    if (!axiosInstance) {
      throw new MandatoryProviderException("axiosInstance");
    }
    const isAuthenticated = get(isAuthenticatedSelector);
    if (!isAuthenticated) {
      logger().debug("FolderHierarchySelector can't fetch without authentication");
      return void 0;
    }
    if (!folderId) {
      return void 0;
    }
    const apiFolder = get(getFolderSelector({ folderId, countMedias, withChildrenList }));
    if (!apiFolder || !apiFolder._links) {
      logger().debug("folderHierarchySelector - no apiFolder found");
      return void 0;
    }
    const path = apiFolder._links["self"].href;
    const indexAPIInPath = path.indexOf("api");
    const folderIdsFromLink = path.substring(indexAPIInPath).match(/(\d+)/g).map((folderIdFromLink) => parseInt(folderIdFromLink));
    let folderIds = folderIdsFromLink;
    if (folderRootId) {
      folderIds = folderIds.slice(folderIds.indexOf(folderRootId));
    }
    if (folderIds.length === 0) {
      return void 0;
    }
    const folderTrees = get(
      searchFoldersSelector({
        folderIds,
        countMedias,
        withChildrenList
      })
    );
    if (!folderTrees) {
      return void 0;
    }
    return [...folderTrees].sort(
      (a, b) => folderIds.indexOf(a.folder.id) - folderIds.indexOf(b.folder.id)
    );
  }
});

// src/providers/breadcrumb/atoms.ts
var import_recoil110 = require("recoil");
var currentFolderRootBreadcrumbContext = (0, import_recoil110.atom)({
  key: "CurrentFolderRootBreadcrumbContext",
  default: void 0
});

// src/providers/folder/hooks/useFolderHierarchy.ts
function useFolderHierarchy({
  folderId,
  folderRootId
}) {
  const [folderTrees, setFolderTrees] = (0, import_recoil111.useRecoilState)(
    folderHierarchyState({ folderId, folderRootId })
  );
  const folderIds = folderTrees?.map((ft) => ft.folder.id);
  const [currentFolderRoot, setCurrentFolderRoot] = (0, import_recoil111.useRecoilState)(
    currentFolderRootBreadcrumbContext
  );
  const setFolderTreesState = (0, import_recoil111.useSetRecoilState)(folderTreesSelector(folderIds));
  const folderHierarchyQuery = (0, import_recoil111.useRecoilValueLoadable)(
    folderHierarchySelector({ folderId, folderRootId, countMedias: true, withChildrenList: true })
  );
  const loading = folderHierarchyQuery.state === "loading";
  (0, import_react22.useEffect)(() => {
    if (folderHierarchyQuery.state === "hasValue") {
      setFolderTrees(folderHierarchyQuery.contents);
      setFolderTreesState(folderHierarchyQuery.contents);
      if (!currentFolderRoot) {
        setCurrentFolderRoot(
          folderHierarchyQuery.contents && folderHierarchyQuery.contents.length > 0 ? folderHierarchyQuery.contents[0].folder.id : void 0
        );
      }
    }
  }, [
    currentFolderRoot,
    folderHierarchyQuery.contents,
    folderHierarchyQuery.state,
    setCurrentFolderRoot,
    setFolderTrees,
    setFolderTreesState
  ]);
  return { folderTrees, loading };
}

// src/providers/folder/hooks/useFolderTree.ts
var import_react23 = require("react");
var import_recoil112 = require("recoil");
function useFolderTree({
  folderId,
  rootFolderIds,
  countMedias = true
}) {
  const rootFolderTreeFakeId = -1;
  const [folderTreeQuery, setFolderTree] = (0, import_recoil112.useRecoilStateLoadable)(
    folderTreeSelector(folderId ?? rootFolderTreeFakeId)
  );
  const folderTree = folderTreeQuery.state === "hasValue" ? folderTreeQuery.contents : void 0;
  const folderIds = folderId ? [folderId] : rootFolderIds;
  const folderTreesSearchQuery = (0, import_recoil112.useRecoilValueLoadable)(
    searchFoldersSelector({ folderIds, withChildrenList: true, countMedias })
  );
  const loading = folderTreesSearchQuery.state === "loading" || folderTreeQuery.state === "loading";
  (0, import_react23.useEffect)(() => {
    if (folderTreesSearchQuery.state === "hasValue" && folderTreesSearchQuery.contents?.[0]) {
      if (!folderId && (!rootFolderIds || rootFolderIds.length !== 0)) {
        setFolderTree({
          folder: { id: rootFolderTreeFakeId },
          children: folderTreesSearchQuery.contents?.map((tree) => tree.folder)
        });
      } else {
        setFolderTree(folderTreesSearchQuery.contents[0]);
      }
    }
  }, [
    folderId,
    folderTreesSearchQuery.contents,
    folderTreesSearchQuery.state,
    rootFolderIds,
    rootFolderTreeFakeId,
    setFolderTree
  ]);
  return { folderTree, loading };
}

// src/providers/folder/hooks/useFolderSearch.ts
var import_react24 = require("react");
var import_recoil113 = require("recoil");
function useFolderSearch({
  folderIds,
  query,
  withChildrenList,
  countMedias = false
}) {
  const [folderTrees, setFolderTrees] = (0, import_recoil113.useRecoilState)(
    folderSearchState({ folderIds, query, withChildrenList })
  );
  const folderTreesSearchQuery = (0, import_recoil113.useRecoilValueLoadable)(
    searchFoldersSelector({
      folderIds,
      query,
      withChildrenList,
      countMedias
    })
  );
  const loading = folderTreesSearchQuery.state === "loading";
  (0, import_react24.useEffect)(() => {
    if (folderTreesSearchQuery.state === "hasValue" && folderTreesSearchQuery.contents) {
      setFolderTrees(folderTreesSearchQuery.contents);
    }
  }, [folderTreesSearchQuery.contents, folderTreesSearchQuery.state, setFolderTrees]);
  return {
    folderTrees,
    loading
  };
}

// src/providers/element/selectors/element.ts
var import_recoil114 = require("recoil");
var elementQuerySelector = (0, import_recoil114.selectorFamily)({
  key: "ElementQuerySelector",
  get: ({ elementId, embeddedFolders, permalinks }) => async ({ get }) => {
    const sheetFields = get(sheetFieldsSelector);
    const forms = get(formsQuerySelector);
    const customerCommonOverride = get(customerCommonOverrideAtom);
    if (!elementId || !sheetFields || !forms) {
      console.debug("elementQuerySelector mandatory params not valued : cancel", {
        elementId,
        sheetFields,
        forms
      });
      return void 0;
    }
    const { getElement } = get(
      elementFetcherSelector({
        fetcherMode: get(fetcherModeAtom),
        embeddedFolders
      })
    );
    const kpkApiMedia = (await getElement(elementId))?.data;
    const kpkApiMediaPermalink = permalinks ? get(elementPermalinkQuerySelector({ elementId })) : void 0;
    if (kpkApiMedia) {
      const { element } = customSelectorInOut(
        "ElementSelectorIn" /* ElementSelectorIn */,
        {
          element: convertToKpkMedia(
            forms,
            kpkApiMedia,
            sheetFields || [],
            kpkApiMediaPermalink,
            "whr" /* WHR */,
            get(tagsQuerySelector)
          )
        },
        customerCommonOverride
      );
      return element || void 0;
    }
    return void 0;
  }
});
var elementPermalinkQuerySelector = (0, import_recoil114.selectorFamily)({
  key: "ElementPermalinkQuerySelector",
  get: ({ elementId }) => async ({ get }) => {
    if (!elementId) {
      console.debug("elementPermalinkQuerySelector mandatory params not valued : cancel", {
        elementId
      });
      return void 0;
    }
    const { getElementPermalinks } = get(
      elementFetcherSelector({
        fetcherMode: get(fetcherModeAtom)
      })
    );
    return (await getElementPermalinks(elementId))?.data?._embedded?.permalink || [];
  }
});

// src/providers/element/models.ts
var QueryParamElement = /* @__PURE__ */ ((QueryParamElement2) => {
  QueryParamElement2["HIGHLIGHT_ASSOCIATIONS"] = "highlightAssociations";
  return QueryParamElement2;
})(QueryParamElement || {});

// src/providers/firstLogin/hooks.ts
var import_react25 = require("react");
var import_recoil115 = require("recoil");

// src/providers/firstLogin/utils.ts
var convertIsPassedGetDamTypeToFirstLoginType = (isPassedGetDamType) => {
  if (isPassedGetDamType.includes("NOT_AUTHORIZED_WITH_FORM" /* NOT_AUTHORIZED_WITH_FORM */)) {
    return "NOT_AUTHORIZED_WITH_FORM" /* NOT_AUTHORIZED_WITH_FORM */;
  }
  return isPassedGetDamType;
};

// src/providers/firstLogin/hooks.ts
var useFirstLoginType = ({
  isPassedGetDam,
  query = {},
  redirectUrl = location.origin,
  locale,
  registrationPage = ""
}) => {
  const [forceType, setForceType] = (0, import_react25.useState)(void 0);
  const token = (0, import_recoil115.useRecoilValue)(authTokensAtom);
  const { logout } = useAuthLogout();
  const _hash = (forceType || query?.[FIRST_LOGIN_TYPE_QUERY_PARAM] || isPassedGetDam).slice("NOT_AUTHORIZED_WITH_FORM" /* NOT_AUTHORIZED_WITH_FORM */.length);
  const type = (0, import_react25.useMemo)(() => {
    if (forceType) {
      return convertIsPassedGetDamTypeToFirstLoginType(forceType);
    }
    if (FIRST_LOGIN_TYPE_QUERY_PARAM in query) {
      return convertIsPassedGetDamTypeToFirstLoginType(
        query[FIRST_LOGIN_TYPE_QUERY_PARAM]
      );
    }
    return convertIsPassedGetDamTypeToFirstLoginType(isPassedGetDam);
  }, [forceType, isPassedGetDam, query]);
  const registrationFormHash = (0, import_react25.useMemo)(() => {
    if (type === "NOT_AUTHORIZED_WITH_FORM" /* NOT_AUTHORIZED_WITH_FORM */) {
      return _hash;
    }
    return void 0;
  }, [_hash, type]);
  const _handleLogout = (0, import_react25.useCallback)(
    (redirectUri) => {
      if (token) {
        return logout(redirectUri);
      }
      return location.replace(redirectUri);
    },
    [logout, token]
  );
  const onClose = (0, import_react25.useCallback)(
    (forceType2) => {
      const outputType = forceType2 || "NONE" /* NONE */;
      setForceType(outputType);
      if (outputType === "NONE" /* NONE */) {
        _handleLogout(redirectUrl);
      } else {
        _handleLogout(`${redirectUrl}/?${FIRST_LOGIN_TYPE_QUERY_PARAM}=${outputType}`);
      }
    },
    [_handleLogout, redirectUrl]
  );
  const registrationFormUrlPath = (0, import_recoil115.useRecoilValue)(registrationFormUrlPathState);
  const registrationFormUrl = (0, import_react25.useMemo)(
    () => registrationFormHash && registrationFormUrlPath ? `${registrationFormUrlPath}${locale ? `${locale}/` : ""}${registrationFormHash}${registrationPage}?needAuthentication=true&redirectUrl=${encodeURIComponent(
      redirectUrl
    )}` : void 0,
    [redirectUrl, registrationFormHash, registrationFormUrlPath, locale, registrationPage]
  );
  const registrationFormUrlWithForm = (0, import_react25.useMemo)(
    () => registrationFormHash && registrationFormUrlPath ? `${registrationFormUrlPath}${locale ? `${locale}/` : ""}${registrationFormHash}${registrationPage}/form?needAuthentication=true&redirectUrl=${encodeURIComponent(
      redirectUrl
    )}` : void 0,
    [redirectUrl, registrationFormHash, registrationFormUrlPath, locale, registrationPage]
  );
  return { type, registrationFormUrl, registrationFormUrlWithForm, registrationFormHash, onClose };
};

// src/providers/signatures/selectors.ts
var import_recoil116 = require("recoil");
var getSignaturesSelector = (0, import_recoil116.selectorFamily)({
  key: "GetSignaturesSelector",
  get: ({ serviceId, baseUrl, resourcePaths }) => async ({ get }) => {
    const { getSignedLinks: getSignedLinks2 } = get(signaturesFetcherSelector(get(fetcherModeAtom)));
    const folders = await getSignedLinks2({ serviceId, baseUrl, resourcePaths });
    return folders ? folders.data.signedUrls : [];
  }
});

// src/providers/ui/selector/index.ts
var import_api_client41 = require("@keepeek/api-client");
var import_recoil117 = require("recoil");
var currentUiQuery = (0, import_recoil117.selector)({
  key: "CurrentUiQuery",
  get: async ({ get }) => {
    const logger = get(getLoggerAtom);
    if (!logger) {
      throw new MandatoryProviderException("logger");
    }
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    const isAuthenticated = get(isAuthenticatedSelector);
    if (!isAuthenticated) {
      logger().debug("UiSelector can't fetch without authentication");
      return void 0;
    }
    const { data } = await (0, import_api_client41.getCurrentUi)(getAxiosInstance());
    return {
      id: data.id,
      gdprCurrentResources: data.gdprCurrentResources,
      gdprUpdateDate: data.gdprUpdateDate
    };
  }
});

// src/providers/ui/hook/useCurrentUi.ts
var import_recoil118 = require("recoil");
var useCurrentUi = () => {
  const queryCurrentUi = (0, import_recoil118.useRecoilValueLoadable)(currentUiQuery);
  const refresh = (0, import_recoil118.useRecoilRefresher_UNSTABLE)(currentUiQuery);
  const currentUi = queryCurrentUi.state === "hasValue" ? queryCurrentUi.contents : {};
  const loadingUi = queryCurrentUi.state === "loading";
  if (!loadingUi && currentUi) {
    return {
      currentUi,
      refresh
    };
  }
  return { refresh };
};

// src/providers/ui/hook/useUiByClientId.ts
var import_recoil120 = require("recoil");

// src/providers/ui/selector/uiByClientId.ts
var import_api_client42 = require("@keepeek/api-client");
var import_recoil119 = require("recoil");
var uiByClientIdQuery = (0, import_recoil119.selectorFamily)({
  key: "UiByClientIdQuery",
  get: ({ clientId }) => async ({ get }) => {
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    if (!clientId) {
      return void 0;
    }
    const { data } = await (0, import_api_client42.getUiByClientId)(getAxiosInstance(), { clientId });
    return {
      id: data.id,
      gdprCurrentResources: data.gdprCurrentResources,
      gdprUpdateDate: data.gdprUpdateDate
    };
  }
});

// src/providers/ui/hook/useUiByClientId.ts
var useUiByClientId = (clientId) => {
  const queryUiByClientId = (0, import_recoil120.useRecoilValueLoadable)(uiByClientIdQuery({ clientId }));
  const ui = queryUiByClientId.state === "hasValue" ? queryUiByClientId.contents : {};
  const loadingUi = queryUiByClientId.state === "loading";
  if (!loadingUi && ui) {
    return {
      ui
    };
  }
  return {};
};

// src/providers/basket/atoms/index.ts
var import_recoil127 = require("recoil");

// src/providers/basket/atoms/addTo.ts
var import_recoil121 = require("recoil");
var addToBasketModalState = (0, import_recoil121.atom)({
  key: "AddToBasketModalState",
  default: false
});
var addToBasketSelection = (0, import_recoil121.atom)({
  key: "AddToBasketSelection",
  default: []
});

// src/providers/basket/atoms/create.ts
var import_recoil122 = require("recoil");
var createBasketModalState = (0, import_recoil122.atom)({
  key: "CreateBasketModalState",
  default: false
});
var createBasketTitleState = (0, import_recoil122.atom)({
  key: "CreateBasketTitleState",
  default: "false"
});

// src/providers/basket/atoms/delete.ts
var import_recoil123 = require("recoil");
var massBasketDeleteModalState = (0, import_recoil123.atomFamily)({
  key: "massBasketDeleteModalState",
  default: false,
  effects: (basketIds) => [localStorageEffect(`massBasketDeleteModalState-${basketIds}`)]
});

// src/providers/basket/atoms/download.ts
var import_recoil124 = require("recoil");
var downloadBasketAskedAtom = (0, import_recoil124.atomFamily)({
  key: "DownloadBasketAskedAtom",
  default: false
});

// src/providers/basket/atoms/list.ts
var import_recoil125 = require("recoil");
var basketListState = (0, import_recoil125.atom)({
  key: "BasketListState",
  default: [],
  effects: [localStorageEffect(`BasketListState`)]
});
var basketListCallIdState = (0, import_recoil125.atom)({
  key: "BasketListCallIdState",
  default: 0
});
var basketElementsState = (0, import_recoil125.atomFamily)({
  key: "BasketElementsState",
  default: [],
  effects: (key2) => [localStorageEffect(`BasketElementsState-${key2}`)]
});
var basketCountState = (0, import_recoil125.atomFamily)({
  key: "BasketCountState",
  default: 0,
  effects: (key2) => [localStorageEffect(`BasketCountState-${key2}`)]
});

// src/providers/basket/atoms/share.ts
var import_api_client43 = require("@keepeek/api-client");
var import_recoil126 = require("recoil");
var shareBasketModalState = (0, import_recoil126.atomFamily)({
  key: "ShareBasketModalState",
  default: false
});
var selectedExportDefinitionForPublicSharingState = (0, import_recoil126.atom)({
  key: "SelectedExportDefinitionForPublicSharingState",
  default: import_api_client43.KpkApiPublicShareExportDefinition.HD
});
var selectedDeactivationDateForPublicSharingState = (0, import_recoil126.atom)({
  key: "SelectedDeactivationDateForPublicSharingState",
  default: {
    active: false,
    date: (0, import_dayjs.default)().add(6, "month").format("YYYY-MM-DDTHH:mm")
  }
});
var selectedAccessCodeForPublicSharingState = (0, import_recoil126.atom)({
  key: "SelectedAccessCodeForPublicSharingState",
  default: {
    active: false,
    code: void 0
  }
});
var selectedAttachmentsVisibleForPublicSharingState = (0, import_recoil126.atom)({
  key: "SelectedAttachmentsVisibleForPublicSharingState",
  default: {
    attachmentsVisible: false
  }
});
var selectedStatusForPublicSharingState = (0, import_recoil126.atomFamily)({
  key: "SelectedStatusForPublicSharingState",
  default: import_api_client43.KpkApiPublicShareStatus.Deactivated
});
var updatePublicSharedState = (0, import_recoil126.atom)({
  key: "UpdatePublicSharedState",
  default: 0
});

// src/providers/basket/atoms/index.ts
var basketActiveAtom = (0, import_recoil127.atom)({
  key: "BasketActiveAtom",
  default: false
});
var basketInternalMode = (0, import_recoil127.atom)({
  key: "BasketInternalMode",
  default: void 0
});
var basketInternalModePerUserTypeConfiguration = (0, import_recoil127.atom)({
  key: "BasketInternalModePerUserTypeConfiguration",
  default: void 0,
  effects: [localStorageEffect(`BasketInternalModePerUserTypeConfiguration`)]
});

// src/providers/basket/hooks/useBasketAddTo.ts
var import_react28 = require("react");
var import_uniqBy3 = __toESM(require("lodash/uniqBy"));
var import_react_i18next8 = require("react-i18next");
var import_recoil136 = require("recoil");

// src/providers/basket/selectors/edit.ts
var import_recoil129 = require("recoil");

// src/providers/basket/selectors/list.ts
var import_recoil128 = require("recoil");

// src/providers/basket/utils.ts
var import_api_client44 = require("@keepeek/api-client");
var import_react_i18next7 = require("react-i18next");
async function getBasketList(axiosInstance, logger, size = 100, page = 1, q, fq, sort) {
  logger && logger().debug(`getBasketList`);
  try {
    return await getBasketListAndConvert(axiosInstance, size, page, q, fq, sort);
  } catch (error) {
    logger && logger().error(`error getting basket list (error ${error.response.status})`);
    if (error.response.status === 500) {
      try {
        await createBasket(axiosInstance, {
          title: (0, import_react_i18next7.getI18n)().t("basket.create.default-name.label")
        });
        return await getBasketListAndConvert(axiosInstance, size, page, q, fq, sort);
      } catch (error2) {
        logger && logger().error(`error getting basket list, cannot create default basket`);
      }
    }
  }
  return { baskets: null, totalCount: void 0 };
}
async function getBasketListAndConvert(axiosInstance, size = 100, page = 1, q, fq, sort) {
  const resultBaskets = await (0, import_api_client44.searchBaskets)(axiosInstance, {
    size,
    page,
    fq: fq && fq.length !== 0 ? fq : [],
    q,
    sort
  });
  const { totalCount, _embedded } = resultBaskets.data;
  return { baskets: convertToKpkBaskets(_embedded?.basket), totalCount };
}
async function createBasket(axiosInstance, { title }, logger) {
  logger && logger().debug(`createBasket`);
  try {
    const result = await (0, import_api_client44.createBasket)(axiosInstance, {
      basket: {
        title: title || (0, import_dayjs.default)().format("L LT")
      },
      axiosRequestConfig: {
        handleErrorLocally: true
      }
    });
    if (result.status === 200 || result.status === 201) {
      const basketId = Number(
        result.headers.location.split("/")[result.headers.location.split("/").length - 1]
      );
      return basketId;
    }
  } catch (error) {
    logger && logger().error(`error creating basket`);
  }
  return false;
}
async function updateBasket(axiosInstance, params, logger) {
  logger && logger().debug(`updateBasket`);
  try {
    const result = await (0, import_api_client44.updateBasket)(axiosInstance, {
      basket: {
        id: params.id,
        title: params.title
      },
      axiosRequestConfig: {
        handleErrorLocally: true
      }
    });
    return result.status === 204;
  } catch (error) {
    logger && logger().error(`error updating basket`);
  }
  return false;
}
async function deleteBasket(axiosInstance, basketId, logger) {
  logger && logger().debug(`deleteBasket`);
  try {
    const result = await (0, import_api_client44.deleteBasket)(axiosInstance, {
      basketId,
      axiosRequestConfig: {
        handleErrorLocally: true
      }
    });
    return result.status === 204;
  } catch (error) {
    logger && logger().error(`error deleting basket`);
  }
  return false;
}
var convertToKpkBaskets = (kpkApiBaskets) => {
  if (kpkApiBaskets) {
    return kpkApiBaskets.map((kpkApiBasket) => {
      return {
        id: kpkApiBasket.id || 0,
        title: kpkApiBasket.title || "",
        mediaCount: kpkApiBasket.mediaCount || 0,
        media: kpkApiBasket?._links?.["kpk:cover-xlarge"]?.href ?? ""
      };
    });
  }
  return [];
};
var convertToKpkSharePublicBasket = (kpkAPIPublicShare, displayBackofficeSharedBasket) => {
  let entryPoint;
  const detailHref = kpkAPIPublicShare._links?.["kpk:detail"]?.href;
  if (displayBackofficeSharedBasket && detailHref) {
    entryPoint = detailHref;
  } else if (detailHref) {
    entryPoint = `${window.location.origin}/share/${detailHref.substring(
      detailHref.lastIndexOf("/") + 1
    )}`;
  }
  return {
    status: kpkAPIPublicShare.status,
    exportDefinition: kpkAPIPublicShare.exportDefinition,
    deactivationDate: kpkAPIPublicShare.deactivationDate,
    accessCode: kpkAPIPublicShare.accessCode,
    attachmentsVisible: kpkAPIPublicShare.attachmentsVisible,
    entryPoint
  };
};
async function putSharePublicBasket(axiosInstance, params, logger) {
  const { basketId, publicShare } = params;
  try {
    if (basketId) {
      const result = await (0, import_api_client44.putSharePublicBasket)(axiosInstance, {
        basketId,
        accessCode: publicShare.accessCode,
        attachmentsVisible: publicShare.attachmentsVisible,
        deactivationDate: publicShare.deactivationDate,
        status: publicShare?.status ?? import_api_client44.KpkApiPublicShareStatus.Deactivated,
        exportDefinition: publicShare.exportDefinition
      });
      if (result.status === 204 || result.status === 200) {
        return true;
      } else {
        logger && logger().warn(
          "basket provider - util - putSharePublicBasket:",
          "Cannot publish, response is not 200 nor 204",
          result
        );
      }
    } else {
      logger && logger().warn(
        "basket provider - util - putSharePublicBasket:",
        "Cannot publish without a basketId",
        basketId
      );
    }
  } catch (err) {
    logger && logger().warn("basket provider - util - putSharePublicBasket:", err);
  }
  throw new Error("putSharePublicBasket");
}

// src/providers/basket/constants.ts
var BASKET_LIST_DEFAULT_SIZE = 100;

// src/providers/basket/selectors/list.ts
var basketListQuery = (0, import_recoil128.selectorFamily)({
  key: "BasketListQuery",
  get: ({
    sort = `${"creationDate" /* CreationDate */} ${"desc" /* DSC */}`,
    size = BASKET_LIST_DEFAULT_SIZE,
    page = 1,
    q = "",
    fq = []
  }) => async ({ get }) => {
    const axiosInstance = get(getAxiosInstanceAtom);
    const logger = get(getLoggerAtom);
    const isAuthenticated = get(isAuthenticatedSelector);
    if (!isAuthenticated) {
      logger && logger().debug("BasketListQuery can't fetch without authentication");
      return { baskets: null, totalCount: void 0 };
    }
    get(basketListCallIdState);
    get(shouldUpdateAdvancedSearchId("basket-detail" /* BASKET_DETAIL */));
    if (axiosInstance) {
      return await getBasketList(axiosInstance(), logger, size, page, q, fq, sort);
    }
    throw new Error("basketListQuery");
  }
});
var basketListSelector = (0, import_recoil128.selector)({
  key: "BasketListSelector",
  get: ({ get }) => {
    const basketList = get(basketListState);
    const basketListMerge = basketList.map((basket) => ({
      ...basket,
      elements: get(basketElementsState(basket.id)),
      mediaCount: get(basketCountState(basket.id))
    }));
    return basketListMerge;
  },
  set: ({ set }, newBasketList) => {
    set(
      basketListState,
      newBasketList.map(({ id, title, media, mediaCount }) => ({ id, title, media, mediaCount }))
    );
    newBasketList.forEach(({ id, mediaCount, elements }) => {
      set(basketCountState(id), mediaCount);
      set(basketElementsState(id), elements);
    });
  }
});
var basketSelector = (0, import_recoil128.selectorFamily)({
  key: "BasketSelector",
  get: ({ id }) => ({ get }) => get(basketListSelector).find((b) => b.id === id),
  set: ({ id }) => ({ set }, newBasket) => {
    if (!id) {
      return void 0;
    }
    set(basketListState, (basketList) => {
      const newBasketList = [];
      basketList.forEach((basket) => {
        if (basket.id === id) {
          newBasketList.push({
            id: newBasket.id,
            media: newBasket.media,
            mediaCount: newBasket.mediaCount,
            title: newBasket.title
          });
        } else {
          newBasketList.push(basket);
        }
      });
      return newBasketList;
    });
    if (newBasket) {
      set(basketCountState(id), newBasket.mediaCount);
      set(basketElementsState(id), newBasket.elements);
    }
    return;
  }
});
var basketListRawSelector = (0, import_recoil128.selector)({
  key: "BasketListRawSelector",
  get: ({ get }) => get(basketListState),
  set: ({ set }, newBasketListRaw) => {
    set(basketListState, newBasketListRaw);
    newBasketListRaw.forEach(({ id, mediaCount }) => {
      set(basketCountState(id), mediaCount);
    });
  }
});
var basketListCallIdsSelector = (0, import_recoil128.selector)({
  key: "BasketListCallIdsSelector",
  get: ({ get }) => get(basketListCallIdState),
  set: ({ set }, callId) => {
    set(basketListCallIdState, callId);
  }
});

// src/providers/basket/selectors/edit.ts
var basketTitle = (0, import_recoil129.selectorFamily)({
  key: "BasketTitle",
  get: (id) => ({ get }) => get(basketSelector({ id }))?.title,
  set: (id) => ({ set }, title) => set(
    basketSelector({ id }),
    (currVal) => currVal ? {
      ...currVal,
      title: title || currVal.title
    } : void 0
  )
});

// src/providers/basket/selectors/elements.ts
var import_api_client45 = require("@keepeek/api-client");
var import_recoil130 = require("recoil");
var basketElementsSelector = (0, import_recoil130.selectorFamily)({
  key: "BasketElementsSelector",
  get: (id) => ({ get }) => {
    if (id) {
      const currentBasket = get(basketSelector({ id }));
      if (currentBasket) {
        const { elements, mediaCount } = currentBasket;
        return { elements, mediaCount };
      }
    }
    return void 0;
  },
  set: (id) => ({ set }, newValues) => {
    set(basketSelector({ id }), (basket) => {
      if (basket) {
        let media = basket.media;
        if (media === "" || (basket.elements?.length ?? 0) === 0) {
          media = newValues.elements?.[0]?.previewUrl ?? "";
        }
        return {
          ...basket,
          elements: newValues.elements,
          mediaCount: newValues.mediaCount,
          media
        };
      }
      return void 0;
    });
  }
});
var basketTotalCountSelector = (0, import_recoil130.selectorFamily)({
  key: "BasketTotalCountSelector",
  get: (id) => ({ get }) => {
    const currentBasketElements = get(basketElementsSelector(id));
    return currentBasketElements?.mediaCount ?? -1;
  }
});
var basketDownloadLevelSelector = (0, import_recoil130.selectorFamily)({
  key: "BasketDownloadLevelSelector",
  get: (id) => ({ get }) => {
    const currentBasketElements = get(basketElementsSelector(id));
    const noneDownloadLevel = currentBasketElements?.elements?.find(
      (e) => e.downloadLevel === import_api_client45.KpkApiMediaDownloadLevel.None
    );
    if (noneDownloadLevel) {
      return import_api_client45.KpkApiPublicShareExportDefinition.None;
    }
    const bdDownloadLevel = currentBasketElements?.elements?.find(
      (e) => e.downloadLevel === import_api_client45.KpkApiMediaDownloadLevel.Bd
    );
    if (bdDownloadLevel) {
      return import_api_client45.KpkApiPublicShareExportDefinition.Bd;
    }
    return import_api_client45.KpkApiPublicShareExportDefinition.HD;
  }
});
var basketItemSelector = (0, import_recoil130.selectorFamily)({
  key: "BasketItemSelector",
  get: (id) => ({ get }) => {
    if (id) {
      const basketList = get(basketListSelector);
      if (basketList && basketList.length !== 0) {
        const firstBasket = get(basketSelector({ id: basketList[0].id }));
        if (firstBasket) {
          return get(getBasketSelector(firstBasket.id));
        }
      }
    }
    return null;
  }
});
var getBasketSelector = (0, import_recoil130.selectorFamily)({
  key: "GetBasketSelector",
  get: (basketId) => async ({ get }) => {
    const axiosInstance = get(getAxiosInstanceAtom);
    const logger = get(getLoggerAtom);
    const internalMode = get(basketInternalMode);
    if (internalMode === void 0 || internalMode) {
      return null;
    }
    const isAuthenticated = get(isAuthenticatedSelector);
    if (!isAuthenticated) {
      logger && logger().debug("GetBasketSelector can't fetch without authentication");
      return null;
    }
    get(basketListCallIdState);
    if (axiosInstance) {
      try {
        const kpkApiBasket = await (0, import_api_client45.getBasket)(axiosInstance(), {
          basketId,
          axiosRequestConfig: {
            disableNotificationErrorCodes: [404]
          }
        });
        return {
          id: kpkApiBasket.data.id || 0,
          title: kpkApiBasket.data.title || "",
          mediaCount: kpkApiBasket.data.mediaCount || 0,
          media: kpkApiBasket.data?._links?.["kpk:cover-xlarge"]?.href ?? "",
          share: kpkApiBasket.data?._links?.["kpk:share"] !== void 0
        };
      } catch (error) {
        logger && logger().error(`error getting basket item (error ${error.response.status})`);
      }
    }
    throw new Error("getBasketSelector");
  }
});
var basketTotalCountWithInternalModeSelector = (0, import_recoil130.selectorFamily)({
  key: "BasketTotalCountSelector",
  get: (params) => ({ get }) => {
    const internalMode = get(basketInternalMode);
    if (internalMode === void 0) {
      return -1;
    }
    if (internalMode) {
      const currentBasketElement = get(basketElementsSelector(params.basketId));
      return currentBasketElement?.mediaCount || -1;
    } else {
      return get(dataViewElementsTotalCountSelector(params));
    }
  }
});

// src/providers/basket/selectors/share.ts
var import_api_client46 = require("@keepeek/api-client");
var import_recoil131 = require("recoil");
var basketPublicShareQuery = (0, import_recoil131.selectorFamily)({
  key: "BasketPublicShareQuery",
  get: ({ displayBackofficeSharedBasket, basketId }) => async ({ get }) => {
    const internalMode = get(basketInternalMode);
    const axiosInstance = get(getAxiosInstanceAtom);
    const modalIsOpen = get(shareBasketModalState(basketId));
    const logger = get(getLoggerAtom);
    if (internalMode === void 0 || internalMode) {
      return {};
    }
    const isAuthenticated = get(isAuthenticatedSelector);
    if (!isAuthenticated) {
      logger && logger().debug("BasketPublicShareQuery can't fetch without authentication");
      return {};
    }
    get(updatePublicSharedState);
    if (basketId && axiosInstance && modalIsOpen) {
      try {
        const { data } = await (0, import_api_client46.getSharePublicBasket)(axiosInstance(), {
          basketId,
          axiosRequestConfig: {
            handleErrorLocally: true
          }
        });
        return convertToKpkSharePublicBasket(data, displayBackofficeSharedBasket ?? false);
      } catch (error) {
        logger && logger().error("basketShareEntryPointSelector", error);
      }
    }
    return {};
  }
});

// src/providers/basket/hooks/useBasketInternalAddTo.ts
var import_api_client47 = require("@keepeek/api-client");
var import_recoil132 = require("recoil");
function useBasketInternalAddTo() {
  const axiosInstance = (0, import_recoil132.useRecoilValue)(getAxiosInstanceAtom);
  return (0, import_recoil132.useRecoilCallback)(
    ({ set, snapshot }) => async (mediaIdsToAdd, basketId) => {
      const elementsAlreadyInBasket = await snapshot.getPromise(basketElementsSelector(basketId));
      const mediaIdToFetch = mediaIdsToAdd.filter(
        (selection) => !elementsAlreadyInBasket?.elements?.some((e) => e.id === selection)
      );
      if (mediaIdToFetch.length === 0) {
        return;
      }
      const fields = await snapshot.getPromise(
        dataViewFieldConstructorSelector({ key: "basket" /* BASKET */, customFields: [] })
      );
      const searchMediasResult = axiosInstance && await (0, import_api_client47.searchMedias)(axiosInstance(), {
        fields: formatFieldsForKpkApi(fields),
        size: mediaIdToFetch.length,
        fq: [`mediaId:(${mediaIdToFetch.join(" ")})`]
      });
      if (!searchMediasResult || !searchMediasResult.data || !searchMediasResult.data._embedded || !searchMediasResult.data._embedded.media) {
        return;
      }
      const sheetFields = await snapshot.getPromise(sheetFieldsSelector);
      const forms = await snapshot.getPromise(formsQuerySelector);
      set(basketElementsSelector(basketId), (currVal) => {
        let newElements = currVal?.elements && [...currVal.elements];
        searchMediasResult?.data?._embedded?.media.filter((m) => !newElements?.some((e) => e.id === m.id)).forEach((kpkApiMedia) => {
          if (!newElements) {
            newElements = [];
          }
          newElements.push(
            convertToKpkMedia(forms, kpkApiMedia, sheetFields || [], [], "whr" /* WHR */)
          );
        });
        return {
          elements: newElements,
          mediaCount: newElements?.length || 0
        };
      });
    }
  );
}
var useBasketInternalAddTo_default = useBasketInternalAddTo;

// src/providers/basket/hooks/useBasketList.ts
var import_react27 = require("react");
var import_recoil134 = require("recoil");

// src/providers/basket/hooks/useBasketInternalMode.ts
var import_react26 = require("react");
var import_api_client48 = require("@keepeek/api-client");
var import_recoil133 = require("recoil");
var useBasketInternalMode = () => {
  const setBasketInternalMode = (0, import_recoil133.useSetRecoilState)(basketInternalMode);
  const { publicVisitor } = useIsVisitor();
  const queryCurrentUserAssignedGroups = (0, import_recoil133.useRecoilValueLoadable)(currentUserAssignedGroupsQuery);
  const basketInternalModePerUserType = (0, import_recoil133.useRecoilValue)(basketInternalModePerUserTypeConfiguration);
  (0, import_react26.useEffect)(() => {
    const matchAdminAndGroup = queryCurrentUserAssignedGroups.state === "hasValue" && queryCurrentUserAssignedGroups.contents.some(
      (group) => group.type && basketInternalModePerUserType?.includes(group.type) && group.enabled && group.status === import_api_client48.KpkApiAssignedGroupStatus.Valid
    );
    if (publicVisitor || matchAdminAndGroup || basketInternalModePerUserType?.includes("ALL" /* All */)) {
      setBasketInternalMode(true);
    } else {
      setBasketInternalMode(false);
    }
  }, [
    basketInternalModePerUserType,
    publicVisitor,
    queryCurrentUserAssignedGroups.contents,
    queryCurrentUserAssignedGroups.state,
    setBasketInternalMode
  ]);
};

// src/providers/basket/hooks/useBasketList.ts
function useBasketList({ basketPartitioning }) {
  useBasketInternalMode();
  const { currentUi } = useCurrentUi();
  const basketListLoadable = (0, import_recoil134.useRecoilValueLoadable)(
    basketListQuery({ fq: basketPartitioning ? [`uiId:${currentUi?.id}`] : [] })
  );
  const setBasketListRaw = (0, import_recoil134.useSetRecoilState)(basketListRawSelector);
  const basketList = (0, import_recoil134.useRecoilValue)(basketListSelector);
  const internalMode = (0, import_recoil134.useRecoilValue)(basketInternalMode);
  const setShouldNotCreateAdvancedId = (0, import_recoil134.useSetRecoilState)(
    shouldNotCreateAdvancedId("basket" /* BASKET */)
  );
  (0, import_react27.useEffect)(() => {
    if (internalMode === void 0) {
      return;
    }
    if (basketListLoadable.state === "hasValue" && basketListLoadable.contents.baskets && !internalMode) {
      setBasketListRaw(basketListLoadable.contents.baskets);
    }
    setShouldNotCreateAdvancedId(internalMode);
  }, [basketListLoadable, internalMode, setBasketListRaw, setShouldNotCreateAdvancedId]);
  return {
    basketList
  };
}
var useBasketList_default = useBasketList;

// src/providers/basket/hooks/useBasketsReload.ts
var import_recoil135 = require("recoil");
var useBasketsReload = () => {
  const setCallId = (0, import_recoil135.useSetRecoilState)(basketListCallIdsSelector);
  const internalMode = (0, import_recoil135.useRecoilValue)(basketInternalMode);
  return () => {
    if (internalMode === void 0) {
      return;
    }
    if (!internalMode) {
      setCallId((v) => v + 1);
    }
  };
};

// src/providers/basket/hooks/useBasketAddTo.ts
function useBasketAddTo(element, basketId, activateBasketPartitioning, sentryCallback, snackbarCallback, callBack) {
  const axiosInstance = (0, import_recoil136.useRecoilValue)(getAxiosInstanceAtom);
  const logger = (0, import_recoil136.useRecoilValue)(getLoggerAtom);
  const directExportNumberLimit = (0, import_recoil136.useRecoilValue)(directExportNumberLimitSelector);
  const addMediasToInternalBasket = useBasketInternalAddTo_default();
  const [open, setOpen] = (0, import_recoil136.useRecoilState)(addToBasketModalState);
  const reloadBaskets = useBasketsReload();
  const { basketList } = useBasketList_default({ basketPartitioning: activateBasketPartitioning });
  const [selectionToAdd, setSelectionToAdd] = (0, import_recoil136.useRecoilState)(addToBasketSelection);
  const setSelectedElements = (0, import_recoil136.useSetRecoilState)(selectedElements("basket" /* BASKET */));
  const { t } = (0, import_react_i18next8.useTranslation)();
  const setBasketElements = (0, import_recoil136.useSetRecoilState)(basketElementsSelector(basketId));
  const internalMode = (0, import_recoil136.useRecoilValue)(basketInternalMode);
  const setShouldRefreshGetAdvancedSearchBasketQuery = (0, import_recoil136.useSetRecoilState)(
    shouldRefreshGetAdvancedSearchQuery("basket" /* BASKET */)
  );
  const setShouldRefreshGetAdvancedSearchBasketDetailQuery = (0, import_recoil136.useSetRecoilState)(
    shouldRefreshGetAdvancedSearchQuery("basket-detail" /* BASKET_DETAIL */)
  );
  const filters = (0, import_recoil136.useRecoilValue)(activeBusinessFiltersState("search" /* SEARCH */));
  const { elements } = useDataView({ key: "search" /* SEARCH */, filters: filters || null });
  const addElementsToBasket = (ids) => {
    setBasketElements((currVal) => {
      if (internalMode === void 0) {
        return void 0;
      }
      if (currVal) {
        const hasDoublon = currVal.elements?.some(({ id }) => ids.includes(id)) ?? false;
        if (hasDoublon && !internalMode) {
          return currVal;
        }
        let newElements = elements.filter(({ id }) => ids.includes(id));
        if (newElements.length === 0 && ids.length === 1 && element?.id === ids[0]) {
          newElements.push(element);
        }
        newElements = (0, import_uniqBy3.default)([...newElements, ...currVal?.elements ?? []], "id");
        const mediaCount = internalMode ? newElements.length : currVal.mediaCount + ids.length;
        return {
          elements: newElements,
          mediaCount
        };
      }
      return void 0;
    });
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `addElementsToCurrentBasket: ${ids.join(",")}`
    });
  };
  async function onSelectBasket(basketId2) {
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `onSelectBasket: ${basketId2}`
    });
    if (internalMode === void 0) {
      return;
    }
    const basket = basketList?.find((b) => b.id === basketId2);
    const mediaIds = [...selectionToAdd];
    if (internalMode && directExportNumberLimit && (basket && mediaIds.length + basket.mediaCount > directExportNumberLimit || !basket && mediaIds.length > directExportNumberLimit)) {
      snackbarCallback && snackbarCallback({
        message: t("basket.addto.max-reached-anonymous.label", {
          count: directExportNumberLimit
        }),
        options: { variant: "warning" }
      });
      return;
    }
    close();
    if (!internalMode) {
      addElementsToBasket(mediaIds);
    }
    if (axiosInstance) {
      try {
        let result;
        if (internalMode) {
          await addMediasToInternalBasket(mediaIds, basketId2);
        } else {
          await addMediasToBasket(axiosInstance(), { basketId: basketId2, mediaIds }, logger);
          if (result !== null && basket) {
            setShouldRefreshGetAdvancedSearchBasketQuery((val) => val + 1);
            setShouldRefreshGetAdvancedSearchBasketDetailQuery((val) => val + 1);
          }
        }
        if (result !== null) {
          snackbarCallback && snackbarCallback({
            message: t("basket.addto.success.label", {
              count: mediaIds.length,
              basketTitle: basket ? `"${basket.title}"` : ""
            }),
            options: { key: "addToBasketSuccess", id: "addToBasketSuccess", variant: "success" }
          });
        }
        reloadBaskets();
        if (callBack) {
          callBack();
        }
      } catch (error) {
        logger && logger().error("useBasketAddTo: onSelectBasket", error);
        snackbarCallback && snackbarCallback({
          message: t("basket.addto.error.label"),
          options: { variant: "error" }
        });
      }
    }
  }
  function close() {
    setOpen(false);
    setSelectionToAdd([]);
    setSelectedElements([]);
    sentryCallback && sentryCallback({
      category: "VISUAL_FEEDBACK" /* VISUAL_FEEDBACK */,
      message: `addToBasketModalState: close`
    });
  }
  const [openCreateBasket, setOpenCreateBasket] = (0, import_recoil136.useRecoilState)(createBasketModalState);
  (0, import_react28.useEffect)(() => {
    const hasSelection = selectionToAdd.length > 0;
    const hasBasket = !((basketList?.length ?? 0) === 0);
    const noModalOpen = !open && !openCreateBasket;
    if (hasSelection && noModalOpen && hasBasket) {
      setOpen(true);
      sentryCallback && sentryCallback({
        category: "VISUAL_FEEDBACK" /* VISUAL_FEEDBACK */,
        message: `addToBasketModalState: open`
      });
    } else if (!hasSelection) {
      setOpen(false);
      sentryCallback && sentryCallback({
        category: "VISUAL_FEEDBACK" /* VISUAL_FEEDBACK */,
        message: `addToBasketModalState: close`
      });
    }
  }, [basketList?.length, open, openCreateBasket, selectionToAdd.length, sentryCallback, setOpen]);
  function createBasket2() {
    setOpenCreateBasket(true);
    setOpen(false);
    sentryCallback && sentryCallback({
      category: "VISUAL_FEEDBACK" /* VISUAL_FEEDBACK */,
      message: `addToBasketModalState: close`
    });
  }
  return {
    onSelectBasket,
    open,
    close,
    count: selectionToAdd.length,
    basketList,
    createBasket: createBasket2,
    setSelectionToAdd
  };
}
var useBasketAddTo_default = useBasketAddTo;

// src/providers/basket/hooks/useBasketCreate.ts
var import_react30 = require("react");
var import_react_i18next9 = require("react-i18next");
var import_recoil138 = require("recoil");

// src/providers/basket/hooks/useOpenCreateBasket.ts
var import_react29 = require("react");
var import_recoil137 = require("recoil");
var useOpenCreateBasket = (sentryCallback) => {
  const setOpen = (0, import_recoil137.useSetRecoilState)(createBasketModalState);
  return (0, import_react29.useCallback)(() => {
    setOpen(true);
    sentryCallback && sentryCallback({
      category: "VISUAL_FEEDBACK" /* VISUAL_FEEDBACK */,
      message: `createBasketModalState: open`
    });
  }, [sentryCallback, setOpen]);
};

// src/providers/basket/hooks/useBasketCreate.ts
var createBasketInputId = "CreateBasketInput";
function useBasketCreate(element, activateBasketPartitioning, sentryCallback, snackbarCallback, callBack) {
  const axiosInstance = (0, import_recoil138.useRecoilValue)(getAxiosInstanceAtom);
  const openCreateBasket = useOpenCreateBasket();
  const [open, setOpen] = (0, import_recoil138.useRecoilState)(createBasketModalState);
  const [title, setTitle] = (0, import_recoil138.useRecoilState)(createBasketTitleState);
  const { t } = (0, import_react_i18next9.useTranslation)();
  const reloadBaskets = useBasketsReload();
  const { basketList } = useBasketList_default({ basketPartitioning: activateBasketPartitioning });
  const [selectionToAdd, setSelectionToAdd] = (0, import_recoil138.useRecoilState)(addToBasketSelection);
  const { onSelectBasket } = useBasketAddTo_default(element, void 0, activateBasketPartitioning);
  const [createLoading, setCreateLoading] = (0, import_react30.useState)(false);
  const internalMode = (0, import_recoil138.useRecoilValue)(basketInternalMode);
  const setBasketsinList = (0, import_recoil138.useSetRecoilState)(basketListSelector);
  function close() {
    setOpen(false);
    setSelectionToAdd([]);
    sentryCallback && sentryCallback({
      category: "VISUAL_FEEDBACK" /* VISUAL_FEEDBACK */,
      message: `createBasketModalState: close`
    });
  }
  async function createBasket2() {
    if (internalMode === void 0) {
      return Promise.reject("internalMode not yet valued");
    }
    setCreateLoading(true);
    let basketCreated = false;
    if (internalMode) {
      basketCreated = basketList.length + 1;
      setBasketsinList((currVal) => [
        ...currVal,
        { id: basketCreated, title, mediaCount: 0, elements: [], media: "" }
      ]);
    } else if (axiosInstance) {
      basketCreated = await createBasket(axiosInstance(), { title });
    }
    setCreateLoading(false);
    if (basketCreated) {
      snackbarCallback && snackbarCallback({
        message: t("basket.create.status.success.label", { title }),
        options: {
          key: "basketCreationSuccess",
          id: "basketCreationSuccess",
          variant: "success"
        }
      });
      if (selectionToAdd.length > 0) {
        onSelectBasket(basketCreated);
      } else {
        reloadBaskets();
      }
      callBack && callBack(basketCreated);
    } else {
      snackbarCallback && snackbarCallback({
        message: t("basket.create.status.error.label", { title }),
        options: {
          variant: "error"
        }
      });
    }
    close();
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `createBasket`
    });
    return Promise.resolve();
  }
  (0, import_react30.useEffect)(() => {
    if (open) {
      setTitle((0, import_dayjs.default)().format("L LT"));
      setTimeout(() => {
        const input = document.getElementById(createBasketInputId);
        input?.select();
      }, 100);
    }
  }, [open, setTitle]);
  (0, import_react30.useEffect)(() => {
    const hasSelection = selectionToAdd.length > 0;
    const hasBasket = !((basketList?.length ?? 0) === 0);
    const noModalOpen = !open;
    if (hasSelection && noModalOpen && !hasBasket) {
      openCreateBasket();
    }
  }, [basketList?.length, open, openCreateBasket, selectionToAdd.length, setOpen]);
  return {
    open,
    close,
    title,
    setTitle,
    createBasket: createBasket2,
    loading: createLoading
  };
}

// src/providers/basket/hooks/useBasketDelete.ts
var import_react_i18next10 = require("react-i18next");
var import_recoil139 = require("recoil");
var useBasketDelete = (basketId, sentryCallback, snackbarCallback, deleteCallBack) => {
  const { t } = (0, import_react_i18next10.useTranslation)();
  const [basketList, setBasketList] = (0, import_recoil139.useRecoilState)(basketListSelector);
  const reloadBaskets = useBasketsReload();
  const setShouldNotCreateAdvancedId = (0, import_recoil139.useSetRecoilState)(
    shouldNotCreateAdvancedId("basket" /* BASKET */)
  );
  const internalMode = (0, import_recoil139.useRecoilValue)(basketInternalMode);
  const axiosInstance = (0, import_recoil139.useRecoilValue)(getAxiosInstanceAtom);
  const logger = (0, import_recoil139.useRecoilValue)(getLoggerAtom);
  const deleteBasket2 = async () => {
    if (internalMode === void 0) {
      return Promise.reject("internalMode not yet valued");
    }
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `deleteBasket: ${basketId}`
    });
    const newBasketList = [...basketList.filter((basket) => basket.id !== basketId)];
    if (newBasketList.length === 0 || internalMode) {
      setShouldNotCreateAdvancedId(true);
    }
    setBasketList(newBasketList);
    try {
      if (basketId) {
        if (!internalMode && axiosInstance) {
          await deleteBasket(axiosInstance(), basketId);
        }
        reloadBaskets();
        if (deleteCallBack) {
          deleteCallBack();
        }
        return snackbarCallback && snackbarCallback({
          message: t("basket.delete.status.success.label", {
            title: basketList.find((b) => b.id === basketId)?.title
          }),
          options: {
            variant: "success"
          }
        });
      } else {
        logger && logger().warn("useBasketDelete - deleteBasket: no basketId provided");
      }
    } catch (error) {
      logger && logger().warn("useBasketDelete - deleteBasket:", error);
    }
    reloadBaskets();
    return snackbarCallback && snackbarCallback({
      message: t("basket.delete.status.error.label", {
        title: basketList.find((b) => b.id === basketId)?.title
      }),
      options: {
        variant: "error"
      }
    });
  };
  return {
    deleteBasket: deleteBasket2
  };
};

// src/providers/basket/hooks/useBasketsDelete.ts
var import_react_i18next11 = require("react-i18next");
var import_recoil140 = require("recoil");
var useBasketsDelete = (basketIds, sentryCallback, snackbarCallback) => {
  const { t } = (0, import_react_i18next11.useTranslation)();
  const [open, setOpen] = (0, import_recoil140.useRecoilState)(massBasketDeleteModalState(basketIds));
  const reloadBaskets = useBasketsReload();
  const internalMode = (0, import_recoil140.useRecoilValue)(basketInternalMode);
  const axiosInstance = (0, import_recoil140.useRecoilValue)(getAxiosInstanceAtom);
  const logger = (0, import_recoil140.useRecoilValue)(getLoggerAtom);
  const deleteBaskets = async () => {
    if (internalMode === void 0) {
      return Promise.reject("internalMode not yet valued");
    }
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `deleteBaskets: ${basketIds?.toString()}`
    });
    try {
      if (basketIds) {
        if (!internalMode && axiosInstance) {
          await Promise.all(
            basketIds?.map(
              (basketId) => deleteBasket(axiosInstance(), basketId)
            )
          );
        }
        reloadBaskets();
        return snackbarCallback && snackbarCallback({
          message: t("baskets.delete.status.success.label", { count: basketIds.length || 0 }),
          options: {
            variant: "success"
          }
        });
      } else {
        logger && logger().warn("useBasketsDelete - deleteBaskets: no basketIds provided");
      }
    } catch (error) {
      logger && logger().warn("useBasketsDelete - deleteBaskets:", error);
    }
    reloadBaskets();
    return snackbarCallback && snackbarCallback({
      message: t("baskets.delete.status.error.label"),
      options: {
        variant: "error"
      }
    });
  };
  const close = () => {
    setOpen(false);
    sentryCallback && sentryCallback({
      category: "VISUAL_FEEDBACK" /* VISUAL_FEEDBACK */,
      message: `basketDeleteModalState: close`
    });
  };
  return {
    deleteBaskets,
    open,
    setOpen,
    close
  };
};

// src/providers/basket/hooks/useBasketDownload.ts
var import_react31 = require("react");
var import_recoil144 = require("recoil");

// src/providers/downloadManager/atoms/preferences.ts
var import_recoil141 = require("recoil");
var downloadManagerPreferenceLastUsedFormatsState = (0, import_recoil141.atom)({
  key: "DownloadManagerPreferenceLastUsedFormatsState",
  default: [],
  effects: [localStorageEffect("DownloadManagerPreferenceLastUsedFormatsState")]
});
var downloadManagerPreferenceFormatByState = (0, import_recoil141.atom)({
  key: "DownloadManagerPreferenceFormatByState",
  default: 0 /* TYPE */,
  effects: [localStorageEffect("DownloadManagerPreferenceFormatByState")]
});
var downloadManagerPreferenceFormatFavoritesState = (0, import_recoil141.atom)({
  key: "DownloadManagerPreferenceFormatFavoritesState",
  default: [],
  effects: [localStorageEffect("DownloadManagerPreferenceFormatFavoritesState")]
});

// src/providers/downloadManager/atoms/selections.ts
var import_recoil142 = require("recoil");
var DownloadManagerOpenStatus = /* @__PURE__ */ ((DownloadManagerOpenStatus2) => {
  DownloadManagerOpenStatus2["ALLOWED"] = "allowed";
  DownloadManagerOpenStatus2["MAX_REACHED"] = "max_reached";
  DownloadManagerOpenStatus2["MAX_REACHED_ANONYMOUS"] = "max_reached_anonymous";
  return DownloadManagerOpenStatus2;
})(DownloadManagerOpenStatus || {});
var downloadManagerOpenStatusState = (0, import_recoil142.atom)({
  key: "DownloadManagerOpenStatusState",
  default: "allowed" /* ALLOWED */
});
var downloadManagerOpenState = (0, import_recoil142.atom)({
  key: "DownloadManagerOpenState",
  default: false
});
var downloadManagerDataviewKey = (0, import_recoil142.atom)({
  key: "DownloadManagerDataviewKey",
  default: void 0
});
var downloadManagerSelectedElementsState = (0, import_recoil142.atom)({
  key: "DownloadManagerSelectedElementsState",
  default: []
});
var tabLoadingAtom = (0, import_recoil142.atom)({
  key: "TabLoadingAtom",
  default: false
});
var elementsSelectionIdState = (0, import_recoil142.atom)({
  key: "ElementsSelectionIdState",
  default: null
});

// src/providers/downloadManager/selectors/selections.ts
var import_recoil143 = require("recoil");

// src/providers/downloadManager/utils.ts
var isMaxReachedAnonymous = (elementsNbr, fetcherMode, directExportNumberLimit, isPublicVisitor2) => {
  if (directExportNumberLimit === void 0) {
    return false;
  } else {
    return (isPublicVisitor2 || 0 /* SHARE */ === fetcherMode) && elementsNbr > directExportNumberLimit;
  }
};

// src/providers/downloadManager/selectors/selections.ts
var downloadManagerSelectionSelector = (0, import_recoil143.selectorFamily)({
  key: "DownloadManagerSelectionSelector",
  get: () => ({ get }) => get(downloadManagerSelectedElementsState),
  set: (key2) => ({ get, set }, newValue) => {
    let state = true;
    let status = "allowed" /* ALLOWED */;
    const maxElements = get(maxElementsByDownloadSelector);
    const directExportNumberLimit = get(directExportNumberLimitSelector);
    const fetcherMode = get(fetcherModeAtom);
    const isPublicVisitor2 = get(isPublicVisitorState);
    if (isMaxReachedAnonymous(
      newValue.length,
      fetcherMode,
      directExportNumberLimit,
      isPublicVisitor2
    )) {
      status = "max_reached_anonymous" /* MAX_REACHED_ANONYMOUS */;
      state = false;
    } else if (newValue.length > maxElements) {
      status = "max_reached" /* MAX_REACHED */;
      state = false;
    }
    if (status === "allowed" /* ALLOWED */) {
      set(downloadManagerSelectedElementsState, newValue);
    }
    set(downloadManagerOpenStatusState, status);
    set(downloadManagerOpenState, state);
    set(downloadManagerDataviewKey, key2);
  }
});

// src/providers/basket/hooks/useBasketDownload.ts
var useBasketDownload = (key2, selectedElementIds, page, basketId) => {
  const [downloadAsked, setDownloadAsked] = (0, import_recoil144.useRecoilState)(downloadBasketAskedAtom(basketId));
  const setSelectionToDownloadManager = (0, import_recoil144.useSetRecoilState)(downloadManagerSelectionSelector(key2));
  const internalMode = (0, import_recoil144.useRecoilValue)(basketInternalMode);
  const currentBasketElements = (0, import_recoil144.useRecoilValue)(basketElementsSelector(basketId));
  const filters = basketId ? [createBasketBusinessFilter(basketId)] : null;
  const totalCount = (0, import_recoil144.useRecoilValue)(basketTotalCountSelector(basketId));
  const { selectAll, unSelectAll } = useSelectAllInAdvancedSearch({
    key: key2,
    filters,
    totalCount,
    page,
    basketId
  });
  (0, import_react31.useEffect)(() => {
    if (internalMode === void 0) {
      return;
    }
    if (selectedElementIds.length > 0 && downloadAsked && !internalMode) {
      setSelectionToDownloadManager(selectedElementIds);
      unSelectAll();
      setDownloadAsked(false);
    } else if (internalMode && downloadAsked && currentBasketElements?.elements) {
      const ids = currentBasketElements.elements.map((el) => el.id);
      setSelectionToDownloadManager(ids);
      setDownloadAsked(false);
    }
  }, [
    downloadAsked,
    selectedElementIds,
    setSelectionToDownloadManager,
    unSelectAll,
    internalMode,
    currentBasketElements?.elements,
    setDownloadAsked
  ]);
  const download = (0, import_react31.useCallback)(() => {
    if (internalMode === void 0) {
      return;
    }
    if (!internalMode) {
      unSelectAll();
      selectAll();
    }
    setDownloadAsked(true);
  }, [internalMode, selectAll, setDownloadAsked, unSelectAll]);
  return download;
};

// src/providers/basket/hooks/useBasketEdit.ts
var import_react_i18next12 = require("react-i18next");
var import_recoil145 = require("recoil");
function useBasketEdit({
  basketId,
  sentryCallback,
  snackbarCallback,
  updateCallback = () => {
  }
}) {
  const { t } = (0, import_react_i18next12.useTranslation)();
  const reloadBaskets = useBasketsReload();
  const internalMode = (0, import_recoil145.useRecoilValue)(basketInternalMode);
  const axiosInstance = (0, import_recoil145.useRecoilValue)(getAxiosInstanceAtom);
  const setBasketTitle = (0, import_recoil145.useSetRecoilState)(basketTitle(basketId));
  const update = async ({ title }) => {
    if (internalMode === void 0) {
      updateCallback(false);
      return Promise.reject("internalMode not yet valued");
    }
    const id = basketId;
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `basket edit update: ${basketId}`
    });
    if (id) {
      let success = false;
      if (internalMode) {
        setBasketTitle(title);
        success = true;
      } else if (axiosInstance) {
        success = await updateBasket(axiosInstance(), { id, title });
      }
      if (success) {
        reloadBaskets();
        snackbarCallback && snackbarCallback({
          message: t("basket.edit.status.success.label", { title }),
          options: {
            variant: "success"
          }
        });
        return updateCallback(true);
      }
    }
    snackbarCallback && snackbarCallback({
      message: t("basket.edit.status.error.label", { title }),
      options: {
        variant: "error"
      }
    });
    return updateCallback(false);
  };
  return {
    update
  };
}

// src/providers/basket/hooks/useBasketPageCount.ts
var import_recoil146 = require("recoil");
var useBasketPageCount = (basketId) => {
  const totalCount = (0, import_recoil146.useRecoilValue)(basketTotalCountSelector(basketId));
  const size = (0, import_recoil146.useRecoilValue)(dataViewSize("basket" /* BASKET */));
  const internalMode = (0, import_recoil146.useRecoilValue)(basketInternalMode);
  if (internalMode === void 0 || internalMode) {
    return void 0;
  } else {
    return Math.ceil(totalCount / size);
  }
};

// src/providers/basket/hooks/useBasketRemove.ts
var import_api_client49 = require("@keepeek/api-client");
var import_recoil147 = require("recoil");
var useBasketRemove = (basketId, sentryCallback) => {
  const axiosInstance = (0, import_recoil147.useRecoilValue)(getAxiosInstanceAtom);
  const logger = (0, import_recoil147.useRecoilValue)(getLoggerAtom);
  const setBasket = (0, import_recoil147.useSetRecoilState)(basketSelector({ id: basketId }));
  const refreshBasketSelector = (0, import_recoil147.useRecoilRefresher_UNSTABLE)(getBasketSelector(basketId ?? 0));
  const updateBasketAdvancedSearchId = (0, import_recoil147.useSetRecoilState)(
    shouldUpdateAdvancedSearchId("basket" /* BASKET */)
  );
  const updateBasketDetailAdvancedSearchId = (0, import_recoil147.useSetRecoilState)(
    shouldUpdateAdvancedSearchId("basket-detail" /* BASKET_DETAIL */)
  );
  const internalMode = (0, import_recoil147.useRecoilValue)(basketInternalMode);
  const reloadCurrentBasketElements = () => {
    if (internalMode === void 0) {
      return;
    }
    if (!internalMode) {
      updateBasketAdvancedSearchId((val) => val + 1);
      updateBasketDetailAdvancedSearchId((val) => val + 1);
    }
  };
  const remove = async (elementId) => {
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `useBasketRemove - remove: ${basketId}, elementId: ${elementId}`
    });
    if (internalMode === void 0) {
      return Promise.reject("internalMode not yet valued");
    }
    setBasket((basket) => {
      if (basket) {
        const newBasket = {
          ...basket,
          elements: basket.elements?.filter((el) => el.id !== elementId),
          mediaCount: basket.mediaCount - 1
        };
        return newBasket;
      }
      return void 0;
    });
    if (basketId) {
      try {
        if (!internalMode && axiosInstance) {
          await removeMediaFromBasket(
            axiosInstance(),
            {
              basketId,
              mediaId: elementId
            },
            logger
          );
        }
        reloadCurrentBasketElements();
      } catch (error) {
        logger && logger().error("useBasketRemove - remove:", error);
      }
    } else {
      logger && logger().warn("useBasketRemove - remove: no basketId provided");
    }
    return Promise.resolve();
  };
  const clearBasket = async () => {
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `clearBasket: ${basketId}`
    });
    if (internalMode === void 0) {
      return Promise.reject("internalMode not yet valued");
    }
    setBasket((basket) => {
      if (basket) {
        return {
          ...basket,
          elements: [],
          mediaCount: 0
        };
      }
      return void 0;
    });
    if (basketId) {
      try {
        if (!internalMode && axiosInstance) {
          await (0, import_api_client49.removeAllMediasFromBasket)(axiosInstance(), {
            basketId
          });
        }
        reloadCurrentBasketElements();
        refreshBasketSelector();
      } catch (error) {
        logger && logger().error("useBasketRemove - clearBasket:", error);
      }
    } else {
      logger && logger().warn("useBasketRemove - clearBasket: no basketId provided");
    }
    return Promise.resolve();
  };
  return {
    remove,
    clearBasket
  };
};

// src/providers/basket/hooks/useBasketShare.ts
var import_react33 = require("react");
var import_api_client50 = require("@keepeek/api-client");
var import_react_i18next13 = require("react-i18next");
var import_recoil149 = require("recoil");

// src/providers/utils.ts
var import_react32 = require("react");
var import_recoil148 = require("recoil");
function useLoadableErrorLogger(loadable, loadableName) {
  const name = `: ${loadableName}`;
  const logger = (0, import_recoil148.useRecoilValue)(getLoggerAtom);
  (0, import_react32.useEffect)(() => {
    if (loadable.state === "hasError") {
      logger && logger().error(`error during loadable${loadableName ? name : ""}`, loadable.contents);
    }
  }, [loadable.contents, loadable.state, loadableName, logger, name]);
}
function removeLastOccurence(value, termToRemoveRgex) {
  const indexOf = value?.match(termToRemoveRgex)?.index;
  return indexOf && indexOf > -1 ? value?.substring(0, indexOf) : value;
}

// src/providers/basket/hooks/useBasketShare.ts
var ShareEntryPointInputId = "ShareEntryPoint-BasketShare";
function useBasketShare(displayBackofficeSharedBasket, basketId, sentryCallback, snackbarCallback) {
  const { t } = (0, import_react_i18next13.useTranslation)();
  const [open, setOpen] = (0, import_recoil149.useRecoilState)(shareBasketModalState(basketId));
  const internalMode = (0, import_recoil149.useRecoilValue)(basketInternalMode);
  const axiosInstance = (0, import_recoil149.useRecoilValue)(getAxiosInstanceAtom);
  const logger = (0, import_recoil149.useRecoilValue)(getLoggerAtom);
  const basketItemLoadable = (0, import_recoil149.useRecoilValueLoadable)(basketItemSelector(basketId));
  useLoadableErrorLogger(basketItemLoadable, `useBasketShare basketItemLoadable`);
  const basketMaxDownloadLevel = (0, import_recoil149.useRecoilValue)(basketDownloadLevelSelector(basketId));
  const publicShareAuthorized = basketItemLoadable?.state === "hasValue" && (basketItemLoadable.contents?.share || false);
  const [selectedExportDefinition, setSelectedExportDefinition] = (0, import_recoil149.useRecoilState)(
    selectedExportDefinitionForPublicSharingState
  );
  const resetSelectedExportDefinition = (0, import_recoil149.useResetRecoilState)(
    selectedExportDefinitionForPublicSharingState
  );
  const [selectedDeactivationDate, setSelectedDeactivationDate] = (0, import_recoil149.useRecoilState)(
    selectedDeactivationDateForPublicSharingState
  );
  const resetSelectedDeactivationDate = (0, import_recoil149.useResetRecoilState)(
    selectedDeactivationDateForPublicSharingState
  );
  const [selectedAccessCode, setSelectedAccessCode] = (0, import_recoil149.useRecoilState)(
    selectedAccessCodeForPublicSharingState
  );
  const resetSelectedAccessCode = (0, import_recoil149.useResetRecoilState)(selectedAccessCodeForPublicSharingState);
  const [selectedAttachmentsVisible, setSelectedAttachmentsVisible] = (0, import_recoil149.useRecoilState)(
    selectedAttachmentsVisibleForPublicSharingState
  );
  const resetSelectedAttachmentsVisible = (0, import_recoil149.useResetRecoilState)(
    selectedAttachmentsVisibleForPublicSharingState
  );
  const [selectedStatus, setSelectedStatus] = (0, import_recoil149.useRecoilState)(
    selectedStatusForPublicSharingState(basketId)
  );
  const resetSelectedStatus = (0, import_recoil149.useResetRecoilState)(selectedStatusForPublicSharingState(basketId));
  const setUpdatePublicSharedState = (0, import_recoil149.useSetRecoilState)(updatePublicSharedState);
  const publicShareQuery = (0, import_recoil149.useRecoilValueLoadable)(
    basketPublicShareQuery({ displayBackofficeSharedBasket, basketId })
  );
  const publicShare = publicShareQuery.state === "hasValue" ? publicShareQuery.contents : null;
  const publicShareLoading = publicShareQuery.state === "loading";
  const [copyEntryPointWhenPublicShareIsReady, setCopyEntryPointWhenPublicShareIsReady] = (0, import_react33.useState)(false);
  function close() {
    setOpen(false);
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: "shareBasketModalState: close"
    });
  }
  function share() {
    if (internalMode === void 0) {
      return;
    }
    if (!internalMode) {
      setCopyEntryPointWhenPublicShareIsReady(true);
      setOpen(true);
      sentryCallback && sentryCallback({
        category: "USER_INTERACTION" /* USER_INTERACTION */,
        message: "shareBasketModalState: open"
      });
    }
  }
  const copyEntryPoint = (0, import_react33.useCallback)(async () => {
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `share basket copyEntryPoint: ${publicShare?.entryPoint}, basketId: ${basketId}`
    });
    try {
      const permission = await navigator.permissions.query({ name: "clipboard-write" });
      if ((permission.state === "granted" || permission.state === "prompt") && publicShare?.entryPoint) {
        await navigator.clipboard.writeText(publicShare.entryPoint);
        return snackbarCallback && snackbarCallback({
          message: t("basket.share.content.link.copy-link.notification-success"),
          options: {
            variant: "info",
            preventDuplicate: true
          }
        });
      }
    } catch (error) {
      if (currentBrowser() === "Google Chrome or Chromium" /* Chrome */) {
        logger && logger().error("copyEntryPoint", error);
      }
    }
    try {
      const input = document.querySelector(`#${ShareEntryPointInputId}`);
      input.select();
      document.execCommand("copy");
      return snackbarCallback && snackbarCallback({
        message: t("basket.share.content.link.copy-link.notification-success"),
        options: {
          variant: "info",
          preventDuplicate: true
        }
      });
    } catch (error) {
      logger && logger().error("copyEntryPoint", error);
    }
    return snackbarCallback && snackbarCallback({
      message: t("basket.share.content.link.copy-link.notification-fail"),
      options: {
        variant: "warning",
        preventDuplicate: true
      }
    });
  }, [basketId, logger, publicShare?.entryPoint, sentryCallback, snackbarCallback, t]);
  (0, import_react33.useEffect)(() => {
    if (publicShare?.entryPoint !== void 0 && selectedStatus === import_api_client50.KpkApiPublicShareStatus.Activated) {
      setCopyEntryPointWhenPublicShareIsReady(false);
      try {
        copyEntryPoint();
      } catch (error) {
        snackbarCallback && snackbarCallback({
          message: t("basket.share.content.link.copy-link.notification-fail"),
          options: {
            variant: "warning",
            preventDuplicate: true
          }
        });
      }
    }
  }, [
    copyEntryPointWhenPublicShareIsReady,
    publicShare?.entryPoint,
    copyEntryPoint,
    logger,
    snackbarCallback,
    t,
    selectedStatus
  ]);
  const exportDefinitions = Object.values(import_api_client50.KpkApiPublicShareExportDefinition).map(
    (defintion) => ({
      title: t(`basket.share.content.export-definition.${defintion}.title`),
      description: t(`basket.share.content.export-definition.${defintion}.description`),
      id: defintion,
      metas: [],
      href: "",
      active: defintion === selectedExportDefinition
    })
  );
  const exportDefinitionFilteredByRights = exportDefinitions.filter((e) => {
    if (basketMaxDownloadLevel === import_api_client50.KpkApiPublicShareExportDefinition.None) {
      return e.id === import_api_client50.KpkApiPublicShareExportDefinition.None;
    } else if (basketMaxDownloadLevel === import_api_client50.KpkApiPublicShareExportDefinition.Bd) {
      return e.id === import_api_client50.KpkApiPublicShareExportDefinition.None || e.id === import_api_client50.KpkApiPublicShareExportDefinition.Bd;
    } else {
      return e.id;
    }
  });
  (0, import_react33.useEffect)(() => {
    if (publicShare?.exportDefinition) {
      setSelectedExportDefinition(publicShare.exportDefinition);
    } else {
      resetSelectedExportDefinition();
    }
    if (publicShare?.accessCode) {
      setSelectedAccessCode({
        active: true,
        code: publicShare?.accessCode
      });
    } else {
      resetSelectedAccessCode();
    }
    if (publicShare?.attachmentsVisible) {
      setSelectedAttachmentsVisible({
        attachmentsVisible: publicShare?.attachmentsVisible
      });
    } else {
      resetSelectedAttachmentsVisible();
    }
    if (publicShare?.deactivationDate) {
      setSelectedDeactivationDate({
        active: true,
        date: (0, import_dayjs.default)(publicShare.deactivationDate).toISOString()
      });
    } else {
      resetSelectedDeactivationDate();
    }
    if (publicShare?.status) {
      setSelectedStatus(publicShare.status);
    } else {
      resetSelectedStatus();
    }
  }, [
    publicShare,
    resetSelectedAccessCode,
    resetSelectedAttachmentsVisible,
    resetSelectedDeactivationDate,
    resetSelectedExportDefinition,
    resetSelectedStatus,
    setSelectedAccessCode,
    setSelectedAttachmentsVisible,
    setSelectedDeactivationDate,
    setSelectedExportDefinition,
    setSelectedStatus
  ]);
  async function publish({
    closePopup,
    initialAttachmentsVisible
  }) {
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `share basket publish: ${basketId}`
    });
    setSelectedStatus(import_api_client50.KpkApiPublicShareStatus.Activated);
    if (selectedAccessCode.active && (selectedAccessCode.code === null || selectedAccessCode.code === void 0 || selectedAccessCode.code.length < 1)) {
      return snackbarCallback && snackbarCallback({
        message: t("basket.share.notification.publish.error.access.code"),
        options: {
          variant: "error"
        }
      });
    }
    if (closePopup === void 0 || closePopup) {
      copyEntryPoint();
      close();
    } else {
      setCopyEntryPointWhenPublicShareIsReady(true);
    }
    try {
      if (basketId && axiosInstance) {
        await putSharePublicBasket(axiosInstance(), {
          basketId,
          publicShare: {
            accessCode: selectedAccessCode.active && selectedAccessCode.code ? selectedAccessCode.code : void 0,
            attachmentsVisible: initialAttachmentsVisible !== void 0 ? initialAttachmentsVisible : selectedAttachmentsVisible.attachmentsVisible,
            status: import_api_client50.KpkApiPublicShareStatus.Activated,
            exportDefinition: selectedExportDefinition,
            deactivationDate: selectedDeactivationDate.active && selectedDeactivationDate.date ? (0, import_dayjs.default)(selectedDeactivationDate.date).toISOString() : void 0
          }
        });
        setUpdatePublicSharedState((currVal) => currVal + 1);
        return snackbarCallback && snackbarCallback({
          message: t("basket.share.notification.publish.success"),
          options: {
            variant: "success"
          }
        });
      } else {
        logger && logger().warn("useBasketShare, publish: no basketId provided");
      }
    } catch (error) {
      logger && logger().warn("useBasketShare, publish:", error);
    }
    return snackbarCallback && snackbarCallback({
      message: t("basket.share.notification.publish.fail"),
      options: {
        variant: "error"
      }
    });
  }
  async function unPublish() {
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `share basket unPublish: ${basketId}`
    });
    setSelectedStatus(import_api_client50.KpkApiPublicShareStatus.Deactivated);
    try {
      if (basketId && axiosInstance) {
        await putSharePublicBasket(axiosInstance(), {
          basketId,
          publicShare: {
            accessCode: selectedAccessCode.active && selectedAccessCode.code ? selectedAccessCode.code : void 0,
            attachmentsVisible: selectedAttachmentsVisible.attachmentsVisible,
            status: import_api_client50.KpkApiPublicShareStatus.Deactivated,
            exportDefinition: selectedExportDefinition,
            deactivationDate: selectedDeactivationDate.active && selectedDeactivationDate.date ? (0, import_dayjs.default)(selectedDeactivationDate.date).toISOString() : void 0
          }
        });
        setUpdatePublicSharedState((currVal) => currVal + 1);
        return snackbarCallback && snackbarCallback({
          message: t("basket.share.notification.unpublish.success"),
          options: {
            variant: "info"
          }
        });
      } else {
        logger && logger().warn("useBasketShare, unpublish: no basketId provided");
      }
    } catch (error) {
      logger && logger().warn("useBasketShare, unpublish:", error);
    }
    return snackbarCallback && snackbarCallback({
      message: t("basket.share.notification.unpublish.fail"),
      options: {
        variant: "error"
      }
    });
  }
  return {
    open,
    close,
    share,
    publicShare,
    publicShareLoading,
    copyEntryPoint,
    exportDefinitions: exportDefinitionFilteredByRights,
    selectedExportDefinition,
    basketMaxDownloadLevel,
    setSelectedExportDefinition,
    selectedDeactivationDate,
    setSelectedDeactivationDate,
    selectedAccessCode,
    setSelectedAccessCode,
    selectedAttachmentsVisible,
    setSelectedAttachmentsVisible,
    selectedStatus,
    publish,
    unPublish,
    publicShareAuthorized
  };
}

// src/providers/basket/hooks/useBasketSynchronization.ts
var import_react34 = require("react");
var import_recoil150 = require("recoil");
var useBasketSynchronization = (basketId) => {
  const setBasketElements = (0, import_recoil150.useSetRecoilState)(basketElementsSelector(basketId));
  const setShouldNotCreateAdvancedId = (0, import_recoil150.useSetRecoilState)(
    shouldNotCreateAdvancedId("basket" /* BASKET */)
  );
  const sort = (0, import_recoil150.useRecoilValue)(dataViewSortSelector("basket" /* BASKET */));
  const size = (0, import_recoil150.useRecoilValue)(dataViewSize("basket" /* BASKET */));
  const page = (0, import_recoil150.useRecoilValue)(dataViewPage("basket" /* BASKET */));
  const filtersConfiguration = (0, import_recoil150.useRecoilValue)(businessFiltersConfiguration) || null;
  const filters = (0, import_react34.useMemo)(() => {
    if (basketId) {
      return [createBasketBusinessFilter(basketId)];
    }
    return null;
  }, [basketId]);
  const { elements } = useDataView({ key: "basket" /* BASKET */, filters });
  const totalCount = (0, import_recoil150.useRecoilValue)(
    basketTotalCountWithInternalModeSelector(
      serializeComplexeParamsForRecoil({
        key: "basket" /* BASKET */,
        id: basketId,
        filters,
        filtersConfiguration,
        sort,
        size,
        page
      })
    )
  );
  const internalMode = (0, import_recoil150.useRecoilValue)(basketInternalMode);
  (0, import_react34.useEffect)(() => {
    if (internalMode === void 0) {
      return;
    }
    if (basketId && !internalMode) {
      setShouldNotCreateAdvancedId(false);
    } else {
      setShouldNotCreateAdvancedId(true);
    }
  }, [basketId, setShouldNotCreateAdvancedId, internalMode]);
  (0, import_react34.useEffect)(() => {
    if (internalMode === void 0) {
      return;
    }
    if (totalCount !== -1 && !internalMode) {
      setBasketElements({ elements, mediaCount: totalCount });
    }
  }, [elements, setBasketElements, totalCount, internalMode]);
};

// src/providers/basket/hooks/useBasketListPaginated.ts
var import_recoil151 = require("recoil");
var useBasketListPaginated = ({
  sortParam,
  sizeParam,
  pageParam,
  qParam,
  fqParam
}) => {
  const basketListReference = (0, import_recoil151.useRecoilValue)(basketListSelector);
  const basketListApi = (0, import_recoil151.useRecoilValue)(
    basketListQuery({
      sort: sortParam,
      size: sizeParam,
      page: pageParam,
      q: qParam,
      fq: fqParam
    })
  );
  useBasketInternalMode();
  const internalMode = (0, import_recoil151.useRecoilValue)(basketInternalMode);
  const basketList = internalMode ? { baskets: basketListReference, totalCount: void 0 } : basketListApi;
  return { basketList };
};

// src/providers/dataViewElement/hooks/useDataViewElement.ts
var import_uniq4 = __toESM(require("lodash/uniq"));
var import_recoil154 = require("recoil");

// src/providers/dataViewElement/selectors.ts
var import_recoil152 = require("recoil");
var dataViewElementFieldsToDisplaySelector = (0, import_recoil152.selectorFamily)({
  key: "DataViewElementFieldsToDisplaySelector",
  get: ({ key: key2, id, isUnitaryShareElement }) => ({ get }) => {
    const filters = get(activeBusinessFiltersState(key2));
    const getLogger = get(getLoggerAtom);
    if (!getLogger) {
      throw new MandatoryProviderException("getLogger");
    }
    if (filters === void 0) {
      getLogger().debug(
        "dataViewElementFieldsToDisplaySelector : canceled because filters is not yet valued"
      );
      return {
        functionalFieldsToDisplay: [],
        technicalFieldsToDisplay: [],
        listViewFieldsToDisplay: []
      };
    }
    let element = void 0;
    if (!isUnitaryShareElement) {
      element = get(
        dataViewElement(
          serializeComplexeParamsForRecoil({
            key: key2,
            id,
            filters
          })
        )
      );
    }
    const forms = get(formsQuerySelector);
    const { functionalFields, technicalFields, listViewFields } = get(
      dataViewFieldsConfiguration
    ) ?? {
      functionalFieldsToDisplay: void 0,
      technicalFieldsToDisplay: void 0,
      listViewFieldsToDisplay: void 0
    };
    if (!element && !isUnitaryShareElement) {
      return {
        functionalFieldsToDisplay: [],
        technicalFieldsToDisplay: [],
        listViewFieldsToDisplay: []
      };
    }
    const fields = {
      functionalFieldsToDisplay: element && getFieldsToDisplay(functionalFields || {}, element, forms) || [],
      technicalFieldsToDisplay: element && getFieldsToDisplay(technicalFields || {}, element, forms) || [],
      listViewFieldsToDisplay: element && getFieldsToDisplay(listViewFields || {}, element, forms) || []
    };
    return fields;
  }
});

// src/providers/dataViewElement/atoms.ts
var import_recoil153 = require("recoil");
var insertElement = (0, import_recoil153.atom)({
  key: "InsertElement",
  default: void 0
});

// src/providers/dataViewElement/hooks/useDataViewElement.ts
var useDataViewElement = ({
  key: key2,
  id,
  sentryCallback,
  openElementCallback,
  filters,
  basketId,
  isUnitaryShareElement
}) => {
  const { elements } = useDataView({ key: key2, filters: filters || null });
  const element = (0, import_recoil154.useRecoilValue)(
    dataViewElement(serializeComplexeParamsForRecoil({ key: key2, id, filters: filters || null }))
  );
  const [isSelected, setSelected] = (0, import_recoil154.useRecoilState)(elementIsSelected({ key: key2, id }));
  const queryFields = (0, import_recoil154.useRecoilValueLoadable)(
    dataViewElementFieldsToDisplaySelector({ key: key2, id, isUnitaryShareElement })
  );
  const functionalFieldsToDisplay = queryFields.state === "hasValue" ? queryFields.contents.functionalFieldsToDisplay : [];
  const technicalFieldsToDisplay = queryFields.state === "hasValue" ? queryFields.contents.technicalFieldsToDisplay : [];
  const listViewFieldsToDisplay = queryFields.state === "hasValue" ? queryFields.contents.listViewFieldsToDisplay : [];
  const [selecteds, setSelecteds] = (0, import_recoil154.useRecoilState)(selectedElements(key2));
  const selectionMode = selecteds.length > 0;
  const singleSelection = selecteds.length == 1;
  const setSelectionToDownloadManager = (0, import_recoil154.useSetRecoilState)(downloadManagerSelectionSelector(key2));
  const setSelectionToAdd = (0, import_recoil154.useSetRecoilState)(addToBasketSelection);
  const setInsertElement = (0, import_recoil154.useSetRecoilState)(insertElement);
  const setPreferenceFormat = (0, import_recoil154.useSetRecoilState)(downloadManagerPreferenceFormatByState);
  const { remove } = useBasketRemove(basketId, sentryCallback);
  const { handleSelections } = useShareManagerSelections();
  function click() {
    setSelected((prevValue) => !prevValue);
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `useDataViewElement - click, key: ${key2}, id: ${id}`
    });
  }
  function doubleClick() {
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `useDataViewElement - doubleClick, key: ${key2}, id: ${id}`
    });
    openElementCallback && openElementCallback({ elementId: id });
  }
  function actionClick(action) {
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `useDataViewElement - actionClick, key: ${key2}, id: ${id}, action: ${action}`
    });
    if (!selectionMode || singleSelection) {
      switch (action) {
        case "openElement" /* OPEN_ELEMENT */:
          if (!singleSelection) {
            openElementCallback && openElementCallback({ elementId: id });
          }
          break;
        case "download" /* DOWNLOAD */:
          setSelectionToDownloadManager([id]);
          break;
        case "showAttachment" /* SHOW_ATTACHMENT */:
          setPreferenceFormat(2 /* OTHER */);
          setSelectionToDownloadManager([id]);
          break;
        case "addSelectionToBasket" /* ADD_TO_BASKET */:
          setSelectionToAdd([id]);
          break;
        case "removeFromBasket" /* REMOVE_FROM_BASKET */:
          remove(id);
          break;
        case "share" /* SHARE */:
          handleSelections([
            {
              type: "UNITARY_PUBLIC_SHARE" /* UNITARY_PUBLIC_SHARE */,
              elements: [
                {
                  id,
                  title: elements.find((e) => e.id === id)?.title.value || "",
                  mediaType: elements.find((e) => e.id === id)?.mediaType || "image/jpg"
                }
              ]
            }
          ]);
          break;
        case "insert" /* INSERT */:
          setInsertElement([id]);
          break;
        default:
          console.debug(`${action} sur l'\xE9l\xE9ment ${id}`);
          break;
      }
    }
  }
  function majClick() {
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `useDataViewElement - majClick, key: ${key2}, id: ${id}`
    });
    setSelected(true);
    if (selecteds.length !== 0) {
      const currSelecteds = [...selecteds, id];
      let firstElementSelectedIndex = -1;
      let lastElementSelectedIndex = -1;
      let selectedIndex = elements.findIndex((el) => el.id === id);
      let selectedIsTheFirst = false;
      elements.some((el, i) => {
        const match = currSelecteds.includes(el.id);
        if (match) {
          firstElementSelectedIndex = i;
          selectedIsTheFirst = el.id === id;
        }
        return match;
      });
      if (selectedIsTheFirst) {
        selectedIndex = [...elements].reverse().findIndex((el) => el.id === id);
        [...elements].reverse().some((el, i) => {
          const match = currSelecteds.includes(el.id);
          if (match) {
            lastElementSelectedIndex = i;
          }
          return match;
        });
      }
      const startIndex = selectedIsTheFirst ? lastElementSelectedIndex : firstElementSelectedIndex;
      const iterator = selectedIsTheFirst ? [...elements].reverse() : elements;
      iterator.slice(startIndex, selectedIndex).forEach((el) => {
        setSelecteds((currVal) => (0, import_uniq4.default)([...currVal, el.id]));
      });
    }
  }
  function associationClick() {
    sentryCallback && sentryCallback({
      category: "USER_INTERACTION" /* USER_INTERACTION */,
      message: `useDataViewElement - associationClick, key: ${key2}, id: ${id}`
    });
    openElementCallback && openElementCallback({ elementId: id, options: { highlightAssociations: true } });
  }
  return {
    element,
    isSelected,
    setSelected,
    functionalFieldsToDisplay,
    technicalFieldsToDisplay,
    listViewFieldsToDisplay,
    loadingFields: queryFields.state === "loading",
    selectionMode,
    singleSelection,
    click,
    doubleClick,
    actionClick,
    majClick,
    associationClick
  };
};

// src/providers/dataViewElement/hooks/useDataViewElementButtons.ts
var import_recoil156 = require("recoil");

// src/providers/thumbnailGenerator/hooks.ts
var import_api_client51 = require("@keepeek/api-client");
var import_recoil155 = require("recoil");
var useThumbnailGeneratorAllowed = (user) => {
  const techPro = (0, import_recoil155.useRecoilValue)(thumbnailGenerationServiceConfigurationSelector);
  const hasPublicShare = userHasPublicShare(user?._embedded?.profile?.authorizations);
  return (media) => techPro.enabled && hasPublicShare && media.formType === 0 /* PICTURE */ && media.downloadLevel === import_api_client51.KpkApiMediaDownloadLevel.HD;
};

// src/providers/dataViewElement/hooks/useDataViewElementButtons.ts
var useDataViewElementButtons = ({
  key: key2,
  id,
  isShare,
  shareTokenDownloadAuthorized,
  filters,
  enabledActions = [
    "showAttachment" /* SHOW_ATTACHMENT */,
    "addSelectionToBasket" /* ADD_TO_BASKET */,
    "download" /* DOWNLOAD */,
    "share" /* SHARE */
  ],
  attachmentsVisible
}) => {
  const { hasPublicShare, currentUser } = useCurrentUser();
  const isThumbnailGeneratorAllowed = useThumbnailGeneratorAllowed(currentUser);
  const getDataViewElementsButtonsConfiguration = (0, import_recoil156.useRecoilValue)(
    dataViewElementsButtonsConfiguration
  );
  const getCustomerCommonOverride = (0, import_recoil156.useRecoilValue)(customerCommonOverrideAtom);
  const element = (0, import_recoil156.useRecoilValue)(
    dataViewElement(serializeComplexeParamsForRecoil({ key: key2, id, filters: filters || null }))
  );
  const customerOverrideElementActions = element && getCustomerOverrideFunction(
    "ElementActions" /* ElementActions */,
    {
      elementId: element.id
    },
    getCustomerCommonOverride
  );
  return {
    showAttachmentButton: showAttachmentButton(
      element,
      getDataViewElementsButtonsConfiguration,
      customerOverrideElementActions,
      enabledActions,
      attachmentsVisible
    ),
    showAddToBasketButton: showAddToBasketButton(
      isShare,
      customerOverrideElementActions,
      enabledActions
    ),
    showRemoveFromBasketButton: showRemoveFromBasketButton(enabledActions),
    showDownloadButton: showDownloadButton(
      isShare,
      shareTokenDownloadAuthorized,
      element,
      customerOverrideElementActions,
      enabledActions
    ),
    showShareButton: showShareButton(
      isShare,
      hasPublicShare,
      getDataViewElementsButtonsConfiguration,
      enabledActions
    ),
    showInsertButton: showInsertButton(enabledActions),
    showThumbnailGeneratorButton: showThumbnailGeneratorButton(
      enabledActions,
      isThumbnailGeneratorAllowed,
      element
    )
  };
};
var hasAttachments = (element) => element && !!element.attachmentCounts && !!element.attachmentCounts.online && element.attachmentCounts.online > 0 || false;
var showShareButton = (isShare, hasPublicShare, dataViewElementsButtonsConfiguration2, enabledActions) => {
  if (!enabledActions.includes("share" /* SHARE */)) {
    return false;
  }
  if (isShare) {
    return false;
  }
  return dataViewElementsButtonsConfiguration2?.showShare && hasPublicShare || false;
};
var showAttachmentButton = (element, dataViewElementsButtonsConfiguration2, customerOverrideElementActions, enabledActions, attachmentsVisible) => {
  if (!enabledActions.includes("showAttachment" /* SHOW_ATTACHMENT */)) {
    return false;
  }
  if (!element) {
    return false;
  }
  const showAttachmentConfiguration = dataViewElementsButtonsConfiguration2?.showAttachment;
  const customerOverrideShowAttachment = customerOverrideElementActions?.attachment ?? true;
  return hasAttachments(element) && showAttachmentConfiguration && customerOverrideShowAttachment && attachmentsVisible || false;
};
var showAddToBasketButton = (isShare, customerOverrideElementActions, enabledActions) => {
  if (!enabledActions.includes("addSelectionToBasket" /* ADD_TO_BASKET */)) {
    return false;
  }
  if (isShare) {
    return false;
  }
  return customerOverrideElementActions?.basket ?? true;
};
var showRemoveFromBasketButton = (enabledActions) => {
  if (!enabledActions.includes("removeFromBasket" /* REMOVE_FROM_BASKET */)) {
    return false;
  }
  return true;
};
var showDownloadButton = (isShare, shareTokenDownloadAuthorized, element, customerOverrideElementActions, enabledActions) => {
  if (!enabledActions.includes("download" /* DOWNLOAD */)) {
    return false;
  }
  if (!element) {
    return false;
  }
  if (element.mediaType === MEDIA_TYPE_RICH_ELEMENT) {
    return false;
  }
  return (customerOverrideElementActions?.download ?? true) && (!isShare || isShare && shareTokenDownloadAuthorized);
};
var showInsertButton = (enabledActions) => {
  return enabledActions.includes("insert" /* INSERT */);
};
var showThumbnailGeneratorButton = (enabledActions, isThumbnailGeneratorAllowed, element) => enabledActions.includes("showThumbnailGenerator" /* SHOW_THUMBNAIL_GENERATOR */) && element && isThumbnailGeneratorAllowed(element) || false;

// src/providers/dataViewElement/hooks/useDataViewElementLinks.ts
var import_recoil157 = require("recoil");
var useDataViewElementLinks = ({
  key: key2,
  id,
  filters,
  attachmentsVisible
}) => {
  const getDataViewElementsLinksConfiguration = (0, import_recoil157.useRecoilValue)(dataViewElementsLinksConfiguration);
  const element = (0, import_recoil157.useRecoilValue)(
    dataViewElement(serializeComplexeParamsForRecoil({ key: key2, id, filters: filters || null }))
  );
  return {
    showAttachmentLink: showAttachmentLink(
      element,
      getDataViewElementsLinksConfiguration,
      attachmentsVisible
    ),
    showMediaLinkLink: showMediaLinkLink(element, getDataViewElementsLinksConfiguration)
  };
};
var hasAttachments2 = (element) => element && !!element.attachmentCounts && !!element.attachmentCounts.online && element.attachmentCounts.online > 0 || false;
var hasMediaLinks = (element) => element && !!element.mediaLinkCount && element.mediaLinkCount > 0 || false;
var showAttachmentLink = (element, dataViewElementsLinksConfiguration2, attachmentsVisible) => dataViewElementsLinksConfiguration2?.showAttachment && hasAttachments2(element) && attachmentsVisible || false;
var showMediaLinkLink = (element, dataViewElementsLinksConfiguration2) => {
  return dataViewElementsLinksConfiguration2?.showMediaLink && hasMediaLinks(element) || false;
};

// src/providers/thumbnailTemplates/selectors.ts
var import_recoil158 = require("recoil");
var getUserThumbnailTemplatesSelector = (0, import_recoil158.selectorFamily)({
  key: "GetUserThumbnailTemplatesSelector",
  get: (params) => async ({ get }) => {
    const { getUserThumbnailTemplates: getUserThumbnailTemplates2 } = get(
      userThumbnailTemplatesFetcherSelector(get(fetcherModeAtom))
    );
    const result = await getUserThumbnailTemplates2(params);
    return result?.data;
  }
});

// src/providers/backConfig/selectors.ts
var import_api_client52 = require("@keepeek/api-client");
var import_recoil159 = require("recoil");
var apiConfigSelector = (0, import_recoil159.selector)({
  key: "ApiConfigSelector",
  get: async ({ get }) => {
    const getAxiosInstance = get(getAxiosInstanceAtom);
    if (!getAxiosInstance) {
      throw new MandatoryProviderException("getAxiosInstance");
    }
    const apiConfig = await (0, import_api_client52.getApi)(getAxiosInstance());
    const versionString = apiConfig.data.release;
    const version = versionString.split(".");
    if (version && version.length === 3) {
      return { x: parseInt(version[0]), y: parseInt(version[1]), z: parseInt(version[2]) };
    }
    return void 0;
  }
});

// src/providers/backConfig/hooks.ts
var import_recoil160 = require("recoil");
var useApiConfig = () => {
  const apiConfig = (0, import_recoil160.useRecoilValue)(apiConfigSelector);
  function isApiVersionGreaterOrEqualThan(x, y, z) {
    if (!apiConfig) {
      return false;
    }
    return apiConfig.x > x || apiConfig.x === x && apiConfig.y > y || apiConfig.x === x && apiConfig.y === y && apiConfig.z >= z;
  }
  return { isApiVersionGreaterOrEqualThan };
};

// src/providers/kalitee/index.ts
async function getKaliteeChecks(params) {
  if (!params.axiosInstance) {
    throw new MandatoryProviderException("Error axiosInstance is mandatory");
  }
  try {
    const result = await params.axiosInstance.post(
      `${params.kaliteeAPIUrl}/blur_detector`,
      JSON.stringify({
        threshold: params.threshold,
        image_base64: params.base64File
      }),
      {
        headers: {
          "Content-type": "application/json",
          "Ocp-Apim-Subscription-Key": params.kaliteeAPIKey
        }
      }
    );
    return Promise.resolve(result.data);
  } catch (error) {
    console.error("Error while error fetching Kalitee,", error);
    return Promise.reject(error);
  }
}
async function getKaliteeGs1(params) {
  if (!params.axiosInstance) {
    throw new MandatoryProviderException("Error axiosInstance is mandatory");
  }
  try {
    const result = await params.axiosInstance.post(
      `${params.kaliteeAPIUrl}/gs1`,
      JSON.stringify({
        file_name: params.fileName,
        image_base64: params.base64File
      }),
      {
        headers: {
          "Content-type": "application/json",
          "Ocp-Apim-Subscription-Key": params.kaliteeAPIKey
        }
      }
    );
    return Promise.resolve(result.data);
  } catch (error) {
    console.error("Error while error fetching Kalitee,", error);
    return Promise.reject(error);
  }
}
//# sourceMappingURL=index.js.map
